/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		31: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"4bc0323c","1":"3a3251aa","2":"15f012e7","3":"6176ffcc","4":"8e9837d1","5":"481fb3f3","6":"8c86e532","7":"8ed375ef","8":"95d2b376","9":"fb2a79f7","10":"ee95df34","11":"3d0bf21f","12":"dfe65db1","13":"3db54c38","14":"29bc2dfa","15":"6e2bbbf6","16":"c6948cc3","17":"e6ed3443","18":"ee511672","19":"ed6f0387","20":"a1119c49","21":"32c05636","22":"29ab987e","23":"9aa0dff4","24":"ff8b3d11","25":"44665376","26":"d6917636","27":"63875eb1","28":"320035b4","29":"cb799a39","30":"740f0291"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 58);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(65);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(71)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return log; });
/* unused harmony export setFatalFunction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getJson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return logJsonAsFormatted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setLogCategory; });
var logFatalFunction=null;// IMPORTANT : must match the LogCategory values from settings.js !!!
var LogCategory={startup:{name:"startup",log:true},info:{name:"info",log:false},warn:{name:"warn",log:false},error:{name:"ERROR",log:true},fatal:{name:"FATAL",log:true},initializeData:{name:"initialize",log:false},initialState:{name:"initialState",log:false},newUser:{name:"newUser",log:true},expires:{name:"expires",log:false},product:{name:"product",log:false},price:{name:"price",log:false},callback:{name:"callback",log:false},postInitialCall:{name:"postInitialCall",log:false},clientCall:{name:"clientCall",log:false},rawApiCallHeaders:{name:"rawApiCAllHeaders",log:false},rawApiCall:{name:"rawApiCall",log:false},rawApiPostBody:{name:"rawApiPostBody",log:false},rawApiCallAnswer:{name:"rawApiCallAnswer",log:false},purchase:{name:"purchase",log:false},restriction:{name:"restriction",log:false}};var logFormattedJson=false;function doLog(msg,severity,json_extra){console.log(severity+" : "+msg);}// example: log(LogCategory.info, "titi");
//
// 4 may 2020 : json_extra - extra info that is to be interpreted as json; for now, only used for critical errors
var log=function log(category,msg,json_extra){if(category.log){if(category.name!="FATAL")doLog(msg,category.name,json_extra);else logFatal(msg,json_extra);}};var logFatal=function logFatal(msg,json_extra){if(logFatalFunction==null)doLog(msg+json_extra,"FATAL");else{if(json_extra!==undefined)logFatalFunction(msg,json_extra);else logFatalFunction(msg,{extra:""});/*
        if ( json_extra !== undefined)
            logFatalFunction(msg, JSON.stringify(json_extra, null, 2));
        else 
            logFatalFunction(msg, "");*/}};var setFatalFunction=function setFatalFunction(f){logFatalFunction=f;};var getJson=function getJson(s){return logFormattedJson?JSON.stringify(s,null,2):JSON.stringify(s);};var logJsonAsFormatted=function logJsonAsFormatted(b){logFormattedJson=b;};var setLogCategory=function setLogCategory(lc){LogCategory=lc;};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(77);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(95);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports={Hm3:1,Omaha:2,HmApps:3};

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isServer; });
/* unused harmony export serverclientPrefix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules__ = __webpack_require__(105);
// A nice helper to tell us if we're on the server
var isServer=!(typeof window!=='undefined'&&window.document&&window.document.createElement);var serverclientPrefix=isServer?"[server] ":"[client] ";/* harmony default export */ __webpack_exports__["a"] = (function(){var url=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'/';// Create a history depending on the environment
var history=isServer?Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])({initialEntries:[url]}):Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])();var enhancers=[];// Dev tools are helpful
if(false){var devToolsExtension=window.devToolsExtension;if(typeof devToolsExtension==='function'){enhancers.push(devToolsExtension());}}var middleware=[__WEBPACK_IMPORTED_MODULE_2_redux_thunk__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["routerMiddleware"])(history)];if(false){var _require=require('redux-logger'),logger=_require.logger;middleware.push(logger);}var composedEnhancers=__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */].apply(undefined,[__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(undefined,middleware)].concat(enhancers));// Do we have preloaded state available? Great, save it.
var initialState=!isServer?window.__PRELOADED_STATE__:{};// Delete it once we have it stored in a variable
if(!isServer){delete window.__PRELOADED_STATE__;}// Create the store
var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(Object(__WEBPACK_IMPORTED_MODULE_1_connected_react_router__["connectRouter"])(history)(__WEBPACK_IMPORTED_MODULE_4__modules__["a" /* default */]),initialState,composedEnhancers);return{store:store,history:history};});

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_logger__ = __webpack_require__(3);
/* harmony default export */ __webpack_exports__["a"] = ({language:"en",initialized:false,keys:{// Replayer
"notAllowedByLicense":"","selectHandToExport":"","selectFormat":"","originalFormat":"","ctrlCToCopy":"","availableTags":"","welcomeToHm3":"","theme":"","deck":"","showHandResults":"","showHeroCards":"","showBB":"","combineFolds":"","maskPlayerNames":"","statsUpToTimeOfHand":"","showHud":"","replaySpeed":"","hand":"","next100Hands":"","prev100Hands":"","addEditHandMarking":"","wonXBB":"","lostXBB":"","wonLossNA":"","potBB":"","userWentAllin":"","pot":"","potOdds":"","hhGameStart":"","hhHandNotes":"","hhFold":"","hhCheck":"","hhCall":"","hhBet":"","hhRaise":"","hhReturnedTo":"","hhWin":"","hhRake":"","hhActionEnded":"","hhMuck":"","hhShow":"","hhPostSB":"","hhPostBB":"","hhPostDB":"","skipEndOfHandLabel":"",// Situational Views
"threebetResultsTitle":"","threebetPositionTitle":"","threebetRangeTitle":"","threebetSuccessTitle":"","threebetFlopHandStrengthTitle":"","threebetWinrate":"","threebetFrequency":"","threebetRange":"","threebetSuccessRate":"","threebetFlopWinrate":"","threebetWinrateHandStrengthAxis":"","threebetHandCount":"","threebetWinrateKey":"","threebetThreeBetPercentKey":"","threebetWinrateAxis":"","threebetThreeBetPercentAxis":"","threebetSuccessPercentAxis":"","threebetNetwonTitle":"","threebetNetwonMin":"","threebetNetwonMax":"","threebetDealtFrequencyTitle":"","threebetDealtFrequencyMin":"","threebetDealtFrequencyMax":"","availableStringPositionString":"","availableStringFlopMadeHandValueString":"","availableStringRiverMadeHandValueSummary":"","availableStringFlopFlushTextureTypeAsString":"","availableStringFlopStraightTextureTypeAsString":"","availableStringFlopPairedTextureTypeAsString":"","availableStringInPositionOnFlopShort":"","availableStringInPositionOnFlopLong":"","availableStringRiverplayCallEfficiency":"","availableStringRiverplayBetEfficiency":"","availableStringCBetSpots":"","availableStringRiverFirstActionString":"","ECCallCallVsVillainOpenAllinPreflop":"","ECCallEVCallVsVillainOpenAllinPreflop":"","ECTBetCallVsVillainOpenAllinPreflop":"","ECTBetEVCallVsVillainOpenAllinPreflop":"","ERRaiseCallVsVillainOpenAllinPreflop":"","ERRaiseEVCallVsVillainOpenAllinPreflop":"","ERTBetCallVsVillainOpenAllinPreflop":"","ERTBetEVCallVsVillainOpenAllinPreflop":"","BPCCallCallVsVillainOpenAllinPreflop":"","BPCCallEVCallVsVillainOpenAllinPreflop":"","BPCTBetCallVsVillainOpenAllinPreflop":"","BPCTBetEVCallVsVillainOpenAllinPreflop":"","BPRRaiseAllinVsRaisePreflop":"","BPRRaiseEVAllinVsRaisePreflop":"","BPRTBetAllinVsRaisePreflop":"","BPRTBetEVAllinVsRaisePreflop":"","threebetHandAxis":"","threebetNetBbAxis":"","tourneyallinCallingByStackTitle":"","tourneyallinRaisingByStackTitle":"","tourneyallinRaisingAllinRangeTitle":"","tourneyallinCallingAllinRangeTitle":"","tourneyallinCallingAllinByPositionTitle":"","tourneyallinRaisingAllinByPositionTitle":"","tourneyallinCallAIEVWinrate":"","tourneyallinRaiseAIEVWinrate":"","tourneyallinCallAIWinrate":"","tourneyallinRaiseAIWinrate":"","tourneyallinExpectedWon":"","tourneyallinCallingOpenAI":"","tourneyallinCalling3BetAI":"","tourneyallinPositionAxis":"","tourneyallinExpectationAxis":"","tourneyallinRacesWonPAxis":"","tourneyallinEquityPAxis":"","tourneyallinCallvsOpen":"","tourneyallinCallvs3Bet":"","tourneyallinPreflopEffectiveStackSizeAxis":"","tourneyallinRaisevsOpen":"","tourneyallinRaisevs3Bet":"","tourneyallinRaisingOpenAI":"","tourneyallinRaising3BetAI":"","bubblePrizePoolWinningsTitle":"","bubbleExpectationWhenReachingBubbleTitle":"","bubblePositionTitle":"","bubbleBeforeAndAfterTitle":"","bubbleStackSizeTitle":"","bubbleCallRangesTitle":"","bubbleShoveRangesTitle":"","bubblePrizePoolWon":"","bubbleExpectedValue":"","bubbleAverageStack":"","bubbleCallAIWinrate":"","bubbleShoveAIWinrate":"","tooFewHands":"","bubblePrizePoolP":"","bubbleBubbleStage":"","bubbleEVbb100hands":"","bubbleICMDescription":"","bubblePercentageDescription":"","bubblePreflopDescription":"","bubblePreflopDescription2":"","bubbleBubblePlayers":"","bubblePlayersAtBubble":"","bubbleBubblePosition":"","bubbleICMDescription3":"","bubblePercentageDescription3":"","bubblePreflopDescription3":"","bubbleSitNGoEntrants":"","bubbleICMDescription4":"","bubblePercentageDescription4":"","bubblePreflopDescription4":"","bubbleCallingAllInRange":"","bubbleBubbleStackSize":"","bubbleEffectiveStackSizebb":"","bubbleICMDescription5":"","bubblePercentageDescription5":"","bubblePreflopDescription5":"","cbetCBetSuccessBoardTexture":"","cbetCBetSuccessPosition":"","cbetHandStrengthwhenCBettting":"","cbetCBetSpotsHeadsUpvsMultiway":"","cbetCBetSpotsInPositionvsOutofPosition":"","cbetResultsSkippedCBet":"","cbetOverallSuccess":"","cbetFlopCBetSuccess":"","cbetCBetWinrate":"","cbetSkippedCBetWinnings":"","cbetActionIP":"","cbetActionOOP":"","cbetNoHandsIP":"","cbetNoHandsOOP":"","hands":"","cbetResultsSkippedDonut1Title":"","cbetResultsSkippedDonutSubtitle":"","cbetResultsSkippedDonut1TitleNoHands":"","cbetResultsSkippedDonut2Title":"","cbetResultsSkippedDonut2TitleNoHands":"","cbetWonLost":"","cbetActionHU":"","cbetActionMultiway":"","cbetActionHUNoHands":"","cbetActionMultiwayNoHands":"","winrateBB100":"","winrate":"","cbetSuccessP":"","leakonomicsWhenUporDownInSession":"","leakonomicsSessionProgress":"","leakonomicsAfterAllinSeries":"","leakonomicsWhenMultitabling":"","leakonomicsVsOpponentbyNoteColor":"","leakonomicsAfterWinningorlosingapot":"","leakonomicsNetWon":"","leakonomicsRollingWindow":"","leakonomicsUpDownSessionNames":"","leakonomicsBestWrt":"","leakonomicsBestWrtAt":"","leakonomicsWinlossSessionNames":"","leakonomicsAllinRate":"","leakonomicsWinningP":"","leakonomicsLosingP":"","leakonomicsBestWrt2":"","leakonomicsBestWrtAt2":"","at":"","leakonomicsWinrateBb100P":"","leakonomicsPotsLost":"","leakonomicsPotsWon":"","leakonomicsPreflopStatsDev":"","leakonomicsAllinSplit":"","leakonomicsAllinWinsInaRow":"","winnings":"","orLess":"","leakonomicsSessionsSplit":"","leakonomicsPotAmountWonbb":"","netWonBb":"","leakonomicsSessionProgressMin":"","leakonomicsSessionProgressSessionNames":"","leakonomicsOpponentNoteColor":"","numberOfTables":"","sessions":"","riverRiverHoleCards":"","riverRiverHandStrength":"","riverRiverAgression":"","riverRiverCallEfficiency":"","riverRiverBetEfficiency":"","riverRiverPotSize":"","wonAtShowdown":"","riverAggression":"","riverCallEff":"","riverBetEff":"","riverWentToShowdown":"","totalHands":"","handFrequencyP":"","riverAsPreflopAggressor":"","riverVsPreflopAggressor":"","riverCheckedToRiver":"","riverHereyoucanfind":"","tip":"","riverCombinethisview":"","riverRiverBetEfficiencyNetWon":"","riverRBE":"","riverCombinethisview2":"","riverMadeRiverCbet":"","riverMadeRiverDonkBet":"","riverSmallriverbets":"","riverBigriverbets":"","riverFacedRiverCbet":"","riverFacedRiverDonkBet":"","riverRiverBet":"","riverRiverCall":"","riverRiverRaise":"","riverRiverFold":"","riverWonHand":"","riverLostHand":"","riverSawShowdown":"","riverNoShowdown":"","riverRiverCallEfficiencyNetWon":"","riverRCE":"","riverCombinethisview3":"","riverHereyoucanfind4":"","riverCombinethisview4":"","riverHereyoucanfind5":"","riverCombinethisview5":"","potSizeFrequencyP":"","riverHereyoucanfind6":"","riverCombinethisview6":"","ipOopTip":"","threebetBetFrequencyTip":"","tourneyallinRaisingCallingByPositionTip":"","riverHandFrequencyTip":"","riverPotSizeFrequencyTip":"","riverCallEfficiencyTip":"","riverBetEfficiencyTip":"","cbetCbetSuccessTip":"","amountBb":"","amountBbPlus":"","amountBb100":"","inPosition":"","outOfPosition":"","overall":"",// HM3 Licensing UI
"backToReleaseNotes":"","backToMyLicense":"","backToCardInfo":"","backToPayment":"","orderBuyNow":"","orderProceed":"","headerTextTrial":"","headerTextFree":"","smallStakes":"","allStakes":"","smallStakesCaps":"","allStakesCaps":"","smallStakesMaintenance":"","allStakesMaintenance":"","buyHoldemSmallStakes":"","buyHoldemAllStakes":"","buyHoldemOmahaAllStakes":"","buyOmahaSmallStakes":"","buyOmahaAllStakes":"","holdemManager":"","holdem":"","omaha":"","hmApps":"","holdemManagerCaps":"","omahaCaps":"","hm3":"","om3":"","hm3andOm3":"","expiredOn":"","expiresOn":"","recommended":"","seeAllOptionsInStore":"","paypalExternalBrowser":"","skrillExternalBrowser":"","selectProduct":"","availableUpdate":"","versionAvailable":"","fullFaq":"","reviewOptions":"","maintenanceOptions":"","addProductToLicense":"","purchasePrice":"","errorName":"","errorAddress":"","errorCountry":"","errorCity":"","errorZip":"","name":"","address":"","city":"","state":"","zip":"","country":"","selectCountry":"","billingInfo":"","buyNowTip":"","licenses":"","version":"","viewReleaseNotes":"","updateAndRenewMaintenance":"","renewGetUpdatesUntil":"","update":"","updateAndSwitchToFree":"","updateAndSwitchToFreeDetails1":"","updateAndSwitchToFreeDetails2":"","updateAndSwitch":"","errorCreditCardDigitsOnly":"","errorCreditCard":"","errorRequired":"","errorCardExpired":"","errorCvv":"","cardInfo":"","cardNo":"","expiry":"","year":"","month":"","month01":"","month02":"","month03":"","month04":"","month05":"","month06":"","month07":"","month08":"","month09":"","month10":"","month11":"","month12":"","cvv":"","active":"","manageSubscription":"","youAreUpToDate":"","releaseNotes":"","netellerInfo":"","netellerSignin":"","continue_":"","netellerAccount":"","netellerPassword":"","orderSummary":"","changeProducts":"","total":"","paypalComplete":"","paypalOpenedInNewBrowser":"","reloadLicense":"","thankYouForPurchase":"","purchaseConfirm1":"","purchaseConfirm2":"","restricted":"","restrictionsWithYourLicense":"","paymentPleaseChoose":"","paymentSelectExisting":"","paymentSelectNew":"","paymentMethod":"","changePaymentMethod":"","licensedTo":"","learnMore":"","startTrial":"","purchase":"","trialSuccessfullyStarted":"","trialSuccessDetails1":"","trialSuccessDetails2":"","trialSuccessDetails3":"","havingTrouble":"","contactUs":"","startUsing":"","missedUpdates":"","updatesAreCritical":"","view":"","oneYearOfUpdates":"","renew":"","startingAt":"","upgrade":"","removesRestrictions1":"","removesRestrictions2":"","removesRestrictions3":"","upgradePrice":"","continueFreemium":"","defaultFatalError":"","restrictCashHandsType":"","restrictTourneyType":"","restrictLimitCashHandsType":"","restrictHudType":"","restrictReportDataType":"","restrictCashHands":"","restrictTourney":"","restrictLimitCashHands":"","restrictHud":"","restrictReportData":"","restrictionUnlimited":"","errorState":"","activeHoldemLicense":"","activeOmahaLicense":"","reinstallOldVersion":"","removesRestrictions3b":"","removesRestrictions4b":"","noActiveHoldemLicense":"","noActiveOmahaLicense":"","free":"","netellerSecureId":"","recurringPriceDescription":"","recurringSubscription":"","positivePrice":"","faq":"","forMoreDetails":"","recurringYear":"","recurringMonth":"","recurringDay":"","restrictionsSmall":"","afterDiscount":"","upgradeDiscount":"","discountExpires":"","discountSinglePurchase":"","errorNetellerAccount":"","errorNetellerSecureId":"","continueTrial":"","continueTrialDaysRemaining":"","netellerInvalidCredentials":"","required":"","paymentSeeWebsite1":"","paymentSeeWebsite2":"","paymentSeeWebsite3":"","paymentOr":"","couldNotStartMlaTitle":"","couldNotStartMlaText":"","restrictionsWithYourLicenseText":"",// 28 oct 2019
"hm3ForFreeDidYouKnow":"","hm3ForFreeStoreCredit":"","hm3ForFreeToward":"","hm3ForFreeAnyProduct":"","hm3ForFreeExclusive":"","hm3ForFreeSeeDetails":"","hm3ForFreeContinueTrial":"","hm3ForFreeContinueFreemium":"","hm3ForFreeSeeAllOffers":"","continueToHm3ForFree":"",// 15 sept 2020
"versionAvailable2":"","hmAppViewOptions":"","hmAppRemoveRestrictions":"","hmAppActive":"","hmAppActiveUpcase":"","hmAppManage":"","hmAppActivate":"","hmAppWatchVideo":"","hmAppFree":"","hmAppApps":"","hmAppActivated":"","hmAppDayTrial":"","hmAppVersion":"","hmAppIncluding":"","hmAppTrial":"","hmAppPrice":"","hmAppVisitWebsite":"","hmAppContactSupport":"","hmAppActiveAppsLicense":"","hmAppNoActiveAppsLicense":"","hmAppBackToHmApps":"","seeAllOptionsInStoreWeb":"","expiredHeaderTextTrial":"","rangeWizardRestrictionsSmall":"","hmAppsAnnualSupport":"","hmAppOrderSummary":"","hmAppNoHmApps":"","hmAppSubscribe":"","hmOrOmahaRenewal":"","renewalRecurringSubscription":"","renewSingle":"","afterRefund":"","monthSingle":"","monthPlural":"","yearSingle":"","yearPlural":"","hmAppOrderSummaryFree":"","daySingle":"","dayPlural":"","prefixMonthSingle":"","prefixYearSingle":"","prefixDaySingle":"","annual":"","monthly":"","asteriskNotecadyIncluded":""},// note: for POEEditor, we need the keys to be enclosed in quotes as well
en:{"hmAppViewOptions":"View Options","hmAppRemoveRestrictions":"Remove Restrictions","hmAppActive":"Active","hmAppActiveUpcase":"ACTIVE","hmAppManage":"Manage","hmAppActivate":"ACTIVATE","hmAppWatchVideo":"Watch Video","hmAppFree":"FREE","hmAppApps":"HM APPS","hmAppActivated":"Activated","hmAppVersion":"version","hmAppDayTrial":"${0}-Day","hmAppIncluding":"Including","hmAppTrial":"Trial","hmAppPrice":"$${0}/${1}","hmAppVisitWebsite":"Visit Website","hmAppContactSupport":"Contact Support","hmAppActiveAppsLicense":"ACTIVE ${0} LICENSE","hmAppNoActiveAppsLicense":"NO ACTIVE ${0} LICENSE","hmAppBackToHmApps":"Back to HM Apps","seeAllOptionsInStoreWeb":"See all options in the store (WEB)","expiredHeaderTextTrial":"Expired Trial","rangeWizardRestrictionsSmall":"NL/PL Cash <b>restricted</b> up to $0.50 big blinds\r\nFL Cash <b>restricted</b> up to $0.50 big blinds\r\nTournaments <b>restricted</b> up to $22.00 buy-ins.","hmAppsAnnualSupport":"Annual Support & Maintenance","hmAppOrderSummary":"${0} will automatically renew every ${1} for the amount of $${2} unless canceled prior to renewal. View ","hmAppNoHmApps":"HM Apps require a paid HM3 license with an active support and maintenance contract. ","hmAppSubscribe":"Subscribe","hmOrOmahaRenewal":"Renew Now","renewalRecurringSubscription":"The annual Support & Maintenance will automatically renew in ${1} (${2}) for $${0}. View","renewSingle":"Renew","afterRefund":"After pro-rated discount of current support & maintenance subscription","monthSingle":"month","monthPlural":"${0} Months","yearSingle":"Year","yearPlural":"${0} Years","hmAppOrderSummaryFree":"${0} is FREE. View ","daySingle":"Day","dayPlural":"${0} Days","prefixMonthSingle":"1 Month","prefixYearSingle":"1 Year","prefixDaySingle":"1 Day","annual":"Annual","monthly":"Monthly","asteriskNotecadyIncluded":"* As a NoteCaddy for HM2 license holder, you will receive 4 months free.",// Replayer
"notAllowedByLicense":"Hand Not Allowed by License","selectHandToExport":"Select Hand To Export","selectFormat":"Select format...","originalFormat":"Original Format","ctrlCToCopy":"Ctrl-C to Copy to Clipboard","availableTags":"Available Tags","welcomeToHm3":"Welcome to the HoldemManager3 Replayer!","theme":"Theme:","deck":"Deck:","showHandResults":"Show Hand Results:","showHeroCards":"Always Show Hero Hole Cards:","showBB":"Show Chips in BB:","combineFolds":"Combine Folds:","maskPlayerNames":"Mask Player Names:","statsUpToTimeOfHand":"Stats Up To Time Of Hand:","showHud":"Show HUD:","replaySpeed":"Replay speed:","hand":"Hand","next100Hands":"Next 100 Hands","prev100Hands":"Prev 100 Hands","addEditHandMarking":"Add/Edit Hand Markings","wonXBB":"Won ${0} BB","lostXBB":"Lost ${0} BB","wonLossNA":"Won/Loss NA","potBB":"Pot: ${0} BB","userWentAllin":"User Went Allin","pot":"Pot: ${0}","potOdds":"Pot Odds: ${0}:1","hhGameStart":"${0} game ${1} begins at ${2}","hhHandNotes":"Hand Note(s)","hhFold":"${0} Folds","hhCheck":"${0} Checks","hhCall":"${0} Calls ${1}","hhBet":"${0} Bets ${1}","hhRaise":"${0} Raises ${1}","hhReturnedTo":"${1} Returned to ${0}","hhWin":"${0} Wins ${1}","hhRake":"Rake: ${0}","hhActionEnded":"Action has ended.","hhMuck":"${0} mucks ${1}","hhShow":"${0} shows ${1}","hhPostSB":"${0} posts small blind","hhPostBB":"${0} posts big blind","hhPostDB":"${0} posts a dead blind","skipEndOfHandLabel":"Skip End Of Hand",// Situational views
"inPosition":"In Position","outOfPosition":"Out Of Position","amountBb":"${0} bb","amountBbPlus":"${0}+ bb","amountBb100":"${0} bb/100","cbetCbetSuccessTip":"Cbet Success: ${0} % <br/>Winrate: ${1} bb/100","riverBetEfficiencyTip":"${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverCallEfficiencyTip":"${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverHandFrequencyTip":"Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100","riverPotSizeFrequencyTip":"Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100","tourneyallinRaisingCallingByPositionTip":"${0} (${1})<br/>Races Won: ${2}","threebetBetFrequencyTip":"3-Bet: ${0} % <br/>Winrate: ${1} bb/100","ipOopTip":"${0}<br/>In Position: ${1}<br/>Out of Position: ${2}","riverHereyoucanfind6":"Here you can find how often and how efficiently you play on the river based on pot size.","riverCombinethisview6":"Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.","potSizeFrequencyP":"Pot Size Frequency (%)","riverHereyoucanfind5":"Here you can find how often and how efficiently you play different hole cards on the river.","riverCombinethisview5":"Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.","riverHereyoucanfind4":"Here you can find how often and how efficiently you play on the river with different hand strengths.","riverCombinethisview4":"Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.","riverRiverCallEfficiencyNetWon":"River Call Efficiency Net Won","riverRCE":"River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.","riverCombinethisview3":"Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.","riverSawShowdown":"Saw Showdown","riverNoShowdown":"No Showdown","riverMadeRiverCbet":"Made River Cbet","riverMadeRiverDonkBet":"Made River Donk Bet","riverSmallriverbets":"Small river bets (<50% pot)","riverBigriverbets":"Big river bets (>100% pot)","riverFacedRiverCbet":"Faced River Cbet","riverFacedRiverDonkBet":"Faced River Donk Bet","riverRiverBet":"River Bet","riverRiverCall":"River Call","riverRiverRaise":"River Raise","riverRiverFold":"River Fold","riverWonHand":"Won Hand","riverLostHand":"Lost Hand","riverRiverBetEfficiencyNetWon":"River Bet Efficiency Net Won","riverRBE":"River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.","riverCombinethisview2":"Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.","riverHereyoucanfind":"Here you can find how aggressively you play on the river and your results for each action played.","tip":"Tip","riverCombinethisview":"Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more","riverAsPreflopAggressor":"As Preflop Aggressor","riverVsPreflopAggressor":"Vs Preflop Aggressor","riverCheckedToRiver":"Checked To River","handFrequencyP":"Hand Frequency (%)","totalHands":"Total Hands","wonAtShowdown":"Won At Showdown","riverAggression":"River Aggression","riverCallEff":"River Call Eff","riverBetEff":"River Bet Eff","riverWentToShowdown":"Went To Showdown","riverRiverHoleCards":"River Hole Cards","riverRiverHandStrength":"River Hand Strength","riverRiverAgression":"River Agression %","riverRiverCallEfficiency":"River Call Efficiency","riverRiverBetEfficiency":"River Bet Efficiency","riverRiverPotSize":"River Pot Size","numberOfTables":"Number Of Tables","sessions":"Sessions","leakonomicsOpponentNoteColor":"Opponent Note Color","leakonomicsSessionProgressSessionNames":"Shorter;Average Session Length;Longer","leakonomicsSessionProgressMin":"Session Progress (Min)","netWonBb":"Net Won (bb)","leakonomicsSessionsSplit":"Sessions Split","leakonomicsPotAmountWonbb":"Pot Amount Won (bb)","orLess":"${0} or less","leakonomicsAllinSplit":"All-in Split","leakonomicsAllinWinsInaRow":"All-in Wins in a Row","winnings":"Winnings","leakonomicsRollingWindow":"Rolling Window Graph","leakonomicsNetWon":"Net Won Up/Down","leakonomicsUpDownSessionNames":"When Down;Neutral;When Up","leakonomicsPreflopStatsDev":"Preflop Stats Dev","leakonomicsBestWrt":"Best wrt: ${0} bb","leakonomicsBestWrtAt":"At ${0} min","leakonomicsWinlossSessionNames":"Loss Series;Neutral;Win Series","leakonomicsAllinRate":"All-in Rate","leakonomicsWinningP":"Winning: ${0}%","leakonomicsLosingP":"Losing: ${0}%","leakonomicsBestWrt2":"Best wrt: ${0} bb/hr","leakonomicsBestWrtAt2":"At ${0} table(s)","at":"At","leakonomicsWinrateBb100P":"Winrate: 5bb/100","leakonomicsPotsLost":"Pots lost: ${0}%","leakonomicsPotsWon":"Pots won: ${0}%","leakonomicsWhenUporDownInSession":"When Up or Down In Session","leakonomicsSessionProgress":"Session Progress","leakonomicsAfterAllinSeries":"After All-in Series","leakonomicsWhenMultitabling":"When Multitabling","leakonomicsVsOpponentbyNoteColor":"Vs Opponent by Note Color","leakonomicsAfterWinningorlosingapot":"After Winning or losing a pot","cbetSuccessP":"CBet Success %","winrate":"Winrate","winrateBB100":"Winrate (bb/100)","cbetActionHU":"CBet action: Heads Up","cbetActionMultiway":"CBet action: Multiway","cbetActionHUNoHands":"Heads Up: No Hands","cbetActionMultiwayNoHands":"Multiway: No Hands","cbetWonLost":"$ Won / Lost","cbetResultsSkippedDonut1Title":"Overall Skipped Cbet","cbetResultsSkippedDonutSubtitle":"Over ${0} Hands<br/>${1} bb/100","cbetResultsSkippedDonut1TitleNoHands":"Overall Skipped Cbet: No Hands","cbetResultsSkippedDonut2Title":"Overall CBet Success","cbetResultsSkippedDonut2TitleNoHands":"Overall Cbet Success: No Hands","hands":"Hands","cbetActionIP":"CBet action: In Position","cbetActionOOP":"CBet action: Out Of Position","cbetNoHandsIP":"In Position: No Hands","cbetNoHandsOOP":"Out Of Position: No Hands","cbetOverallSuccess":"Overall Success","cbetFlopCBetSuccess":"Flop CBet Success","cbetCBetWinrate":"CBet Winrate","cbetSkippedCBetWinnings":"Skipped CBet Winnings","cbetCBetSuccessBoardTexture":"CBet Success: Board Texture","cbetCBetSuccessPosition":"CBet Success: Position","cbetHandStrengthwhenCBettting":"Hand Strength when CBettting","cbetCBetSpotsHeadsUpvsMultiway":"CBet Spots - HeadsUp vs Multiway","cbetCBetSpotsInPositionvsOutofPosition":"CBet Spots - In Position vs Out of Position","cbetResultsSkippedCBet":"Results Skipped CBet","bubbleICMDescription5":"The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.","bubblePercentageDescription5":"Percentage of the prize pool won categorized by your effective stack size","bubblePreflopDescription5":"Your preflop stats categorized on your stack size","bubbleEffectiveStackSizebb":"Effective Stack Size (bb)","bubbleBubbleStackSize":"Bubble Stack Size","bubbleCallingAllInRange":"Calling All-In Range","bubbleSitNGoEntrants":"Sit 'N Go Entrants","bubbleICMDescription4":"The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.","bubblePercentageDescription4":"Percentage of the prize pool won categorized by the number of entrants","bubblePreflopDescription4":"Your preflop stats categorized on your stack size","bubbleBubblePosition":"Bubble Position","bubbleICMDescription3":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.","bubblePercentageDescription3":"Percentage of the prize pool won categorized by your position","bubblePreflopDescription3":"Your preflop stats categorized by your position","bubblePreflopDescription2":"Percentage of the prize pool won categorized by the number players remaining at the bubble","bubblePlayersAtBubble":"# Players At Bubble","bubbleBubblePlayers":"Bubble Players at Bubble","bubblePrizePoolP":"Prize Pool%","bubbleBubbleStage":"Bubble Stage","bubbleEVbb100hands":"EV BB/100 Hands","bubbleICMDescription":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.","bubblePercentageDescription":"Percentage of the prize pool won before, during, and after the bubble","bubblePreflopDescription":"Your preflop stats categorized on your stack size","bubblePrizePoolWon":"Prize Pool Won","bubbleExpectedValue":"Expected Value","bubbleAverageStack":"Average Stack","bubbleCallAIWinrate":"Call AI Winrate","bubbleShoveAIWinrate":"Shove AI Winrate","tooFewHands":"Too Few Hands For This Report","bubblePrizePoolWinningsTitle":"Prize Pool Winnings","bubbleExpectationWhenReachingBubbleTitle":"Expectation When Reaching Bubble","bubblePositionTitle":"Position","bubbleBeforeAndAfterTitle":"Before And After","bubbleStackSizeTitle":"Stack Size","bubbleCallRangesTitle":"Call Ranges","bubbleShoveRangesTitle":"Shove Ranges","tourneyallinRaisingOpenAI":"Raising Open AI","tourneyallinRaising3BetAI":"Raising 3Bet AI","tourneyallinRaisevsOpen":"Raise vs Open","tourneyallinRaisevs3Bet":"Raise vs 3-Bet","tourneyallinCallvsOpen":"Call vs Open","tourneyallinCallvs3Bet":"Call vs 3-Bet","tourneyallinPreflopEffectiveStackSizeAxis":"Preflop Effective Stack Size","tourneyallinRacesWonPAxis":"Races Won %","tourneyallinEquityPAxis":"Equity %","tourneyallinCallingOpenAI":"Calling Open AI","tourneyallinCalling3BetAI":"Calling 3Bet AI","tourneyallinPositionAxis":"Position","tourneyallinExpectationAxis":"Expectation","threebetResultsTitle":"Results","threebetPositionTitle":"Position","threebetRangeTitle":"Three Bet Range","threebetSuccessTitle":"Three Bet Success","threebetFlopHandStrengthTitle":"Flop Hand Strength","threebetWinrate":"3Bet Winrate","threebetFrequency":"3Bet Frequency","threebetRange":"3Bet Range","threebetSuccessRate":"3Bet Success Rate","threebetFlopWinrate":"Flop Winrate","threebetWinrateHandStrengthAxis":"Winrate Hand Strength (bb/100)","threebetHandCount":"${0} (${1} Hands)","threebetWinrateKey":"Winrate","threebetThreeBetPercentKey":"3-Bet %","threebetWinrateAxis":"Winrate (bb/100)","threebetThreeBetPercentAxis":"3-Bet %","threebetSuccessPercentAxis":"Success %","threebetNetwonTitle":"Net Won","threebetNetwonMin":"Loss","threebetNetwonMax":"Profit","threebetDealtFrequencyTitle":"Dealt Frequency","threebetDealtFrequencyMin":"Less Frequent","threebetDealtFrequencyMax":"More Frequent","tourneyallinExpectedWon":"Expected Won","availableStringPositionString":"EP;MP;CO;BTN;SB;BB","availableStringFlopMadeHandValueString":"Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush","availableStringRiverMadeHandValueSummary":"Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush","availableStringFlopFlushTextureTypeAsString":"Flush Rainbow;Flush Two Tone;Flush Monotone","availableStringFlopStraightTextureTypeAsString":"Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper","availableStringFlopPairedTextureTypeAsString":"Paired Board;Not Paired","availableStringInPositionOnFlopShort":"IP;OOP","availableStringInPositionOnFlopLong":"In Position;Out Of Position","availableStringRiverplayCallEfficiency":"Call Efficiency;In Position;Out Of Position","availableStringRiverplayBetEfficiency":"Bet Efficiency;In Position;Out Of Position","availableStringCBetSpots":"Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand","availableStringRiverFirstActionString":"Fold;Check;Call;Bet;Raise","ECCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","ECCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","ECTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","ECTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","ERRaiseCallVsVillainOpenAllinPreflop":"AI PF vs Raise","ERRaiseEVCallVsVillainOpenAllinPreflop":"Expectation AI PF vs Raise","ERTBetCallVsVillainOpenAllinPreflop":"3Bet AI PF vs Re-Raise","ERTBetEVCallVsVillainOpenAllinPreflop":"Expectation 3Bet AI PF vs Re-Raise","BPCCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","BPCCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","BPCTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","BPCTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","BPRRaiseAllinVsRaisePreflop":"AI PF vs Raise","BPRRaiseEVAllinVsRaisePreflop":"Expectation AI PF vs Raise","BPRTBetAllinVsRaisePreflop":"3Bet AI PF vs Re-Raise","BPRTBetEVAllinVsRaisePreflop":"Expectation 3Bet AI PF vs Re-Raise","threebetHandAxis":"Hand","threebetNetBbAxis":"Net BBs","tourneyallinCallingByStackTitle":"Expectation Calling All-In By Stack Size","tourneyallinRaisingByStackTitle":"Expectation Raising All-In By Stack Size","tourneyallinRaisingAllinRangeTitle":"Raising All-In Range","tourneyallinCallingAllinRangeTitle":"Calling All-In Range","tourneyallinCallingAllinByPositionTitle":"Calling All-In Results By Position","tourneyallinRaisingAllinByPositionTitle":"Raising All-In Results By Position","tourneyallinCallAIEVWinrate":"Call AI EV Winrate","tourneyallinRaiseAIEVWinrate":"Raise AI EV Winrate","tourneyallinCallAIWinrate":"Call AI Winrate","tourneyallinRaiseAIWinrate":"Raise AI Winrate","overall":"Overall",// HM3 Licensing UI
"backToReleaseNotes":"Back To Release Notes","backToMyLicense":"Back to My License","backToCardInfo":"Back to Credit Card Info","backToPayment":"Back to Payment Method","orderBuyNow":"Buy Now","orderProceed":"Proceed","headerTextTrial":"Trial (${0} Days Remaining)","headerTextFree":"Free","smallStakes":"Small Stakes","allStakes":"All Stakes","smallStakesCaps":"SMALL STAKES","allStakesCaps":"ALL STAKES","smallStakesMaintenance":"SMALL STAKES MAINTENANCE","allStakesMaintenance":"ALL STAKES MAINTENANCE","buyHoldemSmallStakes":"Holdem Small Stakes","buyHoldemAllStakes":"Holdem All Stakes","buyHoldemOmahaAllStakes":"All Stakes","buyOmahaSmallStakes":"Omaha Small Stakes","buyOmahaAllStakes":"Omaha All Stakes","holdemManager":"Holdem Manager","holdemManagerCaps":"HOLDEM MANAGER","omahaCaps":"OMAHA","holdem":"Holdem","omaha":"Omaha","hmApps":"HM Apps","hm3":"HM3","om3":"OM3","hm3andOm3":"HM3 + OM3","expiredOn":"Expired on ${0}","expiresOn":"Expires on ${0}","recommended":"RECOMMENDED","seeAllOptionsInStore":"See all options in the Store","paypalExternalBrowser":"PayPal will open in an external browser to complete the payment process.","skrillExternalBrowser":"Skrill will load in an external browser to complete the payment process.","selectProduct":"SELECT PRODUCT","availableUpdate":"AVAILABLE UPDATE:","versionAvailable":"Version ${0} is available: ${1}","versionAvailable2":"Version ${0} is available","fullFaq":"Full release notes FAQ","reviewOptions":"Review your Holdem maintenance options before proceeding with the update","maintenanceOptions":"Maintenance Options","addProductToLicense":"ADD ${0} TO YOUR CURRENT LICENSE","purchasePrice":"Purchase (${0})","errorName":"Please enter your Full Name","errorAddress":"Please enter your Street name and number","errorCountry":"Please enter your Country","errorCity":"Please enter your City","errorZip":"Please enter a valid Zip Code","billingInfo":"BILLING INFO","name":"Full Name","address":"Street Address","city":"City","state":"State/Province","zip":"Zip/Postal Code","country":"Country","selectCountry":"Select a country","buyNowTip":"Please select an existing or new payment method before proceeding","licenses":"LICENSES","version":"Version ${0}","viewReleaseNotes":"View release notes on website","updateAndRenewMaintenance":"UPDATE & RENEW MAINTENANCE","renewGetUpdatesUntil":"By renewing maintenance you will receive all HM3 updates through ${0}","update":"Update","updateAndSwitchToFree":"UPDATE & SWITCH TO FREE VERSION","updateAndSwitchToFreeDetails1":"You will receive the update but your HM3 (Holdem) software will revert to Free version and will have","updateAndSwitchToFreeDetails2":"limited functionality","updateAndSwitch":"Update & Switch","errorCreditCardDigitsOnly":"The credit card number should contain digits only.","errorCreditCard":"Please enter a valid card number.","errorRequired":"Required","errorCardExpired":"Card Expired","errorCvv":"CVV should be ${0} digits in length","cardInfo":"CREDIT CARD INFO","cardNo":"Card No","expiry":"Expiry","year":"year","month":"month","month01":"Jan","month02":"Feb","month03":"Mar","month04":"Apr","month05":"May","month06":"Jun","month07":"Jul","month08":"Aug","month09":"Sep","month10":"Oct","month11":"Nov","month12":"Dec","cvv":"CVV","active":"Active","manageSubscription":"Manage Subscription","youAreUpToDate":"You are up to date","releaseNotes":"Release notes for ${0}","netellerInfo":"NETELLER Account Information","netellerSignin":"Sign into your NETELLER account to complete your purchase","continue_":"Continue","netellerAccount":"NETELLER email or Account ID","netellerPassword":"Password","orderSummary":"ORDER SUMMARY:","changeProducts":"Change Product(s)","total":"Total","paypalComplete":"PLEASE COMPLETE YOUR PAYPAL PURCHASE IN YOUR BROWSER","paypalOpenedInNewBrowser":"We have opened PayPal in your default internet browser window. Please login to your PayPal account and complete the purchase. Once the purchase has been completed, return here and click 'Reload License' to load the license that you have purchased.","reloadLicense":"Reload License","thankYouForPurchase":"Thank You For Your Purchase","purchaseConfirm1":"You will receive an email confirmation shortly at ${0}","purchaseConfirm2":"Please click the reload license button below and your purchased license will be active.","restricted":"restricted","restrictionsWithYourLicense":"RESTRICTIONS WITH YOUR CURRENT LICENSE","paymentPleaseChoose":"Please choose a payment method","paymentMethod":"Payment Method:","changePaymentMethod":"Change Payment Method","licensedTo":"LICENSED TO","learnMore":"Learn more","startTrial":"Start Trial","purchase":"Purchase","trialSuccessfullyStarted":"Trial Successfully Started","trialSuccessDetails1":"Your 14 day trial is now active. Please","trialSuccessDetails2":"upgrade","trialSuccessDetails3":" as soon as possible to avoid interruptions to your service.","havingTrouble":"Having trouble?","contactUs":"Contact Us","startUsing":"Start using HM3 Now","missedUpdates":"${0} missed updates","updatesAreCritical":"Updates are critical to ensuring that HM3 continues to import your hand histories after poker sites make changes to their software. New features and functionalities are also released through updates.","view":"View","oneYearOfUpdates":"Includes ${0} of updates","renew":"Renew (${0})","startingAt":"Starting At","upgrade":"Upgrade","removesRestrictions1":"Removes","removesRestrictions2":"restrictions","removesRestrictions3":" and includes ${0} of updates","upgradePrice":"Upgrade (${0})","required":"Required","continueFreemium":"Continue Free Version","defaultFatalError":"An unexpected internal server error has occurred and an administrator has been notified. Please try purchasing again later.","restrictCashHandsType":"Cash Hands","restrictTourneyType":"Tournament","restrictLimitCashHandsType":"Limit Cash Hands","restrictHudType":"HUD","restrictReportDataType":"Report Data","restrictCashHands":"$ ${0} and below","restrictLimitCashHands":"$ ${0} and below","restrictTourney":"Max ${0}","restrictHud":"Max ${0} Table(s)","restrictReportData":"Last ${0} Hands","restrictionUnlimited":"Unlimited","errorState":"Required","activeHoldemLicense":"ACTIVE HOLDEM LICENSE","activeOmahaLicense":"ACTIVE OMAHA LICENSE","reinstallOldVersion":"Reinstall Old Version","removesRestrictions3b":"and reverts back to your paid license but updates are","removesRestrictions4b":"NOT INCLUDED","noActiveHoldemLicense":"NO ACTIVE HOLDEM LICENSE","noActiveOmahaLicense":"NO ACTIVE OMAHA LICENSE","free":"FREE","netellerSecureId":"Your NETELLER Secure ID","recurringPriceDescription":"${0} Included*","recurringYear":"Year","recurringMonth":"Month","recurringDay":"Day","restrictionsSmall":"No Limit/Pot Limit Cash <b>restricted</b> up to $0.50 big blinds\r\nFixed Limit Cash <b>restricted</b> up to $1.00 big blinds\r\nTournaments <b>restricted</b> up to $22.00 buy-ins.","afterDiscount":"Price after limited time discount","upgradeDiscount":"UPGRADE DISCOUNT","discountSinglePurchase":"Discount applies to a single purchase.","errorNetellerAccount":"Invalid Neteller Account ID","errorNetellerSecureId":"Please enter your 6-digit Secure ID","continueTrial":"Continue Trial","continueTrialDaysRemaining":"(${0} Days Remaining)","netellerInvalidCredentials":"We could not validate your Neteller credentials. Please try logging in again.","faq":"FAQ","forMoreDetails":" for more details on managing your annual Support & Maintenance renewal.","recurringSubscription":"* Payment method is required for the annual Support & Maintenance renewal of $${0} which will be billed in ${1} (${2}). View","positivePrice":"* The annual Support & Maintenance renewal of $${0} will be billed in ${1} (${2}). View","paymentSeeWebsite1":"See","paymentSeeWebsite2":"STORE","paymentSeeWebsite3":" for other payment options","paymentSelectExisting":"Select existing payment method:","paymentSelectNew":"Add new payment method:","paymentOr":"- OR -","discountExpires":"Discount Expires on ${0}","couldNotStartMlaTitle":"We encountered a problem","couldNotStartMlaText":"Could Not Start My Licenses. An Administrator has been notified. Please check again later. If the problem persists, please contact our support.","restrictionsWithYourLicenseText":"<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration",// 28 oct 2019
"hm3ForFreeDidYouKnow":"Did you know you could get HM3 for FREE!","hm3ForFreeStoreCredit":"CREDIT","hm3ForFreeToward":"toward","hm3ForFreeAnyProduct":"ANY Hold'em Manager product","hm3ForFreeExclusive":"Exclusive Offer From","hm3ForFreeSeeDetails":"See Offer Details","hm3ForFreeContinueTrial":"Continue To Trial Version","hm3ForFreeContinueFreemium":"Continue To Free Version","hm3ForFreeSeeAllOffers":"See all \"Get It Free\" offers in our store","continueToHm3ForFree":"Continue"},chinese:{"notAllowedByLicense":"许可证不允许的手牌","selectHandToExport":"选择手牌并导出","selectFormat":"选择格式……","originalFormat":"原始格式","ctrlCToCopy":"Ctrl-C，复制到剪切板","availableTags":"可用标签","welcomeToHm3":"欢迎来到HoldemManager3回放器！","theme":"主题:","deck":"一副扑克牌:","showHandResults":"显示手牌结果:","showHeroCards":"一直显示前手底牌:","showBB":"显示大盲位上的筹码:","combineFolds":"综合弃牌:","maskPlayerNames":"隐藏玩家姓名:","statsUpToTimeOfHand":"统计值达到了手牌时间：","showHud":"显示HUD：","replaySpeed":"回放速度：","hand":"手牌","next100Hands":"下100张手牌","prev100Hands":"前100张手牌","addEditHandMarking":"添加/编辑手牌标记","wonXBB":"赢得${0}大盲注","lostXBB":"损失${0}大盲注","wonLossNA":"赢得/损失NA","potBB":"彩池：${0}大盲注","userWentAllin":"用户押上了全部赌注","pot":"彩池：${0}","potOdds":"彩池概率：${0}:1","hhGameStart":"${0}游戏${1}开始于${2}","hhHandNotes":"手牌记录","hhFold":"${0}弃牌","hhCheck":"${0}看牌","hhCall":"${0} 跟注 ${1}","hhBet":"${0} 下注 ${1}","hhRaise":"${0} 加注 ${1}","hhReturnedTo":"${1}回报${0}","hhWin":"${0}赢得${1}","hhRake":"佣金：${0}","hhActionEnded":"操作已结束。","hhMuck":"${0}盖牌 ${1}","hhShow":"${0}显示 ${1}","hhPostSB":"${0}发布小盲注","hhPostBB":"${0}发布大盲注","hhPostDB":"${0}发布死盲注","backToReleaseNotes":"返回发行说明","backToMyLicense":"返回我的许可证","backToCardInfo":"返回信用卡信息","backToPayment":"返回支付方式","orderBuyNow":"立即购买","orderProceed":"继续","headerTextTrial":"试用（还有${0}天）","headerTextFree":"免费","smallStakes":"小额赌注","allStakes":"全部赌注","smallStakesCaps":"小额赌注","allStakesCaps":"全部赌注","smallStakesMaintenance":"小额赌注维护","allStakesMaintenance":"全部赌注维护","buyHoldemSmallStakes":"德州扑克小额赌注","buyHoldemAllStakes":"德州扑克全部赌注","buyHoldemOmahaAllStakes":"全部赌注","buyOmahaSmallStakes":"奥马哈扑克小额赌注","buyOmahaAllStakes":"奥马哈扑克全部赌注","holdemManager":"Holdem Manager","holdemManagerCaps":"HOLDEM MANAGER","omahaCaps":"奥马哈扑克","holdem":"德州扑克","omaha":"奥马哈扑克","hmApps":"HM应用","hm3":"HM3","om3":"OM3","hm3andOm3":"HM3 + OM3","expiredOn":"于${0}到期","expiresOn":"于 ${0}到期","recommended":"推荐","seeAllOptionsInStore":"查看商店所有选项","paypalExternalBrowser":"PayPal将在外部浏览器中打开，完成支付过程。","skrillExternalBrowser":"Skrill将在外部浏览器中加载，完成支付过程。","selectProduct":"选择产品","availableUpdate":"可用更新：","versionAvailable":"版本${0} 可用： ${1}","fullFaq":"完整发行说明常见问答","reviewOptions":"在继续进行升级前，请查看您的德州扑克维护选项","maintenanceOptions":"维护选项","addProductToLicense":"将 ${0} 添加到您当前的许可证","purchasePrice":"购买(${0})","errorName":"请输入您的完整姓名","errorAddress":"请输入您的街道名和编号","errorCountry":"请输入您的国家","errorCity":"请输入您的城市","errorZip":"请输入有效邮编","billingInfo":"账单信息","name":"完整姓名","address":"街道地址","city":"城市","state":"州/省","zip":"邮编","country":"国家","selectCountry":"选择一个国家","buyNowTip":"在继续之前，请选择现有的或新的支付方式","licenses":"许可证","version":"版本 ${0}","viewReleaseNotes":"查看网站上的发行说明","updateAndRenewMaintenance":"升级与更新维护","renewGetUpdatesUntil":"通过更新维护，您将获得通过${0}完成的全部HM3升级","update":"升级","updateAndSwitchToFree":"升级并切换到免费版","updateAndSwitchToFreeDetails1":"您将得以升级，但是您的HM3（德州扑克）软件将转为免费版并将有","updateAndSwitchToFreeDetails2":"功能有限","updateAndSwitch":"升级与切换","errorCreditCardDigitsOnly":"信用卡号应只包含数字。","errorCreditCard":"请输入有效的信用卡号。","errorRequired":"需要","errorCardExpired":"卡已过期","errorCvv":"CVV长度应为{0}个数字","cardInfo":"信用卡信息","cardNo":"卡号","expiry":"有效期","year":"年","month":"月","month01":"一月","month02":"二月","month03":"三月","month04":"四月","month05":"五月","month06":"六月","month07":"七月","month08":"八月","month09":"九月","month10":"十月","month11":"十一月","month12":"十二月","cvv":"CVV","active":"有效","manageSubscription":"管理订阅","youAreUpToDate":"您的版本是最新版本","releaseNotes":"${0}发行说明","netellerInfo":"NETELLER账户信息","netellerSignin":"登录您的NETELLER账户，完成购买","continue_":"继续","netellerAccount":"NETELLER账户","netellerPassword":"密码","orderSummary":"订单汇总：","changeProducts":"更换产品","total":"总计","paypalComplete":"请在您的浏览器中完成您的PAYPAL购买","paypalOpenedInNewBrowser":"我们在您的默认网络浏览器窗口中打开了 PayPal。请登录您的 PayPal账户，完成本次购买。购买完成后，请返回到这里，点击‘重新加载许可证’，加载已购买的许可证。","reloadLicense":"重新加载许可证","thankYouForPurchase":"感谢您的购买","purchaseConfirm1":"您很快将在${0}收到一封确认邮件。","purchaseConfirm2":"请点击下方的重新加载许可证按钮，您购买的许可证将激活。","restricted":"有限制的","restrictionsWithYourLicense":"当前许可证的限制","paymentPleaseChoose":"请选择一种支付方式","paymentSelectExisting":"选择现有的支付方式：","paymentSelectNew":"添加新的支付方式：","paymentMethod":"支付方式：","changePaymentMethod":"变更支付方式","licensedTo":"授权给","learnMore":"了解更多","startTrial":"开始试用","purchase":"购买","trialSuccessfullyStarted":"成功开始试用","trialSuccessDetails1":"您的14天试用现在已激活。请","trialSuccessDetails2":"升级","trialSuccessDetails3":" 尽早完成，避免打断您的服务。","havingTrouble":"遇到问题？","contactUs":"联系我们","startUsing":"立即开始使用HM3","missedUpdates":"${0}错过了升级","updatesAreCritical":"扑克网站更改软件后，要保证HM3持续导入您的手牌历史，升级至关重要。通过升级还发布了全新的特征和功能。","view":"查看","oneYearOfUpdates":"包括一年的升级","renew":"更新(${0})\n","startingAt":"启动时间","upgrade":"升级","removesRestrictions1":"移除","removesRestrictions2":"限制","removesRestrictions3":" 并包括一年的升级","upgradePrice":"升级(${0})","required":"需要","continueFreemium":"继续使用免费版本","defaultFatalError":"内部服务器出现意外错误，已通知管理员。请稍后再次尝试购买。","restrictCashHandsType":"现金手牌","restrictTourneyType":"锦标赛","restrictLimitCashHandsType":"限制现金手牌","restrictHudType":"HUD","restrictReportDataType":"报告数据","restrictCashHands":"$ ${0}及以下","restrictLimitCashHands":"$ ${0}及以下","restrictTourney":"最多${0}","restrictHud":"最多${0} 张牌桌","restrictReportData":"最后${0}手牌","restrictionUnlimited":"不限","errorState":"需要","activeHoldemLicense":"有效的德州扑克许可证","activeOmahaLicense":"有效的奥马哈扑克许可证","reinstallOldVersion":"重新安装旧版","removesRestrictions3b":"返回到您已支付的许可证，但是升级是","removesRestrictions4b":"不包含","noActiveHoldemLicense":"没有有效的德州扑克许可证","noActiveOmahaLicense":"没有有效的奥马哈扑克许可证","free":"免费","netellerSecureId":"安全ID","recurringPriceDescription":"包括${0} ${1}*","recurringYear":"年","recurringMonth":"月","recurringDay":"日","restrictionsSmall":"无限注/底池限注现金 <b>限制</b>为$0.50大盲注 有限注现金<b>限制</b>为 $1.00大盲注 锦标赛<b>限制</b>为$22.00买入。","afterDiscount":"限时折扣后的价格","upgradeDiscount":"升级折扣","discountExpires":"折扣将于${0}到期","discountSinglePurchase":"折扣适用于单次购买。","errorNetellerAccount":"无效的Neteller账户ID","errorNetellerSecureId":"请输入您的6位数安全ID","continueTrial":"继续试用","continueTrialDaysRemaining":"（还剩下${0}天）","netellerInvalidCredentials":"我们无法验证您的Neteller凭证。请尝试再次登录。","faq":"常见问答","forMoreDetails":" 了解更多关于管理您年度支持与维护更新的详情。","recurringSubscription":"*$${0}的年度支持与维护更新（将在一年 (${1})后入账）需要支付方式。查看","positivePrice":"$${0}的年度支持与维护更新将在一年 (${1})后入账。查看","paymentSeeWebsite1":"查看","paymentSeeWebsite2":"商店","paymentSeeWebsite3":" 了解其他支付选项","paymentOr":"- 或者 -","couldNotStartMlaTitle":"我们遇到了一个问题","couldNotStartMlaText":"无法启用我的许可证。已通知管理员。请稍后查看。如果问题仍然存在，请联系我们的帮助人员。","skipEndOfHandLabel":"Skip End Of Hand","inPosition":"In Position","outOfPosition":"Out Of Position","amountBb":"${0} bb","amountBbPlus":"${0}+ bb","amountBb100":"${0} bb/100","cbetCbetSuccessTip":"Cbet Success: ${0} % <br/>Winrate: ${1} bb/100","riverBetEfficiencyTip":"${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverCallEfficiencyTip":"${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverHandFrequencyTip":"Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100","riverPotSizeFrequencyTip":"Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100","tourneyallinRaisingCallingByPositionTip":"${0} (${1})<br/>Races Won: ${2}","threebetBetFrequencyTip":"3-Bet: ${0} % <br/>Winrate: ${1} bb/100","ipOopTip":"${0}<br/>In Position: ${1}<br/>Out of Position: ${2}","riverHereyoucanfind6":"Here you can find how often and how efficiently you play on the river based on pot size.","riverCombinethisview6":"Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.","potSizeFrequencyP":"Pot Size Frequency (%)","riverHereyoucanfind5":"Here you can find how often and how efficiently you play different hole cards on the river.","riverCombinethisview5":"Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.","riverHereyoucanfind4":"Here you can find how often and how efficiently you play on the river with different hand strengths.","riverCombinethisview4":"Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.","riverRiverCallEfficiencyNetWon":"River Call Efficiency Net Won","riverRCE":"River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.","riverCombinethisview3":"Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.","riverSawShowdown":"Saw Showdown","riverNoShowdown":"No Showdown","riverMadeRiverCbet":"Made River Cbet","riverMadeRiverDonkBet":"Made River Donk Bet","riverSmallriverbets":"Small river bets (<50% pot)","riverBigriverbets":"Big river bets (>100% pot)","riverFacedRiverCbet":"Faced River Cbet","riverFacedRiverDonkBet":"Faced River Donk Bet","riverRiverBet":"River Bet","riverRiverCall":"River Call","riverRiverRaise":"River Raise","riverRiverFold":"River Fold","riverWonHand":"Won Hand","riverLostHand":"Lost Hand","riverRiverBetEfficiencyNetWon":"River Bet Efficiency Net Won","riverRBE":"River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.","riverCombinethisview2":"Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.","riverHereyoucanfind":"Here you can find how aggressively you play on the river and your results for each action played.","tip":"Tip","riverCombinethisview":"Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more","riverAsPreflopAggressor":"As Preflop Aggressor","riverVsPreflopAggressor":"Vs Preflop Aggressor","riverCheckedToRiver":"Checked To River","handFrequencyP":"Hand Frequency (%)","totalHands":"Total Hands","wonAtShowdown":"Won At Showdown","riverAggression":"River Aggression","riverCallEff":"River Call Eff","riverBetEff":"River Bet Eff","riverWentToShowdown":"Went To Showdown","riverRiverHoleCards":"River Hole Cards","riverRiverHandStrength":"River Hand Strength","riverRiverAgression":"River Agression %","riverRiverCallEfficiency":"River Call Efficiency","riverRiverBetEfficiency":"River Bet Efficiency","riverRiverPotSize":"River Pot Size","numberOfTables":"Number Of Tables","sessions":"Sessions","leakonomicsOpponentNoteColor":"Opponent Note Color","leakonomicsSessionProgressSessionNames":"Shorter;Average Session Length;Longer","leakonomicsSessionProgressMin":"Session Progress (Min)","netWonBb":"Net Won (bb)","leakonomicsSessionsSplit":"Sessions Split","leakonomicsPotAmountWonbb":"Pot Amount Won (bb)","orLess":"${0} or less","leakonomicsAllinSplit":"All-in Split","leakonomicsAllinWinsInaRow":"All-in Wins in a Row","winnings":"Winnings","leakonomicsRollingWindow":"Rolling Window Graph","leakonomicsNetWon":"Net Won Up/Down","leakonomicsUpDownSessionNames":"When Down;Neutral;When Up","leakonomicsPreflopStatsDev":"Preflop Stats Dev","leakonomicsBestWrt":"Best wrt: ${0} bb","leakonomicsBestWrtAt":"At ${0} min","leakonomicsWinlossSessionNames":"Loss Series;Neutral;Win Series","leakonomicsAllinRate":"All-in Rate","leakonomicsWinningP":"Winning: ${0}%","leakonomicsLosingP":"Losing: ${0}%","leakonomicsBestWrt2":"Best wrt: ${0} bb/hr","leakonomicsBestWrtAt2":"At ${0} table(s)","at":"At","leakonomicsWinrateBb100P":"Winrate: 5bb/100","leakonomicsPotsLost":"Pots lost: ${0}%","leakonomicsPotsWon":"Pots won: ${0}%","leakonomicsWhenUporDownInSession":"When Up or Down In Session","leakonomicsSessionProgress":"Session Progress","leakonomicsAfterAllinSeries":"After All-in Series","leakonomicsWhenMultitabling":"When Multitabling","leakonomicsVsOpponentbyNoteColor":"Vs Opponent by Note Color","leakonomicsAfterWinningorlosingapot":"After Winning or losing a pot","cbetSuccessP":"CBet Success %","winrate":"Winrate","winrateBB100":"Winrate (bb/100)","cbetActionHU":"CBet action: Heads Up","cbetActionMultiway":"CBet action: Multiway","cbetActionHUNoHands":"Heads Up: No Hands","cbetActionMultiwayNoHands":"Multiway: No Hands","cbetWonLost":"$ Won / Lost","cbetResultsSkippedDonut1Title":"Overall Skipped Cbet","cbetResultsSkippedDonutSubtitle":"Over ${0} Hands<br/>${1} bb/100","cbetResultsSkippedDonut1TitleNoHands":"Overall Skipped Cbet: No Hands","cbetResultsSkippedDonut2Title":"Overall CBet Success","cbetResultsSkippedDonut2TitleNoHands":"Overall Cbet Success: No Hands","hands":"Hands","cbetActionIP":"CBet action: In Position","cbetActionOOP":"CBet action: Out Of Position","cbetNoHandsIP":"In Position: No Hands","cbetNoHandsOOP":"Out Of Position: No Hands","cbetOverallSuccess":"Overall Success","cbetFlopCBetSuccess":"Flop CBet Success","cbetCBetWinrate":"CBet Winrate","cbetSkippedCBetWinnings":"Skipped CBet Winnings","cbetCBetSuccessBoardTexture":"CBet Success: Board Texture","cbetCBetSuccessPosition":"CBet Success: Position","cbetHandStrengthwhenCBettting":"Hand Strength when CBettting","cbetCBetSpotsHeadsUpvsMultiway":"CBet Spots - HeadsUp vs Multiway","cbetCBetSpotsInPositionvsOutofPosition":"CBet Spots - In Position vs Out of Position","cbetResultsSkippedCBet":"Results Skipped CBet","bubbleICMDescription5":"The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.","bubblePercentageDescription5":"Percentage of the prize pool won categorized by your effective stack size","bubblePreflopDescription5":"Your preflop stats categorized on your stack size","bubbleEffectiveStackSizebb":"Effective Stack Size (bb)","bubbleBubbleStackSize":"Bubble Stack Size","bubbleCallingAllInRange":"Calling All-In Range","bubbleSitNGoEntrants":"Sit 'N Go Entrants","bubbleICMDescription4":"The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.","bubblePercentageDescription4":"Percentage of the prize pool won categorized by the number of entrants","bubblePreflopDescription4":"Your preflop stats categorized on your stack size","bubbleBubblePosition":"Bubble Position","bubbleICMDescription3":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.","bubblePercentageDescription3":"Percentage of the prize pool won categorized by your position","bubblePreflopDescription3":"Your preflop stats categorized by your position","bubblePreflopDescription2":"Percentage of the prize pool won categorized by the number players remaining at the bubble","bubblePlayersAtBubble":"# Players At Bubble","bubbleBubblePlayers":"Bubble Players at Bubble","bubblePrizePoolP":"Prize Pool%","bubbleBubbleStage":"Bubble Stage","bubbleEVbb100hands":"EV BB/100 Hands","bubbleICMDescription":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.","bubblePercentageDescription":"Percentage of the prize pool won before, during, and after the bubble","bubblePreflopDescription":"Your preflop stats categorized on your stack size","bubblePrizePoolWon":"Prize Pool Won","bubbleExpectedValue":"Expected Value","bubbleAverageStack":"Average Stack","bubbleCallAIWinrate":"Call AI Winrate","bubbleShoveAIWinrate":"Shove AI Winrate","tooFewHands":"Too Few Hands For This Report","bubblePrizePoolWinningsTitle":"Prize Pool Winnings","bubbleExpectationWhenReachingBubbleTitle":"Expectation When Reaching Bubble","bubblePositionTitle":"Position","bubbleBeforeAndAfterTitle":"Before And After","bubbleStackSizeTitle":"Stack Size","bubbleCallRangesTitle":"Call Ranges","bubbleShoveRangesTitle":"Shove Ranges","tourneyallinRaisingOpenAI":"Raising Open AI","tourneyallinRaising3BetAI":"Raising 3Bet AI","tourneyallinRaisevsOpen":"Raise vs Open","tourneyallinRaisevs3Bet":"Raise vs 3-Bet","tourneyallinCallvsOpen":"Call vs Open","tourneyallinCallvs3Bet":"Call vs 3-Bet","tourneyallinPreflopEffectiveStackSizeAxis":"Preflop Effective Stack Size","tourneyallinRacesWonPAxis":"Races Won %","tourneyallinEquityPAxis":"Equity %","tourneyallinCallingOpenAI":"Calling Open AI","tourneyallinCalling3BetAI":"Calling 3Bet AI","tourneyallinPositionAxis":"Position","tourneyallinExpectationAxis":"Expectation","threebetResultsTitle":"Results","threebetPositionTitle":"Position","threebetRangeTitle":"Three Bet Range","threebetSuccessTitle":"Three Bet Success","threebetFlopHandStrengthTitle":"Flop Hand Strength","threebetWinrate":"3Bet Winrate","threebetFrequency":"3Bet Frequency","threebetRange":"3Bet Range","threebetSuccessRate":"3Bet Success Rate","threebetFlopWinrate":"Flop Winrate","threebetWinrateHandStrengthAxis":"Winrate Hand Strength (bb/100)","threebetHandCount":"${0} (${1} Hands)","threebetWinrateKey":"Winrate","threebetThreeBetPercentKey":"3-Bet %","threebetWinrateAxis":"Winrate (bb/100)","threebetThreeBetPercentAxis":"3-Bet %","threebetSuccessPercentAxis":"Success %","threebetNetwonTitle":"Net Won","threebetNetwonMin":"Loss","threebetNetwonMax":"Profit","threebetDealtFrequencyTitle":"Dealt Frequency","threebetDealtFrequencyMin":"Less Frequent","threebetDealtFrequencyMax":"More Frequent","tourneyallinExpectedWon":"Expected Won","availableStringPositionString":"EP;MP;CO;BTN;SB;BB","availableStringFlopMadeHandValueString":"Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush","availableStringRiverMadeHandValueSummary":"Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush","availableStringFlopFlushTextureTypeAsString":"Flush Rainbow;Flush Two Tone;Flush Monotone","availableStringFlopStraightTextureTypeAsString":"Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper","availableStringFlopPairedTextureTypeAsString":"Paired Board;Not Paired","availableStringInPositionOnFlopShort":"IP;OOP","availableStringInPositionOnFlopLong":"In Position;Out Of Position","availableStringRiverplayCallEfficiency":"Call Efficiency;In Position;Out Of Position","availableStringRiverplayBetEfficiency":"Bet Efficiency;In Position;Out Of Position","availableStringCBetSpots":"Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand","availableStringRiverFirstActionString":"Fold;Check;Call;Bet;Raise","ECCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","ECCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","ECTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","ECTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","ERRaiseCallVsVillainOpenAllinPreflop":"AI PF vs Raise","ERRaiseEVCallVsVillainOpenAllinPreflop":"Expectation AI PF vs Raise","ERTBetCallVsVillainOpenAllinPreflop":"3Bet AI PF vs Re-Raise","ERTBetEVCallVsVillainOpenAllinPreflop":"Expectation 3Bet AI PF vs Re-Raise","BPCCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","BPCCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","BPCTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","BPCTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","BPRRaiseAllinVsRaisePreflop":"AI PF vs Raise","BPRRaiseEVAllinVsRaisePreflop":"Expectation AI PF vs Raise","BPRTBetAllinVsRaisePreflop":"3Bet AI PF vs Re-Raise","BPRTBetEVAllinVsRaisePreflop":"Expectation 3Bet AI PF vs Re-Raise","threebetHandAxis":"Hand","threebetNetBbAxis":"Net BBs","tourneyallinCallingByStackTitle":"Expectation Calling All-In By Stack Size","tourneyallinRaisingByStackTitle":"Expectation Raising All-In By Stack Size","tourneyallinRaisingAllinRangeTitle":"Raising All-In Range","tourneyallinCallingAllinRangeTitle":"Calling All-In Range","tourneyallinCallingAllinByPositionTitle":"Calling All-In Results By Position","tourneyallinRaisingAllinByPositionTitle":"Raising All-In Results By Position","tourneyallinCallAIEVWinrate":"Call AI EV Winrate","tourneyallinRaiseAIEVWinrate":"Raise AI EV Winrate","tourneyallinCallAIWinrate":"Call AI Winrate","tourneyallinRaiseAIWinrate":"Raise AI Winrate","overall":"Overall","restrictionsWithYourLicenseText":"<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"},french:{"notAllowedByLicense":"Main non autorisée par la licence","selectHandToExport":"Sélectionnez la main pour l'exporter","selectFormat":"Sélectionnez le format...","originalFormat":"Format d'origine","ctrlCToCopy":"Faites CTRL + C  pour copier dans le presse-papier","availableTags":"Tags disponibles","welcomeToHm3":"Bienvenue sur le dispositif de rediffusion de Holdem Manager3 !","theme":"Thème : ","deck":"Jeu : ","showHandResults":"Montrez les résultats pour la.les main.s :","showHeroCards":"Toujours montrer les cartes cachées ou fermées (\"Hole Cards\")","showBB":"Afficher les jetons en Grande blinde (BB) :","combineFolds":"Combiner les couchers (\"Folds\") : ","maskPlayerNames":"Masquer le nom des joueurs :","statsUpToTimeOfHand":"Les stats jusqu'à l'heure de la main :","showHud":"Montrer l'affichage tête haute (HUD) :","replaySpeed":"Remontrer la vitesse :","hand":"Main","next100Hands":"Les 100 prochaines mains","prev100Hands":"Les 100 mains précédentes","addEditHandMarking":"Ajouter/modifier les marquages de main","wonXBB":"A gagné ${0} en  BB","lostXBB":"A perdu ${0} en  BB","wonLossNA":"Gain/perte en NA","potBB":"Cagnotte: ${0} en BB","userWentAllin":"L'utilisateur a misé tous ses jetons sur le tapis","pot":"Cagnotte: ${0}","potOdds":"Cote de la cagnotte : ${0} : 1","hhGameStart":"${0} partie ${1} commence à $ {2}","hhHandNotes":"Note(s) sur la.les main.s","hhFold":"Couchers ${0}","hhCheck":"Paroles (\"checks\") ${0}","hhCall":"${0} Calls ${1}","hhBet":"${0} Mises ${1}","hhRaise":"${0} Hausses ${1}","hhReturnedTo":"${1} retour à  ${0}","hhWin":"${0} rapporte.nt ${1}","hhRake":"Commission: ${0}","hhActionEnded":"L'action est terminée.","hhMuck":"${0} mains face cachée ${1}","hhShow":"${0} montre.nt ${1}","hhPostSB":"${0} publie une petite blinde (SB)","hhPostBB":" $ {0} publie une grosse blinde (BB)","hhPostDB":"${0} publie une blinde morte (\"Dead Blind\")","backToReleaseNotes":"Retour à l'affichage des notes","backToMyLicense":"Retour à ma licence","backToCardInfo":"Retour aux coordonnées de CB","backToPayment":"Retour au moyen de paiement","orderBuyNow":"Acheter tout de suite","orderProceed":"Continuer","headerTextTrial":"Période d'essai (${0} jours restants)","headerTextFree":"Gratuit.e","smallStakes":"Petites mises","allStakes":"Toutes les mises","smallStakesCaps":"PETITES MISES","allStakesCaps":"TOUTES LES MISES","smallStakesMaintenance":"MAINTENANCE DES PETITES MISES EN COURS","allStakesMaintenance":"MAINTENANCE DE TOUTES LES MISES EN COURS","buyHoldemSmallStakes":"Petites mises Holdem","buyHoldemAllStakes":"Toutes les mises Holdem","buyHoldemOmahaAllStakes":"Toutes les mises","buyOmahaSmallStakes":"Petites mises Omaha","buyOmahaAllStakes":"Toutes les mises Omaha","holdemManager":"Holdem Manager","holdemManagerCaps":"HOLDEM MANAGER","omahaCaps":"OMAHA","holdem":"Holdem","omaha":"Omaha","hmApps":"Applis HM","hm3":"HM3","om3":"OM3","hm3andOm3":"HM3 + OM3","expiredOn":"Est arrivé.e à échéance le ${0}","expiresOn":"Arrivera à échéance le ${0}","recommended":"RECOMMANDÉ.E.S","seeAllOptionsInStore":"Voir toutes les possibilités dans la boutique","paypalExternalBrowser":"Paypal est sur le point d'ouvrir une nouvelle fenêtre pour finaliser votre règlement.","skrillExternalBrowser":"Skrill est sur le point d'ouvrir une nouvelle fenêtre pour finaliser votre règlement.","selectProduct":"SÉLECTIONNEZ VOTRE PRODUIT","availableUpdate":"MISE À JOUR DE LA DISPONIBILITÉ:","versionAvailable":"La version ${0} est disponible : ${1}","fullFaq":"Foire aux questions complète sur les notes de publication","reviewOptions":"Consultez vos options de maintenance Holdem avant de procéder à la mise à jour.","maintenanceOptions":"Options de maintenance","addProductToLicense":"AJOUTEZ ${0} À VOTRE LICENCE ACTUELLE","purchasePrice":"Achat (${0})","errorName":"Veuillez saisir votre nom complet.","errorAddress":"Veuillez saisir le nom de votre rue et le numéro.","errorCountry":"Veuillez saisir votre pays.","errorCity":"Veuillez saisir votre ville.","errorZip":"Veuillez saisir un code postal valide.","billingInfo":"COORDONN\x0E\xC9ES DE FACTURATION","name":"Nom complet","address":"Adresse postale","city":"Ville","state":"État/province","zip":"Code postal","country":"Pays","selectCountry":"Sélectionnez un pays.","buyNowTip":"Veuillez sélectionner le mode de paiement actuel ou souhaité avant de continuer.","licenses":"LICENCES","version":"Version ${0}","viewReleaseNotes":"Affichez les notes de publication de la version sur le site Internet","updateAndRenewMaintenance":"METTRE À JOUR ET RENOUVELER LA MAINTENANCE","renewGetUpdatesUntil":"En acceptant de renouveler la maintenance, vous recevrez toutes les mises à jour HM3 par le biais de ${0}","update":"Mettre à jour","updateAndSwitchToFree":"METTRE À JOUR ET PASSER À LA VERSION GRATUITE","updateAndSwitchToFreeDetails1":"Vous recevrez la mise à jour, mais votre logiciel MH3 (Holdem) passera de nouveau  à la version gratuite et vous ne disposerez plus que de","updateAndSwitchToFreeDetails2":"fonctions limitées.","updateAndSwitch":"Mettre à jour et commuter","errorCreditCardDigitsOnly":"Le numéro de votre carte de paiement ne doit comporter que des chiffres.","errorCreditCard":"Veuillez saisir un numéro de carte de paiement valable.","errorRequired":"Champ obligatoire","errorCardExpired":"Votre carte n'est plus valable.","errorCvv":"Le CVV ne doit comporter que ${0} chiffres.","cardInfo":"COORDONNÉES DE LA CARTE DE PAIEMENT","cardNo":"Carte N°","expiry":"Date d'échéance","year":"année","month":"mois","month01":"janvier","month02":"février","month03":"mars","month04":"avril","month05":"mai","month06":"juin","month07":"juillet","month08":"août","month09":"septembre","month10":"octobre","month11":"novembre","month12":"décembre","cvv":"CVV","active":"Activé.e","manageSubscription":"Gérer mon abonnement","youAreUpToDate":"Vous êtes à jour.","releaseNotes":"Notes de publication pour ${0}","netellerInfo":"Coordonnées du compte NETELLER","netellerSignin":"Connectez-vous à votre compte NETTELLER pour terminer votre achat.","continue_":"Continuer","netellerAccount":"Compte Neteller","netellerPassword":"Mot de passe","orderSummary":"RÉCAPITULATIF DE LA COMMANDE :","changeProducts":"Remplacer un.des produit.s","total":"Total","paypalComplete":"VEUILLEZ PROCÉDER À VOTRE ACHAT SUR PAYPAL DANS LA FENÊTRE À CET EFFET","paypalOpenedInNewBrowser":"Nous avons ouvert Paypal dans la fenêtre de votre navigateur Internet par défaut. Veuillez vous connecter à votre compte Paypal pour finaliser l'achat. Une fois que celui-ci sera terminé, revenez sur cette page, puis cliquez sur \"Télécharger de nouveau la licence\" pour acquérir la licence que vous aurez réglée.\n","reloadLicense":"Télécharger de nouveau la licence","thankYouForPurchase":"Nous vous remercions de votre achat.","purchaseConfirm1":"Vous recevrez prochainement un courriel de confirmation à l'adresse ${0}.","purchaseConfirm2":"Veuillez cliquer sur le bouton du nouveau téléchargement de licence, afin d'activer la licence achetée.","restricted":"Accès restreint","restrictionsWithYourLicense":"LES RESTRICTIONS S'APPLIQUANT À VOTRE LICENCE ACTUELLE","paymentPleaseChoose":"Veuillez choisir un moyen de paiement.","paymentSelectExisting":"Sélectionnez votre moyen de paiement actuel.","paymentSelectNew":"Moyen de paiement","paymentMethod":"Moyen de paiement :","changePaymentMethod":"Changer de moyen de paiement","licensedTo":"LICENCE D\xC9LIVR\xC9E \x12\xC0","learnMore":"En savoir plus","startTrial":"Commencer la période d'essai","purchase":"Acheter","trialSuccessfullyStarted":"Début de la période d'essai confirmé","trialSuccessDetails1":"Votre période d'essai de 14 jours vient d'être activée. Veuillez","trialSuccessDetails2":"passer à une inscription payante","trialSuccessDetails3":"dès que possible, afin d'éviter la suspension de nos prestations.","havingTrouble":"Vous éprouvez des difficultés pour effectuer les opérations nécessaires?","contactUs":"Contactez nous","startUsing":"Commencez à profiter de HM3 dès maintenant.","missedUpdates":"${0} mises à jour manquées","updatesAreCritical":"Les mises à jour sont primordiales pour vous assurer que la plateforme MH3 ne s'est pas arrêtée d'importer les historiques de vos mains après que les sites de poker en ligne ont apporté des modifications à leur logiciels. Les nouveautés relatives aux fonctionnalités sont également mises en service grâce aux mises à jour.","view":"Afficher","oneYearOfUpdates":"L'achat comprend les mises à jour sur une année.","renew":"Renouveler (${0})","startingAt":"À partir de","upgrade":"Le passage à une inscription payante","removesRestrictions1":"supprime","removesRestrictions2":"les restrictions d'accès","removesRestrictions3":"et comprend également les mises à jour sur une année.","upgradePrice":"Passer à une inscription payante  (${0})","required":"Champ obligatoire","continueFreemium":"Continuer à me servir de la version gratuite","defaultFatalError":"Une erreur inattendue de notre serveur interne s'est produite : un administrateur en a été averti.","restrictCashHandsType":"Me faire régler les mains","restrictTourneyType":"Tournoi","restrictLimitCashHandsType":"Limiter les mains pouvant être réglées","restrictHudType":"Affichage tête haute (HUD)","restrictReportDataType":"Signaler ces données","restrictCashHands":"$ ${0} et en deçà","restrictLimitCashHands":"$ ${0} et en deçà","restrictTourney":"${0} au maximum","restrictHud":"Nombre de table.s maximum ${0}","restrictReportData":"${0} dernières mains ","restrictionUnlimited":"Illimité","errorState":"Champ obligatoire","activeHoldemLicense":"LICENCE HOLDEM ACTIVÉE","activeOmahaLicense":"LICENCE OMAHA ACTIVÉE","reinstallOldVersion":"Réinstaller l'ancienne version","removesRestrictions3b":"et retournez à votre licence payante, mais les mises à jour ne sont ","removesRestrictions4b":"PAS COMPRISES.","noActiveHoldemLicense":"AUCUNE LICENCE HOLDEM N'EST ACTIVÉE.","noActiveOmahaLicense":"AUCUNE LICENCE OMAHA N'EST ACTIVÉE.","free":"GRATUITE","netellerSecureId":"Identification sécurisée","recurringPriceDescription":"${0} ${1} sont compris.es*","recurringYear":"Année","recurringMonth":"Mois","recurringDay":"Jour","restrictionsSmall":"L'illimité/Paiement limité de la cagnotte <b>restreint</b> jusqu'aux 0.50 $ en\nBB  \nPaiement limité fixe <b>restreint</b> jusqu'à 1.00 $ en BB.\nTournois <b>restreints</b> jusqu'à $22.00 en niveaux supplémentaires.","afterDiscount":"Le tarif après la réduction courant sur une période limitée","upgradeDiscount":"SUPPRIMER LA RÉDUCTION","discountExpires":"La réduction prendra fin le ${0}","discountSinglePurchase":"La réduction ne peut porter que sur un seul achat.","errorNetellerAccount":"Numéro de compte Netteler non valable","errorNetellerSecureId":"Veuillez saisir votre numéro d'identification sécurisée à 6 chiffres.","continueTrial":"Souhaite poursuivre la préiode d'essai","continueTrialDaysRemaining":"(${0} jours restants)","netellerInvalidCredentials":"Nous n'avons pas été en mesure de valider vos coordonnées Neteller. Veuillez tenter à nouveau de vous reconnecter . ","faq":"Foire aux questions","forMoreDetails":" pour une information complète relative à la gestion du renouvellement de votre abonnement à l'assistance technique et à la maintenance. ","recurringSubscription":"* Le moyen de paiement enregistré sert pour le renouvellement annuel de l'abonnement à l'assistance technique et à la maintenance s'élevant à ${0} $, et qui vous sera facturé dans un an (${1}). Afficher","positivePrice":"L'abonnement à l'assistance technique et à la maintenance s'élevant à ${0} $, et qui vous sera facturé dans un an (${1}). Afficher","paymentSeeWebsite1":"Voir","paymentSeeWebsite2":"BOUTIQUE","paymentSeeWebsite3":" pour d'autres possibilités de paiement","paymentOr":"- OU -","couldNotStartMlaTitle":"Nous avons rencontré un problème","couldNotStartMlaText":"Impossible de démarrer Mes Licences. Un administrateur a été prévenu. Veuillez réessayer plus tard. Si le problème persiste, veuillez contacter notre support.","skipEndOfHandLabel":"Skip End Of Hand","inPosition":"In Position","outOfPosition":"Out Of Position","amountBb":"${0} bb","amountBbPlus":"${0}+ bb","amountBb100":"${0} bb/100","cbetCbetSuccessTip":"Cbet Success: ${0} % <br/>Winrate: ${1} bb/100","riverBetEfficiencyTip":"${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverCallEfficiencyTip":"${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverHandFrequencyTip":"Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100","riverPotSizeFrequencyTip":"Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100","tourneyallinRaisingCallingByPositionTip":"${0} (${1})<br/>Races Won: ${2}","threebetBetFrequencyTip":"3-Bet: ${0} % <br/>Winrate: ${1} bb/100","ipOopTip":"${0}<br/>In Position: ${1}<br/>Out of Position: ${2}","riverHereyoucanfind6":"Here you can find how often and how efficiently you play on the river based on pot size.","riverCombinethisview6":"Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.","potSizeFrequencyP":"Pot Size Frequency (%)","riverHereyoucanfind5":"Here you can find how often and how efficiently you play different hole cards on the river.","riverCombinethisview5":"Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.","riverHereyoucanfind4":"Here you can find how often and how efficiently you play on the river with different hand strengths.","riverCombinethisview4":"Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.","riverRiverCallEfficiencyNetWon":"River Call Efficiency Net Won","riverRCE":"River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.","riverCombinethisview3":"Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.","riverSawShowdown":"Saw Showdown","riverNoShowdown":"No Showdown","riverMadeRiverCbet":"Made River Cbet","riverMadeRiverDonkBet":"Made River Donk Bet","riverSmallriverbets":"Small river bets (<50% pot)","riverBigriverbets":"Big river bets (>100% pot)","riverFacedRiverCbet":"Faced River Cbet","riverFacedRiverDonkBet":"Faced River Donk Bet","riverRiverBet":"River Bet","riverRiverCall":"River Call","riverRiverRaise":"River Raise","riverRiverFold":"River Fold","riverWonHand":"Won Hand","riverLostHand":"Lost Hand","riverRiverBetEfficiencyNetWon":"River Bet Efficiency Net Won","riverRBE":"River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.","riverCombinethisview2":"Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.","riverHereyoucanfind":"Here you can find how aggressively you play on the river and your results for each action played.","tip":"Tip","riverCombinethisview":"Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more","riverAsPreflopAggressor":"As Preflop Aggressor","riverVsPreflopAggressor":"Vs Preflop Aggressor","riverCheckedToRiver":"Checked To River","handFrequencyP":"Hand Frequency (%)","totalHands":"Total Hands","wonAtShowdown":"Won At Showdown","riverAggression":"River Aggression","riverCallEff":"River Call Eff","riverBetEff":"River Bet Eff","riverWentToShowdown":"Went To Showdown","riverRiverHoleCards":"River Hole Cards","riverRiverHandStrength":"River Hand Strength","riverRiverAgression":"River Agression %","riverRiverCallEfficiency":"River Call Efficiency","riverRiverBetEfficiency":"River Bet Efficiency","riverRiverPotSize":"River Pot Size","numberOfTables":"Number Of Tables","sessions":"Sessions","leakonomicsOpponentNoteColor":"Opponent Note Color","leakonomicsSessionProgressSessionNames":"Shorter;Average Session Length;Longer","leakonomicsSessionProgressMin":"Session Progress (Min)","netWonBb":"Net Won (bb)","leakonomicsSessionsSplit":"Sessions Split","leakonomicsPotAmountWonbb":"Pot Amount Won (bb)","orLess":"${0} or less","leakonomicsAllinSplit":"All-in Split","leakonomicsAllinWinsInaRow":"All-in Wins in a Row","winnings":"Winnings","leakonomicsRollingWindow":"Rolling Window Graph","leakonomicsNetWon":"Net Won Up/Down","leakonomicsUpDownSessionNames":"When Down;Neutral;When Up","leakonomicsPreflopStatsDev":"Preflop Stats Dev","leakonomicsBestWrt":"Best wrt: ${0} bb","leakonomicsBestWrtAt":"At ${0} min","leakonomicsWinlossSessionNames":"Loss Series;Neutral;Win Series","leakonomicsAllinRate":"All-in Rate","leakonomicsWinningP":"Winning: ${0}%","leakonomicsLosingP":"Losing: ${0}%","leakonomicsBestWrt2":"Best wrt: ${0} bb/hr","leakonomicsBestWrtAt2":"At ${0} table(s)","at":"At","leakonomicsWinrateBb100P":"Winrate: 5bb/100","leakonomicsPotsLost":"Pots lost: ${0}%","leakonomicsPotsWon":"Pots won: ${0}%","leakonomicsWhenUporDownInSession":"When Up or Down In Session","leakonomicsSessionProgress":"Session Progress","leakonomicsAfterAllinSeries":"After All-in Series","leakonomicsWhenMultitabling":"When Multitabling","leakonomicsVsOpponentbyNoteColor":"Vs Opponent by Note Color","leakonomicsAfterWinningorlosingapot":"After Winning or losing a pot","cbetSuccessP":"CBet Success %","winrate":"Winrate","winrateBB100":"Winrate (bb/100)","cbetActionHU":"CBet action: Heads Up","cbetActionMultiway":"CBet action: Multiway","cbetActionHUNoHands":"Heads Up: No Hands","cbetActionMultiwayNoHands":"Multiway: No Hands","cbetWonLost":"$ Won / Lost","cbetResultsSkippedDonut1Title":"Overall Skipped Cbet","cbetResultsSkippedDonutSubtitle":"Over ${0} Hands<br/>${1} bb/100","cbetResultsSkippedDonut1TitleNoHands":"Overall Skipped Cbet: No Hands","cbetResultsSkippedDonut2Title":"Overall CBet Success","cbetResultsSkippedDonut2TitleNoHands":"Overall Cbet Success: No Hands","hands":"Hands","cbetActionIP":"CBet action: In Position","cbetActionOOP":"CBet action: Out Of Position","cbetNoHandsIP":"In Position: No Hands","cbetNoHandsOOP":"Out Of Position: No Hands","cbetOverallSuccess":"Overall Success","cbetFlopCBetSuccess":"Flop CBet Success","cbetCBetWinrate":"CBet Winrate","cbetSkippedCBetWinnings":"Skipped CBet Winnings","cbetCBetSuccessBoardTexture":"CBet Success: Board Texture","cbetCBetSuccessPosition":"CBet Success: Position","cbetHandStrengthwhenCBettting":"Hand Strength when CBettting","cbetCBetSpotsHeadsUpvsMultiway":"CBet Spots - HeadsUp vs Multiway","cbetCBetSpotsInPositionvsOutofPosition":"CBet Spots - In Position vs Out of Position","cbetResultsSkippedCBet":"Results Skipped CBet","bubbleICMDescription5":"The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.","bubblePercentageDescription5":"Percentage of the prize pool won categorized by your effective stack size","bubblePreflopDescription5":"Your preflop stats categorized on your stack size","bubbleEffectiveStackSizebb":"Effective Stack Size (bb)","bubbleBubbleStackSize":"Bubble Stack Size","bubbleCallingAllInRange":"Calling All-In Range","bubbleSitNGoEntrants":"Sit 'N Go Entrants","bubbleICMDescription4":"The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.","bubblePercentageDescription4":"Percentage of the prize pool won categorized by the number of entrants","bubblePreflopDescription4":"Your preflop stats categorized on your stack size","bubbleBubblePosition":"Bubble Position","bubbleICMDescription3":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.","bubblePercentageDescription3":"Percentage of the prize pool won categorized by your position","bubblePreflopDescription3":"Your preflop stats categorized by your position","bubblePreflopDescription2":"Percentage of the prize pool won categorized by the number players remaining at the bubble","bubblePlayersAtBubble":"# Players At Bubble","bubbleBubblePlayers":"Bubble Players at Bubble","bubblePrizePoolP":"Prize Pool%","bubbleBubbleStage":"Bubble Stage","bubbleEVbb100hands":"EV BB/100 Hands","bubbleICMDescription":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.","bubblePercentageDescription":"Percentage of the prize pool won before, during, and after the bubble","bubblePreflopDescription":"Your preflop stats categorized on your stack size","bubblePrizePoolWon":"Prize Pool Won","bubbleExpectedValue":"Expected Value","bubbleAverageStack":"Average Stack","bubbleCallAIWinrate":"Call AI Winrate","bubbleShoveAIWinrate":"Shove AI Winrate","tooFewHands":"Too Few Hands For This Report","bubblePrizePoolWinningsTitle":"Prize Pool Winnings","bubbleExpectationWhenReachingBubbleTitle":"Expectation When Reaching Bubble","bubblePositionTitle":"Position","bubbleBeforeAndAfterTitle":"Before And After","bubbleStackSizeTitle":"Stack Size","bubbleCallRangesTitle":"Call Ranges","bubbleShoveRangesTitle":"Shove Ranges","tourneyallinRaisingOpenAI":"Raising Open AI","tourneyallinRaising3BetAI":"Raising 3Bet AI","tourneyallinRaisevsOpen":"Raise vs Open","tourneyallinRaisevs3Bet":"Raise vs 3-Bet","tourneyallinCallvsOpen":"Call vs Open","tourneyallinCallvs3Bet":"Call vs 3-Bet","tourneyallinPreflopEffectiveStackSizeAxis":"Preflop Effective Stack Size","tourneyallinRacesWonPAxis":"Races Won %","tourneyallinEquityPAxis":"Equity %","tourneyallinCallingOpenAI":"Calling Open AI","tourneyallinCalling3BetAI":"Calling 3Bet AI","tourneyallinPositionAxis":"Position","tourneyallinExpectationAxis":"Expectation","threebetResultsTitle":"Results","threebetPositionTitle":"Position","threebetRangeTitle":"Three Bet Range","threebetSuccessTitle":"Three Bet Success","threebetFlopHandStrengthTitle":"Flop Hand Strength","threebetWinrate":"3Bet Winrate","threebetFrequency":"3Bet Frequency","threebetRange":"3Bet Range","threebetSuccessRate":"3Bet Success Rate","threebetFlopWinrate":"Flop Winrate","threebetWinrateHandStrengthAxis":"Winrate Hand Strength (bb/100)","threebetHandCount":"${0} (${1} Hands)","threebetWinrateKey":"Winrate","threebetThreeBetPercentKey":"3-Bet %","threebetWinrateAxis":"Winrate (bb/100)","threebetThreeBetPercentAxis":"3-Bet %","threebetSuccessPercentAxis":"Success %","threebetNetwonTitle":"Net Won","threebetNetwonMin":"Loss","threebetNetwonMax":"Profit","threebetDealtFrequencyTitle":"Dealt Frequency","threebetDealtFrequencyMin":"Less Frequent","threebetDealtFrequencyMax":"More Frequent","tourneyallinExpectedWon":"Expected Won","availableStringPositionString":"EP;MP;CO;BTN;SB;BB","availableStringFlopMadeHandValueString":"Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush","availableStringRiverMadeHandValueSummary":"Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush","availableStringFlopFlushTextureTypeAsString":"Flush Rainbow;Flush Two Tone;Flush Monotone","availableStringFlopStraightTextureTypeAsString":"Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper","availableStringFlopPairedTextureTypeAsString":"Paired Board;Not Paired","availableStringInPositionOnFlopShort":"IP;OOP","availableStringInPositionOnFlopLong":"In Position;Out Of Position","availableStringRiverplayCallEfficiency":"Call Efficiency;In Position;Out Of Position","availableStringRiverplayBetEfficiency":"Bet Efficiency;In Position;Out Of Position","availableStringCBetSpots":"Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand","availableStringRiverFirstActionString":"Fold;Check;Call;Bet;Raise","ECCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","ECCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","ECTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","ECTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","ERRaiseCallVsVillainOpenAllinPreflop":"AI PF vs Raise","ERRaiseEVCallVsVillainOpenAllinPreflop":"Expectation AI PF vs Raise","ERTBetCallVsVillainOpenAllinPreflop":"3Bet AI PF vs Re-Raise","ERTBetEVCallVsVillainOpenAllinPreflop":"Expectation 3Bet AI PF vs Re-Raise","BPCCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","BPCCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","BPCTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","BPCTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","BPRRaiseAllinVsRaisePreflop":"AI PF vs Raise","BPRRaiseEVAllinVsRaisePreflop":"Expectation AI PF vs Raise","BPRTBetAllinVsRaisePreflop":"3Bet AI PF vs Re-Raise","BPRTBetEVAllinVsRaisePreflop":"Expectation 3Bet AI PF vs Re-Raise","threebetHandAxis":"Hand","threebetNetBbAxis":"Net BBs","tourneyallinCallingByStackTitle":"Expectation Calling All-In By Stack Size","tourneyallinRaisingByStackTitle":"Expectation Raising All-In By Stack Size","tourneyallinRaisingAllinRangeTitle":"Raising All-In Range","tourneyallinCallingAllinRangeTitle":"Calling All-In Range","tourneyallinCallingAllinByPositionTitle":"Calling All-In Results By Position","tourneyallinRaisingAllinByPositionTitle":"Raising All-In Results By Position","tourneyallinCallAIEVWinrate":"Call AI EV Winrate","tourneyallinRaiseAIEVWinrate":"Raise AI EV Winrate","tourneyallinCallAIWinrate":"Call AI Winrate","tourneyallinRaiseAIWinrate":"Raise AI Winrate","overall":"Overall","restrictionsWithYourLicenseText":"<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"},german:{"notAllowedByLicense":"Lizenz erlaubt Hand nicht","selectHandToExport":"Wähle Hand für Export","selectFormat":"Wähle Format","originalFormat":"Originalformat","ctrlCToCopy":"Strg-C zum Kopieren in die Zwischenablage","availableTags":"Verfügbare Tags","welcomeToHm3":"Willkommen zum HoldemManager3 Replayer!","theme":"Thema: ","deck":"Deck: ","showHandResults":"Zeige Hand Resultat: ","showHeroCards":"Zeige Heros Hole Cards immer: ","showBB":"Zeige Chips in BB: ","combineFolds":"Kombiniere Folds: ","maskPlayerNames":"Maskiere Spieler Namen: ","statsUpToTimeOfHand":"Statistiken bis zur Zeit der Hand: ","showHud":"Zeige Hud: ","replaySpeed":"Replayer Geschwindigkeit: ","hand":"Hand","next100Hands":"Nächste 100 Hände","prev100Hands":"Vorherige 100 Hände","addEditHandMarking":"Hinzufügen/Bearbeiten von Hand Markierungen","wonXBB":"Gewonnen ${0} BB","lostXBB":"Verloren ${0} BB","wonLossNA":"Gewonnen/Verloren NA","potBB":"Pot ${0} BB","userWentAllin":"Benutzer ging Allin","pot":"Pot ${0}","potOdds":"Pot Odds: ${0}:1","hhGameStart":"${0} Spiel ${1} beginnt um ${2}","hhHandNotes":"Hand Notiz(en)","hhFold":"${0} foldet","hhCheck":"${0} checkt","hhCall":"${0} callt ${1}","hhBet":"${0} bettet ${1}","hhRaise":"${0} raist ${1}","hhReturnedTo":"${1} zurück zu ${0}","hhWin":"${0} gewinnt ${1}","hhRake":"Rake: ${0}","hhActionEnded":"Aktion ist beendet","hhMuck":"${0} muckt ${1}","hhShow":"${0} zeigt ${1}","hhPostSB":"${0} postet Small Blind","hhPostBB":"${0} postet Big Blind","hhPostDB":"${0} postet einen Dead Blind","backToReleaseNotes":"Zurück zu den Release Notes","backToMyLicense":"Zurück zu meiner Lizenz","backToCardInfo":"Zurück zu Kreditkarten Info","backToPayment":"Zurück zu Zahlungsmethoden","orderBuyNow":"Jetzt kaufen","orderProceed":"Weiter","headerTextTrial":"Trial (${0} Tage verbleibend)","headerTextFree":"Frei","smallStakes":"Small Stakes","allStakes":"Alle Stakes","smallStakesCaps":"SMALL STAKES","allStakesCaps":"ALLE STAKES","smallStakesMaintenance":"SMALL STAKES WARTUNG","allStakesMaintenance":"ALLE STAKES WARTUNG","buyHoldemSmallStakes":"Holdem Small Stakes","buyHoldemAllStakes":"Holdem alle Stakes","buyHoldemOmahaAllStakes":"Alle Stakes","buyOmahaSmallStakes":"Omaha Small Stakes","buyOmahaAllStakes":"Omaha alle Stakes","holdemManager":"Holdem Manager","holdemManagerCaps":"HOLDEM MANAGER","omahaCaps":"OMAHA","holdem":"Holdem","omaha":"Omaha","hmApps":"HM Appś","hm3":"HM3","om3":"OM3","hm3andOm3":"HM3 + OM3","expiredOn":"Abgelaufen am ${0}","expiresOn":"Läuft ab am ${0}","recommended":"EMPFOHLEN","seeAllOptionsInStore":"Zeige alle Optionen im Store","paypalExternalBrowser":"PayPal wird in einem externen Browser geöffnet um den Zahlungsprozess abzuschließen","skrillExternalBrowser":"Skrill wird in einem externen Browser geöffnet um den Zahlungsprozess abzuschließen","selectProduct":"WÄHLE PRODUKT","availableUpdate":"VERFÜGBARES UPDATE: ","versionAvailable":"Version ${0} ist verfügbar: ${1}","fullFaq":"Komplette Release Notes FAQ","reviewOptions":"Prüfe deine Holdem Wartungsoptionen bevor du mit dem Update weiter machst","maintenanceOptions":"Wartungsoptionen","addProductToLicense":"FÜGE ${0} ZU DEINER AKTUELLEN LIZENZ","purchasePrice":"Kauf (${0})","errorName":"Bitte gib deinen vollständigen Namen ein","errorAddress":"Bitte gib Straße und Hausnummer ein","errorCountry":"Bitte gib dein Land ein","errorCity":"Bitte gib deinen Wohnort ein","errorZip":"Bitte gib eine gültige Postleitzahl ein","billingInfo":"RECHNUNGSINFO","name":"Voller Name","address":"Straße","city":"Stadt","state":"Bundesland","zip":"Postleitzahl","country":"Land","selectCountry":"Wähle ein Land","buyNowTip":"Bitte wähle vor dem Weitermachen eine vorhandene oder neue Zahlungsmethode aus","licenses":"LIZENZEN","version":"Version ${0}","viewReleaseNotes":"Zeige die Release Notes auf der Webseite","updateAndRenewMaintenance":"UPDATE & ERNEUERUNG WARTUNG","renewGetUpdatesUntil":"Durch die Erneuerung der Wartung bekommst du alle HM3 Updates durch ${0}","update":"Update","updateAndSwitchToFree":"UPDATE & UMSTELLEN ZUR FREIEN VERSION","updateAndSwitchToFreeDetails1":"Du erhältst das Update aber deine HM3 (Holdem) Software wird umgestellt auf die freie Version und bekommt","updateAndSwitchToFreeDetails2":"Eingeschränkte Funktionalität","updateAndSwitch":"Update & Umstellung","errorCreditCardDigitsOnly":"Die Kreditkartennummer sollte nur Zahlen enthalten.","errorCreditCard":"Bitte gib eine gültige Kartennummer ein.","errorRequired":"Erforderlich","errorCardExpired":"Karte abgelaufen","errorCvv":"CVV sollte eine Länge von ${0} haben","cardInfo":"KREDITKARTEN INFO","cardNo":"Kartennr","expiry":"Ablaufdatum","year":"Jahr","month":"Monat","month01":"Jan","month02":"Feb","month03":"Mär","month04":"Apr","month05":"Mai","month06":"Jun","month07":"Jul","month08":"Aug","month09":"Sep","month10":"Okt","month11":"Nov","month12":"Dez","cvv":"CVV","active":"Aktiv","manageSubscription":"Verwalte Abonnements","youAreUpToDate":"Du bist auf dem aktuellen Stand","releaseNotes":"Release Notes für ${0}","netellerInfo":"Neteller Konto Informationen","netellerSignin":"Melde dich in deinem Neteller Konto an um den Kauf abzuschließen","continue_":"Weiter","netellerAccount":"Neteller Konto","netellerPassword":"Passwort","orderSummary":"BESTELLZUSAMMENFASSUNG: ","changeProducts":"Produkt(e) ändern","total":"Gesamt","paypalComplete":"BITTE VERVOLLSTÄNDIGE DEINEN PAYPAL KAUF IN DEINEM BROWSER","paypalOpenedInNewBrowser":"Wir haben PayPal in deinem Default Internet Browser geöffnet. Bitte melde dich in deinem PayPal Konto an und vervollständige den Kauf. Sobald der Kauf abgeschlossen ist, kehre hierher zurück und klicke 'Lade Lizenz neu' um die gekaufte Lizenz zu laden.","reloadLicense":"Lade Lizenz neu","thankYouForPurchase":"Vielen Dank für den Kauf","purchaseConfirm1":"Du erhältst in Kürze eine Bestätigung per Email an ${0}","purchaseConfirm2":"Bitte klicke den Lade Lizenz neu Button unten und deine gekaufte Lizenz wird aktiviert.","restricted":"eingeschränkt","restrictionsWithYourLicense":"EINSCHRÄNKUNGEN DEINER AKTUELLEN LIZENZ","paymentPleaseChoose":"Bitte wähle eine Zahlungsmethode","paymentSelectExisting":"Wähle vorhandene Zahlungsmethode: ","paymentSelectNew":"Zahlungsmethode","paymentMethod":"Zahlungsmethode: ","changePaymentMethod":"Ändere Zahlungsmethode","licensedTo":"LIZENSIERT FÜR","learnMore":"Erfahre mehr","startTrial":"Starte Trial","purchase":"Kauf","trialSuccessfullyStarted":"Trial erfolgreich gestartet","trialSuccessDetails1":"Deine 14 Tage Trial ist jetzt aktiv. Bitte ","trialSuccessDetails2":"Upgrade","trialSuccessDetails3":" sobald wie möglich um Unterbrechungen deiner Dienste zu vermeiden.","havingTrouble":"Du hast Probleme? ","contactUs":"Kontaktiere uns","startUsing":"Starte jetzt HM3","missedUpdates":"${0} fehlende Updates","updatesAreCritical":"Updates sind wichtig um sicherzustellen, dass HM3 weiter Hände importieren kann nachdem Pokerseiten Änderungen an ihrer Software vorgenommen haben. Neue Features und Funktionalitäten werden ebenfalls durch Updates veröffentlicht.","view":"Zeige","oneYearOfUpdates":"inklusive 1 Jahr Updates","renew":"Erneuere (${0})","startingAt":"Starte um","upgrade":"Upgrade","removesRestrictions1":"Entfernt ","removesRestrictions2":"Einschränkungen","removesRestrictions3":" und enthält ein Jahr Updates","upgradePrice":"Upgrade (${0})","required":"Erforderlich","continueFreemium":"mit freier Version weitermachen","defaultFatalError":"Ein unerwarteter interner Serverfehler ist aufgetreten und ein Administrator wurde benachrichtigt. Bitte versuch es später nochmal.","restrictCashHandsType":"Cash Hände","restrictTourneyType":"Turnier","restrictLimitCashHandsType":"Limit Cash Hände","restrictHudType":"HUD","restrictReportDataType":"Report Daten","restrictCashHands":"$ ${0} und darunter","restrictLimitCashHands":"$ ${0} und darunter","restrictTourney":"Max ${0}","restrictHud":"Max ${0} Tisch(e)","restrictReportData":"Letzte ${0} Hände","restrictionUnlimited":"Unbegrenzt","errorState":"Erforderlich","activeHoldemLicense":"AKTIVE HOLDEM LIZENZ","activeOmahaLicense":"AKTIVE OMAHA LIZENZ","reinstallOldVersion":"Installiere alte Version wieder","removesRestrictions3b":"und kehre zu deiner bezahlten Lizenz zurück aber Updates werden","removesRestrictions4b":"NICHT ENTHALTEN","noActiveHoldemLicense":"KEINE AKTIVE HOLDEM LIZENZ","noActiveOmahaLicense":"KEINE AKTIVE OMAHA LIZENZ","free":"FREI","netellerSecureId":"Secure ID","recurringPriceDescription":"${0} ${1} enthalten*","recurringYear":"Jahr","recurringMonth":"Monat","recurringDay":"Tag","restrictionsSmall":"No Limit/Pot Limit Cash <b>eingeschränkt</b> bis zu $0.50 big blinds\nFixed Limit Cash <b>eingeschränkt</b> bis zu $1.00 big blinds\nTournaments <b>eingeschränkt</b> bis zu $22.00 buy-ins.","afterDiscount":"Preis nach zeitlich begrenztem Nachlass ","upgradeDiscount":"UPGRADE NACHLASS","discountExpires":"Nachlass läuft am ${0} ab","discountSinglePurchase":"Nachlass gültig für einzelnen Kauf","errorNetellerAccount":"Ungültige Neteller Konto ID","errorNetellerSecureId":"Bitte gib deine 6-stellige Secure ID ein","continueTrial":"Weiter mit Trial","continueTrialDaysRemaining":"(${0} Tage verbleibend)","netellerInvalidCredentials":"Wir konnten deine Neteller Anmeldedaten nicht überprüfen. Bitte versuch dich nochmal anzumelden.","faq":"FAQ","forMoreDetails":" für weitere Details zur Verwaltung deiner jährliche Support & Wartungs Verlängerung.","recurringSubscription":"* Eine Zahlungsmethode ist erforderlich für die jährliche Support & Wartungs Verlängerung von $${0}. Dies wird in einem Jahr (${1}) berechnet.\nZeige ","positivePrice":"Die jährliche Support & Wartungs Verlängerung von $${0} wird in einem Jahr (${1}) berechnet. Zeige ","paymentSeeWebsite1":"Zeige ","paymentSeeWebsite2":"STORE","paymentSeeWebsite3":" für weitere Zahlungsoptionen","paymentOr":"- ODER -","couldNotStartMlaTitle":"Wir haben ein Problem entdeckt","couldNotStartMlaText":"Konnte Meine Lizenzen nicht starten. Ein Administrator wurde informiert. Bitte versuche es später nochmal. Wenn das Problem weiterhin besteht, kontaktiere bitte unseren Support.","skipEndOfHandLabel":"Skip End Of Hand","inPosition":"In Position","outOfPosition":"Out Of Position","amountBb":"${0} bb","amountBbPlus":"${0}+ bb","amountBb100":"${0} bb/100","cbetCbetSuccessTip":"Cbet Success: ${0} % <br/>Winrate: ${1} bb/100","riverBetEfficiencyTip":"${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverCallEfficiencyTip":"${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverHandFrequencyTip":"Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100","riverPotSizeFrequencyTip":"Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100","tourneyallinRaisingCallingByPositionTip":"${0} (${1})<br/>Races Won: ${2}","threebetBetFrequencyTip":"3-Bet: ${0} % <br/>Winrate: ${1} bb/100","ipOopTip":"${0}<br/>In Position: ${1}<br/>Out of Position: ${2}","riverHereyoucanfind6":"Here you can find how often and how efficiently you play on the river based on pot size.","riverCombinethisview6":"Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.","potSizeFrequencyP":"Pot Size Frequency (%)","riverHereyoucanfind5":"Here you can find how often and how efficiently you play different hole cards on the river.","riverCombinethisview5":"Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.","riverHereyoucanfind4":"Here you can find how often and how efficiently you play on the river with different hand strengths.","riverCombinethisview4":"Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.","riverRiverCallEfficiencyNetWon":"River Call Efficiency Net Won","riverRCE":"River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.","riverCombinethisview3":"Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.","riverSawShowdown":"Saw Showdown","riverNoShowdown":"No Showdown","riverMadeRiverCbet":"Made River Cbet","riverMadeRiverDonkBet":"Made River Donk Bet","riverSmallriverbets":"Small river bets (<50% pot)","riverBigriverbets":"Big river bets (>100% pot)","riverFacedRiverCbet":"Faced River Cbet","riverFacedRiverDonkBet":"Faced River Donk Bet","riverRiverBet":"River Bet","riverRiverCall":"River Call","riverRiverRaise":"River Raise","riverRiverFold":"River Fold","riverWonHand":"Won Hand","riverLostHand":"Lost Hand","riverRiverBetEfficiencyNetWon":"River Bet Efficiency Net Won","riverRBE":"River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.","riverCombinethisview2":"Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.","riverHereyoucanfind":"Here you can find how aggressively you play on the river and your results for each action played.","tip":"Tip","riverCombinethisview":"Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more","riverAsPreflopAggressor":"As Preflop Aggressor","riverVsPreflopAggressor":"Vs Preflop Aggressor","riverCheckedToRiver":"Checked To River","handFrequencyP":"Hand Frequency (%)","totalHands":"Total Hands","wonAtShowdown":"Won At Showdown","riverAggression":"River Aggression","riverCallEff":"River Call Eff","riverBetEff":"River Bet Eff","riverWentToShowdown":"Went To Showdown","riverRiverHoleCards":"River Hole Cards","riverRiverHandStrength":"River Hand Strength","riverRiverAgression":"River Agression %","riverRiverCallEfficiency":"River Call Efficiency","riverRiverBetEfficiency":"River Bet Efficiency","riverRiverPotSize":"River Pot Size","numberOfTables":"Number Of Tables","sessions":"Sessions","leakonomicsOpponentNoteColor":"Opponent Note Color","leakonomicsSessionProgressSessionNames":"Shorter;Average Session Length;Longer","leakonomicsSessionProgressMin":"Session Progress (Min)","netWonBb":"Net Won (bb)","leakonomicsSessionsSplit":"Sessions Split","leakonomicsPotAmountWonbb":"Pot Amount Won (bb)","orLess":"${0} or less","leakonomicsAllinSplit":"All-in Split","leakonomicsAllinWinsInaRow":"All-in Wins in a Row","winnings":"Winnings","leakonomicsRollingWindow":"Rolling Window Graph","leakonomicsNetWon":"Net Won Up/Down","leakonomicsUpDownSessionNames":"When Down;Neutral;When Up","leakonomicsPreflopStatsDev":"Preflop Stats Dev","leakonomicsBestWrt":"Best wrt: ${0} bb","leakonomicsBestWrtAt":"At ${0} min","leakonomicsWinlossSessionNames":"Loss Series;Neutral;Win Series","leakonomicsAllinRate":"All-in Rate","leakonomicsWinningP":"Winning: ${0}%","leakonomicsLosingP":"Losing: ${0}%","leakonomicsBestWrt2":"Best wrt: ${0} bb/hr","leakonomicsBestWrtAt2":"At ${0} table(s)","at":"At","leakonomicsWinrateBb100P":"Winrate: 5bb/100","leakonomicsPotsLost":"Pots lost: ${0}%","leakonomicsPotsWon":"Pots won: ${0}%","leakonomicsWhenUporDownInSession":"When Up or Down In Session","leakonomicsSessionProgress":"Session Progress","leakonomicsAfterAllinSeries":"After All-in Series","leakonomicsWhenMultitabling":"When Multitabling","leakonomicsVsOpponentbyNoteColor":"Vs Opponent by Note Color","leakonomicsAfterWinningorlosingapot":"After Winning or losing a pot","cbetSuccessP":"CBet Success %","winrate":"Winrate","winrateBB100":"Winrate (bb/100)","cbetActionHU":"CBet action: Heads Up","cbetActionMultiway":"CBet action: Multiway","cbetActionHUNoHands":"Heads Up: No Hands","cbetActionMultiwayNoHands":"Multiway: No Hands","cbetWonLost":"$ Won / Lost","cbetResultsSkippedDonut1Title":"Overall Skipped Cbet","cbetResultsSkippedDonutSubtitle":"Over ${0} Hands<br/>${1} bb/100","cbetResultsSkippedDonut1TitleNoHands":"Overall Skipped Cbet: No Hands","cbetResultsSkippedDonut2Title":"Overall CBet Success","cbetResultsSkippedDonut2TitleNoHands":"Overall Cbet Success: No Hands","hands":"Hands","cbetActionIP":"CBet action: In Position","cbetActionOOP":"CBet action: Out Of Position","cbetNoHandsIP":"In Position: No Hands","cbetNoHandsOOP":"Out Of Position: No Hands","cbetOverallSuccess":"Overall Success","cbetFlopCBetSuccess":"Flop CBet Success","cbetCBetWinrate":"CBet Winrate","cbetSkippedCBetWinnings":"Skipped CBet Winnings","cbetCBetSuccessBoardTexture":"CBet Success: Board Texture","cbetCBetSuccessPosition":"CBet Success: Position","cbetHandStrengthwhenCBettting":"Hand Strength when CBettting","cbetCBetSpotsHeadsUpvsMultiway":"CBet Spots - HeadsUp vs Multiway","cbetCBetSpotsInPositionvsOutofPosition":"CBet Spots - In Position vs Out of Position","cbetResultsSkippedCBet":"Results Skipped CBet","bubbleICMDescription5":"The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.","bubblePercentageDescription5":"Percentage of the prize pool won categorized by your effective stack size","bubblePreflopDescription5":"Your preflop stats categorized on your stack size","bubbleEffectiveStackSizebb":"Effective Stack Size (bb)","bubbleBubbleStackSize":"Bubble Stack Size","bubbleCallingAllInRange":"Calling All-In Range","bubbleSitNGoEntrants":"Sit 'N Go Entrants","bubbleICMDescription4":"The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.","bubblePercentageDescription4":"Percentage of the prize pool won categorized by the number of entrants","bubblePreflopDescription4":"Your preflop stats categorized on your stack size","bubbleBubblePosition":"Bubble Position","bubbleICMDescription3":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.","bubblePercentageDescription3":"Percentage of the prize pool won categorized by your position","bubblePreflopDescription3":"Your preflop stats categorized by your position","bubblePreflopDescription2":"Percentage of the prize pool won categorized by the number players remaining at the bubble","bubblePlayersAtBubble":"# Players At Bubble","bubbleBubblePlayers":"Bubble Players at Bubble","bubblePrizePoolP":"Prize Pool%","bubbleBubbleStage":"Bubble Stage","bubbleEVbb100hands":"EV BB/100 Hands","bubbleICMDescription":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.","bubblePercentageDescription":"Percentage of the prize pool won before, during, and after the bubble","bubblePreflopDescription":"Your preflop stats categorized on your stack size","bubblePrizePoolWon":"Prize Pool Won","bubbleExpectedValue":"Expected Value","bubbleAverageStack":"Average Stack","bubbleCallAIWinrate":"Call AI Winrate","bubbleShoveAIWinrate":"Shove AI Winrate","tooFewHands":"Too Few Hands For This Report","bubblePrizePoolWinningsTitle":"Prize Pool Winnings","bubbleExpectationWhenReachingBubbleTitle":"Expectation When Reaching Bubble","bubblePositionTitle":"Position","bubbleBeforeAndAfterTitle":"Before And After","bubbleStackSizeTitle":"Stack Size","bubbleCallRangesTitle":"Call Ranges","bubbleShoveRangesTitle":"Shove Ranges","tourneyallinRaisingOpenAI":"Raising Open AI","tourneyallinRaising3BetAI":"Raising 3Bet AI","tourneyallinRaisevsOpen":"Raise vs Open","tourneyallinRaisevs3Bet":"Raise vs 3-Bet","tourneyallinCallvsOpen":"Call vs Open","tourneyallinCallvs3Bet":"Call vs 3-Bet","tourneyallinPreflopEffectiveStackSizeAxis":"Preflop Effective Stack Size","tourneyallinRacesWonPAxis":"Races Won %","tourneyallinEquityPAxis":"Equity %","tourneyallinCallingOpenAI":"Calling Open AI","tourneyallinCalling3BetAI":"Calling 3Bet AI","tourneyallinPositionAxis":"Position","tourneyallinExpectationAxis":"Expectation","threebetResultsTitle":"Results","threebetPositionTitle":"Position","threebetRangeTitle":"Three Bet Range","threebetSuccessTitle":"Three Bet Success","threebetFlopHandStrengthTitle":"Flop Hand Strength","threebetWinrate":"3Bet Winrate","threebetFrequency":"3Bet Frequency","threebetRange":"3Bet Range","threebetSuccessRate":"3Bet Success Rate","threebetFlopWinrate":"Flop Winrate","threebetWinrateHandStrengthAxis":"Winrate Hand Strength (bb/100)","threebetHandCount":"${0} (${1} Hands)","threebetWinrateKey":"Winrate","threebetThreeBetPercentKey":"3-Bet %","threebetWinrateAxis":"Winrate (bb/100)","threebetThreeBetPercentAxis":"3-Bet %","threebetSuccessPercentAxis":"Success %","threebetNetwonTitle":"Net Won","threebetNetwonMin":"Loss","threebetNetwonMax":"Profit","threebetDealtFrequencyTitle":"Dealt Frequency","threebetDealtFrequencyMin":"Less Frequent","threebetDealtFrequencyMax":"More Frequent","tourneyallinExpectedWon":"Expected Won","availableStringPositionString":"EP;MP;CO;BTN;SB;BB","availableStringFlopMadeHandValueString":"Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush","availableStringRiverMadeHandValueSummary":"Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush","availableStringFlopFlushTextureTypeAsString":"Flush Rainbow;Flush Two Tone;Flush Monotone","availableStringFlopStraightTextureTypeAsString":"Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper","availableStringFlopPairedTextureTypeAsString":"Paired Board;Not Paired","availableStringInPositionOnFlopShort":"IP;OOP","availableStringInPositionOnFlopLong":"In Position;Out Of Position","availableStringRiverplayCallEfficiency":"Call Efficiency;In Position;Out Of Position","availableStringRiverplayBetEfficiency":"Bet Efficiency;In Position;Out Of Position","availableStringCBetSpots":"Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand","availableStringRiverFirstActionString":"Fold;Check;Call;Bet;Raise","ECCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","ECCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","ECTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","ECTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","ERRaiseCallVsVillainOpenAllinPreflop":"AI PF vs Raise","ERRaiseEVCallVsVillainOpenAllinPreflop":"Expectation AI PF vs Raise","ERTBetCallVsVillainOpenAllinPreflop":"3Bet AI PF vs Re-Raise","ERTBetEVCallVsVillainOpenAllinPreflop":"Expectation 3Bet AI PF vs Re-Raise","BPCCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","BPCCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","BPCTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","BPCTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","BPRRaiseAllinVsRaisePreflop":"AI PF vs Raise","BPRRaiseEVAllinVsRaisePreflop":"Expectation AI PF vs Raise","BPRTBetAllinVsRaisePreflop":"3Bet AI PF vs Re-Raise","BPRTBetEVAllinVsRaisePreflop":"Expectation 3Bet AI PF vs Re-Raise","threebetHandAxis":"Hand","threebetNetBbAxis":"Net BBs","tourneyallinCallingByStackTitle":"Expectation Calling All-In By Stack Size","tourneyallinRaisingByStackTitle":"Expectation Raising All-In By Stack Size","tourneyallinRaisingAllinRangeTitle":"Raising All-In Range","tourneyallinCallingAllinRangeTitle":"Calling All-In Range","tourneyallinCallingAllinByPositionTitle":"Calling All-In Results By Position","tourneyallinRaisingAllinByPositionTitle":"Raising All-In Results By Position","tourneyallinCallAIEVWinrate":"Call AI EV Winrate","tourneyallinRaiseAIEVWinrate":"Raise AI EV Winrate","tourneyallinCallAIWinrate":"Call AI Winrate","tourneyallinRaiseAIWinrate":"Raise AI Winrate","overall":"Overall","restrictionsWithYourLicenseText":"<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"},italian:{"notAllowedByLicense":"Mano Non Consentita dalla Licenza","selectHandToExport":"Seleziona Mano da Esportare","selectFormat":"Seleziona il formato...","originalFormat":"Formato Originale","ctrlCToCopy":"Ctrl-C per Copiare negli Appunti","availableTags":"Tag Disponibili","welcomeToHm3":"Benvenuto al HoldemManager3 Replayer!","theme":"Tema: ","deck":"Mazzo: ","showHandResults":"Mostra Risultati delle Mani: ","showHeroCards":"Mostra Sempre le Carte Coperte dell'Eroe: ","showBB":"Mostra le Chip del Grande Buio: ","combineFolds":"Fold Combinato: ","maskPlayerNames":"Maschera i Nomi dei Giocatori: ","statsUpToTimeOfHand":"Statistiche in Corso Fino al Gioco della Mano: ","showHud":"Mostra HUD: ","replaySpeed":"Rigioca speed: ","hand":"Mano","next100Hands":"Le prossime 100 Mani","prev100Hands":"Le 100 Mani Precedenti","addEditHandMarking":"Aggiungi/Modifica Marcature Mani","wonXBB":"Vinto ${0} Grande Buio","lostXBB":"Perso ${0} Grande Buio\n","wonLossNA":"Vincita/Perdita Non Disponibile","potBB":"Piatto: ${0} Grande Buio\n","userWentAllin":"L'Utente è andato All-in","pot":"Piatto: ${0}","potOdds":"Pot Odds: ${0}:1","hhGameStart":"${0} gioco ${1} inizia con ${2}\n","hhHandNotes":"Nota(e) della Mano","hhFold":"${0} Fold\n","hhCheck":"${0} Check\n","hhCall":"${0} Call ${1}\n","hhBet":"${0} Puntate ${1}\n","hhRaise":"${0} Raise ${1}\n","hhReturnedTo":"${1} Ritornato a ${0}\n","hhWin":"${0} Vincite ${1}\n","hhRake":"Rake: ${0}","hhActionEnded":"L'azione è terminata.","hhMuck":"${0} muck ${1}\n","hhShow":"${0} mostra ${1}\n","hhPostSB":"${0} piazza il piccolo buio\n","hhPostBB":"${0} piazza il grande buio","hhPostDB":"${0} piazza un dead blind","backToReleaseNotes":"Torna alle Note di Rilascio","backToMyLicense":"Torna alla Mia Licenza","backToCardInfo":"Torna alle Informazioni Sulla Carta di Credito","backToPayment":"Torna al Metodo di Pagamento","orderBuyNow":"Acquista Ora","orderProceed":"Procedi","headerTextTrial":"Prova (${0} Giorni Rimanenti)","headerTextFree":"Gratis","smallStakes":"Piccole Puntate","allStakes":"Tutte le Puntate","smallStakesCaps":"PICCOLE PUNTATE","allStakesCaps":"TUTTE LE PUNTATE","smallStakesMaintenance":"MANUTENZIONE SULLE PICCOLE PUNTATE","allStakesMaintenance":"MANUTENZIONE SU TUTTE LE PUNTATE","buyHoldemSmallStakes":"Piccole Puntate Holdem","buyHoldemAllStakes":"Tutte le Puntate Holdem","buyHoldemOmahaAllStakes":"Tutte le Puntate","buyOmahaSmallStakes":"Piccole Puntate Omaha","buyOmahaAllStakes":"Tutte le Puntate Omaha","holdemManager":"Holdem Manager","holdemManagerCaps":"HOLDEM MANAGER","omahaCaps":"OMAHA","holdem":"Holdem","omaha":"Omaha","hmApps":"App HM","hm3":"HM3","om3":"OM3","hm3andOm3":"HM3+OM3","expiredOn":"Scaduto il ${0}","expiresOn":"Scade il ${0}","recommended":"CONSIGLIATO","seeAllOptionsInStore":"Vedi tutte le opzioni nel Negozio","paypalExternalBrowser":"PayPal si aprirà in un browser esterno per completare la procedura di pagamento.","skrillExternalBrowser":"Skrill si caricherà in un browser esterno per completare la procedura di pagamento.","selectProduct":"SELEZIONA IL PRODOTTO","availableUpdate":"AGGIORNAMENTO DISPONIBILE: ","versionAvailable":"La versione ${0} è disponibile: ${1}","fullFaq":"Note di rilascio complete FAQ","reviewOptions":"Controlla le opzioni di manutenzione del tuo Holdem prima di procedere con l'aggiornamento","maintenanceOptions":"Opzioni di Manutenzione","addProductToLicense":"AGGIUNGI ${0} ALLA TUA LICENZA ATTUALE","purchasePrice":"Acquista (${0})","errorName":"Si prega di inserire il proprio Nome e Cognome","errorAddress":"Si prega di inserire il proprio indirizzo e numero civico","errorCountry":"Si prega di inserire il proprio Paese","errorCity":"Si prega di inserire la propria Città","errorZip":"Si prega di inserire un Codice Postale valido","billingInfo":"INFORMAZIONI DI FATTURAZIONE","name":"Nome e Cognome","address":"Indirizzo","city":"Città","state":"Stato/Provincia","zip":"CAP/Codice Postale","country":"Paese","selectCountry":"Seleziona il tuo Paese","buyNowTip":"Prima di procedere si prega di inserire un metodo di pagamento esistente o nuovo","licenses":"LICENZE","version":"Versione ${0}\n","viewReleaseNotes":"Visualizza le note di rilascio sul sito web","updateAndRenewMaintenance":"AGGIORNAMENTO E RINNOVO DELLA MANUTENZIONE","renewGetUpdatesUntil":"Rinnovando la manutenzione riceverai tutti gli aggiornamenti HM3 attraverso ${0}","update":"Aggiorna","updateAndSwitchToFree":"AGGIORNA E PASSA ALLA VERSIONE GRATUITA","updateAndSwitchToFreeDetails1":"Riceverai l'aggiornamento ma il tuo software HM3 (Holdem) tornerà alla versione Gratuita e avrà","updateAndSwitchToFreeDetails2":"funzioni limitate","updateAndSwitch":"Aggiorna & Cambia","errorCreditCardDigitsOnly":"Il numero della carta di credito è composto solo da cifre.","errorCreditCard":"Si prega di inserire un numero di carta valido.","errorRequired":"Richiesto","errorCardExpired":"Carta Scaduta","errorCvv":"Il codice CVV è composto da ${0} cifre","cardInfo":"INFORMAZIONI SULLA CARTA DI CREDITO","cardNo":"Numero della Carta","expiry":"Scadenza","year":"anno","month":"mese","month01":"Gen","month02":"Feb","month03":"Mar","month04":"Apr","month05":"Mag","month06":"Giu","month07":"Lug","month08":"Ago","month09":"Set","month10":"Ott","month11":"Nov","month12":"Dic","cvv":"CVV","active":"Attivo","manageSubscription":"Gestisci la Sottoscrizione","youAreUpToDate":"Sei aggiornato","releaseNotes":"Note di rilascio per ${0}","netellerInfo":"Informazioni sul Conto NETELLER","netellerSignin":"Accedi al tuo conto NETELLER per completare il tuo acquisto","continue_":"Continua","netellerAccount":"Conto Neteller","netellerPassword":"Password","orderSummary":"RIEPILOGO DELL'ORDINE: ","changeProducts":"Cambia Prodotto(i)","total":"Totale","paypalComplete":"SI PREGA DI COMPLETARE IL PROPRIO ACQUISTO PAYPAL NEL PROPRIO BROWSER","paypalOpenedInNewBrowser":"Abbiamo aperto Paypal nella finestra del tuo browser internet predefinito. Si prega di effettuare il login al proprio conto PayPal per completare l'acquisto. Una volta completato l'acquisto, ritornare qui e cliccare su 'Ricarica Licenza' per caricare la licenza appena acquistata.","reloadLicense":"Ricarica la Licenza","thankYouForPurchase":"Grazie Per Il Tuo Acquisto","purchaseConfirm1":"A breve riceverai una mail di conferma al ${0}","purchaseConfirm2":"Cliccare sul tasto di ricarica licenza qui sotto e la tua licenza acquistata sarà attiva.","restricted":"soggetta a restrizioni","restrictionsWithYourLicense":"LA TUA LICENZA ATTUALE E' SOGGETTA A RESTRIZIONI","paymentPleaseChoose":"Si prega di scegliere un metodo di pagamento","paymentSelectExisting":"Seleziona un metodo di pagamento esistente: ","paymentSelectNew":"Metodo di Pagamento","paymentMethod":"Metodo di Pagamento: ","changePaymentMethod":"Cambia Metodo di Pagamento","licensedTo":"CONCESSO IN LICENZA A","learnMore":"Per saperne di più","startTrial":"Inizia la Prova","purchase":"Acquista","trialSuccessfullyStarted":"Prova Avviata con Successo","trialSuccessDetails1":"Ora la tua prova di 14 giorni è attiva. Si prega di ","trialSuccessDetails2":"effettuare l'aggiornamento","trialSuccessDetails3":" il prima possibile per evitare interruzioni di servizio.","havingTrouble":"Stai riscontrando problemi? ","contactUs":"Contattaci","startUsing":"Ora inizia a utilizzare l'HM3 ","missedUpdates":"${0} aggiornamenti persi\n","updatesAreCritical":"Gli aggiornamenti sono importanti per garantire che l'HM3 continui a importare le cronologie delle tue mani dopo che i siti poker avranno apportato modifiche ai loro software. Tramite gli aggiornamenti saranno rilasciati anche nuove caratteristiche e funzioni.","view":"Visualizza","oneYearOfUpdates":"Include un anno di aggiornamenti","renew":"Rinnova (${0})","startingAt":"Partendo da","upgrade":"Aggiornamento","removesRestrictions1":"Rimuove ","removesRestrictions2":"restrizioni","removesRestrictions3":" e include un anno di aggiornamenti","upgradePrice":"Aggiornamento (${0})\n","required":"Richiesto","continueFreemium":"Continua con la Versione Gratuita","defaultFatalError":"Si è verificato un errore imprevisto all'interno del server, un amministratore è stato avvisato. Provare ad effettuare l'acquisto più tardi.","restrictCashHandsType":"Mani Cash","restrictTourneyType":"Torneo","restrictLimitCashHandsType":"Limite Mani Cash","restrictHudType":"HUD","restrictReportDataType":"Rapporto Dati","restrictCashHands":"$ ${0} e inferiore","restrictLimitCashHands":"$ ${0} e inferiore","restrictTourney":"Max ${0}","restrictHud":"Max ${0} Tavolo(i)","restrictReportData":"Ultime Mani ${0} \n","restrictionUnlimited":"Senza limiti","errorState":"Richiesto","activeHoldemLicense":"LICENZA HOLDEM ATTIVA","activeOmahaLicense":"LICENZA OMAHA ATTIVA","reinstallOldVersion":"Reinstalla la Versione Precedente","removesRestrictions3b":"e torna alla tua licenza a pagamento ma gli aggiornamenti ","removesRestrictions4b":"NON SONO INCLUSI","noActiveHoldemLicense":"NESSUNA LICENZA HOLDEM ATTIVA","noActiveOmahaLicense":"NESSUNA LICENZA OMAHA ATTIVA","free":"GRATUITO","netellerSecureId":"ID di Sicurezza","recurringPriceDescription":"${0} ${1} Incluso*\n","recurringYear":"Anno","recurringMonth":"Mese","recurringDay":"Giorno","restrictionsSmall":"Nessun Limite/Limite Pot Cash <b>con restrizioni</b> fino a $0.50 per il grande buio\nLimite Fisso Cash <b>con restrizioni</b> fino a $1,00 per il grande buio\nTornei <b>con restrizioni</b> fino a $22,00 per i buy-in.\n","afterDiscount":"Prezzo dopo lo sconto a scadenza limitata","upgradeDiscount":"AGGIORNA LO SCONTO","discountExpires":"Lo Sconto Scade il ${0}","discountSinglePurchase":"Lo Sconto si applica ad un singolo acquisto.","errorNetellerAccount":"Conto ID Neteller Non Valido","errorNetellerSecureId":"Inserisci il tuo ID di Sicurezza a 6 cifre","continueTrial":"Continua con la Prova","continueTrialDaysRemaining":"(${0} Giorni Rimanenti)","netellerInvalidCredentials":"Non è stato possibile convalidare le tue credenziali Neteller. Prova ad accedere di nuovo.","faq":"FAQ","forMoreDetails":" per ottenere maggiori dettagli su come gestire il rinnovo annuale del servizio di Supporto & Manutenzione","recurringSubscription":"* È richiesto un metodo di pagamento per il rinnovo annuale del servizio di Supporto & Manutenzione di $${0} che verrà fatturato in un anno (${1}). Visualizza ","positivePrice":"Il rinnovo annuale del servizio di Supporto & Manutenzione pari a $${0} verrà fatturato in un anno (${1}). Visualizza ","paymentSeeWebsite1":"Vedi","paymentSeeWebsite2":"NEGOZIO","paymentSeeWebsite3":" per altre opzioni di pagamento","paymentOr":"- O -","couldNotStartMlaTitle":"Abbiamo riscontrato un problema","couldNotStartMlaText":"Impossibile avviare le Mie Licenze. Un Amministratore è stato notificato. Si prega di ricontrollare più tardi. Se il problema persiste contattare il nostro supporto.","skipEndOfHandLabel":"Skip End Of Hand","inPosition":"In Position","outOfPosition":"Out Of Position","amountBb":"${0} bb","amountBbPlus":"${0}+ bb","amountBb100":"${0} bb/100","cbetCbetSuccessTip":"Cbet Success: ${0} % <br/>Winrate: ${1} bb/100","riverBetEfficiencyTip":"${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverCallEfficiencyTip":"${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverHandFrequencyTip":"Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100","riverPotSizeFrequencyTip":"Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100","tourneyallinRaisingCallingByPositionTip":"${0} (${1})<br/>Races Won: ${2}","threebetBetFrequencyTip":"3-Bet: ${0} % <br/>Winrate: ${1} bb/100","ipOopTip":"${0}<br/>In Position: ${1}<br/>Out of Position: ${2}","riverHereyoucanfind6":"Here you can find how often and how efficiently you play on the river based on pot size.","riverCombinethisview6":"Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.","potSizeFrequencyP":"Pot Size Frequency (%)","riverHereyoucanfind5":"Here you can find how often and how efficiently you play different hole cards on the river.","riverCombinethisview5":"Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.","riverHereyoucanfind4":"Here you can find how often and how efficiently you play on the river with different hand strengths.","riverCombinethisview4":"Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.","riverRiverCallEfficiencyNetWon":"River Call Efficiency Net Won","riverRCE":"River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.","riverCombinethisview3":"Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.","riverSawShowdown":"Saw Showdown","riverNoShowdown":"No Showdown","riverMadeRiverCbet":"Made River Cbet","riverMadeRiverDonkBet":"Made River Donk Bet","riverSmallriverbets":"Small river bets (<50% pot)","riverBigriverbets":"Big river bets (>100% pot)","riverFacedRiverCbet":"Faced River Cbet","riverFacedRiverDonkBet":"Faced River Donk Bet","riverRiverBet":"River Bet","riverRiverCall":"River Call","riverRiverRaise":"River Raise","riverRiverFold":"River Fold","riverWonHand":"Won Hand","riverLostHand":"Lost Hand","riverRiverBetEfficiencyNetWon":"River Bet Efficiency Net Won","riverRBE":"River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.","riverCombinethisview2":"Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.","riverHereyoucanfind":"Here you can find how aggressively you play on the river and your results for each action played.","tip":"Tip","riverCombinethisview":"Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more","riverAsPreflopAggressor":"As Preflop Aggressor","riverVsPreflopAggressor":"Vs Preflop Aggressor","riverCheckedToRiver":"Checked To River","handFrequencyP":"Hand Frequency (%)","totalHands":"Total Hands","wonAtShowdown":"Won At Showdown","riverAggression":"River Aggression","riverCallEff":"River Call Eff","riverBetEff":"River Bet Eff","riverWentToShowdown":"Went To Showdown","riverRiverHoleCards":"River Hole Cards","riverRiverHandStrength":"River Hand Strength","riverRiverAgression":"River Agression %","riverRiverCallEfficiency":"River Call Efficiency","riverRiverBetEfficiency":"River Bet Efficiency","riverRiverPotSize":"River Pot Size","numberOfTables":"Number Of Tables","sessions":"Sessions","leakonomicsOpponentNoteColor":"Opponent Note Color","leakonomicsSessionProgressSessionNames":"Shorter;Average Session Length;Longer","leakonomicsSessionProgressMin":"Session Progress (Min)","netWonBb":"Net Won (bb)","leakonomicsSessionsSplit":"Sessions Split","leakonomicsPotAmountWonbb":"Pot Amount Won (bb)","orLess":"${0} or less","leakonomicsAllinSplit":"All-in Split","leakonomicsAllinWinsInaRow":"All-in Wins in a Row","winnings":"Winnings","leakonomicsRollingWindow":"Rolling Window Graph","leakonomicsNetWon":"Net Won Up/Down","leakonomicsUpDownSessionNames":"When Down;Neutral;When Up","leakonomicsPreflopStatsDev":"Preflop Stats Dev","leakonomicsBestWrt":"Best wrt: ${0} bb","leakonomicsBestWrtAt":"At ${0} min","leakonomicsWinlossSessionNames":"Loss Series;Neutral;Win Series","leakonomicsAllinRate":"All-in Rate","leakonomicsWinningP":"Winning: ${0}%","leakonomicsLosingP":"Losing: ${0}%","leakonomicsBestWrt2":"Best wrt: ${0} bb/hr","leakonomicsBestWrtAt2":"At ${0} table(s)","at":"At","leakonomicsWinrateBb100P":"Winrate: 5bb/100","leakonomicsPotsLost":"Pots lost: ${0}%","leakonomicsPotsWon":"Pots won: ${0}%","leakonomicsWhenUporDownInSession":"When Up or Down In Session","leakonomicsSessionProgress":"Session Progress","leakonomicsAfterAllinSeries":"After All-in Series","leakonomicsWhenMultitabling":"When Multitabling","leakonomicsVsOpponentbyNoteColor":"Vs Opponent by Note Color","leakonomicsAfterWinningorlosingapot":"After Winning or losing a pot","cbetSuccessP":"CBet Success %","winrate":"Winrate","winrateBB100":"Winrate (bb/100)","cbetActionHU":"CBet action: Heads Up","cbetActionMultiway":"CBet action: Multiway","cbetActionHUNoHands":"Heads Up: No Hands","cbetActionMultiwayNoHands":"Multiway: No Hands","cbetWonLost":"$ Won / Lost","cbetResultsSkippedDonut1Title":"Overall Skipped Cbet","cbetResultsSkippedDonutSubtitle":"Over ${0} Hands<br/>${1} bb/100","cbetResultsSkippedDonut1TitleNoHands":"Overall Skipped Cbet: No Hands","cbetResultsSkippedDonut2Title":"Overall CBet Success","cbetResultsSkippedDonut2TitleNoHands":"Overall Cbet Success: No Hands","hands":"Hands","cbetActionIP":"CBet action: In Position","cbetActionOOP":"CBet action: Out Of Position","cbetNoHandsIP":"In Position: No Hands","cbetNoHandsOOP":"Out Of Position: No Hands","cbetOverallSuccess":"Overall Success","cbetFlopCBetSuccess":"Flop CBet Success","cbetCBetWinrate":"CBet Winrate","cbetSkippedCBetWinnings":"Skipped CBet Winnings","cbetCBetSuccessBoardTexture":"CBet Success: Board Texture","cbetCBetSuccessPosition":"CBet Success: Position","cbetHandStrengthwhenCBettting":"Hand Strength when CBettting","cbetCBetSpotsHeadsUpvsMultiway":"CBet Spots - HeadsUp vs Multiway","cbetCBetSpotsInPositionvsOutofPosition":"CBet Spots - In Position vs Out of Position","cbetResultsSkippedCBet":"Results Skipped CBet","bubbleICMDescription5":"The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.","bubblePercentageDescription5":"Percentage of the prize pool won categorized by your effective stack size","bubblePreflopDescription5":"Your preflop stats categorized on your stack size","bubbleEffectiveStackSizebb":"Effective Stack Size (bb)","bubbleBubbleStackSize":"Bubble Stack Size","bubbleCallingAllInRange":"Calling All-In Range","bubbleSitNGoEntrants":"Sit 'N Go Entrants","bubbleICMDescription4":"The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.","bubblePercentageDescription4":"Percentage of the prize pool won categorized by the number of entrants","bubblePreflopDescription4":"Your preflop stats categorized on your stack size","bubbleBubblePosition":"Bubble Position","bubbleICMDescription3":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.","bubblePercentageDescription3":"Percentage of the prize pool won categorized by your position","bubblePreflopDescription3":"Your preflop stats categorized by your position","bubblePreflopDescription2":"Percentage of the prize pool won categorized by the number players remaining at the bubble","bubblePlayersAtBubble":"# Players At Bubble","bubbleBubblePlayers":"Bubble Players at Bubble","bubblePrizePoolP":"Prize Pool%","bubbleBubbleStage":"Bubble Stage","bubbleEVbb100hands":"EV BB/100 Hands","bubbleICMDescription":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.","bubblePercentageDescription":"Percentage of the prize pool won before, during, and after the bubble","bubblePreflopDescription":"Your preflop stats categorized on your stack size","bubblePrizePoolWon":"Prize Pool Won","bubbleExpectedValue":"Expected Value","bubbleAverageStack":"Average Stack","bubbleCallAIWinrate":"Call AI Winrate","bubbleShoveAIWinrate":"Shove AI Winrate","tooFewHands":"Too Few Hands For This Report","bubblePrizePoolWinningsTitle":"Prize Pool Winnings","bubbleExpectationWhenReachingBubbleTitle":"Expectation When Reaching Bubble","bubblePositionTitle":"Position","bubbleBeforeAndAfterTitle":"Before And After","bubbleStackSizeTitle":"Stack Size","bubbleCallRangesTitle":"Call Ranges","bubbleShoveRangesTitle":"Shove Ranges","tourneyallinRaisingOpenAI":"Raising Open AI","tourneyallinRaising3BetAI":"Raising 3Bet AI","tourneyallinRaisevsOpen":"Raise vs Open","tourneyallinRaisevs3Bet":"Raise vs 3-Bet","tourneyallinCallvsOpen":"Call vs Open","tourneyallinCallvs3Bet":"Call vs 3-Bet","tourneyallinPreflopEffectiveStackSizeAxis":"Preflop Effective Stack Size","tourneyallinRacesWonPAxis":"Races Won %","tourneyallinEquityPAxis":"Equity %","tourneyallinCallingOpenAI":"Calling Open AI","tourneyallinCalling3BetAI":"Calling 3Bet AI","tourneyallinPositionAxis":"Position","tourneyallinExpectationAxis":"Expectation","threebetResultsTitle":"Results","threebetPositionTitle":"Position","threebetRangeTitle":"Three Bet Range","threebetSuccessTitle":"Three Bet Success","threebetFlopHandStrengthTitle":"Flop Hand Strength","threebetWinrate":"3Bet Winrate","threebetFrequency":"3Bet Frequency","threebetRange":"3Bet Range","threebetSuccessRate":"3Bet Success Rate","threebetFlopWinrate":"Flop Winrate","threebetWinrateHandStrengthAxis":"Winrate Hand Strength (bb/100)","threebetHandCount":"${0} (${1} Hands)","threebetWinrateKey":"Winrate","threebetThreeBetPercentKey":"3-Bet %","threebetWinrateAxis":"Winrate (bb/100)","threebetThreeBetPercentAxis":"3-Bet %","threebetSuccessPercentAxis":"Success %","threebetNetwonTitle":"Net Won","threebetNetwonMin":"Loss","threebetNetwonMax":"Profit","threebetDealtFrequencyTitle":"Dealt Frequency","threebetDealtFrequencyMin":"Less Frequent","threebetDealtFrequencyMax":"More Frequent","tourneyallinExpectedWon":"Expected Won","availableStringPositionString":"EP;MP;CO;BTN;SB;BB","availableStringFlopMadeHandValueString":"Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush","availableStringRiverMadeHandValueSummary":"Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush","availableStringFlopFlushTextureTypeAsString":"Flush Rainbow;Flush Two Tone;Flush Monotone","availableStringFlopStraightTextureTypeAsString":"Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper","availableStringFlopPairedTextureTypeAsString":"Paired Board;Not Paired","availableStringInPositionOnFlopShort":"IP;OOP","availableStringInPositionOnFlopLong":"In Position;Out Of Position","availableStringRiverplayCallEfficiency":"Call Efficiency;In Position;Out Of Position","availableStringRiverplayBetEfficiency":"Bet Efficiency;In Position;Out Of Position","availableStringCBetSpots":"Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand","availableStringRiverFirstActionString":"Fold;Check;Call;Bet;Raise","ECCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","ECCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","ECTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","ECTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","ERRaiseCallVsVillainOpenAllinPreflop":"AI PF vs Raise","ERRaiseEVCallVsVillainOpenAllinPreflop":"Expectation AI PF vs Raise","ERTBetCallVsVillainOpenAllinPreflop":"3Bet AI PF vs Re-Raise","ERTBetEVCallVsVillainOpenAllinPreflop":"Expectation 3Bet AI PF vs Re-Raise","BPCCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","BPCCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","BPCTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","BPCTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","BPRRaiseAllinVsRaisePreflop":"AI PF vs Raise","BPRRaiseEVAllinVsRaisePreflop":"Expectation AI PF vs Raise","BPRTBetAllinVsRaisePreflop":"3Bet AI PF vs Re-Raise","BPRTBetEVAllinVsRaisePreflop":"Expectation 3Bet AI PF vs Re-Raise","threebetHandAxis":"Hand","threebetNetBbAxis":"Net BBs","tourneyallinCallingByStackTitle":"Expectation Calling All-In By Stack Size","tourneyallinRaisingByStackTitle":"Expectation Raising All-In By Stack Size","tourneyallinRaisingAllinRangeTitle":"Raising All-In Range","tourneyallinCallingAllinRangeTitle":"Calling All-In Range","tourneyallinCallingAllinByPositionTitle":"Calling All-In Results By Position","tourneyallinRaisingAllinByPositionTitle":"Raising All-In Results By Position","tourneyallinCallAIEVWinrate":"Call AI EV Winrate","tourneyallinRaiseAIEVWinrate":"Raise AI EV Winrate","tourneyallinCallAIWinrate":"Call AI Winrate","tourneyallinRaiseAIWinrate":"Raise AI Winrate","overall":"Overall","restrictionsWithYourLicenseText":"<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"},japanese:{"notAllowedByLicense":"ライセンスで許可されていないハンド","selectHandToExport":"エクスポートするハンドを選択","selectFormat":"フォーマットを選択してください...","originalFormat":"オリジナルのフォーマット","ctrlCToCopy":"Ctrl + Cでクリップボードにコピー","availableTags":"利用可能なタグ","welcomeToHm3":"ホールデムマネージャー3のリプレイヤーの皆さん、ようこそ！","theme":"テーマ：　","deck":"デッキ：","showHandResults":"ハンドの結果を表示：","showHeroCards":"常にヒーローホールカードを表示：","showBB":"BBでチップを表示：","combineFolds":"フォ―ルドを結合：","maskPlayerNames":"プレーヤーネームを隠す：","statsUpToTimeOfHand":"ハンドの時間までの統計：","showHud":"HUD (ヘッズアップディスプレイ)を表示：","replaySpeed":"再生速度：","hand":"ハンド","next100Hands":"次の100ハンド","prev100Hands":"前の100ハンド","addEditHandMarking":"ハンドマーキング（マーク）の追加/編集","wonXBB":"$ {0} BBを獲得","lostXBB":"$ {0} BBを失いました","wonLossNA":"勝ち/負けの該当なし","potBB":"ポット：$ {0} BB","userWentAllin":"ユーザーがオールイン（全額勝負）","pot":"ポット：$ {0}","potOdds":"ポットオッズ：$ {0}：1","hhGameStart":"$ {0}ゲーム$ {1}は$ {2}で開始","hhHandNotes":"ハンドノート","hhFold":"$ {0}フォ―ルド","hhCheck":"$ {0}チェック","hhCall":"$ {0}コール$ {1}","hhBet":"$ {0}ベット${1}","hhRaise":"$ {0}レイズ$ {1}","hhReturnedTo":"$ {1}リターンド $ {0}","hhWin":"$ {0}勝ち$ {1}","hhRake":"レイク：$ {0}","hhActionEnded":"アクションは終了しました。","hhMuck":"$ {0}マック$ {1}","hhShow":"$ {0}表示 {1}","hhPostSB":"$ {0}件のスモールブラインド","hhPostBB":"$ {0}件のビッグブラインド","hhPostDB":"$ {0}件のデッドブラインド","backToReleaseNotes":"リリースノートに戻る","backToMyLicense":"私のライセンスに戻る","backToCardInfo":"クレジットカード情報に戻る","backToPayment":"支払い方法に戻る","orderBuyNow":"今すぐ購入する","orderProceed":"進む","headerTextTrial":"トライアル（残り日数$ {0}日）","headerTextFree":"無料","smallStakes":"スモール•ステークス","allStakes":"すべてのステークス","smallStakesCaps":"スモール•ステークス","allStakesCaps":"すべてのステークス","smallStakesMaintenance":"スモール•ステークスの管理","allStakesMaintenance":"すべてのステークスの管理","buyHoldemSmallStakes":"ホールデムのスモール•ステークス","buyHoldemAllStakes":"ホールデムのすべてのステークス","buyHoldemOmahaAllStakes":"すべてのステークス","buyOmahaSmallStakes":"オマハのスモール•ステークス","buyOmahaAllStakes":"オマハのすべてのステークス","holdemManager":"ホールデム•マネージャー","holdemManagerCaps":"ホールデム•マネージャー","omahaCaps":"オマハ","holdem":"ホールデム","omaha":"オマハ","hmApps":"HM（ホールデムマネージャー）アプリ","hm3":"HM3（ホールデムマネージャー３）","om3":"OM3（オマハマネージャー３）","hm3andOm3":"HM3（ホールデムマネージャー３）および OM3（オマハマネージャー３）","expiredOn":"  $ {0}に期限切れ","expiresOn":"$ {0}に期限切れとなります","recommended":"おすすめ","seeAllOptionsInStore":"ストア内のすべてのオプションを表示","paypalExternalBrowser":"PayPalは支払いプロセスを完了するために外部のブラウザで開きます。","skrillExternalBrowser":"Skrillは支払いプロセスを完了するために外部ブラウザを読み込みます。","selectProduct":"製品を選択","availableUpdate":"入手可能なアップデート：","versionAvailable":"バージョン$ {0}が利用可能です：$ {1}","fullFaq":"フルリリースノートのよくある質問","reviewOptions":"アップデートを続行する前にHoldem (ホールデム）のメンテナンスオプションを確認してください。","maintenanceOptions":"メンテナンスのオプション","addProductToLicense":"現在のライセンスに$ {0}を追加","purchasePrice":"購入額（$ {0}）","errorName":"あなたのフルネームを入力してください","errorAddress":"あなたの住所の通りの名前と番号を入力してください","errorCountry":"あなたの国を入力してください","errorCity":"あなたの住所の市区町村を入力してください","errorZip":" 有効な郵便番号を入力してください","billingInfo":"  請求書情報","name":"フルネーム","address":"通り名","city":"都市名","state":"都道府県","zip":"郵便番号","country":"国","selectCountry":"国を選択","buyNowTip":"先に進む前に、既存または新しいお支払い方法を選択してください","licenses":"ラインセンス","version":"バージョン$ {0}","viewReleaseNotes":"Webサイトでリリースノートを表示する","updateAndRenewMaintenance":"アップデートと更新のメンテナンス","renewGetUpdatesUntil":"メンテナンスを更新すると、$ {0}を通じてすべてのHM3（ホールデム•マネージャー３）のアップデートを受け取ることができます。","update":"アップデート","updateAndSwitchToFree":"アップデートおよび無料版への切り替え","updateAndSwitchToFreeDetails1":"あなたはアップデートを受け取る事ができますが、あなたのHM3（ホールデム）ソフトウェアは無料版に戻り、維持されます","updateAndSwitchToFreeDetails2":"制限付き機能","updateAndSwitch":"アップデートおよび切り替え","errorCreditCardDigitsOnly":"クレジットカード番号には数字のみを入力してください","errorCreditCard":"  有効なカード番号を入力してください。","errorRequired":"必須","errorCardExpired":"期限切れのカードです","errorCvv":"CVVは$ {0}桁の長さです","cardInfo":"クレジットカード情報","cardNo":"カード番号","expiry":"有効期限","year":"年","month":"月","month01":"1月","month02":"2月","month03":"3月","month04":"4月","month05":"5月","month06":"6月","month07":"7月","month08":"8月","month09":"9月","month10":"10月","month11":"11月","month12":"12月","cvv":"CVV","active":"有効","manageSubscription":"購読を管理する","youAreUpToDate":"あなたは最新の状態です","releaseNotes":"$ {0}のリリースノート","netellerInfo":"NETELLERアカウント情報","netellerSignin":"購入を完了するには、NETELLERアカウントにサインインしてください","continue_":"続行する","netellerAccount":"Netellerアカウント","netellerPassword":"パスワード","orderSummary":"注文の概要：","changeProducts":"製品を変更する","total":"合計","paypalComplete":"あなたのブラウザでPaypalによる購入手続きを完了させてください","paypalOpenedInNewBrowser":"デフォルトのインターネットブラウザウィンドウでPayPalが開かれます。あなたのPayPalアカウントにログインして購入手続きを完了させてください。購入が完了したら、ここに戻り[ライセンスを再読み込み]ボタンをクリックして購入したライセンスを読み込んでください。","reloadLicense":"ライセンスを再読み込み","thankYouForPurchase":"ご購入いただきありがとうございます","purchaseConfirm1":"間もなく$ {0}にEメールによる確認が届きます","purchaseConfirm2":"下の[ライセンスを再読み込み]ボタンをクリックすると、購入されたライセンスが有効になります。","restricted":"制限あり","restrictionsWithYourLicense":"現在のあなたのライセンスによる制限","paymentPleaseChoose":"お支払い方法を選択してください","paymentSelectExisting":"既存のお支払い方法を選択してください：","paymentSelectNew":"支払方法","paymentMethod":"支払方法：","changePaymentMethod":"支払い方法を変更","licensedTo":"ライセンス対象","learnMore":"もっと詳しく知りたい場合はこちら","startTrial":"トライアルを開始","purchase":"購入","trialSuccessfullyStarted":"トライアルは正常に開始されました","trialSuccessDetails1":"あなたの14日間のトライアルが有効になりました。 よろしくお願いします。","trialSuccessDetails2":"アップグレードする","trialSuccessDetails3":"あなたのサービスの中断を避けるためにできるだけ早く行ってください。","havingTrouble":"何かお困りですか？","contactUs":"お問い合わせ","startUsing":"今すぐHM3（ホールデム•マネージャー３）を使い始める","missedUpdates":"$ {0}が更新を見逃しました","updatesAreCritical":"更新を行う事は、ポーカーサイトがソフトウェアに変更を加えた後もHM3（ホールデムマネージャー３）があなたのハンド履歴をインポートし続けることを保証するために重要です。 新しい特徴や機能もアップデートを通じてリリースされています。","view":"表示する","oneYearOfUpdates":"1年間のアップデートが含まれています","renew":"更新（$ {0}）","startingAt":"開始時","upgrade":"アップグレードする","removesRestrictions1":"削除する","removesRestrictions2":"制限事項","removesRestrictions3":"1年間のアップデートが含まれます","upgradePrice":"アップグレード（$ {0}）","required":"必須","continueFreemium":"無料版を続ける","defaultFatalError":"予期しない内部のサーバーエラーが発生し、管理者に通知されました。 後でもう一度購入してみてください。","restrictCashHandsType":"キャッシュハンド","restrictTourneyType":"トーナメント","restrictLimitCashHandsType":"キャッシュハンドの制限","restrictHudType":"HUD（ヘッズアップディスプレイ）","restrictReportDataType":"レポートデータ","restrictCashHands":"$ $ {0}以下","restrictLimitCashHands":"$ $ {0}以下","restrictTourney":"最大$ {0}","restrictHud":"最大$ {0}テーブル","restrictReportData":"最後の$ {0}ハンド","restrictionUnlimited":"無制限","errorState":"必須","activeHoldemLicense":"有効なホールデム•ライセンス","activeOmahaLicense":"有効なオマハ•ライセンス","reinstallOldVersion":"古いバージョンを再インストールする","removesRestrictions3b":"有料ライセンスに戻りますが、更新は","removesRestrictions4b":"含まれていません","noActiveHoldemLicense":"有効なホールデム•ライセンスはありません","noActiveOmahaLicense":"有効なオマハ•ライセンスはありません","free":"無料","netellerSecureId":"セキュアID","recurringPriceDescription":"$ {0} $ {1}が含まれています*","recurringYear":"年","recurringMonth":"月","recurringDay":"日","restrictionsSmall":"ノーリミットキャッシュおよびポット•リミットキャッシュは最大$ 0.50のビッグブラインドに<b>制限</b> されています。固定リミットキャッシュは最大$ 1.00のビッグブラインドに<b>制限</b> されています。トーナメントには最大$ 22.00のバイインの<b>制限</b> があります。","afterDiscount":"期間限定割引後の価格","upgradeDiscount":"割引のアップグレード","discountExpires":" 割引は 2019年3月31日に終了します","discountSinglePurchase":"割引は1回の購入に適用されます。","errorNetellerAccount":"無効なNetellerアカウントID","errorNetellerSecureId":"6桁のセキュアIDを入力してください","continueTrial":"トライアルを続ける","continueTrialDaysRemaining":"（$ {0}日の残り日数）","netellerInvalidCredentials":"あなたのNetellerの認証情報を検証できませんでした。 もう一度ログインしてください。","faq":"よくある質問","forMoreDetails":"年間のサポートとメンテナンスの更新管理の詳細についてはこちらをご覧ください。","recurringSubscription":"*$$ {0}1年以内に請求される（$ {1}）年1回のサポートとメンテナンスの更新にはお支払い方法が必要です。 表示する","positivePrice":"$$ {0}1年以内に請求される（$ {1}）年1回のサポートとメンテナンスの更新。 表示する","paymentSeeWebsite1":"表示する","paymentSeeWebsite2":"ストア","paymentSeeWebsite3":"他の支払い方法について","paymentOr":"- または -","couldNotStartMlaTitle":"問題が発生しました","couldNotStartMlaText":"My Licenses を開始できませんでした。管理者に通知が送られました。後でもう一度チェックしてください。問題が続く場合は、当社サポートにご連絡ください。","skipEndOfHandLabel":"Skip End Of Hand","inPosition":"In Position","outOfPosition":"Out Of Position","amountBb":"${0} bb","amountBbPlus":"${0}+ bb","amountBb100":"${0} bb/100","cbetCbetSuccessTip":"Cbet Success: ${0} % <br/>Winrate: ${1} bb/100","riverBetEfficiencyTip":"${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverCallEfficiencyTip":"${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverHandFrequencyTip":"Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100","riverPotSizeFrequencyTip":"Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100","tourneyallinRaisingCallingByPositionTip":"${0} (${1})<br/>Races Won: ${2}","threebetBetFrequencyTip":"3-Bet: ${0} % <br/>Winrate: ${1} bb/100","ipOopTip":"${0}<br/>In Position: ${1}<br/>Out of Position: ${2}","riverHereyoucanfind6":"Here you can find how often and how efficiently you play on the river based on pot size.","riverCombinethisview6":"Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.","potSizeFrequencyP":"Pot Size Frequency (%)","riverHereyoucanfind5":"Here you can find how often and how efficiently you play different hole cards on the river.","riverCombinethisview5":"Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.","riverHereyoucanfind4":"Here you can find how often and how efficiently you play on the river with different hand strengths.","riverCombinethisview4":"Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.","riverRiverCallEfficiencyNetWon":"River Call Efficiency Net Won","riverRCE":"River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.","riverCombinethisview3":"Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.","riverSawShowdown":"Saw Showdown","riverNoShowdown":"No Showdown","riverMadeRiverCbet":"Made River Cbet","riverMadeRiverDonkBet":"Made River Donk Bet","riverSmallriverbets":"Small river bets (<50% pot)","riverBigriverbets":"Big river bets (>100% pot)","riverFacedRiverCbet":"Faced River Cbet","riverFacedRiverDonkBet":"Faced River Donk Bet","riverRiverBet":"River Bet","riverRiverCall":"River Call","riverRiverRaise":"River Raise","riverRiverFold":"River Fold","riverWonHand":"Won Hand","riverLostHand":"Lost Hand","riverRiverBetEfficiencyNetWon":"River Bet Efficiency Net Won","riverRBE":"River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.","riverCombinethisview2":"Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.","riverHereyoucanfind":"Here you can find how aggressively you play on the river and your results for each action played.","tip":"Tip","riverCombinethisview":"Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more","riverAsPreflopAggressor":"As Preflop Aggressor","riverVsPreflopAggressor":"Vs Preflop Aggressor","riverCheckedToRiver":"Checked To River","handFrequencyP":"Hand Frequency (%)","totalHands":"Total Hands","wonAtShowdown":"Won At Showdown","riverAggression":"River Aggression","riverCallEff":"River Call Eff","riverBetEff":"River Bet Eff","riverWentToShowdown":"Went To Showdown","riverRiverHoleCards":"River Hole Cards","riverRiverHandStrength":"River Hand Strength","riverRiverAgression":"River Agression %","riverRiverCallEfficiency":"River Call Efficiency","riverRiverBetEfficiency":"River Bet Efficiency","riverRiverPotSize":"River Pot Size","numberOfTables":"Number Of Tables","sessions":"Sessions","leakonomicsOpponentNoteColor":"Opponent Note Color","leakonomicsSessionProgressSessionNames":"Shorter;Average Session Length;Longer","leakonomicsSessionProgressMin":"Session Progress (Min)","netWonBb":"Net Won (bb)","leakonomicsSessionsSplit":"Sessions Split","leakonomicsPotAmountWonbb":"Pot Amount Won (bb)","orLess":"${0} or less","leakonomicsAllinSplit":"All-in Split","leakonomicsAllinWinsInaRow":"All-in Wins in a Row","winnings":"Winnings","leakonomicsRollingWindow":"Rolling Window Graph","leakonomicsNetWon":"Net Won Up/Down","leakonomicsUpDownSessionNames":"When Down;Neutral;When Up","leakonomicsPreflopStatsDev":"Preflop Stats Dev","leakonomicsBestWrt":"Best wrt: ${0} bb","leakonomicsBestWrtAt":"At ${0} min","leakonomicsWinlossSessionNames":"Loss Series;Neutral;Win Series","leakonomicsAllinRate":"All-in Rate","leakonomicsWinningP":"Winning: ${0}%","leakonomicsLosingP":"Losing: ${0}%","leakonomicsBestWrt2":"Best wrt: ${0} bb/hr","leakonomicsBestWrtAt2":"At ${0} table(s)","at":"At","leakonomicsWinrateBb100P":"Winrate: 5bb/100","leakonomicsPotsLost":"Pots lost: ${0}%","leakonomicsPotsWon":"Pots won: ${0}%","leakonomicsWhenUporDownInSession":"When Up or Down In Session","leakonomicsSessionProgress":"Session Progress","leakonomicsAfterAllinSeries":"After All-in Series","leakonomicsWhenMultitabling":"When Multitabling","leakonomicsVsOpponentbyNoteColor":"Vs Opponent by Note Color","leakonomicsAfterWinningorlosingapot":"After Winning or losing a pot","cbetSuccessP":"CBet Success %","winrate":"Winrate","winrateBB100":"Winrate (bb/100)","cbetActionHU":"CBet action: Heads Up","cbetActionMultiway":"CBet action: Multiway","cbetActionHUNoHands":"Heads Up: No Hands","cbetActionMultiwayNoHands":"Multiway: No Hands","cbetWonLost":"$ Won / Lost","cbetResultsSkippedDonut1Title":"Overall Skipped Cbet","cbetResultsSkippedDonutSubtitle":"Over ${0} Hands<br/>${1} bb/100","cbetResultsSkippedDonut1TitleNoHands":"Overall Skipped Cbet: No Hands","cbetResultsSkippedDonut2Title":"Overall CBet Success","cbetResultsSkippedDonut2TitleNoHands":"Overall Cbet Success: No Hands","hands":"Hands","cbetActionIP":"CBet action: In Position","cbetActionOOP":"CBet action: Out Of Position","cbetNoHandsIP":"In Position: No Hands","cbetNoHandsOOP":"Out Of Position: No Hands","cbetOverallSuccess":"Overall Success","cbetFlopCBetSuccess":"Flop CBet Success","cbetCBetWinrate":"CBet Winrate","cbetSkippedCBetWinnings":"Skipped CBet Winnings","cbetCBetSuccessBoardTexture":"CBet Success: Board Texture","cbetCBetSuccessPosition":"CBet Success: Position","cbetHandStrengthwhenCBettting":"Hand Strength when CBettting","cbetCBetSpotsHeadsUpvsMultiway":"CBet Spots - HeadsUp vs Multiway","cbetCBetSpotsInPositionvsOutofPosition":"CBet Spots - In Position vs Out of Position","cbetResultsSkippedCBet":"Results Skipped CBet","bubbleICMDescription5":"The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.","bubblePercentageDescription5":"Percentage of the prize pool won categorized by your effective stack size","bubblePreflopDescription5":"Your preflop stats categorized on your stack size","bubbleEffectiveStackSizebb":"Effective Stack Size (bb)","bubbleBubbleStackSize":"Bubble Stack Size","bubbleCallingAllInRange":"Calling All-In Range","bubbleSitNGoEntrants":"Sit 'N Go Entrants","bubbleICMDescription4":"The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.","bubblePercentageDescription4":"Percentage of the prize pool won categorized by the number of entrants","bubblePreflopDescription4":"Your preflop stats categorized on your stack size","bubbleBubblePosition":"Bubble Position","bubbleICMDescription3":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.","bubblePercentageDescription3":"Percentage of the prize pool won categorized by your position","bubblePreflopDescription3":"Your preflop stats categorized by your position","bubblePreflopDescription2":"Percentage of the prize pool won categorized by the number players remaining at the bubble","bubblePlayersAtBubble":"# Players At Bubble","bubbleBubblePlayers":"Bubble Players at Bubble","bubblePrizePoolP":"Prize Pool%","bubbleBubbleStage":"Bubble Stage","bubbleEVbb100hands":"EV BB/100 Hands","bubbleICMDescription":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.","bubblePercentageDescription":"Percentage of the prize pool won before, during, and after the bubble","bubblePreflopDescription":"Your preflop stats categorized on your stack size","bubblePrizePoolWon":"Prize Pool Won","bubbleExpectedValue":"Expected Value","bubbleAverageStack":"Average Stack","bubbleCallAIWinrate":"Call AI Winrate","bubbleShoveAIWinrate":"Shove AI Winrate","tooFewHands":"Too Few Hands For This Report","bubblePrizePoolWinningsTitle":"Prize Pool Winnings","bubbleExpectationWhenReachingBubbleTitle":"Expectation When Reaching Bubble","bubblePositionTitle":"Position","bubbleBeforeAndAfterTitle":"Before And After","bubbleStackSizeTitle":"Stack Size","bubbleCallRangesTitle":"Call Ranges","bubbleShoveRangesTitle":"Shove Ranges","tourneyallinRaisingOpenAI":"Raising Open AI","tourneyallinRaising3BetAI":"Raising 3Bet AI","tourneyallinRaisevsOpen":"Raise vs Open","tourneyallinRaisevs3Bet":"Raise vs 3-Bet","tourneyallinCallvsOpen":"Call vs Open","tourneyallinCallvs3Bet":"Call vs 3-Bet","tourneyallinPreflopEffectiveStackSizeAxis":"Preflop Effective Stack Size","tourneyallinRacesWonPAxis":"Races Won %","tourneyallinEquityPAxis":"Equity %","tourneyallinCallingOpenAI":"Calling Open AI","tourneyallinCalling3BetAI":"Calling 3Bet AI","tourneyallinPositionAxis":"Position","tourneyallinExpectationAxis":"Expectation","threebetResultsTitle":"Results","threebetPositionTitle":"Position","threebetRangeTitle":"Three Bet Range","threebetSuccessTitle":"Three Bet Success","threebetFlopHandStrengthTitle":"Flop Hand Strength","threebetWinrate":"3Bet Winrate","threebetFrequency":"3Bet Frequency","threebetRange":"3Bet Range","threebetSuccessRate":"3Bet Success Rate","threebetFlopWinrate":"Flop Winrate","threebetWinrateHandStrengthAxis":"Winrate Hand Strength (bb/100)","threebetHandCount":"${0} (${1} Hands)","threebetWinrateKey":"Winrate","threebetThreeBetPercentKey":"3-Bet %","threebetWinrateAxis":"Winrate (bb/100)","threebetThreeBetPercentAxis":"3-Bet %","threebetSuccessPercentAxis":"Success %","threebetNetwonTitle":"Net Won","threebetNetwonMin":"Loss","threebetNetwonMax":"Profit","threebetDealtFrequencyTitle":"Dealt Frequency","threebetDealtFrequencyMin":"Less Frequent","threebetDealtFrequencyMax":"More Frequent","tourneyallinExpectedWon":"Expected Won","availableStringPositionString":"EP;MP;CO;BTN;SB;BB","availableStringFlopMadeHandValueString":"Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush","availableStringRiverMadeHandValueSummary":"Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush","availableStringFlopFlushTextureTypeAsString":"Flush Rainbow;Flush Two Tone;Flush Monotone","availableStringFlopStraightTextureTypeAsString":"Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper","availableStringFlopPairedTextureTypeAsString":"Paired Board;Not Paired","availableStringInPositionOnFlopShort":"IP;OOP","availableStringInPositionOnFlopLong":"In Position;Out Of Position","availableStringRiverplayCallEfficiency":"Call Efficiency;In Position;Out Of Position","availableStringRiverplayBetEfficiency":"Bet Efficiency;In Position;Out Of Position","availableStringCBetSpots":"Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand","availableStringRiverFirstActionString":"Fold;Check;Call;Bet;Raise","ECCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","ECCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","ECTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","ECTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","ERRaiseCallVsVillainOpenAllinPreflop":"AI PF vs Raise","ERRaiseEVCallVsVillainOpenAllinPreflop":"Expectation AI PF vs Raise","ERTBetCallVsVillainOpenAllinPreflop":"3Bet AI PF vs Re-Raise","ERTBetEVCallVsVillainOpenAllinPreflop":"Expectation 3Bet AI PF vs Re-Raise","BPCCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","BPCCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","BPCTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","BPCTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","BPRRaiseAllinVsRaisePreflop":"AI PF vs Raise","BPRRaiseEVAllinVsRaisePreflop":"Expectation AI PF vs Raise","BPRTBetAllinVsRaisePreflop":"3Bet AI PF vs Re-Raise","BPRTBetEVAllinVsRaisePreflop":"Expectation 3Bet AI PF vs Re-Raise","threebetHandAxis":"Hand","threebetNetBbAxis":"Net BBs","tourneyallinCallingByStackTitle":"Expectation Calling All-In By Stack Size","tourneyallinRaisingByStackTitle":"Expectation Raising All-In By Stack Size","tourneyallinRaisingAllinRangeTitle":"Raising All-In Range","tourneyallinCallingAllinRangeTitle":"Calling All-In Range","tourneyallinCallingAllinByPositionTitle":"Calling All-In Results By Position","tourneyallinRaisingAllinByPositionTitle":"Raising All-In Results By Position","tourneyallinCallAIEVWinrate":"Call AI EV Winrate","tourneyallinRaiseAIEVWinrate":"Raise AI EV Winrate","tourneyallinCallAIWinrate":"Call AI Winrate","tourneyallinRaiseAIWinrate":"Raise AI Winrate","overall":"Overall","restrictionsWithYourLicenseText":"<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"},polish:{"notAllowedByLicense":"Ręka niedozwolona przez Licencję","selectHandToExport":"Wybierz rękę do zaimportowania","selectFormat":"Wybierz format...","originalFormat":"Oryginalny format","ctrlCToCopy":"Ctrl-C, aby skopiować do schowka","availableTags":"Dostępne tagi","welcomeToHm3":"Witamy w HoldemManager3 Replayer!","theme":"Motyw:","deck":"Talia:","showHandResults":"Pokaż wyniki rąk:","showHeroCards":"Zawsze pokazuj karty Hero Hole:","showBB":"Pokazuj żetony w BB:","combineFolds":"Połącz spasowania:","maskPlayerNames":"Maskuj Nazwy Graczy:","statsUpToTimeOfHand":"Statystyki do czasu ręki:","showHud":"Pokaż HUD:","replaySpeed":"Prędkość powtórki:","hand":"Ręka","next100Hands":"Następne 100 rąk","prev100Hands":"Poprzednie 100 rąk","addEditHandMarking":"Dodaj/Edytuj Oznaczenia Rąk","wonXBB":"Wygrano ${0} BB","lostXBB":"Przegrano ${0} BB","wonLossNA":"Wygrano/Przegrano NA","potBB":"Pula: ${0} BB","userWentAllin":"Użytkownik wszedł Allin","pot":"Pula: ${0}","potOdds":"Szanse puli: ${0}1","hhGameStart":"${0} gra ${1} zaczyna się od ${2}","hhHandNotes":"Notatki ręki","hhFold":"${0} pasuje","hhCheck":"${0} czeka","hhCall":"${0} sprawdza ${1}","hhBet":"${0} podbija ${1}","hhRaise":"${0} przebija ${1}","hhReturnedTo":"${1} wrócił do ${0}","hhWin":"${0} wygrywa ${1}","hhRake":"Rake: ${0}","hhActionEnded":"Akcja zakończona.","hhMuck":"${0} muck ${1}","hhShow":"${0} pokazuje ${1}","hhPostSB":"${0} daje małą w ciemno","hhPostBB":"${0} daje dużą w ciemno","hhPostDB":"${0} daje martwą w ciemno","backToReleaseNotes":"Powrtót do Informacji o wydaniu","backToMyLicense":"Powrót do Mojej Licencji","backToCardInfo":"Powrót do Danych Karty Kredytowej","backToPayment":"Powrót do Metod Płatności","orderBuyNow":"Kup teraz","orderProceed":"Kontynuuj","headerTextTrial":"Trial (pozostało ${0} dni)","headerTextFree":"Za darmo","smallStakes":"Niskie stawki","allStakes":"Wszystkie stawki","smallStakesCaps":"MAŁE STAWKI","allStakesCaps":"WSZYSTKIE STAWKI","smallStakesMaintenance":"KONSERWACJA NISKICH STAWEK","allStakesMaintenance":"KONSERWACJA WSZYSTKICH STAWEK","buyHoldemSmallStakes":"Holdem Niskie stawki","buyHoldemAllStakes":"Holdem Wszystkie stawki","buyHoldemOmahaAllStakes":"Wszystkie stawki","buyOmahaSmallStakes":"Omaha Niskie stawki","buyOmahaAllStakes":"Omaha Wszystkie stawki","holdemManager":"Holdem Manager","holdemManagerCaps":"HOLDEM MANAGER","omahaCaps":"OMAHA","holdem":"Holdem","omaha":"Omaha","hmApps":"Aplikacje HM","hm3":"HM3","om3":"OM3","hm3andOm3":"HM3 + OM3","expiredOn":"Wygasło dnia ${0}","expiresOn":"Wygasa dnia ${0}","recommended":"REKOMENDOWANE","seeAllOptionsInStore":"Zobacz wszystkie opcje w Sklepie","paypalExternalBrowser":"PayPal otworzy się w nowym oknie, aby dokończyć proces płatności.","skrillExternalBrowser":"Skrill otworzy się w nowym oknie, aby dokończyć proces płatności.","selectProduct":"WYBIERZ PRODUKT","availableUpdate":"DOSTĘPNA AKTUALIZACJA:","versionAvailable":"Wersja ${0} jest dostępna: ${1}","fullFaq":"Pełne informacje o wersji FAQ","reviewOptions":"Przed kontynuowaniem aktualizacji przejrzyj opcje konserwacji Holdem","maintenanceOptions":"Opcje konserwacji","addProductToLicense":"DODAJ ${0} DO OBECNEJ LICENCJI","purchasePrice":"Zakup (${0})","errorName":"Wprowadź swoje Imię i Nazwisko","errorAddress":"Wprowadź nazwę ulicy oraz numer domu","errorCountry":"Wprowadź swój kraj","errorCity":"Wprowadź swoje miasto","errorZip":"Wprowadź poprawny kod pocztowy","billingInfo":"INFORMACJE ROZLICZENIOWE","name":"Imię i Nazwisko","address":"Nazwa ulicy","city":"Miasto","state":"Województwo","zip":"Kod pocztowy","country":"Kraj","selectCountry":"Wybierz kraj","buyNowTip":"Przed kontynuowaniem wybierz istniejącą lub nową metodę płatności","licenses":"LICENCJE","version":"Wersja ${0}","viewReleaseNotes":"Zobacz uwagi do wydania na stronie","updateAndRenewMaintenance":"AKTUALIZUJ I ODNÓW KONSERWACJĘ","renewGetUpdatesUntil":"Odnawiając konserwację, otrzymasz wszystkie aktualizacje HM3 poprzez ${0}","update":"Aktualizacja","updateAndSwitchToFree":"AKTUALIZUJ I PRZEŁĄCZ DO DARMOWEJ WERSJI","updateAndSwitchToFreeDetails1":"Otrzymasz aktualizację, ale Twoje oprogramowanie HM3 (Holdem) powróci do wersji darmowej i będzie miało","updateAndSwitchToFreeDetails2":"ograniczoną funkcjonalność","updateAndSwitch":"Aktualizuj i przełącz","errorCreditCardDigitsOnly":"Numer karty kredytowej powinien zawierać tylko cyfry.","errorCreditCard":"Wprowadź poprawny numer karty.","errorRequired":"Wymagany","errorCardExpired":"Karta wygasła","errorCvv":"CVV powinien mieć ${0} cyfr.","cardInfo":"DANE KARTY KREDYTOWEJ","cardNo":"Numer karty","expiry":"Data ważności","year":"rok","month":"miesiąc","month01":"Sty","month02":"Lut","month03":"Mar","month04":"Kwi","month05":"Maj","month06":"Cze","month07":"Lip","month08":"Sie","month09":"Wrz","month10":"Paź","month11":"Lis","month12":"Gru","cvv":"CVV","active":"Aktywne","manageSubscription":"Zarządzaj subskrypcją","youAreUpToDate":"Jesteś na bieżąco","releaseNotes":"Uwagi do wydania dla ${0}","netellerInfo":"Dane konta NETELLER","netellerSignin":"Zaloguj się do konta NETELLER, aby ukończyć zakup.","continue_":"Kontynuuj","netellerAccount":"Konto Neteller","netellerPassword":"Hasło","orderSummary":"PODSUMOWANIE ZAMÓWIENIA: ","changeProducts":"Zmień produkt(y)","total":"Suma","paypalComplete":"PROSZĘ DOKOŃCZYĆ ZAKUP PAYPAL W PRZEGLĄDARCE","paypalOpenedInNewBrowser":"Otworzyliśmy PayPal w nowym oknie domyślnej przeglądarki. Zaloguj się do swojego konta PayPal i dokończ zakup. Po zakończeniu zakupu wróć tutaj i kliknij „Przeładuj licencję”, aby załadować zakupioną licencję","reloadLicense":"Przeładuj licencję","thankYouForPurchase":"Dziękujemy za zakup","purchaseConfirm1":"Wkrótce otrzymasz potwierdzenie e-mailem na ${0}","purchaseConfirm2":"Kliknij przycisk przeładowania licencji poniżej, a zakupiona licencja będzie aktywna.","restricted":"ograniczone","restrictionsWithYourLicense":"OGRANICZENIA TWOJEJ AKTUALNEJ LICENCJI","paymentPleaseChoose":"Proszę wybrać metodę płatności","paymentSelectExisting":"Wybierz istniejącą metodę płatności:","paymentSelectNew":"Dodaj nową metodę płatności:","paymentMethod":"Metoda płatności:","changePaymentMethod":"Zmień metodę płatności","licensedTo":"LICENCJA DLA","learnMore":"Dowiedz się więcej","startTrial":"Rozpocznij okres próbny","purchase":"Zakup","trialSuccessfullyStarted":"Pomyślnie rozpoczęto okres próbny","trialSuccessDetails1":"Twój 14-dniowy okres próbny jest aktywny. Prosimy","trialSuccessDetails2":"ulepszyć","trialSuccessDetails3":" tak szybko, jak to możliwe, aby uniknąć przerw w usłudze.","havingTrouble":"Masz problemy?","contactUs":"Skontaktuj się z nami","startUsing":"Zacznij używać HM3 teraz","missedUpdates":"${0} brakujących aktualizacji","updatesAreCritical":"Aktualizacje są kluczowe dla zapewnienia, że HM3 będzie kontynuował importowanie historii rozdań po wprowadzeniu zmian w oprogramowaniu przez strony pokerowe. Nowe funkcje są również udostępniane poprzez aktualizacje.","view":"Wyświetl","oneYearOfUpdates":"Zawiera rok aktualizacji","renew":"Odnów (${0})","startingAt":"Od","upgrade":"Ulepszenie","removesRestrictions1":"Usuwa","removesRestrictions2":"ograniczenia","removesRestrictions3":" i zawiera rok aktualizacji","upgradePrice":"Ulepszenie (${0})","required":"Wymagane","continueFreemium":"Kontynuuj bezpłatną wersję","defaultFatalError":"Wystąpił nieoczekiwany wewnętrzny błąd serwera i powiadomiono administratora. Spróbuj ponownie później.","restrictCashHandsType":"Rozdania gotówkowe","restrictTourneyType":"Turniej","restrictLimitCashHandsType":"Rozdania gotówkowe limit","restrictHudType":"HUD","restrictReportDataType":"Dane raportu","restrictCashHands":"$ ${0} i poniżej","restrictLimitCashHands":"$ ${0} i poniżej","restrictTourney":"Max ${0}","restrictHud":"Max ${0} Stołów","restrictReportData":"Ostatnie ${0} rąk","restrictionUnlimited":"Nieograniczone","errorState":"Wymagane","activeHoldemLicense":"AKTYWNA LICENCJA HOLDEM","activeOmahaLicense":"AKTYWNA LICENCJA OMAHA","reinstallOldVersion":"Przywraca starą wersję","removesRestrictions3b":"i powraca do Twojej płatnej licencji, ale aktualizacje są","removesRestrictions4b":"NIE WLICZONE","noActiveHoldemLicense":"BRAK AKTYWNEJ LICENCJI HOLDEM","noActiveOmahaLicense":"BRAK AKTYWNEJ LICENCJI OMAHA","free":"DARMOWA","netellerSecureId":"Bezpieczne ID","recurringPriceDescription":"${0} ${1} wliczone*","recurringYear":"Rok","recurringMonth":"Miesiąc","recurringDay":"Dzień","restrictionsSmall":"No Limit/Pot Limit Cash <b>ograniczone</b> do $0.50 dużych w ciemno\nFixed Limit Cash <b>ograniczone</b> do $1.00 dużych w ciemno\nTurnieje <b>ograniczone</b> do $22.00 wpisowego.","afterDiscount":"Cena po ograniczonym czasowo rabacie","upgradeDiscount":"RABAT NA ULEPSZENIE","discountExpires":"Rabat wygasa dnia 31 marca 2019","discountSinglePurchase":"Rabat dotyczy jednego zakupu.","errorNetellerAccount":"Niepoprawne ID konta Neteller","errorNetellerSecureId":"Wprowadź 6-cyfrowe bezpieczne ID","continueTrial":"Kontynuuj trial","continueTrialDaysRemaining":"(pozostało ${0} dni)","netellerInvalidCredentials":"Nie mogliśmy zweryfikować Twoich danych Neteller. Proszę spróbować zalogować się ponownie.","faq":"FAQ","forMoreDetails":", aby dowiedzieć się więcej na temat zarządzania rocznym odnowieniem wsparcia i konserwacji.","recurringSubscription":"*Metoda płatności jest wymagana do corocznego odnawiania wsparcia i konserwacji w wysokości $${0}, które zostanie rozliczone w ciągu jednego roku (${1}). Wyświetl ","positivePrice":"Roczne odnowienie wsparcia i konserwacji $$ {0} będzie rozliczane w ciągu jednego roku (${1}). Wyświetl ","paymentSeeWebsite1":"Zobacz","paymentSeeWebsite2":"SKLEP","paymentSeeWebsite3":" dla innych opcji płatności","paymentOr":"- LUB -","couldNotStartMlaTitle":"Napotkaliśmy problem","couldNotStartMlaText":"Nie można uruchomić Moje Licencje. Administrator został powiadomiony. Sprawdź ponownie później. Jeśli problem będzie się powtarzał, skontaktuj się z naszym wsparciem.","skipEndOfHandLabel":"Skip End Of Hand","inPosition":"In Position","outOfPosition":"Out Of Position","amountBb":"${0} bb","amountBbPlus":"${0}+ bb","amountBb100":"${0} bb/100","cbetCbetSuccessTip":"Cbet Success: ${0} % <br/>Winrate: ${1} bb/100","riverBetEfficiencyTip":"${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverCallEfficiencyTip":"${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverHandFrequencyTip":"Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100","riverPotSizeFrequencyTip":"Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100","tourneyallinRaisingCallingByPositionTip":"${0} (${1})<br/>Races Won: ${2}","threebetBetFrequencyTip":"3-Bet: ${0} % <br/>Winrate: ${1} bb/100","ipOopTip":"${0}<br/>In Position: ${1}<br/>Out of Position: ${2}","riverHereyoucanfind6":"Here you can find how often and how efficiently you play on the river based on pot size.","riverCombinethisview6":"Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.","potSizeFrequencyP":"Pot Size Frequency (%)","riverHereyoucanfind5":"Here you can find how often and how efficiently you play different hole cards on the river.","riverCombinethisview5":"Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.","riverHereyoucanfind4":"Here you can find how often and how efficiently you play on the river with different hand strengths.","riverCombinethisview4":"Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.","riverRiverCallEfficiencyNetWon":"River Call Efficiency Net Won","riverRCE":"River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.","riverCombinethisview3":"Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.","riverSawShowdown":"Saw Showdown","riverNoShowdown":"No Showdown","riverMadeRiverCbet":"Made River Cbet","riverMadeRiverDonkBet":"Made River Donk Bet","riverSmallriverbets":"Small river bets (<50% pot)","riverBigriverbets":"Big river bets (>100% pot)","riverFacedRiverCbet":"Faced River Cbet","riverFacedRiverDonkBet":"Faced River Donk Bet","riverRiverBet":"River Bet","riverRiverCall":"River Call","riverRiverRaise":"River Raise","riverRiverFold":"River Fold","riverWonHand":"Won Hand","riverLostHand":"Lost Hand","riverRiverBetEfficiencyNetWon":"River Bet Efficiency Net Won","riverRBE":"River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.","riverCombinethisview2":"Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.","riverHereyoucanfind":"Here you can find how aggressively you play on the river and your results for each action played.","tip":"Tip","riverCombinethisview":"Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more","riverAsPreflopAggressor":"As Preflop Aggressor","riverVsPreflopAggressor":"Vs Preflop Aggressor","riverCheckedToRiver":"Checked To River","handFrequencyP":"Hand Frequency (%)","totalHands":"Total Hands","wonAtShowdown":"Won At Showdown","riverAggression":"River Aggression","riverCallEff":"River Call Eff","riverBetEff":"River Bet Eff","riverWentToShowdown":"Went To Showdown","riverRiverHoleCards":"River Hole Cards","riverRiverHandStrength":"River Hand Strength","riverRiverAgression":"River Agression %","riverRiverCallEfficiency":"River Call Efficiency","riverRiverBetEfficiency":"River Bet Efficiency","riverRiverPotSize":"River Pot Size","numberOfTables":"Number Of Tables","sessions":"Sessions","leakonomicsOpponentNoteColor":"Opponent Note Color","leakonomicsSessionProgressSessionNames":"Shorter;Average Session Length;Longer","leakonomicsSessionProgressMin":"Session Progress (Min)","netWonBb":"Net Won (bb)","leakonomicsSessionsSplit":"Sessions Split","leakonomicsPotAmountWonbb":"Pot Amount Won (bb)","orLess":"${0} or less","leakonomicsAllinSplit":"All-in Split","leakonomicsAllinWinsInaRow":"All-in Wins in a Row","winnings":"Winnings","leakonomicsRollingWindow":"Rolling Window Graph","leakonomicsNetWon":"Net Won Up/Down","leakonomicsUpDownSessionNames":"When Down;Neutral;When Up","leakonomicsPreflopStatsDev":"Preflop Stats Dev","leakonomicsBestWrt":"Best wrt: ${0} bb","leakonomicsBestWrtAt":"At ${0} min","leakonomicsWinlossSessionNames":"Loss Series;Neutral;Win Series","leakonomicsAllinRate":"All-in Rate","leakonomicsWinningP":"Winning: ${0}%","leakonomicsLosingP":"Losing: ${0}%","leakonomicsBestWrt2":"Best wrt: ${0} bb/hr","leakonomicsBestWrtAt2":"At ${0} table(s)","at":"At","leakonomicsWinrateBb100P":"Winrate: 5bb/100","leakonomicsPotsLost":"Pots lost: ${0}%","leakonomicsPotsWon":"Pots won: ${0}%","leakonomicsWhenUporDownInSession":"When Up or Down In Session","leakonomicsSessionProgress":"Session Progress","leakonomicsAfterAllinSeries":"After All-in Series","leakonomicsWhenMultitabling":"When Multitabling","leakonomicsVsOpponentbyNoteColor":"Vs Opponent by Note Color","leakonomicsAfterWinningorlosingapot":"After Winning or losing a pot","cbetSuccessP":"CBet Success %","winrate":"Winrate","winrateBB100":"Winrate (bb/100)","cbetActionHU":"CBet action: Heads Up","cbetActionMultiway":"CBet action: Multiway","cbetActionHUNoHands":"Heads Up: No Hands","cbetActionMultiwayNoHands":"Multiway: No Hands","cbetWonLost":"$ Won / Lost","cbetResultsSkippedDonut1Title":"Overall Skipped Cbet","cbetResultsSkippedDonutSubtitle":"Over ${0} Hands<br/>${1} bb/100","cbetResultsSkippedDonut1TitleNoHands":"Overall Skipped Cbet: No Hands","cbetResultsSkippedDonut2Title":"Overall CBet Success","cbetResultsSkippedDonut2TitleNoHands":"Overall Cbet Success: No Hands","hands":"Hands","cbetActionIP":"CBet action: In Position","cbetActionOOP":"CBet action: Out Of Position","cbetNoHandsIP":"In Position: No Hands","cbetNoHandsOOP":"Out Of Position: No Hands","cbetOverallSuccess":"Overall Success","cbetFlopCBetSuccess":"Flop CBet Success","cbetCBetWinrate":"CBet Winrate","cbetSkippedCBetWinnings":"Skipped CBet Winnings","cbetCBetSuccessBoardTexture":"CBet Success: Board Texture","cbetCBetSuccessPosition":"CBet Success: Position","cbetHandStrengthwhenCBettting":"Hand Strength when CBettting","cbetCBetSpotsHeadsUpvsMultiway":"CBet Spots - HeadsUp vs Multiway","cbetCBetSpotsInPositionvsOutofPosition":"CBet Spots - In Position vs Out of Position","cbetResultsSkippedCBet":"Results Skipped CBet","bubbleICMDescription5":"The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.","bubblePercentageDescription5":"Percentage of the prize pool won categorized by your effective stack size","bubblePreflopDescription5":"Your preflop stats categorized on your stack size","bubbleEffectiveStackSizebb":"Effective Stack Size (bb)","bubbleBubbleStackSize":"Bubble Stack Size","bubbleCallingAllInRange":"Calling All-In Range","bubbleSitNGoEntrants":"Sit 'N Go Entrants","bubbleICMDescription4":"The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.","bubblePercentageDescription4":"Percentage of the prize pool won categorized by the number of entrants","bubblePreflopDescription4":"Your preflop stats categorized on your stack size","bubbleBubblePosition":"Bubble Position","bubbleICMDescription3":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.","bubblePercentageDescription3":"Percentage of the prize pool won categorized by your position","bubblePreflopDescription3":"Your preflop stats categorized by your position","bubblePreflopDescription2":"Percentage of the prize pool won categorized by the number players remaining at the bubble","bubblePlayersAtBubble":"# Players At Bubble","bubbleBubblePlayers":"Bubble Players at Bubble","bubblePrizePoolP":"Prize Pool%","bubbleBubbleStage":"Bubble Stage","bubbleEVbb100hands":"EV BB/100 Hands","bubbleICMDescription":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.","bubblePercentageDescription":"Percentage of the prize pool won before, during, and after the bubble","bubblePreflopDescription":"Your preflop stats categorized on your stack size","bubblePrizePoolWon":"Prize Pool Won","bubbleExpectedValue":"Expected Value","bubbleAverageStack":"Average Stack","bubbleCallAIWinrate":"Call AI Winrate","bubbleShoveAIWinrate":"Shove AI Winrate","tooFewHands":"Too Few Hands For This Report","bubblePrizePoolWinningsTitle":"Prize Pool Winnings","bubbleExpectationWhenReachingBubbleTitle":"Expectation When Reaching Bubble","bubblePositionTitle":"Position","bubbleBeforeAndAfterTitle":"Before And After","bubbleStackSizeTitle":"Stack Size","bubbleCallRangesTitle":"Call Ranges","bubbleShoveRangesTitle":"Shove Ranges","tourneyallinRaisingOpenAI":"Raising Open AI","tourneyallinRaising3BetAI":"Raising 3Bet AI","tourneyallinRaisevsOpen":"Raise vs Open","tourneyallinRaisevs3Bet":"Raise vs 3-Bet","tourneyallinCallvsOpen":"Call vs Open","tourneyallinCallvs3Bet":"Call vs 3-Bet","tourneyallinPreflopEffectiveStackSizeAxis":"Preflop Effective Stack Size","tourneyallinRacesWonPAxis":"Races Won %","tourneyallinEquityPAxis":"Equity %","tourneyallinCallingOpenAI":"Calling Open AI","tourneyallinCalling3BetAI":"Calling 3Bet AI","tourneyallinPositionAxis":"Position","tourneyallinExpectationAxis":"Expectation","threebetResultsTitle":"Results","threebetPositionTitle":"Position","threebetRangeTitle":"Three Bet Range","threebetSuccessTitle":"Three Bet Success","threebetFlopHandStrengthTitle":"Flop Hand Strength","threebetWinrate":"3Bet Winrate","threebetFrequency":"3Bet Frequency","threebetRange":"3Bet Range","threebetSuccessRate":"3Bet Success Rate","threebetFlopWinrate":"Flop Winrate","threebetWinrateHandStrengthAxis":"Winrate Hand Strength (bb/100)","threebetHandCount":"${0} (${1} Hands)","threebetWinrateKey":"Winrate","threebetThreeBetPercentKey":"3-Bet %","threebetWinrateAxis":"Winrate (bb/100)","threebetThreeBetPercentAxis":"3-Bet %","threebetSuccessPercentAxis":"Success %","threebetNetwonTitle":"Net Won","threebetNetwonMin":"Loss","threebetNetwonMax":"Profit","threebetDealtFrequencyTitle":"Dealt Frequency","threebetDealtFrequencyMin":"Less Frequent","threebetDealtFrequencyMax":"More Frequent","tourneyallinExpectedWon":"Expected Won","availableStringPositionString":"EP;MP;CO;BTN;SB;BB","availableStringFlopMadeHandValueString":"Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush","availableStringRiverMadeHandValueSummary":"Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush","availableStringFlopFlushTextureTypeAsString":"Flush Rainbow;Flush Two Tone;Flush Monotone","availableStringFlopStraightTextureTypeAsString":"Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper","availableStringFlopPairedTextureTypeAsString":"Paired Board;Not Paired","availableStringInPositionOnFlopShort":"IP;OOP","availableStringInPositionOnFlopLong":"In Position;Out Of Position","availableStringRiverplayCallEfficiency":"Call Efficiency;In Position;Out Of Position","availableStringRiverplayBetEfficiency":"Bet Efficiency;In Position;Out Of Position","availableStringCBetSpots":"Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand","availableStringRiverFirstActionString":"Fold;Check;Call;Bet;Raise","ECCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","ECCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","ECTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","ECTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","ERRaiseCallVsVillainOpenAllinPreflop":"AI PF vs Raise","ERRaiseEVCallVsVillainOpenAllinPreflop":"Expectation AI PF vs Raise","ERTBetCallVsVillainOpenAllinPreflop":"3Bet AI PF vs Re-Raise","ERTBetEVCallVsVillainOpenAllinPreflop":"Expectation 3Bet AI PF vs Re-Raise","BPCCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","BPCCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","BPCTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","BPCTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","BPRRaiseAllinVsRaisePreflop":"AI PF vs Raise","BPRRaiseEVAllinVsRaisePreflop":"Expectation AI PF vs Raise","BPRTBetAllinVsRaisePreflop":"3Bet AI PF vs Re-Raise","BPRTBetEVAllinVsRaisePreflop":"Expectation 3Bet AI PF vs Re-Raise","threebetHandAxis":"Hand","threebetNetBbAxis":"Net BBs","tourneyallinCallingByStackTitle":"Expectation Calling All-In By Stack Size","tourneyallinRaisingByStackTitle":"Expectation Raising All-In By Stack Size","tourneyallinRaisingAllinRangeTitle":"Raising All-In Range","tourneyallinCallingAllinRangeTitle":"Calling All-In Range","tourneyallinCallingAllinByPositionTitle":"Calling All-In Results By Position","tourneyallinRaisingAllinByPositionTitle":"Raising All-In Results By Position","tourneyallinCallAIEVWinrate":"Call AI EV Winrate","tourneyallinRaiseAIEVWinrate":"Raise AI EV Winrate","tourneyallinCallAIWinrate":"Call AI Winrate","tourneyallinRaiseAIWinrate":"Raise AI Winrate","overall":"Overall","restrictionsWithYourLicenseText":"<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"},portugese:{"notAllowedByLicense":"Mãos não permitidas pela licença","selectHandToExport":"Selecione a mão para exportar","selectFormat":"Selecione o formato","originalFormat":"Formato Original","ctrlCToCopy":"CTRL-C para copiar para área de transferência","availableTags":"Etiquetas disponíveis","welcomeToHm3":"Seja bem vindo ao HoldemManager 3 Replayer!","theme":"Tema:","deck":"Cartas de Jogar:","showHandResults":"Mostrar os resultados de uma mão","showHeroCards":"Mostrar sempre o Hero nas cartas do jogador","showBB":"Mostrar fichas na BB","combineFolds":"Combinar Folds","maskPlayerNames":"Esconder o nome dos jogadores","statsUpToTimeOfHand":"Estatísticas para o tempo da mão","showHud":"Mostrar HUD","replaySpeed":"Replay a velocidade","hand":"Mão","next100Hands":"Próximas 100 Mãos","prev100Hands":"100 Mãos Anteriores","addEditHandMarking":"Adicionar/Editar Marcações","wonXBB":"Won ${0} BB","lostXBB":"Lost ${0} BB","wonLossNA":"Won/Loss NA","potBB":"Pote: ${0} BB","userWentAllin":"Utilizador foi Allin","pot":"Pote: ${0}","potOdds":"Pot Odds: ${0}:1","hhGameStart":"${0} jogo ${1} começa nos ${2}","hhHandNotes":"Nota(s) de Mão(s)","hhFold":"${0} Folds","hhCheck":"${0} Checks","hhCall":"${0} Calls ${1}","hhBet":"${0} Bets ${1}","hhRaise":"${0} Raises ${1}","hhReturnedTo":"${1} Voltou para ${0}","hhWin":"${0} Wins ${1}","hhRake":"Rake: ${0}","hhActionEnded":"A ação terminou.","hhMuck":"${0} mucks ${1}","hhShow":"${0} mostrar ${1}","hhPostSB":"${0} posts small blind","hhPostBB":"${0} posts big blind","hhPostDB":"${0} posts a dead blind","backToReleaseNotes":"Voltar para a liberação de notas","backToMyLicense":"Voltar para a minha licença","backToCardInfo":"Voltar para a informação do cartão de crédito","backToPayment":"Voltar para o método de pagamento","orderBuyNow":"Comprar Agora","orderProceed":"Continuar","headerTextTrial":"Teste (${0} Dias Restantes)","headerTextFree":"Gratuíto","smallStakes":"Small Stakes","allStakes":"All Stakes","smallStakesCaps":"SMALL STAKES","allStakesCaps":"ALL STAKES","smallStakesMaintenance":"MANUTENÇÃO SMALL STAKES","allStakesMaintenance":"MANUTENÇÃO ALL STAKES","buyHoldemSmallStakes":"Holdem Small Stakes","buyHoldemAllStakes":"Holdem All Stakes","buyHoldemOmahaAllStakes":"All Stakes","buyOmahaSmallStakes":"Omaha Small Stakes","buyOmahaAllStakes":"Omaha All Stakes","holdemManager":"Holdem Manager","holdemManagerCaps":"HOLDEM MANAGER","omahaCaps":"OMAHA","holdem":"Holdem","omaha":"Omaha","hmApps":"Aplicações HM","hm3":"HM3","om3":"OM3","hm3andOm3":"HM3 + OM3","expiredOn":"Expirou em ${0}","expiresOn":"Expira em ${0}","recommended":"RECOMENADO","seeAllOptionsInStore":"Ver todas as opções na loja","paypalExternalBrowser":"O PayPal irá abrir uma outra página para que possa continuar a processar o pagamento.","skrillExternalBrowser":"Skrill irá abrir uma outra página para que possa continuar a processar o pagamento.","selectProduct":"SELECIONE O PRODUTO","availableUpdate":"ATUALIZAÇÃO DISPONÍVEL","versionAvailable":"A versão ${0} está disponível: ${1}","fullFaq":"Mostrar todas as notas FAQ","reviewOptions":"Reveja a opção de manutenção do Holdem antes de iniciar o processo de atualização","maintenanceOptions":"Opções de Manutenção","addProductToLicense":"ADICIONAR ${0} PARA A ATUAL LICENÇA","purchasePrice":"Comprar (${0})","errorName":"Por favor introduza o seu Nome Completo","errorAddress":"Por favor introduza a sua Morada e Número","errorCountry":"Por favor introduza o seu País","errorCity":"Por favor introduza a sua Cidade","errorZip":"Por favor introduza o seu Código Postal","billingInfo":"Informação de Faturação","name":"Nome Completo","address":"Morada","city":"Cidade","state":"Estado/Província","zip":"Código Postal","country":"País","selectCountry":"Selecione o país","buyNowTip":"Por favor selecione uma forma de pagamento já existente ou introduza um novo método de pagamento antes de continuar","licenses":"LICENÇAS","version":"Versão ${0}","viewReleaseNotes":"Visualizar versão de notas na página do site","updateAndRenewMaintenance":"ATUALIZAR & RENOVAR A MANUTENÇÃO ","renewGetUpdatesUntil":"Ao renovar a manutenção irá receber todas as atualizações do HM3 através de ${0}","update":"Atualizar","updateAndSwitchToFree":"ATUALIZAR & ALTERAR PARA A VERSÃO GRATUÍTA","updateAndSwitchToFreeDetails1":"Irá receber uma atualização mas o programa HM3 (Holdem) será revertido para a versão gratuíta ","updateAndSwitchToFreeDetails2":"funcionalidade limitada","updateAndSwitch":"Atualizar & Alterar","errorCreditCardDigitsOnly":"O cartão de crédito deverá apenas conter números.","errorCreditCard":"Por favor introduza um número válido do cartão.","errorRequired":"Requerido","errorCardExpired":"O Cartão Expirou","errorCvv":"O CVV deverá ser ${0} em números","cardInfo":"INFORMAÇÃO DO CARTÃO DE CRÉDITO","cardNo":"Num do Cartão","expiry":"Expira","year":"ano","month":"mês","month01":"Jan","month02":"Fev","month03":"Mar","month04":"Abril","month05":"Maio","month06":"Jun","month07":"Jul","month08":"Agosto","month09":"Set","month10":"Out","month11":"Nov","month12":"Dec","cvv":"CVV","active":"Ativo","manageSubscription":"Gestão de Subscrição","youAreUpToDate":"Está atualizado","releaseNotes":"Release notes for ${0}","netellerInfo":"Informação da conta NETELLER","netellerSignin":"Entre na sua conta NETELLER para completar a sua compra.","continue_":"Continue","netellerAccount":"Conta Neteller","netellerPassword":"Palavra Passe","orderSummary":"RESUMO DO PEDIDO","changeProducts":"Alterar Produto(s)","total":"Total","paypalComplete":"POR FAVOR COMPLETE A SUA COMPRA PAYPAL NA PÁGINA WEB","paypalOpenedInNewBrowser":"O PayPal foi aberto em uma janela do navegador de internet padrão. Por favor entre com a sua conta PayPal e complete a compra. Assim que a compra seja realizada, volte aqui e pressione \"Recarregar Licença\" para que a licença que comprou possa ficar disponível.","reloadLicense":"Recarregar Licença","thankYouForPurchase":"Obrigado Pela Sua Compra","purchaseConfirm1":"Irá receber um email em breve com a confirmação em ${0}","purchaseConfirm2":"Por favor pressione o botão recarregar licença e a sua licença comprada ficará ativa.","restricted":"restrito","restrictionsWithYourLicense":"RESTRIÇÕES COM A SUA LICENÇA ATUAL","paymentPleaseChoose":"Por favor escolha um método de pagamento","paymentSelectExisting":"Selecione um método de pagamento já existente","paymentSelectNew":"Método de Pagamento","paymentMethod":"Método de Pagamento:","changePaymentMethod":"Alterar o Método de Pagamento","licensedTo":"LICENÇA PARA","learnMore":"Saber mais","startTrial":"Iniciar Período de Teste ","purchase":"Compra","trialSuccessfullyStarted":"Iniciou o Período de Teste Com Sucesso","trialSuccessDetails1":"O seu período de teste de 14 dias está ativo. Por favor...","trialSuccessDetails2":"Atualizar","trialSuccessDetails3":"...Assim que possível para evitar interrupções no seu serviço.","havingTrouble":"Está a ter problemas?","contactUs":"Contate-nos","startUsing":"Começar a usar o HM3 agora","missedUpdates":"${0} atualizações perdidas","updatesAreCritical":"As atualizações são importantes para assegurarem que o HM3 continua a importar o seu histórico de mãos mesmo quando as salas de jogo alteram o seu próprio programa. Os novos recursos e funcionalidades também são disponíveis através das atualizações.","view":"Visualizar","oneYearOfUpdates":"Inclui um ano de atualizações","renew":"Renovar (${0})","startingAt":"Começar Em","upgrade":"Atualizar","removesRestrictions1":"Remover","removesRestrictions2":"restrições","removesRestrictions3":"e inclui um ano de atualizações","upgradePrice":"Atualizar (${0})","required":"Requirido","continueFreemium":"Continue na Versão Gratuíta","defaultFatalError":"Ocorreu um erro inesperado no servidor interno e um administrador foi notificado. Por favor tente efetuar a sua compra mais tarde.","restrictCashHandsType":"Cash Hands","restrictTourneyType":"Torneio","restrictLimitCashHandsType":"Limit Cash Hands","restrictHudType":"HUD","restrictReportDataType":"Relatório de Data","restrictCashHands":"$ ${0} e abaixo","restrictLimitCashHands":"$ ${0} e abaixo","restrictTourney":"Max ${0}","restrictHud":"Max ${0} Mesa(s)","restrictReportData":"Última(s) ${0} Mão(s)","restrictionUnlimited":"Ilimitado","errorState":"Requirido","activeHoldemLicense":"ATIVAR A LICENÇA HOLDEM","activeOmahaLicense":"ATIVAR A LICENÇA OMAHA","reinstallOldVersion":"Reinstalar a Versão Antiga","removesRestrictions3b":"e retorna de volta para a licença paga e as atualizações são","removesRestrictions4b":"NÃO INCLUSO","noActiveHoldemLicense":"SEM LICENÇA ATIVA HOLDEM","noActiveOmahaLicense":"SEM LICENÇA ATIVA OMAHA","free":"GRATUÍTO","netellerSecureId":"Secure ID","recurringPriceDescription":"${0} ${1} Incluso*","recurringYear":"Ano","recurringMonth":"Mês","recurringDay":"Dia","restrictionsSmall":"No Limit/Pot Limit Cash <b>restricted</b> up to $0.50 big blinds\nFixed Limit Cash <b>restricted</b> up to $1.00 big blinds\nTournaments <b>restricted</b> up to $22.00 buy-ins.","afterDiscount":"Preço após desconto por tempo limitado","upgradeDiscount":"DESCONTO ATUALIZADO","discountExpires":"O desconto expira em ${0}","discountSinglePurchase":"O desconto aplica-se apenas a uma compra única.","errorNetellerAccount":"Número ID Inválido de Conta Neteller","errorNetellerSecureId":"Por favor introduza os seis dígitos do Secure ID","continueTrial":"Continuar teste","continueTrialDaysRemaining":"(${0} Dias Restantes)\n","netellerInvalidCredentials":"Nós não pudemos validar as suas credenciais Neteller. Por favor tente entrar novamente.","faq":"FAQ","forMoreDetails":"para obter mais detalhes sobre como administrar a sua renovação anual de suporte e manutenção.","recurringSubscription":"* O Método de Pagamento é necessário para a renovação da Manutenção e Suporte anual de $${0} que será cobrada em um ano (${1}). Visualizar.","positivePrice":"A renovação anual da Manutenção e Suporte de $${0}  será cobrada em um ano  (${1}). Visualizar.","paymentSeeWebsite1":"Veja","paymentSeeWebsite2":"LOJA","paymentSeeWebsite3":"para outras opções de pagamento","paymentOr":"- OU - ","couldNotStartMlaTitle":"Nós encontramos um problema","couldNotStartMlaText":"Não poderá Iniciar Minhas Licenças. Um Administrador foi informado. Por favor volte a verificar novamente mais tarde. Se o problema persistir, por favor contacte o nosso suporte.","skipEndOfHandLabel":"Skip End Of Hand","inPosition":"In Position","outOfPosition":"Out Of Position","amountBb":"${0} bb","amountBbPlus":"${0}+ bb","amountBb100":"${0} bb/100","cbetCbetSuccessTip":"Cbet Success: ${0} % <br/>Winrate: ${1} bb/100","riverBetEfficiencyTip":"${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverCallEfficiencyTip":"${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverHandFrequencyTip":"Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100","riverPotSizeFrequencyTip":"Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100","tourneyallinRaisingCallingByPositionTip":"${0} (${1})<br/>Races Won: ${2}","threebetBetFrequencyTip":"3-Bet: ${0} % <br/>Winrate: ${1} bb/100","ipOopTip":"${0}<br/>In Position: ${1}<br/>Out of Position: ${2}","riverHereyoucanfind6":"Here you can find how often and how efficiently you play on the river based on pot size.","riverCombinethisview6":"Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.","potSizeFrequencyP":"Pot Size Frequency (%)","riverHereyoucanfind5":"Here you can find how often and how efficiently you play different hole cards on the river.","riverCombinethisview5":"Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.","riverHereyoucanfind4":"Here you can find how often and how efficiently you play on the river with different hand strengths.","riverCombinethisview4":"Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.","riverRiverCallEfficiencyNetWon":"River Call Efficiency Net Won","riverRCE":"River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.","riverCombinethisview3":"Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.","riverSawShowdown":"Saw Showdown","riverNoShowdown":"No Showdown","riverMadeRiverCbet":"Made River Cbet","riverMadeRiverDonkBet":"Made River Donk Bet","riverSmallriverbets":"Small river bets (<50% pot)","riverBigriverbets":"Big river bets (>100% pot)","riverFacedRiverCbet":"Faced River Cbet","riverFacedRiverDonkBet":"Faced River Donk Bet","riverRiverBet":"River Bet","riverRiverCall":"River Call","riverRiverRaise":"River Raise","riverRiverFold":"River Fold","riverWonHand":"Won Hand","riverLostHand":"Lost Hand","riverRiverBetEfficiencyNetWon":"River Bet Efficiency Net Won","riverRBE":"River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.","riverCombinethisview2":"Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.","riverHereyoucanfind":"Here you can find how aggressively you play on the river and your results for each action played.","tip":"Tip","riverCombinethisview":"Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more","riverAsPreflopAggressor":"As Preflop Aggressor","riverVsPreflopAggressor":"Vs Preflop Aggressor","riverCheckedToRiver":"Checked To River","handFrequencyP":"Hand Frequency (%)","totalHands":"Total Hands","wonAtShowdown":"Won At Showdown","riverAggression":"River Aggression","riverCallEff":"River Call Eff","riverBetEff":"River Bet Eff","riverWentToShowdown":"Went To Showdown","riverRiverHoleCards":"River Hole Cards","riverRiverHandStrength":"River Hand Strength","riverRiverAgression":"River Agression %","riverRiverCallEfficiency":"River Call Efficiency","riverRiverBetEfficiency":"River Bet Efficiency","riverRiverPotSize":"River Pot Size","numberOfTables":"Number Of Tables","sessions":"Sessions","leakonomicsOpponentNoteColor":"Opponent Note Color","leakonomicsSessionProgressSessionNames":"Shorter;Average Session Length;Longer","leakonomicsSessionProgressMin":"Session Progress (Min)","netWonBb":"Net Won (bb)","leakonomicsSessionsSplit":"Sessions Split","leakonomicsPotAmountWonbb":"Pot Amount Won (bb)","orLess":"${0} or less","leakonomicsAllinSplit":"All-in Split","leakonomicsAllinWinsInaRow":"All-in Wins in a Row","winnings":"Winnings","leakonomicsRollingWindow":"Rolling Window Graph","leakonomicsNetWon":"Net Won Up/Down","leakonomicsUpDownSessionNames":"When Down;Neutral;When Up","leakonomicsPreflopStatsDev":"Preflop Stats Dev","leakonomicsBestWrt":"Best wrt: ${0} bb","leakonomicsBestWrtAt":"At ${0} min","leakonomicsWinlossSessionNames":"Loss Series;Neutral;Win Series","leakonomicsAllinRate":"All-in Rate","leakonomicsWinningP":"Winning: ${0}%","leakonomicsLosingP":"Losing: ${0}%","leakonomicsBestWrt2":"Best wrt: ${0} bb/hr","leakonomicsBestWrtAt2":"At ${0} table(s)","at":"At","leakonomicsWinrateBb100P":"Winrate: 5bb/100","leakonomicsPotsLost":"Pots lost: ${0}%","leakonomicsPotsWon":"Pots won: ${0}%","leakonomicsWhenUporDownInSession":"When Up or Down In Session","leakonomicsSessionProgress":"Session Progress","leakonomicsAfterAllinSeries":"After All-in Series","leakonomicsWhenMultitabling":"When Multitabling","leakonomicsVsOpponentbyNoteColor":"Vs Opponent by Note Color","leakonomicsAfterWinningorlosingapot":"After Winning or losing a pot","cbetSuccessP":"CBet Success %","winrate":"Winrate","winrateBB100":"Winrate (bb/100)","cbetActionHU":"CBet action: Heads Up","cbetActionMultiway":"CBet action: Multiway","cbetActionHUNoHands":"Heads Up: No Hands","cbetActionMultiwayNoHands":"Multiway: No Hands","cbetWonLost":"$ Won / Lost","cbetResultsSkippedDonut1Title":"Overall Skipped Cbet","cbetResultsSkippedDonutSubtitle":"Over ${0} Hands<br/>${1} bb/100","cbetResultsSkippedDonut1TitleNoHands":"Overall Skipped Cbet: No Hands","cbetResultsSkippedDonut2Title":"Overall CBet Success","cbetResultsSkippedDonut2TitleNoHands":"Overall Cbet Success: No Hands","hands":"Hands","cbetActionIP":"CBet action: In Position","cbetActionOOP":"CBet action: Out Of Position","cbetNoHandsIP":"In Position: No Hands","cbetNoHandsOOP":"Out Of Position: No Hands","cbetOverallSuccess":"Overall Success","cbetFlopCBetSuccess":"Flop CBet Success","cbetCBetWinrate":"CBet Winrate","cbetSkippedCBetWinnings":"Skipped CBet Winnings","cbetCBetSuccessBoardTexture":"CBet Success: Board Texture","cbetCBetSuccessPosition":"CBet Success: Position","cbetHandStrengthwhenCBettting":"Hand Strength when CBettting","cbetCBetSpotsHeadsUpvsMultiway":"CBet Spots - HeadsUp vs Multiway","cbetCBetSpotsInPositionvsOutofPosition":"CBet Spots - In Position vs Out of Position","cbetResultsSkippedCBet":"Results Skipped CBet","bubbleICMDescription5":"The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.","bubblePercentageDescription5":"Percentage of the prize pool won categorized by your effective stack size","bubblePreflopDescription5":"Your preflop stats categorized on your stack size","bubbleEffectiveStackSizebb":"Effective Stack Size (bb)","bubbleBubbleStackSize":"Bubble Stack Size","bubbleCallingAllInRange":"Calling All-In Range","bubbleSitNGoEntrants":"Sit 'N Go Entrants","bubbleICMDescription4":"The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.","bubblePercentageDescription4":"Percentage of the prize pool won categorized by the number of entrants","bubblePreflopDescription4":"Your preflop stats categorized on your stack size","bubbleBubblePosition":"Bubble Position","bubbleICMDescription3":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.","bubblePercentageDescription3":"Percentage of the prize pool won categorized by your position","bubblePreflopDescription3":"Your preflop stats categorized by your position","bubblePreflopDescription2":"Percentage of the prize pool won categorized by the number players remaining at the bubble","bubblePlayersAtBubble":"# Players At Bubble","bubbleBubblePlayers":"Bubble Players at Bubble","bubblePrizePoolP":"Prize Pool%","bubbleBubbleStage":"Bubble Stage","bubbleEVbb100hands":"EV BB/100 Hands","bubbleICMDescription":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.","bubblePercentageDescription":"Percentage of the prize pool won before, during, and after the bubble","bubblePreflopDescription":"Your preflop stats categorized on your stack size","bubblePrizePoolWon":"Prize Pool Won","bubbleExpectedValue":"Expected Value","bubbleAverageStack":"Average Stack","bubbleCallAIWinrate":"Call AI Winrate","bubbleShoveAIWinrate":"Shove AI Winrate","tooFewHands":"Too Few Hands For This Report","bubblePrizePoolWinningsTitle":"Prize Pool Winnings","bubbleExpectationWhenReachingBubbleTitle":"Expectation When Reaching Bubble","bubblePositionTitle":"Position","bubbleBeforeAndAfterTitle":"Before And After","bubbleStackSizeTitle":"Stack Size","bubbleCallRangesTitle":"Call Ranges","bubbleShoveRangesTitle":"Shove Ranges","tourneyallinRaisingOpenAI":"Raising Open AI","tourneyallinRaising3BetAI":"Raising 3Bet AI","tourneyallinRaisevsOpen":"Raise vs Open","tourneyallinRaisevs3Bet":"Raise vs 3-Bet","tourneyallinCallvsOpen":"Call vs Open","tourneyallinCallvs3Bet":"Call vs 3-Bet","tourneyallinPreflopEffectiveStackSizeAxis":"Preflop Effective Stack Size","tourneyallinRacesWonPAxis":"Races Won %","tourneyallinEquityPAxis":"Equity %","tourneyallinCallingOpenAI":"Calling Open AI","tourneyallinCalling3BetAI":"Calling 3Bet AI","tourneyallinPositionAxis":"Position","tourneyallinExpectationAxis":"Expectation","threebetResultsTitle":"Results","threebetPositionTitle":"Position","threebetRangeTitle":"Three Bet Range","threebetSuccessTitle":"Three Bet Success","threebetFlopHandStrengthTitle":"Flop Hand Strength","threebetWinrate":"3Bet Winrate","threebetFrequency":"3Bet Frequency","threebetRange":"3Bet Range","threebetSuccessRate":"3Bet Success Rate","threebetFlopWinrate":"Flop Winrate","threebetWinrateHandStrengthAxis":"Winrate Hand Strength (bb/100)","threebetHandCount":"${0} (${1} Hands)","threebetWinrateKey":"Winrate","threebetThreeBetPercentKey":"3-Bet %","threebetWinrateAxis":"Winrate (bb/100)","threebetThreeBetPercentAxis":"3-Bet %","threebetSuccessPercentAxis":"Success %","threebetNetwonTitle":"Net Won","threebetNetwonMin":"Loss","threebetNetwonMax":"Profit","threebetDealtFrequencyTitle":"Dealt Frequency","threebetDealtFrequencyMin":"Less Frequent","threebetDealtFrequencyMax":"More Frequent","tourneyallinExpectedWon":"Expected Won","availableStringPositionString":"EP;MP;CO;BTN;SB;BB","availableStringFlopMadeHandValueString":"Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush","availableStringRiverMadeHandValueSummary":"Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush","availableStringFlopFlushTextureTypeAsString":"Flush Rainbow;Flush Two Tone;Flush Monotone","availableStringFlopStraightTextureTypeAsString":"Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper","availableStringFlopPairedTextureTypeAsString":"Paired Board;Not Paired","availableStringInPositionOnFlopShort":"IP;OOP","availableStringInPositionOnFlopLong":"In Position;Out Of Position","availableStringRiverplayCallEfficiency":"Call Efficiency;In Position;Out Of Position","availableStringRiverplayBetEfficiency":"Bet Efficiency;In Position;Out Of Position","availableStringCBetSpots":"Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand","availableStringRiverFirstActionString":"Fold;Check;Call;Bet;Raise","ECCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","ECCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","ECTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","ECTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","ERRaiseCallVsVillainOpenAllinPreflop":"AI PF vs Raise","ERRaiseEVCallVsVillainOpenAllinPreflop":"Expectation AI PF vs Raise","ERTBetCallVsVillainOpenAllinPreflop":"3Bet AI PF vs Re-Raise","ERTBetEVCallVsVillainOpenAllinPreflop":"Expectation 3Bet AI PF vs Re-Raise","BPCCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","BPCCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","BPCTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","BPCTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","BPRRaiseAllinVsRaisePreflop":"AI PF vs Raise","BPRRaiseEVAllinVsRaisePreflop":"Expectation AI PF vs Raise","BPRTBetAllinVsRaisePreflop":"3Bet AI PF vs Re-Raise","BPRTBetEVAllinVsRaisePreflop":"Expectation 3Bet AI PF vs Re-Raise","threebetHandAxis":"Hand","threebetNetBbAxis":"Net BBs","tourneyallinCallingByStackTitle":"Expectation Calling All-In By Stack Size","tourneyallinRaisingByStackTitle":"Expectation Raising All-In By Stack Size","tourneyallinRaisingAllinRangeTitle":"Raising All-In Range","tourneyallinCallingAllinRangeTitle":"Calling All-In Range","tourneyallinCallingAllinByPositionTitle":"Calling All-In Results By Position","tourneyallinRaisingAllinByPositionTitle":"Raising All-In Results By Position","tourneyallinCallAIEVWinrate":"Call AI EV Winrate","tourneyallinRaiseAIEVWinrate":"Raise AI EV Winrate","tourneyallinCallAIWinrate":"Call AI Winrate","tourneyallinRaiseAIWinrate":"Raise AI Winrate","overall":"Overall","restrictionsWithYourLicenseText":"<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"},portugese_br:{"notAllowedByLicense":"Mão não permitida pela licença","selectHandToExport":"Selecione a mão para exportar","selectFormat":"Selecionar o formato","originalFormat":"Formato Original","ctrlCToCopy":"Ctrl-C para copiar para a área de transferência","availableTags":"Marcas Disponíveis","welcomeToHm3":"Seja bem vindo ao HoldemManager3 Replayer!","theme":"Tema","deck":"Baralho","showHandResults":"Mostrar Resultado da Mão","showHeroCards":"Sempre mostrar o Herói quando as cartas do jogador estão viradas para baixo","showBB":"Mostrar fichas na BB","combineFolds":"Combinar Folds","maskPlayerNames":"Mascarar os nomes do jogador","statsUpToTimeOfHand":"Estatísticas até o tempo da mão","showHud":"Mostrar HUD","replaySpeed":"Velocidade de Repetição","hand":"Mão","next100Hands":"Próximas 100 mãos","prev100Hands":"100 Mãos Anteriores","addEditHandMarking":"Adicionar/Editar Marcação Manual","wonXBB":"Won ${0} BB","lostXBB":"Lost ${0} BB","wonLossNA":"Won/Loss NA","potBB":"Pote: ${0} BB","userWentAllin":"Usuário foi Allin","pot":"Pote: ${0}","potOdds":"Pot Odds: ${0}:1","hhGameStart":"${0} jogo ${1} começa em ${2}","hhHandNotes":"Nota(s) da Mão","hhFold":"${0} Folds","hhCheck":"${0} Checks","hhCall":"${0} Calls ${1}","hhBet":"${0} Bets ${1}","hhRaise":"${0} Raises ${1}\n","hhReturnedTo":"${1} Returned to ${0}","hhWin":"${0} Wins ${1}","hhRake":"Rake: ${0}","hhActionEnded":"A ação acabou.","hhMuck":"${0} mucks ${1}","hhShow":"${0} shows ${1}","hhPostSB":"${0} posts small blind","hhPostBB":"${0} posts big blind","hhPostDB":"${0} posts a dead blind","backToReleaseNotes":"Voltar para as Notas da Versão atual","backToMyLicense":"Voltar para a Minha Licença","backToCardInfo":"Voltar para a Informação do Cartão de Crédito","backToPayment":"Voltar para o Método de Pagamento","orderBuyNow":"Comprar Agora","orderProceed":"Continuar","headerTextTrial":"O período de teste (${0} Dias Seguintes)","headerTextFree":"Gratuíto","smallStakes":"Small Stakes","allStakes":"All Stakes\n","smallStakesCaps":"SMALL STAKES","allStakesCaps":"ALL STAKES","smallStakesMaintenance":"MANUTENÇÃO DE SMALL STAKES ","allStakesMaintenance":"MANUTENÇÃO DE TODAS AS STAKES","buyHoldemSmallStakes":"Holdem Small Stakes","buyHoldemAllStakes":"Hodem Todas as Stakes","buyHoldemOmahaAllStakes":"All Stakes","buyOmahaSmallStakes":"Omaha Small Stakes","buyOmahaAllStakes":"Omaha All Stakes","holdemManager":"Holdem Manager","holdemManagerCaps":"HOLDEM MANAGER","omahaCaps":"OMAHA","holdem":"HOLDEM","omaha":"Omaha","hmApps":"HM Apps","hm3":"HM3","om3":"OM3","hm3andOm3":"HM3 + OM3","expiredOn":"Expirou em ${0}","expiresOn":"Expira em ${0}","recommended":"RECOMENDADO","seeAllOptionsInStore":"Veja todas as opções da loja","paypalExternalBrowser":"O PayPal será aberto numa janela externa para que você possa completar o pagamento.","skrillExternalBrowser":"A Skrill irá abrir uma janela externa para que você possa completar o pagamento.","selectProduct":"SELECIONE O PRODUTO","availableUpdate":"ATUALIZAÇÃO DISPONÍVEL","versionAvailable":"Versão ${0} está disponível: ${1}","fullFaq":"FAQ de notas da versão completa","reviewOptions":"Reveja as opções de manutenção Holdem antes de continuar com a atualização","maintenanceOptions":"Opções de Manutenção","addProductToLicense":"ADICIONE ${0} PARA A SUA ATUAL LICENÇA","purchasePrice":"Compra (${0})\n","errorName":"Por favor insira o seu Nome Completo","errorAddress":"Por favor insira o nome da sua Rua e número","errorCountry":"Por favor insira o seu País","errorCity":"Por favor insira a sua Cidade","errorZip":"Por favor insira o seu CEP","billingInfo":"Informação de Cobrança","name":"Nome Completo","address":"Nome da Rua","city":"Cidade","state":"Estado/Bairro","zip":"CEP","country":"País","selectCountry":"Selecione o País","buyNowTip":"Por favor selecione uma opção de pagamento existente ou um novo método antes de continuar","licenses":"LICENÇAS","version":"Versão ${0}","viewReleaseNotes":"Visualizar notas atualizadas no navegador","updateAndRenewMaintenance":"ATUALIZAR & RENOVAR A MANUTENÇÃO","renewGetUpdatesUntil":"Renovando a manutenção você irá receber todas as atualizações do HM3 através de ${0}","update":"Atualizar","updateAndSwitchToFree":"ATUALIZAR & TROCAR PARA A VERSÃO GRATUÍTA","updateAndSwitchToFreeDetails1":"Você irá receber a atualização mas o seu programa HM3 (Holdem) irá ser revertido para a versão gratuíta ","updateAndSwitchToFreeDetails2":"funcionalidade limitada","updateAndSwitch":"Atualizar & Trocar","errorCreditCardDigitsOnly":"O número do seu cartão de crédito deverá conter apenas dígitos.","errorCreditCard":"Por favor insira um número de cartão válido.","errorRequired":"Requerido","errorCardExpired":"O Cartão Expirou","errorCvv":"CVV deverá ser ${0} em dígitos","cardInfo":"INFORMAÇÃO DO CARTÃO DE CRÉDITO","cardNo":"Cartão No","expiry":"Expira","year":"ano","month":"mês","month01":"Jan","month02":"Fev","month03":"Mar","month04":"Abril","month05":"Maio","month06":"Jun","month07":"Jul","month08":"Ago","month09":"Set","month10":"Out","month11":"Nov","month12":"Dec","cvv":"CVV","active":"Ativo","manageSubscription":"Gerenciar Assinatura","youAreUpToDate":"Você está atualizado até a data","releaseNotes":"Versão de notas para ${0}","netellerInfo":"Informação da Conta NETELLER","netellerSignin":"Inicie a sessão com a sua conta NETELLER para completar a sua compra","continue_":"Continuar","netellerAccount":"Conta Neteller","netellerPassword":"Senha","orderSummary":"RESUMO DO PEDIDO","changeProducts":"Mudar produto (s)","total":"Total","paypalComplete":"POR FAVOR COMPLETE A SUA COMPRA ATRAVÉS DA PAPYPAL NO SEU NAVEGADOR","paypalOpenedInNewBrowser":"Nós abriremos o PayPal no seu navegador de internet padrão. Por favor inicie sessão com a sua conta PayPal e complete a sua compra. Assim que a sua compra esteja completa, volte aqui e clique em \"Recarregar Licença\" para que a licença que você comprou seja atualizada.","reloadLicense":"Recarregar a licença","thankYouForPurchase":"Obrigado pela sua compra","purchaseConfirm1":"Você irá receber um email em breve com a confirmação em ${0}","purchaseConfirm2":"Por favor clique em recarregar licença no botão abaixo e a sua licença comprada ficará ativa.","restricted":"restrito","restrictionsWithYourLicense":"RESTRIÇÕES COM A SUA LICENÇA ATUAL","paymentPleaseChoose":"Por favor escolha um método de pagamento","paymentSelectExisting":"Selecione um método de pagamento já existente","paymentSelectNew":"Método de Pagamento","paymentMethod":"Método de Pagamento","changePaymentMethod":"Mudar o Método de Pagamento","licensedTo":"LICENÇA PARA","learnMore":"Leia mais","startTrial":"Iniciar o teste","purchase":"Compra","trialSuccessfullyStarted":"O teste começou com sucesso","trialSuccessDetails1":"Os seus 14 dias de teste estão agora ativos. Por favor","trialSuccessDetails2":"atualizar","trialSuccessDetails3":"assim que for possível para evitar interrupções no seu serviço.","havingTrouble":"Você está tendo problemas?","contactUs":"Entre em contato conosco","startUsing":"Iniciar usando o HM3 agora","missedUpdates":"${0} atualizações em falta","updatesAreCritical":"As atualizações são importantes para assegurarem que o HM3 continua a importação do histórico das suas mãos quando que as salas de poker mudam o seu programa. Novos recursos e funcionalidade serão também adicionados com essas atualizações.","view":"Visualizar","oneYearOfUpdates":"Inclui o ano das atualizações","renew":"Renova (${0})","startingAt":"Iniciando em","upgrade":"Atualizar","removesRestrictions1":"Remove","removesRestrictions2":"restrições","removesRestrictions3":"e inclui um ano de atualizações","upgradePrice":"Atualizar (${0})","required":"Requerido","continueFreemium":"Continuar com a Versão Gratuíta","defaultFatalError":"Um erro interno inesperado ocorreu e um administrador foi informado. Por favor tente comprar novamente mais tarde.","restrictCashHandsType":"Mãos de Cash","restrictTourneyType":"Torneio","restrictLimitCashHandsType":"Mãos de Limit Cash","restrictHudType":"HUD","restrictReportDataType":"Reportar Data","restrictCashHands":"$ ${0} e abaixo","restrictLimitCashHands":"$ ${0} e abaixo","restrictTourney":"Máx ${0}","restrictHud":"Máx ${0} Table(s)\n","restrictReportData":"Últimas ${0} Mãos","restrictionUnlimited":"Ilimiatdo","errorState":"Requerido","activeHoldemLicense":"LICENÇA HOLDEM ATIVADA","activeOmahaLicense":"LICENÇA OMAHA ATIVADA","reinstallOldVersion":"Reinstale a Versão Antiga","removesRestrictions3b":"e reverte novamente para a sua versão paga mas as atualizações são","removesRestrictions4b":"NÃO INCLUSO","noActiveHoldemLicense":"SEM LICENÇA HOLDEM ATIVA","noActiveOmahaLicense":"SEM LICENÇA OMAHA ATIVA","free":"GRATUÍTO","netellerSecureId":"Secure ID","recurringPriceDescription":"${0} ${1} Incluso","recurringYear":"Ano","recurringMonth":"Mês","recurringDay":"Dia","restrictionsSmall":"No Limit/Pot Limit Cash <b>restricted</b> up to $0.50 big blinds\nFixed Limit Cash <b>restricted</b> up to $1.00 big blinds\nTournaments <b>restricted</b> up to $22.00 buy-ins.","afterDiscount":"Preço depois do tempo limitado de desconto","upgradeDiscount":"DESCONTO ATUALIZADO","discountExpires":"O desconto expira em ${0}","discountSinglePurchase":"O desconto só se aplica para uma compra única","errorNetellerAccount":"Número de ID da Conta Neteller Inválido","errorNetellerSecureId":"Por favor insira os 6 dígitos do seu ","continueTrial":"Continuar com o teste","continueTrialDaysRemaining":"(${0} Dias Restantes)","netellerInvalidCredentials":"Nós não podemos validar a sua credencial Netteler. Por favor tente iniciar novamente.","faq":"FAQ","forMoreDetails":"para mais detalhes em como gerenciar a sua renovação anual de Suporte & Manutenção.","recurringSubscription":"O Método de Pagamento é solicitado para a renovação anual de Suporte & Manutenção de $${0}  pelo qual será debitaqdo em um ano (${1}). Visualizar","positivePrice":"A renovação de Suporte & Manutenção anual de $${0} será debitada em um ano ${1}). Visualizar","paymentSeeWebsite1":"Veja","paymentSeeWebsite2":"LOJA","paymentSeeWebsite3":"para outras opções de pagamento","paymentOr":"- OU -","couldNotStartMlaTitle":"Nós encontramos um problema","couldNotStartMlaText":"Não pode Iniciar as Minhas Licenças. Um Administrador foi informado. Por favor volte a verificar novamente mais tarde. Se o problema persistir, por favor entre em contato com o nosso suporte.","skipEndOfHandLabel":"Skip End Of Hand","inPosition":"In Position","outOfPosition":"Out Of Position","amountBb":"${0} bb","amountBbPlus":"${0}+ bb","amountBb100":"${0} bb/100","cbetCbetSuccessTip":"Cbet Success: ${0} % <br/>Winrate: ${1} bb/100","riverBetEfficiencyTip":"${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverCallEfficiencyTip":"${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverHandFrequencyTip":"Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100","riverPotSizeFrequencyTip":"Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100","tourneyallinRaisingCallingByPositionTip":"${0} (${1})<br/>Races Won: ${2}","threebetBetFrequencyTip":"3-Bet: ${0} % <br/>Winrate: ${1} bb/100","ipOopTip":"${0}<br/>In Position: ${1}<br/>Out of Position: ${2}","riverHereyoucanfind6":"Here you can find how often and how efficiently you play on the river based on pot size.","riverCombinethisview6":"Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.","potSizeFrequencyP":"Pot Size Frequency (%)","riverHereyoucanfind5":"Here you can find how often and how efficiently you play different hole cards on the river.","riverCombinethisview5":"Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.","riverHereyoucanfind4":"Here you can find how often and how efficiently you play on the river with different hand strengths.","riverCombinethisview4":"Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.","riverRiverCallEfficiencyNetWon":"River Call Efficiency Net Won","riverRCE":"River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.","riverCombinethisview3":"Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.","riverSawShowdown":"Saw Showdown","riverNoShowdown":"No Showdown","riverMadeRiverCbet":"Made River Cbet","riverMadeRiverDonkBet":"Made River Donk Bet","riverSmallriverbets":"Small river bets (<50% pot)","riverBigriverbets":"Big river bets (>100% pot)","riverFacedRiverCbet":"Faced River Cbet","riverFacedRiverDonkBet":"Faced River Donk Bet","riverRiverBet":"River Bet","riverRiverCall":"River Call","riverRiverRaise":"River Raise","riverRiverFold":"River Fold","riverWonHand":"Won Hand","riverLostHand":"Lost Hand","riverRiverBetEfficiencyNetWon":"River Bet Efficiency Net Won","riverRBE":"River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.","riverCombinethisview2":"Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.","riverHereyoucanfind":"Here you can find how aggressively you play on the river and your results for each action played.","tip":"Tip","riverCombinethisview":"Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more","riverAsPreflopAggressor":"As Preflop Aggressor","riverVsPreflopAggressor":"Vs Preflop Aggressor","riverCheckedToRiver":"Checked To River","handFrequencyP":"Hand Frequency (%)","totalHands":"Total Hands","wonAtShowdown":"Won At Showdown","riverAggression":"River Aggression","riverCallEff":"River Call Eff","riverBetEff":"River Bet Eff","riverWentToShowdown":"Went To Showdown","riverRiverHoleCards":"River Hole Cards","riverRiverHandStrength":"River Hand Strength","riverRiverAgression":"River Agression %","riverRiverCallEfficiency":"River Call Efficiency","riverRiverBetEfficiency":"River Bet Efficiency","riverRiverPotSize":"River Pot Size","numberOfTables":"Number Of Tables","sessions":"Sessions","leakonomicsOpponentNoteColor":"Opponent Note Color","leakonomicsSessionProgressSessionNames":"Shorter;Average Session Length;Longer","leakonomicsSessionProgressMin":"Session Progress (Min)","netWonBb":"Net Won (bb)","leakonomicsSessionsSplit":"Sessions Split","leakonomicsPotAmountWonbb":"Pot Amount Won (bb)","orLess":"${0} or less","leakonomicsAllinSplit":"All-in Split","leakonomicsAllinWinsInaRow":"All-in Wins in a Row","winnings":"Winnings","leakonomicsRollingWindow":"Rolling Window Graph","leakonomicsNetWon":"Net Won Up/Down","leakonomicsUpDownSessionNames":"When Down;Neutral;When Up","leakonomicsPreflopStatsDev":"Preflop Stats Dev","leakonomicsBestWrt":"Best wrt: ${0} bb","leakonomicsBestWrtAt":"At ${0} min","leakonomicsWinlossSessionNames":"Loss Series;Neutral;Win Series","leakonomicsAllinRate":"All-in Rate","leakonomicsWinningP":"Winning: ${0}%","leakonomicsLosingP":"Losing: ${0}%","leakonomicsBestWrt2":"Best wrt: ${0} bb/hr","leakonomicsBestWrtAt2":"At ${0} table(s)","at":"At","leakonomicsWinrateBb100P":"Winrate: 5bb/100","leakonomicsPotsLost":"Pots lost: ${0}%","leakonomicsPotsWon":"Pots won: ${0}%","leakonomicsWhenUporDownInSession":"When Up or Down In Session","leakonomicsSessionProgress":"Session Progress","leakonomicsAfterAllinSeries":"After All-in Series","leakonomicsWhenMultitabling":"When Multitabling","leakonomicsVsOpponentbyNoteColor":"Vs Opponent by Note Color","leakonomicsAfterWinningorlosingapot":"After Winning or losing a pot","cbetSuccessP":"CBet Success %","winrate":"Winrate","winrateBB100":"Winrate (bb/100)","cbetActionHU":"CBet action: Heads Up","cbetActionMultiway":"CBet action: Multiway","cbetActionHUNoHands":"Heads Up: No Hands","cbetActionMultiwayNoHands":"Multiway: No Hands","cbetWonLost":"$ Won / Lost","cbetResultsSkippedDonut1Title":"Overall Skipped Cbet","cbetResultsSkippedDonutSubtitle":"Over ${0} Hands<br/>${1} bb/100","cbetResultsSkippedDonut1TitleNoHands":"Overall Skipped Cbet: No Hands","cbetResultsSkippedDonut2Title":"Overall CBet Success","cbetResultsSkippedDonut2TitleNoHands":"Overall Cbet Success: No Hands","hands":"Hands","cbetActionIP":"CBet action: In Position","cbetActionOOP":"CBet action: Out Of Position","cbetNoHandsIP":"In Position: No Hands","cbetNoHandsOOP":"Out Of Position: No Hands","cbetOverallSuccess":"Overall Success","cbetFlopCBetSuccess":"Flop CBet Success","cbetCBetWinrate":"CBet Winrate","cbetSkippedCBetWinnings":"Skipped CBet Winnings","cbetCBetSuccessBoardTexture":"CBet Success: Board Texture","cbetCBetSuccessPosition":"CBet Success: Position","cbetHandStrengthwhenCBettting":"Hand Strength when CBettting","cbetCBetSpotsHeadsUpvsMultiway":"CBet Spots - HeadsUp vs Multiway","cbetCBetSpotsInPositionvsOutofPosition":"CBet Spots - In Position vs Out of Position","cbetResultsSkippedCBet":"Results Skipped CBet","bubbleICMDescription5":"The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.","bubblePercentageDescription5":"Percentage of the prize pool won categorized by your effective stack size","bubblePreflopDescription5":"Your preflop stats categorized on your stack size","bubbleEffectiveStackSizebb":"Effective Stack Size (bb)","bubbleBubbleStackSize":"Bubble Stack Size","bubbleCallingAllInRange":"Calling All-In Range","bubbleSitNGoEntrants":"Sit 'N Go Entrants","bubbleICMDescription4":"The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.","bubblePercentageDescription4":"Percentage of the prize pool won categorized by the number of entrants","bubblePreflopDescription4":"Your preflop stats categorized on your stack size","bubbleBubblePosition":"Bubble Position","bubbleICMDescription3":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.","bubblePercentageDescription3":"Percentage of the prize pool won categorized by your position","bubblePreflopDescription3":"Your preflop stats categorized by your position","bubblePreflopDescription2":"Percentage of the prize pool won categorized by the number players remaining at the bubble","bubblePlayersAtBubble":"# Players At Bubble","bubbleBubblePlayers":"Bubble Players at Bubble","bubblePrizePoolP":"Prize Pool%","bubbleBubbleStage":"Bubble Stage","bubbleEVbb100hands":"EV BB/100 Hands","bubbleICMDescription":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.","bubblePercentageDescription":"Percentage of the prize pool won before, during, and after the bubble","bubblePreflopDescription":"Your preflop stats categorized on your stack size","bubblePrizePoolWon":"Prize Pool Won","bubbleExpectedValue":"Expected Value","bubbleAverageStack":"Average Stack","bubbleCallAIWinrate":"Call AI Winrate","bubbleShoveAIWinrate":"Shove AI Winrate","tooFewHands":"Too Few Hands For This Report","bubblePrizePoolWinningsTitle":"Prize Pool Winnings","bubbleExpectationWhenReachingBubbleTitle":"Expectation When Reaching Bubble","bubblePositionTitle":"Position","bubbleBeforeAndAfterTitle":"Before And After","bubbleStackSizeTitle":"Stack Size","bubbleCallRangesTitle":"Call Ranges","bubbleShoveRangesTitle":"Shove Ranges","tourneyallinRaisingOpenAI":"Raising Open AI","tourneyallinRaising3BetAI":"Raising 3Bet AI","tourneyallinRaisevsOpen":"Raise vs Open","tourneyallinRaisevs3Bet":"Raise vs 3-Bet","tourneyallinCallvsOpen":"Call vs Open","tourneyallinCallvs3Bet":"Call vs 3-Bet","tourneyallinPreflopEffectiveStackSizeAxis":"Preflop Effective Stack Size","tourneyallinRacesWonPAxis":"Races Won %","tourneyallinEquityPAxis":"Equity %","tourneyallinCallingOpenAI":"Calling Open AI","tourneyallinCalling3BetAI":"Calling 3Bet AI","tourneyallinPositionAxis":"Position","tourneyallinExpectationAxis":"Expectation","threebetResultsTitle":"Results","threebetPositionTitle":"Position","threebetRangeTitle":"Three Bet Range","threebetSuccessTitle":"Three Bet Success","threebetFlopHandStrengthTitle":"Flop Hand Strength","threebetWinrate":"3Bet Winrate","threebetFrequency":"3Bet Frequency","threebetRange":"3Bet Range","threebetSuccessRate":"3Bet Success Rate","threebetFlopWinrate":"Flop Winrate","threebetWinrateHandStrengthAxis":"Winrate Hand Strength (bb/100)","threebetHandCount":"${0} (${1} Hands)","threebetWinrateKey":"Winrate","threebetThreeBetPercentKey":"3-Bet %","threebetWinrateAxis":"Winrate (bb/100)","threebetThreeBetPercentAxis":"3-Bet %","threebetSuccessPercentAxis":"Success %","threebetNetwonTitle":"Net Won","threebetNetwonMin":"Loss","threebetNetwonMax":"Profit","threebetDealtFrequencyTitle":"Dealt Frequency","threebetDealtFrequencyMin":"Less Frequent","threebetDealtFrequencyMax":"More Frequent","tourneyallinExpectedWon":"Expected Won","availableStringPositionString":"EP;MP;CO;BTN;SB;BB","availableStringFlopMadeHandValueString":"Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush","availableStringRiverMadeHandValueSummary":"Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush","availableStringFlopFlushTextureTypeAsString":"Flush Rainbow;Flush Two Tone;Flush Monotone","availableStringFlopStraightTextureTypeAsString":"Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper","availableStringFlopPairedTextureTypeAsString":"Paired Board;Not Paired","availableStringInPositionOnFlopShort":"IP;OOP","availableStringInPositionOnFlopLong":"In Position;Out Of Position","availableStringRiverplayCallEfficiency":"Call Efficiency;In Position;Out Of Position","availableStringRiverplayBetEfficiency":"Bet Efficiency;In Position;Out Of Position","availableStringCBetSpots":"Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand","availableStringRiverFirstActionString":"Fold;Check;Call;Bet;Raise","ECCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","ECCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","ECTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","ECTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","ERRaiseCallVsVillainOpenAllinPreflop":"AI PF vs Raise","ERRaiseEVCallVsVillainOpenAllinPreflop":"Expectation AI PF vs Raise","ERTBetCallVsVillainOpenAllinPreflop":"3Bet AI PF vs Re-Raise","ERTBetEVCallVsVillainOpenAllinPreflop":"Expectation 3Bet AI PF vs Re-Raise","BPCCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","BPCCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","BPCTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","BPCTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","BPRRaiseAllinVsRaisePreflop":"AI PF vs Raise","BPRRaiseEVAllinVsRaisePreflop":"Expectation AI PF vs Raise","BPRTBetAllinVsRaisePreflop":"3Bet AI PF vs Re-Raise","BPRTBetEVAllinVsRaisePreflop":"Expectation 3Bet AI PF vs Re-Raise","threebetHandAxis":"Hand","threebetNetBbAxis":"Net BBs","tourneyallinCallingByStackTitle":"Expectation Calling All-In By Stack Size","tourneyallinRaisingByStackTitle":"Expectation Raising All-In By Stack Size","tourneyallinRaisingAllinRangeTitle":"Raising All-In Range","tourneyallinCallingAllinRangeTitle":"Calling All-In Range","tourneyallinCallingAllinByPositionTitle":"Calling All-In Results By Position","tourneyallinRaisingAllinByPositionTitle":"Raising All-In Results By Position","tourneyallinCallAIEVWinrate":"Call AI EV Winrate","tourneyallinRaiseAIEVWinrate":"Raise AI EV Winrate","tourneyallinCallAIWinrate":"Call AI Winrate","tourneyallinRaiseAIWinrate":"Raise AI Winrate","overall":"Overall","restrictionsWithYourLicenseText":"<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"},romanian:{"notAllowedByLicense":"Mâna nu este Permisă de Licență","selectHandToExport":"Selectează Mâna pentru Exportare","selectFormat":"Selectează Formatul...","originalFormat":"Formatul Original","ctrlCToCopy":"Ctrl-C pentru Copiere pe Clipboard","availableTags":"Etichete Disponibile","welcomeToHm3":"Bine ai venit la HoldemManager 3 Replayer!","theme":"Tema:","deck":"Pachetul:","showHandResults":"Arată Rezultatele Mânii ","showHeroCards":"Întotdeauna Arată Cărțile Principale","showBB":"Arată Jetoanele în BB:","combineFolds":"Aruncări Combinate:","maskPlayerNames":"Ascunde Numele Jucătorului:","statsUpToTimeOfHand":"Intervalul de Timp pentru Mână:","showHud":"Arată HUD:","replaySpeed":"Viteza reluării:","hand":"Mâna","next100Hands":"Următoarele 100 de Mâini","prev100Hands":"Cele 100 de Mâini Anterioare","addEditHandMarking":"Adăugare/Editare Marcaje Mână","wonXBB":"Ai câștigat ${0} BB","lostXBB":"Ai pierdut ${0} BB","wonLossNA":"Câștiguri/Pierderi NA","potBB":"Pot: ${0} BB","userWentAllin":"Utilizatorul a Mizat AllIn","pot":"Pot: ${0}","potOdds":"Cote Pot: ${0}:1","hhGameStart":" ${0} jocul ${1} începe de la ${2}","hhHandNotes":"Notă/Note Mână ","hhFold":"${0} Se Aruncă","hhCheck":"${0} Verificat","hhCall":"${0} Cere ${1}","hhBet":"${0} Pariază ${1}","hhRaise":"${0} Crește Miza cu ${1}","hhReturnedTo":"${1} Obținuți de ${0}","hhWin":"${0} A câștigat ${1}","hhRake":"Miza:${0}","hhActionEnded":"Acțiunea s-a terminat.","hhMuck":"${0} distruge miza cu ${1}","hhShow":"${0} arată ${1}","hhPostSB":"${0} joacă cu blind-uri mici","hhPostBB":"${0} joacă cu blind-uri mari","hhPostDB":"${0} joacă cu un blind mort","backToReleaseNotes":"Înapoi la Notele de Eliberare","backToMyLicense":"Înapoi la Licența Mea","backToCardInfo":"Înapoi la Informații Card de Credit","backToPayment":"Înapoi la Metoda de Plată","orderBuyNow":"Cumpără Acum","orderProceed":"Continuă","headerTextTrial":"Demo (${0} Zile Rămase)","headerTextFree":"Gratis","smallStakes":"Mize Mici","allStakes":"Toate Mizele","smallStakesCaps":"MIZE MICI","allStakesCaps":"TOATE MIZELE","smallStakesMaintenance":"ÎNTREȚINERE MIZE MICI","allStakesMaintenance":"ÎNTREȚINERE TOATE MIZELE","buyHoldemSmallStakes":"Holdem Mize Mici","buyHoldemAllStakes":"Holdem Toate Mizele","buyHoldemOmahaAllStakes":"Toate Mizele","buyOmahaSmallStakes":"Omaha Mize Mici","buyOmahaAllStakes":"Omaha Toate Mizele","holdemManager":"Holdem Manager","holdemManagerCaps":"HOLDEM MANAGER","omahaCaps":"OMAHA","holdem":"Holdem","omaha":"Omaha","hmApps":"Aplicații HM","hm3":"HM3","om3":"OM3","hm3andOm3":"HM3 + OM3","expiredOn":"Expirată în ${0}","expiresOn":"Expiră în ${0}","recommended":"RECOMANDATE","seeAllOptionsInStore":"Vezi toate Opțiunile în Magazin","paypalExternalBrowser":"Pay Pal va deschide o pagină externă de browser pentru a completa procesul de plată.","skrillExternalBrowser":"Skrill va deschide o pagină externă de browser pentru a completa procesul de plată.","selectProduct":"SELECTEAZĂ PRODUSUL","availableUpdate":"ACTUALIZARE DISPONIBILĂ:","versionAvailable":"Versiunea ${0} este disponibilă: ${1}","fullFaq":"FAQ Note Complete despre lansare","reviewOptions":"Citește despre opțiunile de întreținere Holdem înainte de a continua cu actualizarea.","maintenanceOptions":"Opțiuni Întreținere","addProductToLicense":"ADAUGĂ ${0} LA LICENȚA TA ACTUALĂ ","purchasePrice":"Preț de Achiziție (${0})","errorName":"Te rugăm să-ți introduci Numele Complet","errorAddress":"Te rugăm să introduci numele și numărul Străzii","errorCountry":"Te rugăm să introduci Țara","errorCity":"Te rugăm să introduci Orașul","errorZip":"Te rugăm să introduci un Cod Poștal valabil","billingInfo":"INFORMAȚII FACTURARE","name":"Nume Complet","address":"Adresa Străzii","city":"Oraș","state":"Județ/Sector","zip":"Zip/Cod Poștal","country":"Țara","selectCountry":"Selectează o Țară","buyNowTip":"Te rugăm să selectezi o metodă de plată nouă sau una deja existentă înainte de a continua","licenses":"LICENȚE","version":"Versiunea ${0}","viewReleaseNotes":"Vizualizează notele de lansare de pe site","updateAndRenewMaintenance":"ÎNTREȚINERE ACTUALIZARE&REÎNNOIRE","renewGetUpdatesUntil":"Prin alegerea mentenanței de reînnoire, vei primi toate actualizările HM3 prin ${0}","update":"Actualizare","updateAndSwitchToFree":"ACTUALIZARE&TRECERE LA VERSIUNEA GRATUITĂ","updateAndSwitchToFreeDetails1":"Vei primi actualizarea, dar software-ul tău HM3 (Holdem) se va schimba în versiunea Gratuită și vei avea","updateAndSwitchToFreeDetails2":"o funcționalitate limitată","updateAndSwitch":"Actualizează & Schimbă","errorCreditCardDigitsOnly":"Numărul cardului de credit trebuie să conțină doar cifre.","errorCreditCard":"Te rugăm să introduci un card de credit valabil.","errorRequired":"Solicitat","errorCardExpired":"Card Expirat","errorCvv":"CVV-ul trebuie să aibă o lungime de ${0} cifre","cardInfo":"INFORMAȚII CARD DE CREDIT","cardNo":"Nr. Card","expiry":"Expiră","year":"anul","month":"luna","month01":"Ian","month02":"Feb","month03":"Mar","month04":"Apr","month05":"Mai","month06":"Iun","month07":"Iul","month08":"Aug","month09":"Sep","month10":"Oct","month11":"Nov","month12":"Dec","cvv":"CVV","active":"Activ","manageSubscription":"Gestionează Abonamentul","youAreUpToDate":"Este valid până la data de ","releaseNotes":"Note de lansare pentru ${0}","netellerInfo":"Informații cont  NETELLER","netellerSignin":"Loghează-te în contul tău NETELLER pentru a putea completa achiziția","continue_":"Continuă","netellerAccount":"Cont Neteller","netellerPassword":"Parola ","orderSummary":"SUMAR COMANDĂ","changeProducts":"Schimbă Produs/e","total":"Total","paypalComplete":"TE RUGĂM SĂ FINALIZEZI ACHIZIȚIA DIN CONTUL TĂU DE PAYPAL","paypalOpenedInNewBrowser":"Am creat o fereastră în browserul de internet pentru logarea în contul tău de PayPal. Te rugăm să te loghezi în contul tău de PayPal și să finalizezi achiziția. Imediat ce ai finalizat achiziția, întoarce-te aici și apasă butonul \"Reîncărcare Licență\" pentru a încărca licența pe care tocmai ai cumpărat-o.","reloadLicense":"Reîncărcare Licență","thankYouForPurchase":"Îți Mulțumim pentru Achiziție","purchaseConfirm1":"Vei primi un email de confirmare intr-un interval scurt de timp la ${0}","purchaseConfirm2":"Vei primi un email de confirmare într-un interval scurt de timp la ${0}","restricted":"restricționat","restrictionsWithYourLicense":"RESTRICȚII PENTRU LICENȚA TA ACTUALĂ","paymentPleaseChoose":"Te rugăm să alegi o metodă de plată","paymentSelectExisting":"Selectează o metodă de plată dintre cele existente:","paymentSelectNew":"Adaugă o nouă metodă de plată:","paymentMethod":"Metodă de Plată:","changePaymentMethod":"Schimbă Metoda de Plată","licensedTo":"LICENȚIAT PENTRU","learnMore":"Află mai multe","startTrial":"Începe Versiunea Demo","purchase":"Achiziționează","trialSuccessfullyStarted":"Versiunea Demo a început cu Succes","trialSuccessDetails1":"Versiunea ta demo de 14 zile este activă. Te rugăm ","trialSuccessDetails2":"să actualizezi","trialSuccessDetails3":"cât de curând posibil pentru a evita orice fel de întreruperi în furnizarea serviciului.","havingTrouble":"Întâmpini probleme?","contactUs":"Contactează-ne","startUsing":"Începe să utilizezi HM3 chiar acum","missedUpdates":" ${0} actualizări ratate","updatesAreCritical":"Actualizările sunt esențiale pentru a asigura continuitatea HM3 și posibilitatea de a importa istoricele mâinilor jucate după ce site-ul de poker își modifică software-ul. Noi caracteristici și funcții sunt lansate odată cu actualizările realizate de noi.","view":"Vizualizare","oneYearOfUpdates":"Include un an de actualizări","renew":"Reînnoire ${0})","startingAt":"Începe La ","upgrade":"Actualizare","removesRestrictions1":"Elimină","removesRestrictions2":"restricțiile\n","removesRestrictions3":"și include un an de actualizări","upgradePrice":"Actualizare (${0})","required":"Necesară","continueFreemium":"Continuă cu Versiunea Gratuită","defaultFatalError":"O eroare internă neașteptată a survenit la server și un administrator a fost informat despre situație. Te rugăm să încerci să efectuezi achiziția din nou, mai târziu.","restrictCashHandsType":"Mâini Cash","restrictTourneyType":"Turneu","restrictLimitCashHandsType":"Mâini Cash Limitate","restrictHudType":"HUD","restrictReportDataType":"Raport de Date","restrictCashHands":"$ ${0} și jos","restrictLimitCashHands":"$ ${0} și jos","restrictTourney":"Max ${0}","restrictHud":"Max ${0} Masă/Mese","restrictReportData":"Ultimele ${0} Mâini","restrictionUnlimited":"Nelimitată","errorState":"Necesară","activeHoldemLicense":"LICENȚĂ HOLDEM ACTIVĂ","activeOmahaLicense":"LICENȚĂ OMAHA ACTIVĂ","reinstallOldVersion":"Reinstalează Versiunea Veche","removesRestrictions3b":"și reîntoarce-te la licența ta plătită, dar actualizările ","removesRestrictions4b":"NU SUNT INCLUSE","noActiveHoldemLicense":"LICENȚA HOLDEM INACTIVĂ","noActiveOmahaLicense":"LICENȚA OMAHA INACTIVĂ","free":"GRATIS","netellerSecureId":"ID Sigur","recurringPriceDescription":"${0} ${1} Inclus*","recurringYear":"Anul","recurringMonth":"Luna","recurringDay":"Ziua","restrictionsSmall":"Pot Fără Limită/Cu Limită Cash <b>restricționat</b> până la $0.50 blind-uri mari\nLimită Fixă de Cash  <b>restricționată</b> până la $1.00 blind-uri mari\nTurnee <b>restricționate</b> până la $22.00 buy-in-uri.","afterDiscount":"Prețul după oferta de reducere promoțională","upgradeDiscount":"REDUCERE PENTRU UPGRADE","discountExpires":"Reducerea expiră în ${0}","discountSinglePurchase":"Reducerea se aplică unei singure achiziții","errorNetellerAccount":"ID Cont Neteller Invalid","errorNetellerSecureId":"Te rugăm să introduci ID-ul de Siguranță din 5 cifre","continueTrial":"Continuă Versiunea Demo","continueTrialDaysRemaining":"(${0} Zile Rămase)","netellerInvalidCredentials":"Nu am putut să-ți validăm acreditările contului tău de Neteller. Te rugăm să te loghezi din nou.","faq":"FAQ","forMoreDetails":"pentru mai multe detalii despre gestionarea opțiunii de reînnoire anuală a funcției Asistență & Întreținere.","recurringSubscription":"Metoda de plată este necesară pentru reînnoirea opțiunii anuale a funcției Asistență & Întreținere pentru $${0}, aceasta fiind facturată pentru un an (${1}). Vezi","positivePrice":"Reînnoirea opțiunii anuale a funcției Asistență & Întreținere pentru $${0} va fi facturată pentru un an (${1}). Vezi","paymentSeeWebsite1":"Vizitează","paymentSeeWebsite2":"MAGAZINUL","paymentSeeWebsite3":"pentru alte metode de plată","paymentOr":"- SAU -","couldNotStartMlaTitle":"Am întâmpinat o problemă","couldNotStartMlaText":"Nu A Fost Posibilă Pornirea Licențelor Mele. Un Administrator a fost notificat despre această problemă. Te rugăm să verifici din nou, mai târziu. Dacă problema continuă, te rugăm să contactezi echipa noastră de asistență.","skipEndOfHandLabel":"Sări Finalul Mâinii ","inPosition":"Pe Poziție","outOfPosition":"În Afara Poziției","amountBb":"${0} bb","amountBbPlus":"${0}+ bb","amountBb100":"${0} bb/100","cbetCbetSuccessTip":"Succes Cbet: ${0} % <br/>Rata de Câștig: ${1} bb/100","riverBetEfficiencyTip":"${0}<br/>Eficiență Pariu: ${1}<br/>Pe Poziție: ${2}<br/>În Afara Poziției: ${3}","riverCallEfficiencyTip":"${0}<br/>Eficiență Call: ${1}<br/>Pe Poziție: ${2}<br/>În Afara Poziției: ${3}","riverHandFrequencyTip":"Frecvența Mâinii: ${0} % <br/>Rata de Câștig: ${1} bb/100","riverPotSizeFrequencyTip":"Frecvență Mărime Pot: ${0} % <br/>Rata de Câștig: ${1} bb/100","tourneyallinRaisingCallingByPositionTip":"${0} (${1})<br/>Curse Câștigate: ${2}","threebetBetFrequencyTip":"3-Pariu: ${0} % <br/>Rata de Câștig: ${1} bb/100","ipOopTip":"${0}<br/>Pe Poziție: ${1}<br/>În Afara Poziției: ${2}","riverHereyoucanfind6":"Aici poți afla cât de des și cât de eficient joci în etapa de River, pe baza mărimii pot-ului.","riverCombinethisview6":"Combină acest mod de vizualizare cu filtrele pentru a afla dacă câștigi mai multe pot-uri mici, pierzi pot-uri mari și altele.","potSizeFrequencyP":"Frecvență Mărime Pot (%)","riverHereyoucanfind5":"Aici poți afla cât de des și cât de eficient joci diverse Cărți întoarse în etapa River.","riverCombinethisview5":"Combină acest mod de vizualizare cu filtrele pentru a afla cum diferă limitele atunci când pariezi, ceri cărți, crești miza și altele.","riverHereyoucanfind4":"Aici poți afla cât de des și cât de eficient joci mâinile în etapa River cu diferite niveluri de putere.","riverCombinethisview4":"Combină acest mod de vizualizare cu filtrele pentru a afla dacă ajungi în etapa de River cu prea multe mâini slabe, dacă mergi în etapa Showdown cu mâini puternice și altele.","riverRiverCallEfficiencyNetWon":"Eficiență Câștig Net la Call River","riverRCE":"Eficiența la Call River (RCE) îți indică nivelul de câștig pentru fiecare blind mare investit în River Calls sau în Check Calls.","riverCombinethisview3":"Combină acest mod de vizualizare cu filtrele pentru a afla cât de eficiente sunt River Calls atunci când joci contra pariurilor CBets, Donk, a diferitelor mărimi de pariuri și altele.","riverSawShowdown":"Vezi Showdown","riverNoShowdown":"Fără Showdown ","riverMadeRiverCbet":"Cbet River Realizat","riverMadeRiverDonkBet":"Pariu River Donk Realizat","riverSmallriverbets":"Pariuri mici River (<50% pot)","riverBigriverbets":"Pariuri mari River (>100% pot)","riverFacedRiverCbet":"Cbet River Întâmpinat","riverFacedRiverDonkBet":"Pariu River Donk Întâmpinat","riverRiverBet":"Pariu River","riverRiverCall":"River Call","riverRiverRaise":"River Raise","riverRiverFold":"River Fold","riverWonHand":"Mână Câștigată","riverLostHand":"Mână Pierdută","riverRiverBetEfficiencyNetWon":"Eficiență Câștig Net Pariu River","riverRBE":"Eficiența Pariu River (RBE) indică valoarea câștigului tău pentru fiecare blind mare investit în pariurile river.","riverCombinethisview2":"Combină acest mod de vizualizare cu filtrele pentru a afla cât de eficiente sunt pariurile tale river atunci când realizezi pariuri CBet, Donk, diferite mărimi de pariuri și altele.","riverHereyoucanfind":"Aici poți afla cât de agresiv joci în etapa River și care sunt rezultatele tale pentru fiecare acțiune realizată.","tip":"Pont","riverCombinethisview":"Combină acest mod de vizualizare cu filtrele pentru a afla cum diferă jocul tău atunci când joci agresiv, împotriva unui jucător agresiv și altele.","riverAsPreflopAggressor":"Ca Stil Agresiv Preflop","riverVsPreflopAggressor":"Vs Stil Agresiv Preflop","riverCheckedToRiver":"Verificat la River","handFrequencyP":"Frecvența Mâinii (%)","totalHands":"Total Mâini ","wonAtShowdown":"Câștigate la Showdown","riverAggression":"Agresivitate la River","riverCallEff":"River Call Eff","riverBetEff":"Pariu River Eff","riverWentToShowdown":"Venite la Showdown","riverRiverHoleCards":"Cărți Întoarse la River","riverRiverHandStrength":"Forța Mâinii la River","riverRiverAgression":"Agresivitate la River %","riverRiverCallEfficiency":"Eficiență River Call","riverRiverBetEfficiency":"Eficiență Pariu River","riverRiverPotSize":"Mărime Pot River","numberOfTables":"Numărul de Mese","sessions":"Sesiuni","leakonomicsOpponentNoteColor":"Culoare Notă Adversar","leakonomicsSessionProgressSessionNames":"Lungimea Sesiunii Mai Scurtă;Medie;Mai Lungă","leakonomicsSessionProgressMin":"Evoluția Sesiunii (Min)","netWonBb":"Câștig Net (bb)","leakonomicsSessionsSplit":"Împărțire Sesiuni","leakonomicsPotAmountWonbb":"Valoarea Pot-ului Câștigat (bb)","orLess":"${0} sau mai puțin","leakonomicsAllinSplit":"Împărțire All-In","leakonomicsAllinWinsInaRow":"Câștiguri All-In la Rând","winnings":"Câștiguri ","leakonomicsRollingWindow":"Grafic Ferestre de Rulaj","leakonomicsNetWon":"Câștig Net Sus/Jos","leakonomicsUpDownSessionNames":"Când este în Jos; Neutru; Când este în Sus","leakonomicsPreflopStatsDev":"Dev Statusuri Preflop","leakonomicsBestWrt":"Cel mai bun wrt: ${0} bb","leakonomicsBestWrtAt":"La min ${0}","leakonomicsWinlossSessionNames":"Serii Pierdute; Neutre; Serii Câștigătoare","leakonomicsAllinRate":"Rata All-In","leakonomicsWinningP":"Câștig: ${0}%","leakonomicsLosingP":"Pierdere: ${0}%","leakonomicsBestWrt2":"Cel mai bun wrt: ${0} bb/hr","leakonomicsBestWrtAt2":"La masa/mesele ${0}","at":"La","leakonomicsWinrateBb100P":"Rata de Câștig: 5bb/100","leakonomicsPotsLost":"Pot-uri pierdute: ${0}%","leakonomicsPotsWon":"Pot-uri câștigate: ${0}%","leakonomicsWhenUporDownInSession":"Când este Sus sau Jos în Sesiune","leakonomicsSessionProgress":"Evoluția Sesiunii","leakonomicsAfterAllinSeries":"Seriile După All-In","leakonomicsWhenMultitabling":"Când Este la Mai multe Mese","leakonomicsVsOpponentbyNoteColor":"Vs. Adversar după Culoarea Notei","leakonomicsAfterWinningorlosingapot":"După Câștigarea sau pierderea unui pot","cbetSuccessP":"Nivel Reușită CBet %","winrate":"Rata de Câștig","winrateBB100":"Rata de câștig (bb/100)","cbetActionHU":"Acțiune CBet: Heads Up","cbetActionMultiway":"Acțiune CBet: Moduri Multiple","cbetActionHUNoHands":"Heads Up: Fără Mâini","cbetActionMultiwayNoHands":"Moduri Multiple: Fără Mâini","cbetWonLost":"$ Pierduți / Câștigați","cbetResultsSkippedDonut1Title":"CBet General Sărit ","cbetResultsSkippedDonutSubtitle":"Peste ${0} Mâini<br/>${1} bb/100","cbetResultsSkippedDonut1TitleNoHands":"CBet General Sărit:Fără Mâini","cbetResultsSkippedDonut2Title":"Nivelul de Reușită General CBet","cbetResultsSkippedDonut2TitleNoHands":"Nivelul de Reușită General CBet: Fără Mâini","hands":"Mâini","cbetActionIP":"Acțiune CBet: Pe Poziție","cbetActionOOP":"Acțiune CBet: În Afara Poziției","cbetNoHandsIP":"Pe Poziție: Fără Mâini","cbetNoHandsOOP":"În Afara Poziției: Fără Mâini","cbetOverallSuccess":"Nivelul de Reușită General","cbetFlopCBetSuccess":"Nivel de Reușită CBet Flop","cbetCBetWinrate":"Rata de Câștig CBet","cbetSkippedCBetWinnings":"Câștiguri Sărite CBet","cbetCBetSuccessBoardTexture":"Nivelul de Reușită CBet: Textura Mesei","cbetCBetSuccessPosition":"Nivelul de Reușită CBet: Poziția","cbetHandStrengthwhenCBettting":"Forța Mâinii când CBetting","cbetCBetSpotsHeadsUpvsMultiway":"Locuri CBet: HeadsUp vs. Moduri Multiple","cbetCBetSpotsInPositionvsOutofPosition":"Locuri CBet: Pe Poziție vs. În Afara Poziției","cbetResultsSkippedCBet":"Rezultate Sărite CBet","bubbleICMDescription5":"Informațiile prezentate mai jos reprezintă ICM (modelul independent de jetoane) - o reprezentare a premiului în câștigurile de la masă și care se bazează pe mărimea efectivă a mizei de la începutul mâinii.","bubblePercentageDescription5":"Procentajul de la premiul în câștiguri de la masă, grupat după mărimea efectivă a mizei","bubblePreflopDescription5":"Status-urile tale la preflop, grupate după mărimea mizei","bubbleEffectiveStackSizebb":"Mărimea Efectivă a Mizei (bb)","bubbleBubbleStackSize":"Mărimea Mizei la Bubble","bubbleCallingAllInRange":"Limita Calling All-In","bubbleSitNGoEntrants":"Intrați Sit 'N Go","bubbleICMDescription4":"Informațiile prezentate mai jos reprezintă ICM (modelul independent de jetoane) - o reprezentare a premiului în câștigurile de la masă, grupat după numărul de intrați în turneu.","bubblePercentageDescription4":"Procentajul de la premiul în câștiguri de la masă, grupat după numărul de intrați","bubblePreflopDescription4":"Status-urile tale la preflop, grupate după mărimea mizei tale","bubbleBubblePosition":"Poziția Bubble","bubbleICMDescription3":"Informațiile prezentate mai jos reprezintă ICM (modelul independent de jetoane) - o reprezentare a premiului în câștigurile de la masă, bazată pe poziția adoptată de tine la masă.","bubblePercentageDescription3":"Procentajul de la premiul în câștiguri de la masă, grupat după poziția ta","bubblePreflopDescription3":"Status-urile tale la preflop, grupate după poziția ta","bubblePreflopDescription2":"Procentajul de la premiul în câștiguri de la masă, grupat după numărul de jucători rămași la bulă.","bubblePlayersAtBubble":"# Jucătorii la Bubble","bubbleBubblePlayers":"Jucătorii la Bulă la Bubble","bubblePrizePoolP":"Premiul General%","bubbleBubbleStage":"Etapa Bubble","bubbleEVbb100hands":"EV BB/100 Mâini","bubbleICMDescription":"Informațiile prezentate mai jos reprezintă ICM (modelul independent de jetoane) - o reprezentare a premiului în câștigurile de la masă, bazată pe nivelul atins la turneu. Înainte de Bubble reprezintă toate mâinile în care ești implicat înainte de atingerea nivelului din turneu în care următorul jucătorul \"iese afară\", iar ceilalți jucători rămași primesc premiile pentru rundă.","bubblePercentageDescription":"Procentajul de la premiul în câștiguri de la masă, înainte, în timpul și după Bubble","bubblePreflopDescription":"Status-urile tale la preflop, grupate după mărimea mizei tale","bubblePrizePoolWon":"Premiu Câștigat la Masă","bubbleExpectedValue":"Valoarea Așteptată","bubbleAverageStack":"Miza Medie","bubbleCallAIWinrate":"Rata de Câștig Call AI","bubbleShoveAIWinrate":"Rata de Câștig Împinse AI","tooFewHands":"Prea Puține Mâini pentru Acest Raport","bubblePrizePoolWinningsTitle":"Premiu Câștiguri la Masă","bubbleExpectationWhenReachingBubbleTitle":"Așteptările Când Se Atinge Bula","bubblePositionTitle":"Poziție","bubbleBeforeAndAfterTitle":"Înainte Și După","bubbleStackSizeTitle":"Mărime Miză","bubbleCallRangesTitle":"Limite Call","bubbleShoveRangesTitle":"Limite Împinse","tourneyallinRaisingOpenAI":"Creștere Open AI ","tourneyallinRaising3BetAI":"Creștere 3Bet AI","tourneyallinRaisevsOpen":"Creștere vs Deschis","tourneyallinRaisevs3Bet":"Creștere vs 3-Bet","tourneyallinCallvsOpen":"Call vs Deschis","tourneyallinCallvs3Bet":"Call vs. 3-Bet","tourneyallinPreflopEffectiveStackSizeAxis":"Mărime Efectivă Miză Preflop","tourneyallinRacesWonPAxis":"Curse Câștigate %","tourneyallinEquityPAxis":"Valoare %","tourneyallinCallingOpenAI":"Calling Open AI","tourneyallinCalling3BetAI":"Calling 3Bet AI","tourneyallinPositionAxis":"Poziție","tourneyallinExpectationAxis":"Așteptări ","threebetResultsTitle":"Rezultate","threebetPositionTitle":"Poziția","threebetRangeTitle":"Trei Limite de Pariu","threebetSuccessTitle":"Trei Niveluri de Reușită la Pariu","threebetFlopHandStrengthTitle":"Forța Mâinii la Flop","threebetWinrate":"Rata de Câștig 3Bet","threebetFrequency":"Frecvența 3Bet","threebetRange":"Limita 3Bet","threebetSuccessRate":"Rata de Reușită 3Bet","threebetFlopWinrate":"Rata de Câștig la Flop","threebetWinrateHandStrengthAxis":"Forța Ratei de Reușită a Mâinii (bb/100)","threebetHandCount":"${0} (${1} Mâini)","threebetWinrateKey":"Rata de Câștig ","threebetThreeBetPercentKey":"3-Bet %","threebetWinrateAxis":"Rata de Câștig (bb/100)","threebetThreeBetPercentAxis":"3-Bet %","threebetSuccessPercentAxis":"Nivel de Succes %","threebetNetwonTitle":"Câștig Net","threebetNetwonMin":"Pierdere","threebetNetwonMax":"Profit","threebetDealtFrequencyTitle":"Frecvența Împărțirii Cărților","threebetDealtFrequencyMin":"Mai Puțin Frecvent","threebetDealtFrequencyMax":"Mai Frecvent","tourneyallinExpectedWon":"Câștig Așteptat ","availableStringPositionString":"EP;MP;CO;BTN;SB;BB","availableStringFlopMadeHandValueString":"Necunoscut;Carte Mare;O Pereche;Doua Perechi;3 de Același Fel;Culoare;Flush;Full House;4 de Același Fel;Chintă la Culoare","availableStringRiverMadeHandValueSummary":"Necunoscut;Carte Mare;O Pereche;Doua Perechi;Trei de Același Fel;Culoare;Flush;Full House;Careu;Chintă la Culoare","availableStringFlopFlushTextureTypeAsString":"Flush la Culoare;Flush În Două Nuanțe;Flush Monocrom","availableStringFlopStraightTextureTypeAsString":"Str - Neconectat;Str - Conectat;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper","availableStringFlopPairedTextureTypeAsString":"Masă Împerecheată; Neîmperecheată","availableStringInPositionOnFlopShort":"\nIP;OOP","availableStringInPositionOnFlopLong":"Pe Poziție;În Afara Poziției","availableStringRiverplayCallEfficiency":"Eficiență Call;Pe Poziție;În Afara Poziției","availableStringRiverplayBetEfficiency":"Eficiență Pariu;Pe Poziție;În Afara Poziției","availableStringCBetSpots":"CBet Sărit;Confruntare Donk;CBet & Mână Câștigată;CBet & Mână Pierdută","availableStringRiverFirstActionString":"Renunțare;Verificare;Cerere;Pariu;Creștere","ECCallCallVsVillainOpenAllinPreflop":"Calling Opp AI PF","ECCallEVCallVsVillainOpenAllinPreflop":"Așteptările Calling Opp AI PF","ECTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","ECTBetEVCallVsVillainOpenAllinPreflop":"Așteptările Calling Opp 3Bet AI PF","ERRaiseCallVsVillainOpenAllinPreflop":"AI PF vs Creștere","ERRaiseEVCallVsVillainOpenAllinPreflop":"Așteptările AI PF vs Creștere","ERTBetCallVsVillainOpenAllinPreflop":"3Bet AI PF vs Re-Creștere","ERTBetEVCallVsVillainOpenAllinPreflop":"Așteptările 3Bet AI PF vs Re-Creștere","BPCCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","BPCCallEVCallVsVillainOpenAllinPreflop":"Așteptările Calling Opp AI PF","BPCTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","BPCTBetEVCallVsVillainOpenAllinPreflop":"Așteptările Calling Opp 3Bet AI PF","BPRRaiseAllinVsRaisePreflop":"AI PF vs Creștere","BPRRaiseEVAllinVsRaisePreflop":"Așteptările AI PF vs Creștere","BPRTBetAllinVsRaisePreflop":"3Bet AI PF vs Re-Creștere","BPRTBetEVAllinVsRaisePreflop":"Așteptările 3Bet AI PF vs Re-Creștere","threebetHandAxis":"Mâna","threebetNetBbAxis":"BB-uri Nete","tourneyallinCallingByStackTitle":"Așteptările Calling All-In După Mărimea Mizei","tourneyallinRaisingByStackTitle":"Așteptările Creșterii All-In După Mărimea Mizei","tourneyallinRaisingAllinRangeTitle":"Limita All-In la Creștere","tourneyallinCallingAllinRangeTitle":"Limita Calling All-In","tourneyallinCallingAllinByPositionTitle":"Rezultatele Calling All-In După Poziție","tourneyallinRaisingAllinByPositionTitle":"Rezultatele Creșterii All-In După Poziție","tourneyallinCallAIEVWinrate":"Call Rata de Câștig AI","tourneyallinRaiseAIEVWinrate":"Creștere Rata de Câștig AI EV","tourneyallinCallAIWinrate":"Call Rata de Câștig AI","tourneyallinRaiseAIWinrate":"Creștere Rata de Câștig AI","overall":"General","restrictionsWithYourLicenseText":"<b>Fără acces</b> la Aplicațiile HM3 \nMesaj versiunea demo în rapoarte și HUD, cu durata de 14 zile"},russian:{"notAllowedByLicense":"Раздача не допускается лицензией","selectHandToExport":"Выбрать раздачу для экспорта","selectFormat":"Выбрать формат...","originalFormat":"Оригинальный формат","ctrlCToCopy":"Ctrl-C для копирования в буфер","availableTags":"Доступные метки","welcomeToHm3":"Добро пожаловать в реплеер HoldemManager3!","theme":"Тема: ","deck":"Колода: ","showHandResults":"Показать результат раздачи: ","showHeroCards":"Всегда показывать карты Hero: ","showBB":"Показать фишки в ББ: ","combineFolds":"Объединить сбросы: ","maskPlayerNames":"Скрыть имена игроков: ","statsUpToTimeOfHand":"Статы на момент начала раздачи: ","showHud":"Показать HUD: ","replaySpeed":"Скорость реплеера: ","hand":"Раздача","next100Hands":"След. 100 рук","prev100Hands":"Пред. 100 рук","addEditHandMarking":"Добавить/Править метки рук","wonXBB":"Выиграно ${0} ББ","lostXBB":"Проиграно ${0} ББ","wonLossNA":"Выигрыш/Проигрыш NA","potBB":"Банк: ${0} ББ","userWentAllin":"Игрок пошел олл-ин","pot":"Банк: ${0}","potOdds":"Шансы банка: ${0}:1","hhGameStart":"${0} игра ${1} начинается на ${2}","hhHandNotes":"Метка(и) рук","hhFold":"${0} сбрасывает","hhCheck":"${0} пропускает","hhCall":"${0} коллирует ${1}","hhBet":"${0} ставит ${1}","hhRaise":"${0} повышает ${1}","hhReturnedTo":"${1} возвращено ${0} ","hhWin":"${0} выиграл ${1}","hhRake":"Рейк: ${0}","hhActionEnded":"Действие завершено.","hhMuck":"${0} сбросил ${1}","hhShow":"${0} показал ${1}","hhPostSB":"${0} поставил малый блайнд","hhPostBB":"${0} поставил большой блайнд","hhPostDB":"${0} поставил мертвый блайнд","backToReleaseNotes":"Назад к списку изменений","backToMyLicense":"Назад к моим лицензиям","backToCardInfo":"Назад к данным кредитной карты","backToPayment":"Назад к методу платежа","orderBuyNow":"Купить сейчас","orderProceed":"Выполнить","headerTextTrial":"Триал (${0} дней осталось)","headerTextFree":"Бесплатно","smallStakes":"Малые ставки","allStakes":"Все лимиты","smallStakesCaps":"МАЛЫЕ СТАВКИ","allStakesCaps":"ВСЕ ЛИМИТЫ","smallStakesMaintenance":"ОБСЛУЖИВАНИЕ МАЛЫХ СТАВОК","allStakesMaintenance":"ОБСЛУЖИВАНИЕ ВСЕХ ЛИМИТОВ","buyHoldemSmallStakes":"Холдем для малых ставок","buyHoldemAllStakes":"Холдем для всех лимитов","buyHoldemOmahaAllStakes":"Все лимиты","buyOmahaSmallStakes":"Омаха для малых ставкок","buyOmahaAllStakes":"Омаха для всех лимитов","holdemManager":"Holdem Manager","holdemManagerCaps":"HOLDEM MANAGER","omahaCaps":"ОМАХА","holdem":"Холдем","omaha":"Омаха","hmApps":"HM Apps","hm3":"HM3","om3":"OM3","hm3andOm3":"HM3 + OM3","expiredOn":"Истёк в ${0}","expiresOn":"Истекает в ${0}","recommended":"РЕКОМЕНДОВАНО","seeAllOptionsInStore":"См. все варианты в магазине","paypalExternalBrowser":"PayPal откроется во внешнем браузере для завершения процесса оплаты.","skrillExternalBrowser":"Skrill откроется во внешнем браузере для завершения процесса оплаты.","selectProduct":"ВЫБРАТЬ ПРОДУКТ","availableUpdate":"ДОСТУПНО ОБНОВЛЕНИЕ: ","versionAvailable":"Версия ${0} доступна: ${1}","fullFaq":"FAQ по списку изменений","reviewOptions":"Просмотр опций обслуживания для Холдем перед запуском обновления","maintenanceOptions":"Опции обслуживания","addProductToLicense":"ДОБАВИТЬ ${0} К ТЕКУЩЕЙ ЛИЦЕНЗИИ","purchasePrice":"Приобрести ${0}","errorName":"Введите свое имя и фамилию","errorAddress":"Введите улицу и номер дома","errorCountry":"Введите страну проживания","errorCity":"Введите город","errorZip":"Введите почтовый индекс","billingInfo":"ПЛАТЁЖНЫЕ ДАННЫЕ","name":"Полное имя","address":"Улица","city":"Город","state":"Область/провинция","zip":"Почтовый индекс","country":"Страна","selectCountry":"Выбор страны","buyNowTip":"Выберите примененный или новый способ платежа перед началом","licenses":"ЛИЦЕНЗИИ","version":"Версия ${0}","viewReleaseNotes":"Просмотр списка изменений на сайте","updateAndRenewMaintenance":"ОБСЛУЖИВАНИЕ ОБНОВЛЕНИЙ И ВОЗОБНОВЛЕНИЙ","renewGetUpdatesUntil":"При возобновлении обслуживания вы также получите все обновления HM3 ${0}","update":"Обновить","updateAndSwitchToFree":"ОБНОВИТЬ И ПЕРЕЙТИ НА БЕСПЛАТНУЮ ВЕРСИЮ","updateAndSwitchToFreeDetails1":"Вы получите обновление, но программа HM3 (Holdem) вернется к бесплатной версии и будет иметь","updateAndSwitchToFreeDetails2":"ограниченную функциональность","updateAndSwitch":"Обновить и переключиться","errorCreditCardDigitsOnly":"Номер банковской карты должен содержать только цифры.","errorCreditCard":"Введите верный номер карты.","errorRequired":"Обязательно","errorCardExpired":"Карта просрочена","errorCvv":"CVV должен быть длиной в ${0} цифры","cardInfo":"ДАННЫЕ БАНКОВСКОЙ КАРТЫ","cardNo":"Номер карты","expiry":"Истекает","year":"год","month":"месяц","month01":"Янв","month02":"Фев","month03":"Мар","month04":"Апр","month05":"Май","month06":"Июн","month07":"Июл","month08":"Авг","month09":"Сен","month10":"Окт","month11":"Ноя","month12":"Дек","cvv":"CVV","active":"Активна","manageSubscription":"Управление подпиской","youAreUpToDate":"Программа обновлена","releaseNotes":"Список изменений для ${0}","netellerInfo":"Информация счета NETELLER","netellerSignin":"Войдите в свой счет NETELLER для завершения покупки","continue_":"Продолжить","netellerAccount":"Счет Neteller","netellerPassword":"Пароль","orderSummary":"ИТОГ ЗАКАЗА: ","changeProducts":"Сменить продукт(ы)","total":"Итого","paypalComplete":"ЗАВЕРШИТЕ ОПЛАТУ ЧЕРЕЗ PAYPAL В БРАУЗЕРЕ","paypalOpenedInNewBrowser":"Мы открыли PayPal в окне интернет-браузера. Зайдите в ваш счет PayPal и завершите покупку. После чего вернитесь сюда и нажмите \"Перезагрузить лицензию\" для загрузки купленной лицензии.","reloadLicense":"Перезагрузить лицензию","thankYouForPurchase":"Спасибо за покупку","purchaseConfirm1":"Вы скоро получите подтверждающее письмо на ${0}","purchaseConfirm2":"Нажмите \"Перезагрузить лицензию\" ниже и купленная вами лицензия станет активной.","restricted":"ограничено","restrictionsWithYourLicense":"ОГРАНИЧЕНИЯ ТЕКУЩЕЙ ЛИЦЕНЗИИ","paymentPleaseChoose":"Выберите способ платежа","paymentSelectExisting":"Выберите способ платежа из имеющихся: ","paymentSelectNew":"Способ платежа","paymentMethod":"Способ платежа: ","changePaymentMethod":"Изменить способ платежа","licensedTo":"ЛИЦЕНЗИЯ ДЛЯ","learnMore":"Узнать больше","startTrial":"Начать триал","purchase":"Купить","trialSuccessfullyStarted":"Триал успешно запущен","trialSuccessDetails1":"Ваша 14-дневная пробная версия теперь активна. Пожалуйста ","trialSuccessDetails2":"улучшите","trialSuccessDetails3":" как можно скорее для предотвращения перерывов в обслуживании.","havingTrouble":"Есть проблемы? ","contactUs":"Связь с нами","startUsing":"Начать пользоваться HM3 сейчас","missedUpdates":"${0} пропущенных обновлений","updatesAreCritical":"Обновления критичны для того, чтобы HM3 продолжал импортировать истории раздач после изменений в клиентах покерных сетей. Также через изменения в программу добавляются новые функции и возможности.","view":"Просмотреть","oneYearOfUpdates":"Включает один год обновлений","renew":"Возобновить (${0})","startingAt":"Начато в","upgrade":"Улучшить","removesRestrictions1":"Удаляет ","removesRestrictions2":"ограничения","removesRestrictions3":" и включает один год обновлений","upgradePrice":"Улучшить (${0})","required":"Обязательно","continueFreemium":"Продолжить бесплатную версию","defaultFatalError":"Произошла непредвиденная внутренняя ошибка сервера, о чем уведомлен администратор. Повторите попытку покупки чуть позже.","restrictCashHandsType":"Кешевые раздачи","restrictTourneyType":"Турниры","restrictLimitCashHandsType":"Кешевые раздачи FL","restrictHudType":"HUD","restrictReportDataType":"Данные отчета","restrictCashHands":"$ ${0} и ниже","restrictLimitCashHands":"$ ${0} и ниже","restrictTourney":"Макс ${0}","restrictHud":"Макс ${0} столов","restrictReportData":"Последние ${0} раздач","restrictionUnlimited":"Неограниченно","errorState":"Обязательно","activeHoldemLicense":"АКТИВНАЯ ЛИЦЕНЗИЯ ХОЛДЕМ","activeOmahaLicense":"АКТИВНАЯ ЛИЦЕНЗИЯ ОМАХА","reinstallOldVersion":"Переустановить старую версию","removesRestrictions3b":"и вернуться к прежней оплаченной лицензии, но обновления ","removesRestrictions4b":"НЕ ВКЛЮЧЕНЫ","noActiveHoldemLicense":"НЕТ АКТИВНОЙ ЛИЦЕНЗИИ ХОЛДЕМ","noActiveOmahaLicense":"НЕТ АКТИВНОЙ ЛИЦЕНЗИИ ОМАХА","free":"БЕСПЛАТНО","netellerSecureId":"Secure ID","recurringPriceDescription":"${0} ${1} включено*","recurringYear":"Год","recurringMonth":"Месяц","recurringDay":"День","restrictionsSmall":"No Limit/Pot Limit Cash <b>ограничены</b> до большого блайнда $0.50\nFixed Limit Cash <b>ограничен</b> до большого блайнда $1.00 \nТурниры <b>ограничены</b> до бай-ина $22.00.","afterDiscount":"Цена после срока действия скидки ","upgradeDiscount":"СКИДКА НА АПГРЕЙД","discountExpires":"Скидка истекает ${0}","discountSinglePurchase":"Скидка действует на одну покупку.","errorNetellerAccount":"Недействительная учетная запись Neteller","errorNetellerSecureId":"Введите 6-значный Secure ID","continueTrial":"Продолжить триал","continueTrialDaysRemaining":"(${0} дней осталось)","netellerInvalidCredentials":"Учетные данные Neteller проверить не удалось. Зайдите в аккаунт еще раз. ","faq":"FAQ","forMoreDetails":" для получения более подробной информации об управлении вашим ежегодным продлением поддержки и обслуживания.","recurringSubscription":"* Cпособ платежа для списания платы за годовую поддержку и техобслуживание $${0}, счет будет выставлен через один год (${1}). Просмотр ","positivePrice":"Счет за обновление годовой поддержки и техобслуживания $ ${0} будет выставлен через один год (${1}). Просмотр  ","paymentSeeWebsite1":"См. ","paymentSeeWebsite2":"МАГАЗИН","paymentSeeWebsite3":" для других опций платежа","paymentOr":"-ИЛИ-","couldNotStartMlaTitle":"Обнаружена проблема","couldNotStartMlaText":"Не удаётся открыть Мои лицензии. Системный администратор уведомлён. Попробуйте ещё раз позже. Однако, необходимо связаться с поддержкой, если проблема останется.","skipEndOfHandLabel":"Пропустить конец раздачи","inPosition":"В позиции","outOfPosition":"Без позиции","amountBb":"${0} бб","amountBbPlus":"${0}+ бб","amountBb100":"${0} бб/100","cbetCbetSuccessTip":"Успех контбета: ${0} % <br/>Винрейт: ${1} бб/100","riverBetEfficiencyTip":"${0}<br/>Эффективность ставки: ${1}<br/>В позиции: ${2}<br/>Без позиции: ${3}","riverCallEfficiencyTip":"${0}<br/>Эффективность коллирования: ${1}<br/>В позиции: ${2}<br/>Без позиции: ${3}","riverHandFrequencyTip":"Частота комбинации: ${0} % <br/>Винрейт: ${1} бб/100","riverPotSizeFrequencyTip":"Частота размера банка: ${0} % <br/>Винрейт: ${1} бб/100","tourneyallinRaisingCallingByPositionTip":"${0} (${1})<br/>Выигранно выставлений: ${2}","threebetBetFrequencyTip":"3-Bet: ${0} % <br/>Винрейт: ${1} бб/100","ipOopTip":"${0}<br/>В позиции: ${1}<br/>Без позиции: ${2}","riverHereyoucanfind6":"Здесь можно узнать, как часто и как эффективно вы играете на ривере в зависимости от размера банка.","riverCombinethisview6":"В сочетании с фильтрами этот обзор покажет, выигрываете ли вы много малых банков, проигрываете ли большие банки и другое.","potSizeFrequencyP":"Pot Size Frequency (%)","riverHereyoucanfind5":"Здесь можно узнать, как часто и как эффективно вы играете различные карманные карты на ривере.","riverCombinethisview5":"Комбинируя этот обзор с фильтрами, можно узнать, как отличаются ваши диапазоны при ставках, коллах, рейзах и т.п.","riverHereyoucanfind4":"Здесь можно узнать, как часто и как эффективно вы играете на ривере комбинации различной силы.","riverCombinethisview4":"Комбинируя этот обзор с фильтрами, можно узнать, доходите ли вы до ривера со слишком слабыми картами, либо смотрите вскрытие с сильной рукой и другое.","riverRiverCallEfficiencyNetWon":"River Call Efficiency Net Won","riverRCE":"River Call Efficiency (RBE) показывает ваш прибыль для каждого большого блайнда, инвестированного в коллы и чек-коллы на ривере.","riverCombinethisview3":"Комбинируя этот обзор с фильтрами, можно узнать, насколько эффективными являются ваши коллы на ривере, когда вы встречаетесь с контбетами, донкбетами, различными размерами ставок и др.","riverSawShowdown":"С вскрытием","riverNoShowdown":"Без вскрытия","riverMadeRiverCbet":"Сделал контбет ривера","riverMadeRiverDonkBet":"Сделал докнбет","riverSmallriverbets":"Малые ставки на ривере (<50% банка)","riverBigriverbets":"Большие ставки на ривере (>100% банка)","riverFacedRiverCbet":"Встретил конбет ривера","riverFacedRiverDonkBet":"Встретил донкбет","riverRiverBet":"Ставка на ривере","riverRiverCall":"Колл на ривере","riverRiverRaise":"Повышение на ривере","riverRiverFold":"Сброс на ривере","riverWonHand":"Выиграл раздачу","riverLostHand":"Проиграл раздачу","riverRiverBetEfficiencyNetWon":"River Bet Efficiency Net Won","riverRBE":"River Bet Efficiency (RBE) показывает ваш прибыль для каждого большого блайнда, инвестированного в ставки на ривере.","riverCombinethisview2":"Комбинируя этот обзор с фильтрами, можно узнать, насколько эффективными являются ваши ставки на ривере, когда вы встречаетесь с контбетами, донкбетами, различными размерами ставок и др.","riverHereyoucanfind":"Здесь можно узнать, как агрессивно вы играете на ривере, и ваши результаты по каждому игровому действию.","tip":"Подсказка","riverCombinethisview":"Комбинируя этот обзор с фильтрами, можно узнать, как различается ваша игра, когда вы являетесь агрессором, против агрессора и др.","riverAsPreflopAggressor":"Как префлоп агрессор","riverVsPreflopAggressor":"На префлоп агрессора","riverCheckedToRiver":"Пропускал до ривера","handFrequencyP":"Hand Frequency (%)","totalHands":"Всего раздач","wonAtShowdown":"Выиграно на вскрытии","riverAggression":"River Aggression","riverCallEff":"River Call Eff","riverBetEff":"River Bet Eff","riverWentToShowdown":"Доход до вскрытия","riverRiverHoleCards":"Карманные карты на ривере","riverRiverHandStrength":"Сила комб. на ривере","riverRiverAgression":"Агрессия на ривере %","riverRiverCallEfficiency":"Эффективность колла на ривере","riverRiverBetEfficiency":"Эффективность ставки на ривере","riverRiverPotSize":"Размер банка на ривере","numberOfTables":"Число столов","sessions":"Сессии","leakonomicsOpponentNoteColor":"Цвет заметки на оппонента","leakonomicsSessionProgressSessionNames":"Shorter;Average Session Length;Longer","leakonomicsSessionProgressMin":"Session Progress (Min)","netWonBb":"Чистый выигрыш (бб)","leakonomicsSessionsSplit":"Sessions Split","leakonomicsPotAmountWonbb":"Pot Amount Won (bb)","orLess":"${0} или меньше","leakonomicsAllinSplit":"All-in Split","leakonomicsAllinWinsInaRow":"All-in Wins in a Row","winnings":"Выигрыши","leakonomicsRollingWindow":"Rolling Window Graph","leakonomicsNetWon":"Net Won Up/Down","leakonomicsUpDownSessionNames":"When Down;Neutral;When Up","leakonomicsPreflopStatsDev":"Preflop Stats Dev","leakonomicsBestWrt":"Best wrt: ${0} bb","leakonomicsBestWrtAt":"At ${0} min","leakonomicsWinlossSessionNames":"Loss Series;Neutral;Win Series","leakonomicsAllinRate":"All-in Rate","leakonomicsWinningP":"Winning: ${0}%","leakonomicsLosingP":"Losing: ${0}%","leakonomicsBestWrt2":"Best wrt: ${0} bb/hr","leakonomicsBestWrtAt2":"At ${0} table(s)","at":"на","leakonomicsWinrateBb100P":"Winrate: 5bb/100","leakonomicsPotsLost":"Pots lost: ${0}%","leakonomicsPotsWon":"Pots won: ${0}%","leakonomicsWhenUporDownInSession":"When Up or Down In Session","leakonomicsSessionProgress":"Session Progress","leakonomicsAfterAllinSeries":"After All-in Series","leakonomicsWhenMultitabling":"При игре на многих столах","leakonomicsVsOpponentbyNoteColor":"Vs Opponent by Note Color","leakonomicsAfterWinningorlosingapot":"После выигрыша или проигрыша банка","cbetSuccessP":"Успех контбета %","winrate":"Винрейт","winrateBB100":"Винрейт (бб/100)","cbetActionHU":"Действия с контбетом: 1 на 1","cbetActionMultiway":"Действия с контбетом: мультивей","cbetActionHUNoHands":"1 на 1: Нет раздач","cbetActionMultiwayNoHands":"Мультивей: Нет раздач","cbetWonLost":"$ Won / Lost","cbetResultsSkippedDonut1Title":"Общий пропуск контбета","cbetResultsSkippedDonutSubtitle":"Более ${0} раздач<br/>${1} бб/100","cbetResultsSkippedDonut1TitleNoHands":"Общий пропуск контбета: Нет раздач","cbetResultsSkippedDonut2Title":"Общий успех контбета","cbetResultsSkippedDonut2TitleNoHands":"Общий успех контбета: Нет раздач","hands":"Раздачи","cbetActionIP":"Действие контбета: В позиции","cbetActionOOP":"Действие контбета: Без позиции","cbetNoHandsIP":"В позиции: Нет раздач","cbetNoHandsOOP":"Без позиции: Нет раздач","cbetOverallSuccess":"Успех общий","cbetFlopCBetSuccess":"Успех контбета на флопе","cbetCBetWinrate":"CBet Winrate","cbetSkippedCBetWinnings":"Skipped CBet Winnings","cbetCBetSuccessBoardTexture":"Успех контбета: Текстура борда","cbetCBetSuccessPosition":"Успех контбета: Позиция","cbetHandStrengthwhenCBettting":"Сила руки при контбете","cbetCBetSpotsHeadsUpvsMultiway":"Контбет диаграммы  - 1 на 1  и Мультивей","cbetCBetSpotsInPositionvsOutofPosition":"Контбет диаграммы - В позиции и Без позиции","cbetResultsSkippedCBet":"Итоги пропуска контбета","bubbleICMDescription5":"Информация ниже показывает представление в ICM (модель независимых фишек) выигранной части призового фонда исходя из вашего эффективного стека в начале раздачи.","bubblePercentageDescription5":"Выигранный процент призового фонда при разных размерах эффективного стека","bubblePreflopDescription5":"Ваши статы префлоп при разных размерах стека","bubbleEffectiveStackSizebb":"Размер эффективного стека (бб)","bubbleBubbleStackSize":"Размер стека на баббле","bubbleCallingAllInRange":"Диапазон коллирования алл-ина","bubbleSitNGoEntrants":"Участников SNG","bubbleICMDescription4":"Информация ниже показывает представление в ICM (модель независимых фишек) выигранной части призового фонда исходя из числа участников турнира.","bubblePercentageDescription4":"Выигранный процент призового фонда при разном числе участников","bubblePreflopDescription4":"Ваши статы префлоп при разных размерах стека","bubbleBubblePosition":"Позиция на баббле","bubbleICMDescription3":"Информация ниже показывает представление в ICM (модель независимых фишек) выигранной части призового фонда исходя из вашей позиции за столом.","bubblePercentageDescription3":"Выигранный процент призового фонда в разных позициях","bubblePreflopDescription3":"Ваши статы префлоп в разных позициях","bubblePreflopDescription2":"Выигранный процент призового фонда при разном числе оставшихся до баббла","bubblePlayersAtBubble":"# игроков на баббле","bubbleBubblePlayers":"Число игроков на баббле","bubblePrizePoolP":"Призовой пул%","bubbleBubbleStage":"Стадия баббла","bubbleEVbb100hands":"EV BB/100 Hands","bubbleICMDescription":"Информация ниже показывает представление в ICM (модель независимых фишек) выигранной части призового фонда исходя из стадии турнира. Перед бабблом показывает все раздачи, в которых вы были задействованы перед достижением той стадии турнира, когда следующий выбитый игрок \"протыкает\" пузырь и все оставшиеся участники будут в призах.","bubblePercentageDescription":"Часть призового фонда, выигранная до, во время и после баббла","bubblePreflopDescription":"Ваши статы префлоп в зависимости от размера своего стека","bubblePrizePoolWon":"Prize Pool Won","bubbleExpectedValue":"Expected Value","bubbleAverageStack":"Средний стек","bubbleCallAIWinrate":"Call AI Winrate","bubbleShoveAIWinrate":"Shove AI Winrate","tooFewHands":"Слишком мало раздач для отчёта","bubblePrizePoolWinningsTitle":"Prize Pool Winnings","bubbleExpectationWhenReachingBubbleTitle":"Ожидание при достижении баббла","bubblePositionTitle":"Позиция","bubbleBeforeAndAfterTitle":"До и после","bubbleStackSizeTitle":"Размер стека","bubbleCallRangesTitle":"Call Ranges","bubbleShoveRangesTitle":"Shove Ranges","tourneyallinRaisingOpenAI":"Повышение как пуш","tourneyallinRaising3BetAI":"Повышение как алл-ин на 3бет","tourneyallinRaisevsOpen":"Повышение на пуш","tourneyallinRaisevs3Bet":"Повышение на 3-бет","tourneyallinCallvsOpen":"Колл на пуш","tourneyallinCallvs3Bet":"Колл на 3-бет алл-ин","tourneyallinPreflopEffectiveStackSizeAxis":"Эффективный стек на префлопе","tourneyallinRacesWonPAxis":"Выиграно выставлений %","tourneyallinEquityPAxis":"Эквити %","tourneyallinCallingOpenAI":"Коллирование пуша","tourneyallinCalling3BetAI":"Коллирование 3бет алл-ина","tourneyallinPositionAxis":"Позиции","tourneyallinExpectationAxis":"Ожидание","threebetResultsTitle":"Результаты","threebetPositionTitle":"Позиция","threebetRangeTitle":"Диапазон трибета","threebetSuccessTitle":"Успех трибета","threebetFlopHandStrengthTitle":"Сила комбинации на флопе","threebetWinrate":"3Bet Winrate","threebetFrequency":"3Bet Frequency","threebetRange":"3Bet Range","threebetSuccessRate":"3Bet Success Rate","threebetFlopWinrate":"Flop Winrate","threebetWinrateHandStrengthAxis":"Винрейт по силе комб. (бб/100)","threebetHandCount":"${0} (${1} Раздач)","threebetWinrateKey":"Winrate","threebetThreeBetPercentKey":"3-Bet %","threebetWinrateAxis":"Винрейт (бб/100)","threebetThreeBetPercentAxis":"3-Bet %","threebetSuccessPercentAxis":"Успех %","threebetNetwonTitle":"Net Won","threebetNetwonMin":"Убыток","threebetNetwonMax":"Прибыль","threebetDealtFrequencyTitle":"Частота получения","threebetDealtFrequencyMin":"Менее часто","threebetDealtFrequencyMax":"Более часто","tourneyallinExpectedWon":"Ожидаемый выигрыш","availableStringPositionString":"EP;MP;CO;BTN;SB;BB","availableStringFlopMadeHandValueString":"Неизвестно;Топ карты;Пара;2 Пары;Сет или трипс;Стрит;Флеш;Фул хаус;Каре;Стрит-флеш","availableStringRiverMadeHandValueSummary":"Неизвестно;Топ карты;Пара;2 Пары;Сет или трипс;Стрит;Флеш;Фул хаус;Каре;Стрит-флеш","availableStringFlopFlushTextureTypeAsString":"Флеш радужный;Флеш двутонный;Флеш монотонный","availableStringFlopStraightTextureTypeAsString":"Стрит - несвязанный;Стрит - Связанный;Стрит - 1 пропуск;Стрит - 2 пропускаr;Стрит - Связ + 1 пропуск","availableStringFlopPairedTextureTypeAsString":"Спаренный борд; Не спаренный","availableStringInPositionOnFlopShort":"IP;OOP","availableStringInPositionOnFlopLong":"В позиции;Без позиции","availableStringRiverplayCallEfficiency":"Эффективность колла;В позиции;Без позиции","availableStringRiverplayBetEfficiency":"Эффективность ставки;В позиции;Без позиции","availableStringCBetSpots":"Пропустил контбет;Встретил донк;Контбет и выиграл;Контбет и проиграл","availableStringRiverFirstActionString":"Сброс;Пропуск;Коллирование;Ставка;Повышение","ECCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","ECCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","ECTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","ECTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","ERRaiseCallVsVillainOpenAllinPreflop":"AI PF vs Raise","ERRaiseEVCallVsVillainOpenAllinPreflop":"Expectation AI PF vs Raise","ERTBetCallVsVillainOpenAllinPreflop":"3Bet AI PF vs Re-Raise","ERTBetEVCallVsVillainOpenAllinPreflop":"Expectation 3Bet AI PF vs Re-Raise","BPCCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","BPCCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","BPCTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","BPCTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","BPRRaiseAllinVsRaisePreflop":"AI PF vs Raise","BPRRaiseEVAllinVsRaisePreflop":"Expectation AI PF vs Raise","BPRTBetAllinVsRaisePreflop":"3Bet AI PF vs Re-Raise","BPRTBetEVAllinVsRaisePreflop":"Expectation 3Bet AI PF vs Re-Raise","threebetHandAxis":"Раздачи","threebetNetBbAxis":"Чистых бб","tourneyallinCallingByStackTitle":"Ожидание коллирования алл-ина по размеру стека","tourneyallinRaisingByStackTitle":"Ожидание повышения до алл-ина по размеру стека","tourneyallinRaisingAllinRangeTitle":"Диапазон повышения до алл-ина","tourneyallinCallingAllinRangeTitle":"Диапазон коллирования алл-ина","tourneyallinCallingAllinByPositionTitle":"Итоги коллирования алл-ина по позициям","tourneyallinRaisingAllinByPositionTitle":"Итоги повышения до алл-ина по позициям","tourneyallinCallAIEVWinrate":"Call AI EV Winrate","tourneyallinRaiseAIEVWinrate":"Raise AI EV Winrate","tourneyallinCallAIWinrate":"Call AI Winrate","tourneyallinRaiseAIWinrate":"Raise AI Winrate","overall":"Общий","restrictionsWithYourLicenseText":"<b>Нет доступа</b> к HM3 Apps\nСообщение пробного периода в отчетах и в HUD\nдлительность 14 дней"},slovenian:{"notAllowedByLicense":"Licenca ne dovoli te igre","selectHandToExport":"Izberi igro za izvoz","selectFormat":"Izberi format...","originalFormat":"Originalen format","ctrlCToCopy":"Ctrl-C za kopiranje v odložišče","availableTags":"Oznake","welcomeToHm3":"Dobrodošli v HoldemManager3 Predvajalniku!","theme":"Tema: ","deck":"Karte: ","showHandResults":"Pokaži rezultat igre: ","showHeroCards":"Vedno pokaži herojeve karte: ","showBB":"Pokaži žetone kot BB: ","combineFolds":"Združi odstope: ","maskPlayerNames":"Prekrij imena igralcev: ","statsUpToTimeOfHand":"Statistika do trenutne Igre:","showHud":"Pokaži HUD:","replaySpeed":"Hitrost predvajalnika: ","hand":"Igra","next100Hands":"Naslednjih 100 Iger","prev100Hands":"Prejšnjih 100 Iger","addEditHandMarking":"Dodaj/Uredi oznake iger","wonXBB":"Pridobil ${0} BB","lostXBB":"Izgubil ${0} BB","wonLossNA":"Zmaga/Izguba ND","potBB":"Pot: ${0} BB","userWentAllin":"Uporabnik je šel Allin","pot":"Pot: ${0}","potOdds":"Pot Oddsi: ${0}:1","hhGameStart":"${0} igra ${1} se začne ${2}","hhHandNotes":"Zapiski igre","hhFold":"${0} odstopi","hhCheck":"${0} čekira","hhCall":"${0}kliče ${1}","hhBet":"${0} stavi ${1}","hhRaise":"${0} viša ${1}","hhReturnedTo":"${1} vrnjeno igralcu ${0}","hhWin":"${0} pridobi ${1}","hhRake":"Rake: ${0}","hhActionEnded":"Akcija se je zaključila.","hhMuck":"${0} zapre ${1}","hhShow":"${0} pokaže ${1}","hhPostSB":"${0} postavi small blind","hhPostBB":"${0} postavi big blind","hhPostDB":"${0} postavi mrtvi blind","backToReleaseNotes":"Nazaj na podrobnosti verzije","backToMyLicense":"Nazaj na licenco","backToCardInfo":"Nazaj na informacije o kreditni kartici","backToPayment":"Nazaj na možnosti plačila","orderBuyNow":"Kupi zdaj","orderProceed":"Nadaljuj","headerTextTrial":"Preizkus (${0} dni ostane)","headerTextFree":"Brezplačno","smallStakes":"Nizki Nivoji","allStakes":"Vsi Nivoji","smallStakesCaps":"NIZKI NIVOJI","allStakesCaps":"VSI NIVOJI","smallStakesMaintenance":"VZDRŽEVANJE NIZKIH NIVOJEV","allStakesMaintenance":"VZDRŽEVANJE VSEH NIVOJEV","buyHoldemSmallStakes":"Holdem Nizki Nivoji","buyHoldemAllStakes":"Holdem Vsi Nivoji","buyHoldemOmahaAllStakes":"Vsi Nivoji","buyOmahaSmallStakes":"Omaha Nizki Nivoji","buyOmahaAllStakes":"Omaha Vsi Nivoji","holdemManager":"Holdem Manager","holdemManagerCaps":"HOLDEM MANAGER","omahaCaps":"OMAHA","holdem":"Holdem","omaha":"Omaha","hmApps":"HM Aplikacije","hm3":"HM3","om3":"OM3","hm3andOm3":"HM3 + OM3","expiredOn":"Pretečeno dne ${0}","expiresOn":"Preteče dne ${0}","recommended":"PRIPOROČLJIVO","seeAllOptionsInStore":"Poglej vse možnosti v trgovini","paypalExternalBrowser":"PayPal se bo odprl v zunanjem brskalniku za zaključitev plačilnega postopka.","skrillExternalBrowser":"Skrill se bo naložil v zunanjem brskalniku za zaključitev plačilnega postopka.","selectProduct":"IZBERITE IZDELEK","availableUpdate":"POSODOBITEV NA RAZPOLAGO:","versionAvailable":"Verzija ${0} je na razpolago: ${1}","fullFaq":"FAQ o podrobnostih te verzije","reviewOptions":"Preglej tvoje Holdem možnosti vzdrževanja predenj nadaljuješ s posodobitvijo","maintenanceOptions":"Možnosti vzdrževanja","addProductToLicense":"DODAJ ${0} TVOJI TRENUTNI LICENCI","purchasePrice":"Nakup (${0})","errorName":"Prosimo, vnesite ime in priimek","errorAddress":"Prosimo, vnesite naslov ulice in hišno številko","errorCountry":"Prosimo, vnesite državo","errorCity":"Prosimo, vnesite mesto","errorZip":"Prosimo, vnesite veljavno poštno številko","billingInfo":"INFORMACIJE ZA OBRAČUN","name":"Ime in Priimek","address":"Naslov Ulice","city":"Mesto","state":"Zvezna država/Provinca","zip":"Zip/Poštna Številka","country":"Država","selectCountry":"Izberite državo","buyNowTip":"Prosimo, izberite obstoječ ali nov način plačlla pred nadaljevanjem","licenses":"LICENCE","version":"Verzija ${0}","viewReleaseNotes":"Poglejte podrobnosti te verzije na spletni strani","updateAndRenewMaintenance":"POSODOBI & OBNOVI VZDRŽEVANJE","renewGetUpdatesUntil":"Z obnovitvijo vzdrževanja boste prejeli vse HM3 posodobitve preko ${0}","update":"Posodobitev","updateAndSwitchToFree":"POSODOBI & ZAMENJAJ NA BREZPLAČNO VERZIJO","updateAndSwitchToFreeDetails1":"Prejeli boste posodobitev, ampak vaša HM3 (Holdem) programska oprema se bo vrnila na brezplačno verzijo in bo imela","updateAndSwitchToFreeDetails2":"omejeno delovanje","updateAndSwitch":"Posodobi & Zamenjaj","errorCreditCardDigitsOnly":"Številka kreditne kartice mora vsebovati samo številke.","errorCreditCard":"Prosimo, vnesite veljavno številko kreditne kartice.","errorRequired":"Obvezno","errorCardExpired":"Kartica je pretekla","errorCvv":"CVV mora imeti vsaj ${0} številke.","cardInfo":"PODATKI KREDITNE KARTICE","cardNo":"Št. kartice","expiry":"Veljavnost","year":"leto","month":"mesec","month01":"Jan","month02":"Feb","month03":"Mar","month04":"Apr","month05":"Maj","month06":"Jun","month07":"Jul","month08":"Avg","month09":"Sep","month10":"Okt","month11":"Nov","month12":"Dec","cvv":"CVV","active":"Aktivno","manageSubscription":"Upravljaj naročnino","youAreUpToDate":"Posodobljeni ste","releaseNotes":"Podrobnosti za verzijo  ${0}","netellerInfo":"Informacije o NETELLER računu","netellerSignin":"Vpišite se v vaš NETELLER račun za zaključitev nakupa","continue_":"Nadaljuj","netellerAccount":"Neteller račun","netellerPassword":"Geslo","orderSummary":"POVZETEK NAROČILA: ","changeProducts":"Zamenjaj Izdelek","total":"Skupno","paypalComplete":"PROSIMO, ZAKLJUČITE VAŠ PAYPAL NAKUP V VAŠEM BRSKALNIKU","paypalOpenedInNewBrowser":"PayPal smo odprli v oknu vašega privzetega brskalnika. Prosimo, vpišite se v vaš PayPal račun in dokončajte nakup. Po zaključenem nakupu, se vrnite sem in kliknite 'Ponovno naloži licenco' za uporabo kupljene licence.","reloadLicense":"Ponovno naloži licenco","thankYouForPurchase":"Hvala za nakup","purchaseConfirm1":"Kmalu boste prejeli potrditveno sporočilo na ${0}","purchaseConfirm2":"Prosimo, kliknite na gumb 'Ponovno naloži licenco' in vaša kupljena licenca bo postala aktivna.","restricted":"omejen dostop","restrictionsWithYourLicense":"OMEJITVE TVOJE TRENUTNE LICENCE","paymentPleaseChoose":"Prosimo, izberite način plačila","paymentSelectExisting":"Izberi obstoječ način plačila:","paymentSelectNew":"Dodaj nov način plačila:","paymentMethod":"Način plačila:","changePaymentMethod":"Zamenjaj način plačila","licensedTo":"REGISTRACIJA NA","learnMore":"Izvedi več","startTrial":"Začni preizkus","purchase":"Nakup","trialSuccessfullyStarted":"Preizkusno obdobje je bilo uspešno zagnano","trialSuccessDetails1":"Tvoje 14-dnevno preizkusno obdobje je sedaj aktivno. Prosimo","trialSuccessDetails2":"nadgradite","trialSuccessDetails3":" takoj, ko bo možno, da se izognete prekinitvi storitve","havingTrouble":"Imate težavo?","contactUs":"Kontaktirajte nas","startUsing":"Nadaljuj v HM3","missedUpdates":"${0} zamujenih posodobitev","updatesAreCritical":"Posodobitve so nujne za zagotovitev neprekinjenega uvoza vaših zgodovin iger potem, ko poker strani naredijo spremembe v svoji programski opremi. Prav tako omogočajo prejem novih funkcij.","view":"Pogled","oneYearOfUpdates":"Vključi eno leto posodobitev","renew":"Obnovi (${0})","startingAt":"Že od:","upgrade":"Nadgradi","removesRestrictions1":"Odstrani","removesRestrictions2":"omejitve","removesRestrictions3":" in vključi eno leto posodobitev","upgradePrice":"Nadgradi (${0})","required":"Obvezno","continueFreemium":"Nadaljuj z brezplačno verzijo","defaultFatalError":"Zgodila se je nepričakovana notranja napaka strežnika, upravitelj je bil obveščen. Prosimo, poskusite kupiti ponovno kasneje.","restrictCashHandsType":"Cash Igre","restrictTourneyType":"Turnir","restrictLimitCashHandsType":"Omeji Cash Igre","restrictHudType":"HUD","restrictReportDataType":"Podatki Poročila","restrictCashHands":"$ ${0} in nižje","restrictLimitCashHands":"$ ${0} in nižje","restrictTourney":"Max ${0}","restrictHud":"Max ${0} Miz","restrictReportData":"Zadnjih ${0} Iger","restrictionUnlimited":"Neomejeno","errorState":"Obvezno","activeHoldemLicense":"AKTIVNA HOLDEM LICENCA","activeOmahaLicense":"AKTIVNA OMAHA LICENCA","reinstallOldVersion":"Ponovno namesti staro verzijo","removesRestrictions3b":"in se vrne nazaj na vašo plačano licenco, ampak posodobitve","removesRestrictions4b":"NISO VKLJUČENE","noActiveHoldemLicense":"NI AKTIVNE HOLDEM LICENCE","noActiveOmahaLicense":"NI AKTIVNE OMAHA LICENCE","free":"BREZPLAČNO","netellerSecureId":"Secure ID","recurringPriceDescription":"${0} ${1} Vključeno*","recurringYear":"Leto","recurringMonth":"Mesec","recurringDay":"Dan","restrictionsSmall":"No Limit/Pot Limit Cash <b>omejeno na</b> na $0.50 big blind\nFixed Limit Cash <b>omejeno na</b> na $1.00 big blind\nTournaments <b>omejeno na</b> na $22.00 buy-in.","afterDiscount":"Cena po časovno omejenem popustu","upgradeDiscount":"POPUST ZA NADGRADNJO","discountExpires":"Popust preteče ${0}","discountSinglePurchase":"Popust velja za en nakup.","errorNetellerAccount":"Neveljaven ID Neteller računa","errorNetellerSecureId":"Prosimo, vnesite svojo 6-mestno številko Secure ID","continueTrial":"Nadaljuj preizkusno obdobje","continueTrialDaysRemaining":"(${0} dni ostane)","netellerInvalidCredentials":"Nismo mogli potrditi vaših Neteller podatkov. Prosimo, poskusite se ponovno vpisati.","faq":"FAQ","forMoreDetails":" za več informacij o upravljanju obnovitve vaše letne podpore & vzdrževanja.","recurringSubscription":"* Za obnovitev letne podpore in vzdrževanja je potreben način plačlla $${0}, kar bo obračunano enkrat letno (${1}). Poglej","positivePrice":"Za obnovitev letne podpore & vzdrževanja bo obračunano $${0} čez eno leto (${1}). Poglej","paymentSeeWebsite1":"Poglej","paymentSeeWebsite2":"TRGOVINA","paymentSeeWebsite3":" za druge načine plačila","paymentOr":"- Ali -","couldNotStartMlaTitle":"Naleteli smo na problem","couldNotStartMlaText":"Ni bilo možno zagnati Mojih Licenc. Skrbnik je bil obveščen. Prosimo, preverite ponovno kasneje. Če problem ne bo odpravljen, prosimo, kontaktirajte našo podporo.","skipEndOfHandLabel":"Preskoči zaključek igre","inPosition":"V poziciji","outOfPosition":"Izven pozicije","amountBb":"${0} bb","amountBbPlus":"${0}+ bb","amountBb100":"${0} bb/100","cbetCbetSuccessTip":"Cbet uspeh: ${0} % <br/>Stopnja zmage: ${1} bb/100","riverBetEfficiencyTip":"${0}<br/>Učinkovitost stave: ${1}<br/>V poziciji: ${2}<br/>Izven pozicije: ${3}","riverCallEfficiencyTip":"${0}<br/>Učinkovitost klica: ${1}<br/>V poziciji: ${2}<br/>Izven pozicije: ${3}","riverHandFrequencyTip":"Pogostost kart: ${0} % <br/>Stopnja zmage: ${1} bb/100","riverPotSizeFrequencyTip":"Pogostost polnega pota: ${0} % <br/>Stopnja zmage: ${1} bb/100","tourneyallinRaisingCallingByPositionTip":"${0} (${1})<br/>Dobljenih Dirk: ${2}","threebetBetFrequencyTip":"3-Bet: ${0} % <br/>Stopnja zmage: ${1} bb/100","ipOopTip":"${0}<br/>In Position: ${1}<br/>Out of Position: ${2}","riverHereyoucanfind6":"Tukaj lahko ugotovite kako pogosto in kako učinkovito igrate na riverju glede na velikost pota.","riverCombinethisview6":"Združite ta pogled s filtri da ugotovite ali zmagujete veliko majhnih potov, izgubljate velike pote in drugo.","potSizeFrequencyP":"Pogostost polnega pota","riverHereyoucanfind5":"Tukaj lahko vidite kako pogosto in kako učinkovito igrate različne začetne karte na riverju.","riverCombinethisview5":"Združite ta pogled s filtri da ugotovite kako se vaš obseg začetnih kart razlikuje ko stavite, kličete, višate in drugo.","riverHereyoucanfind4":"Tukaj lahko ugotovite kako pogosto in kako učinkovito igrate na riverju z različno vrednimi kombinacijami.","riverCombinethisview4":"Združite ta pogled s filtri da ugotovite ali greste do riverja s prešibkimi kombinacijami, ali greste do razkritja z močnimi kombinacijami in drugo.","riverRiverCallEfficiencyNetWon":"Učinkovitost klica na riverju Dobiček","riverRCE":"Učinkovitost klica na riverju vam pokaže donosnost na vsak investiran big blind pri river klicih in ček-klicih.","riverCombinethisview3":"Združite ta pogled s filtri da ugotovite kako učinkoviti so vaši klici na riverju ko ste soočeni s Cbeti, Donk beti, različnimi velikostmi stav in drugo.","riverSawShowdown":"Videl razkritje","riverNoShowdown":"Brez razkritja","riverMadeRiverCbet":"Naredil river Cbet","riverMadeRiverDonkBet":"Naredil river Donk bet","riverSmallriverbets":"Majhne river stave (<50% pota)","riverBigriverbets":"Velike river stave (>100% pota)","riverFacedRiverCbet":"Soočen z river Cbetom","riverFacedRiverDonkBet":"Soočen z river Donk betom","riverRiverBet":"River Stava","riverRiverCall":"River Klic","riverRiverRaise":"River Višanje","riverRiverFold":"River Odstop","riverWonHand":"Zmagal Igro","riverLostHand":"Izgubil Igro","riverRiverBetEfficiencyNetWon":"Učinkovitost stave na riverju Dobiček","riverRBE":"Učinkovitost stave na riverju vam pokaže donosnost na vsak investiran big blind pri river stavah.","riverCombinethisview2":"Združite ta pogled s filtri da ugotovite kako učinkovite so vaše stave na riverju pri Cbetih, Donk betih, različniih velikostih stav in drugo.","riverHereyoucanfind":"Tukaj lahko ugotovite kako agresivno igrate na riverju in vidite rezultate glede na vsako odigrano akcijo.","tip":"Namig","riverCombinethisview":"Združite ta pogled s filtri da ugotovite kako se vaša igra razlikuje ko ste agresor, ko igrate proti agresorju in drugo.","riverAsPreflopAggressor":"Kot preflop agresor","riverVsPreflopAggressor":"Proti preflop agresorju","riverCheckedToRiver":"Čekirano do riverja","handFrequencyP":"Pogostost kombinacij (%)","totalHands":"Število iger","wonAtShowdown":"Zmagal pri razkritju","riverAggression":"River agresija","riverCallEff":"Uč. river klica","riverBetEff":"Uč. river stave","riverWentToShowdown":"Šel do razkritja","riverRiverHoleCards":"River začetne karte","riverRiverHandStrength":"River moč kombinacije","riverRiverAgression":"River agresija %","riverRiverCallEfficiency":"Učinkovitost river klica","riverRiverBetEfficiency":"Učinkovitost river stave","riverRiverPotSize":"Velikost river pota","numberOfTables":"Število miz","sessions":"Seje","leakonomicsOpponentNoteColor":"Barva beležke nasprotnika","leakonomicsSessionProgressSessionNames":"Krajše;Povprečna dolžina seje;Daljše","leakonomicsSessionProgressMin":"Seja v teku (min)","netWonBb":"Dobiček (bb)","leakonomicsSessionsSplit":"Razdeljene seje","leakonomicsPotAmountWonbb":"Dobljena velikost pota (bb)","orLess":"${0} ali manj","leakonomicsAllinSplit":"All-in Razdeljeno","leakonomicsAllinWinsInaRow":"Zaporednih All-in zmag","winnings":"Dobiček","leakonomicsRollingWindow":"Grafični prikaz oken","leakonomicsNetWon":"Dobiček plus/minus","leakonomicsUpDownSessionNames":"Ko v minusu;Nevtralno;Ko v plusu","leakonomicsPreflopStatsDev":"Razlika PF Statistik","leakonomicsBestWrt":"Naj stopnja zmage: ${0} bb","leakonomicsBestWrtAt":"Pri ${0} min","leakonomicsWinlossSessionNames":"Serija izgub;Nevtralno;Serija zmag","leakonomicsAllinRate":"All-in Stopnja","leakonomicsWinningP":"Zmaga: ${0}%","leakonomicsLosingP":"Izguba: ${0}%","leakonomicsBestWrt2":"Naj stopnja zmage: ${0} bb/ura","leakonomicsBestWrtAt2":"Pri ${0} mizah","at":"Pri","leakonomicsWinrateBb100P":"Stopnja zmage: 5bb/100","leakonomicsPotsLost":"Potov izgubljenih: ${0}%","leakonomicsPotsWon":"Potov dobljenih: ${0}%","leakonomicsWhenUporDownInSession":"Ko v plusu ali v minusu v seji","leakonomicsSessionProgress":"Seja v teku","leakonomicsAfterAllinSeries":"Po All-in seriji","leakonomicsWhenMultitabling":"Pri večih mizah","leakonomicsVsOpponentbyNoteColor":"Proti nasprotniku po barvi beležke","leakonomicsAfterWinningorlosingapot":"Po zmagi ali izgubi pota","cbetSuccessP":"Cbet uspeh %","winrate":"Stopnja zmage","winrateBB100":"Stopnja zmage (bb/100)","cbetActionHU":"Cbet akcija: Heads Up","cbetActionMultiway":"Cbet akcija: Več igralcev","cbetActionHUNoHands":"Heads Up: Ni iger","cbetActionMultiwayNoHands":"Več igralcev: Ni iger","cbetWonLost":"$ Pridobil / Izgubil","cbetResultsSkippedDonut1Title":"Skupno izpuščeni Cbeti","cbetResultsSkippedDonutSubtitle":"Po ${0} Igrah<br/>${1} bb/100","cbetResultsSkippedDonut1TitleNoHands":"Skupno izpuščenih Cbetov: Ni iger","cbetResultsSkippedDonut2Title":"Skupno Cbet uspeh","cbetResultsSkippedDonut2TitleNoHands":"Skupno Cbet uspeh: Ni iger","hands":"Igre","cbetActionIP":"CBet akcija: V poziciji","cbetActionOOP":"Cbet akcija: Izven pozicije","cbetNoHandsIP":"V poziciji: Ni iger","cbetNoHandsOOP":"Izven pozicije: Ni iger","cbetOverallSuccess":"Skupni uspeh","cbetFlopCBetSuccess":"Flop CBet uspeh","cbetCBetWinrate":"Cbet Stopnja zmage","cbetSkippedCBetWinnings":"Izpuščeni Cbeti Dobiček","cbetCBetSuccessBoardTexture":"Cbet uspeh: Textura boarda","cbetCBetSuccessPosition":"Cbet uspeh: Pozicija","cbetHandStrengthwhenCBettting":"Moč kombinacije pri CBetanju","cbetCBetSpotsHeadsUpvsMultiway":"CBet situacije - Heads Up proti Več igralcev","cbetCBetSpotsInPositionvsOutofPosition":"Cbet situacije - V poziciji proti Izven pozicije","cbetResultsSkippedCBet":"Izpuščeni Cbeti Rezultat","bubbleICMDescription5":"Informacije spodaj predstavljajo ICM (independent chip model) reprezentacijo dobljenega nagradnega sklada glede na vaš efektiven stack pri začetku igre.","bubblePercentageDescription5":"Odstotki dobljenega nagradnega sklada razvrščeni po vašem efektivnem stacku.","bubblePreflopDescription5":"Vaša preflop statistika razvrščena po velikosti vašega stacka.","bubbleEffectiveStackSizebb":"Efektivna velikost stacka (bb)","bubbleBubbleStackSize":"Velikost stacka na Balonu","bubbleCallingAllInRange":"Klic All-In Rang","bubbleSitNGoEntrants":"Sit 'N Go št. igralcev","bubbleICMDescription4":"Informacije spodaj predstavljajo ICM (independent chip model) reprezentacijo dobljenega nagradnega sklada glede na število igralcev turnirja.","bubblePercentageDescription4":"Odstotki dobljenega nagradnega sklada razvrščeni po številu udeležencev.","bubblePreflopDescription4":"Vaša preflop statistika razvrščena po velikosti vašega stacka.","bubbleBubblePosition":"Pozicija balona","bubbleICMDescription3":"Informacije spodaj predstavljajo ICM (independent chip model) reprezentacijo dobljenega nagradnega sklada glede na pozicijo sedeža.","bubblePercentageDescription3":"Odstotki dobljenega nagradnega sklada razvrščeni po vaši poziciji.","bubblePreflopDescription3":"Vaša preflop statistika razvrščena po vaši poziciji","bubblePreflopDescription2":"Odstotki dobljenega nagradnega sklada razvrščeni po številu obstoječih igralcev na balonu.","bubblePlayersAtBubble":"# Igralcev ","bubbleBubblePlayers":"Balon igralci na balonu","bubblePrizePoolP":"Nagradni sklad%","bubbleBubbleStage":"Faza balona","bubbleEVbb100hands":"EV BB/100 Igre","bubbleICMDescription":"Informacije spodaj predstavljajo ICM (independent chip model) reprezentacijo dobljenega nagradnega sklada glede na fazo turnirja. Pred balonom predstavlja vse igre v katere ste vpleteni pred fazo turnirja, kjer naslednji izpadli igralec poči balon, ostali pa pridejo do denarnih nagrad.","bubblePercentageDescription":"Odstotki dobljenega nagradnega sklada pred, med in po balonu.","bubblePreflopDescription":"Vaša preflop statistika razvrščena po velikosti vašega stacka.","bubblePrizePoolWon":"Dobljeni nagradni sklad","bubbleExpectedValue":"Pričakovana vrednost","bubbleAverageStack":"Povprečna velikost stacka","bubbleCallAIWinrate":"Klic AI Stopnja zmage","bubbleShoveAIWinrate":"Potisk AI Stopnja zmage","tooFewHands":"Premalo iger za to poročilo","bubblePrizePoolWinningsTitle":"Dobiček nagradnega sklada","bubbleExpectationWhenReachingBubbleTitle":"Pričakovana vrednost pri dosegu balona","bubblePositionTitle":"Pozicija","bubbleBeforeAndAfterTitle":"Pred in po","bubbleStackSizeTitle":"Velikost stacka","bubbleCallRangesTitle":"Klic Rangi","bubbleShoveRangesTitle":"Potistk All-in Rangi","tourneyallinRaisingOpenAI":"Višanje Odpiranja AI","tourneyallinRaising3BetAI":"Višanje 3Bet AI","tourneyallinRaisevsOpen":"Višanje proti Odprtju","tourneyallinRaisevs3Bet":"Višanje proti 3-Betu","tourneyallinCallvsOpen":"Klic proti Odprtju","tourneyallinCallvs3Bet":"Klic proti 3-Betu","tourneyallinPreflopEffectiveStackSizeAxis":"Preflop efektivna velikost stacka","tourneyallinRacesWonPAxis":"Dobljenih Dirk %","tourneyallinEquityPAxis":"Vrednost %","tourneyallinCallingOpenAI":"Klic Odprtja AI","tourneyallinCalling3BetAI":"Klic 3Bet AI","tourneyallinPositionAxis":"Pozicija","tourneyallinExpectationAxis":"Pričakovana vrednost","threebetResultsTitle":"Rezultati","threebetPositionTitle":"Pozicija","threebetRangeTitle":"Three Bet Rang","threebetSuccessTitle":"Three Bet Uspeh","threebetFlopHandStrengthTitle":"Flop moč kombinacije","threebetWinrate":"3Bet Stopnja zmage","threebetFrequency":"3Bet pogostost","threebetRange":"3Bet Rang","threebetSuccessRate":"3Bet Stopnja uspeha","threebetFlopWinrate":"Flop Stopnja zmage","threebetWinrateHandStrengthAxis":"Moč kombinacije Stopnja zmage (bb/100)","threebetHandCount":"${0} (${1} Iger)","threebetWinrateKey":"Stopnja zmage","threebetThreeBetPercentKey":"3-Bet %","threebetWinrateAxis":"Stopnja zmage (bb/100)","threebetThreeBetPercentAxis":"3-Bet %","threebetSuccessPercentAxis":"Uspeh %","threebetNetwonTitle":"Dobiček skupno","threebetNetwonMin":"Izguba","threebetNetwonMax":"Dobiček","threebetDealtFrequencyTitle":"Pogostost ","threebetDealtFrequencyMin":"Manj pogosto","threebetDealtFrequencyMax":"Bolj pogosto","tourneyallinExpectedWon":"Pričakovan dobiček","availableStringPositionString":"EP;MP;CO;BTN;SB;BB","availableStringFlopMadeHandValueString":"Neznano;Visoka Karta;En Par;Dva Para;Tris;Lestvica;Flush;Full House;4 of a Kind;Straight Flush","availableStringRiverMadeHandValueSummary":"Neznano;Visoka Karta;En Par;Dva Para;Tris;Lestvica;Flush;Full House;4 of a Kind;Straight Flush","availableStringFlopFlushTextureTypeAsString":"Flush Mavrica;Flush Dvobarvni;Flush Enobarvni","availableStringFlopStraightTextureTypeAsString":"Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper","availableStringFlopPairedTextureTypeAsString":"Parni board;Brez para","availableStringInPositionOnFlopShort":"IP;OOP","availableStringInPositionOnFlopLong":"V poziciji;Izven pozicije","availableStringRiverplayCallEfficiency":"Učinkovitost klica;V poziciji;Izven pozicije","availableStringRiverplayBetEfficiency":"Učinkovitost stave;V poziciji;Izven pozicije","availableStringCBetSpots":"Izpuščeni Cbet;Soočeni z Donk betom;CBet & Zmaga igre;Cbet & Izguba igre","availableStringRiverFirstActionString":"Odstop;Ček;Klic;Stava;Višanje","ECCallCallVsVillainOpenAllinPreflop":"Klic Nasprotnikovega AI PF","ECCallEVCallVsVillainOpenAllinPreflop":"Pričakovana vrednost pri Klicanju nasprotnikovega AI PF","ECTBetCallVsVillainOpenAllinPreflop":"Klic nasprotnikovega 3Bet AI PF","ECTBetEVCallVsVillainOpenAllinPreflop":"Pričakovana vrednost pri Klicanju nasprotnikovega 3Bet AI PF","ERRaiseCallVsVillainOpenAllinPreflop":"AI PF proti Višanju","ERRaiseEVCallVsVillainOpenAllinPreflop":"Pričakovana vrednost AI PF proti Višanju","ERTBetCallVsVillainOpenAllinPreflop":"3Bet AI PF proti Po-Višanju","ERTBetEVCallVsVillainOpenAllinPreflop":"Pričakovana vrednost 3Bet AI PF proti Po-Višanju","BPCCallCallVsVillainOpenAllinPreflop":"Klic nasprotnikovega AI PF","BPCCallEVCallVsVillainOpenAllinPreflop":"Pričakovana vrednost pri klicanju nasprotnikovega AI PF","BPCTBetCallVsVillainOpenAllinPreflop":"Klic nasprotnikovega 3Bet AI PF","BPCTBetEVCallVsVillainOpenAllinPreflop":"Pričakovana vrednost pri Klicanju nasprotnikovega 3Bet AI PF","BPRRaiseAllinVsRaisePreflop":"AI PF proti Višanju","BPRRaiseEVAllinVsRaisePreflop":"Pričakovana vrednost AI PF proti Višanju","BPRTBetAllinVsRaisePreflop":"3Bet AI PF proti Po-Višanju","BPRTBetEVAllinVsRaisePreflop":"Pričakovana vrednost 3Bet AI PF proti Po-Višanju","threebetHandAxis":"Igra","threebetNetBbAxis":"Net BBs","tourneyallinCallingByStackTitle":"Pričakovana vrednost Klicanja All-In po velikosti stacka","tourneyallinRaisingByStackTitle":"Pričakovana vrednost Višanja All-In po velikosti stacka","tourneyallinRaisingAllinRangeTitle":"Višanje All-In Rang","tourneyallinCallingAllinRangeTitle":"Klic All-In Rang","tourneyallinCallingAllinByPositionTitle":"Rezultati Klicanja All-In po poziciji","tourneyallinRaisingAllinByPositionTitle":"Rezultati Višanja All-In po poziciji","tourneyallinCallAIEVWinrate":"Klic AI EV Stopnja zmage","tourneyallinRaiseAIEVWinrate":"Višanje AI Stopnja zmage","tourneyallinCallAIWinrate":"Klic AI Stopnja zmage","tourneyallinRaiseAIWinrate":"Višanje AI Stopnja zmage","overall":"Skupno","restrictionsWithYourLicenseText":"<b>Ni dostopa</b> do HM3 Aplikacij\nSporočilo preizkusne verzije v poročilih in HUDu\ntrajanje 14 dni"},spanish:{"notAllowedByLicense":"Mano No Permitida por Licencia","selectHandToExport":"Seleccione Mano A Exportar","selectFormat":"Seleccione formato...","originalFormat":"Formato Original","ctrlCToCopy":"Ctrl-C para Copiar al Portapapeles","availableTags":"Etiquetas Disponibles","welcomeToHm3":"Bienvenido al Replayer del HoldemManager3 ","theme":"Tema:","deck":"Cubierta:","showHandResults":"Mostrador Resultados de Manos:","showHeroCards":"Siempre Mostrar de Inicio de Hero:","showBB":"Mostrar Manos en CG:","combineFolds":"Combinar Carpetas:","maskPlayerNames":"Máscara de los Nombres de los Jugadores:","statsUpToTimeOfHand":"Estadísticas Hasta el Momento de la Mano:","showHud":"MostrarHUD:","replaySpeed":"Velocidad de Replay","hand":"Mano","next100Hands":"100 Manos Siguientes","prev100Hands":"100 Manos Anteriores","addEditHandMarking":"Añadir/Editar Marcas de Mano","wonXBB":"Ganó ${0} CG","lostXBB":"Perdió ${0} CG","wonLossNA":"Ganó/Perdió NA","potBB":"Bote: ${0} CG","userWentAllin":"El Usuario Fue All In","pot":"Bote: ${0}","potOdds":"Probabilidades del Bote: $ {0}: 1","hhGameStart":"El juego $ {0} $ {1} comienza en $ {2}","hhHandNotes":"Nota(s) de Mano","hhFold":"$ {0} Folds","hhCheck":" ${0} Checks","hhCall":"${0} Calls ${1}","hhBet":"${0} Apuestas ${1}","hhRaise":"${0} Aumentos ${1}","hhReturnedTo":"$ {1} Devuelto a $ {0}","hhWin":"$ {0} Gana $ {1}","hhRake":"Rake: ${0}","hhActionEnded":"La acción ha terminado.","hhMuck":"$ {0} mucks $ {1}","hhShow":"$ {0} muestra $ {1}","hhPostSB":"${0} posts ciega grande","hhPostBB":"${0} posts small grande","hhPostDB":"${0} posts ciega muerta","backToReleaseNotes":"Volver a Las Notas de Lanzamiento","backToMyLicense":"Volver a Mi Licencia","backToCardInfo":"Volver a La Información de La Tarjeta de Crédito","backToPayment":"Volver a Método de Pago","orderBuyNow":"Comprar Ahora","orderProceed":"Proceder","headerTextTrial":"Prueba ($ {0} Días Restantes)","headerTextFree":"Gratis","smallStakes":"Stakes Pequeños","allStakes":"Todos Los Stakes","smallStakesCaps":"Stakes Pequeños","allStakesCaps":"Todos Los Stakes","smallStakesMaintenance":"MANTENIMIENTO DE LOS STAKES PEQUEÑOS","allStakesMaintenance":"MANTENIMIENTO DE TODOS LOS STAKES","buyHoldemSmallStakes":"Stakes Pequeños Holdem","buyHoldemAllStakes":"Todas Los Stakes de Holdem","buyHoldemOmahaAllStakes":"Todos los Stakes","buyOmahaSmallStakes":"Stakes Pequeños Omaha","buyOmahaAllStakes":"Todos Los Stakes Omaha","holdemManager":"Holdem Manager","holdemManagerCaps":"HOLDEM MANAGER","omahaCaps":"OMAHA","holdem":"Holdem","omaha":"Omaha","hmApps":"Apps HM","hm3":"HM3","om3":"OM3","hm3andOm3":"HM3 + OM3","expiredOn":"Expiró en ${0}","expiresOn":"Expira en ${0}","recommended":"RECOMENDADO","seeAllOptionsInStore":"Ver todas las opciones en la Tienda.","paypalExternalBrowser":"PayPal se abrirá en un navegador externo para completar el proceso de pago.","skrillExternalBrowser":"Skrill se cargará en un navegador externo para completar el proceso de pago.","selectProduct":"SELECCIONAR PRODUCTO","availableUpdate":"ACTUALIZACIÓN DISPONIBLE:","versionAvailable":"La versión $ {0} está disponible: $ {1}","fullFaq":"Preguntas Frecuentes de la Versión Completa","reviewOptions":"Revise sus opciones de mantenimiento de Holdem antes de continuar con la actualización","maintenanceOptions":"Opciones de Mantenimiento","addProductToLicense":"AGREGUE $ {0} A SU LICENCIA ACTUAL","purchasePrice":"Compra (${0})","errorName":"Por Favor ingresa tu Nombre Completo","errorAddress":"Por Favor ingresa el nombre de tu Calle y número","errorCountry":"Por Favor ingresa tu País","errorCity":"Por Favor ingresa tu Ciudad","errorZip":"Por favor ingresa un Código Postal válido","billingInfo":"INFORMACIÓN DE FACTURACIÓN","name":"Nombre Completo","address":"Dirección de Calle","city":"Ciudad","state":"Estado/Provincia","zip":"Zip/´Código Postal","country":"País","selectCountry":"Selecciona un país","buyNowTip":"Por favor selecciona un método de pago nuevo o existente antes de continuar.","licenses":"LICENCIAS","version":"Versión $ {0}","viewReleaseNotes":"Ver las notas del lanzamiento en el sitio web","updateAndRenewMaintenance":"ACTUALIZAR Y RENOVAR MANTENIMIENTO","renewGetUpdatesUntil":"Al renovar el mantenimiento, recibirás todas las actualizaciones de HM3 por $ {0}","update":"Actualizar","updateAndSwitchToFree":"ACTUALIZAR Y CAMBIAR A LA VERSIÓN GRATUITA","updateAndSwitchToFreeDetails1":"Recibirás la actualización, pero tu software HM3 (Holdem) volverá a la versión gratuita y tendrá","updateAndSwitchToFreeDetails2":"funcionalidad limidad","updateAndSwitch":"Actualizar y Cambiar","errorCreditCardDigitsOnly":"El número de la tarjeta de crédito debe contener sólo dígitos.","errorCreditCard":"Por favor, ingresa un número de tarjeta válido.","errorRequired":"Requerido","errorCardExpired":"Tarjeta Vencida","errorCvv":"El CVV debe tener $ {0} dígitos de longitud","cardInfo":"INFORMACIÓN DE TARJETA DE CRÉDITO","cardNo":"No de Tarjeta","expiry":"Vencimiento","year":"año","month":"mes","month01":"Enero","month02":"Febrero","month03":"Marzo","month04":"Abril","month05":"Mayo","month06":"Junio","month07":"Julio","month08":"Agosto","month09":"Septiembre","month10":"Octubre","month11":"Noviembre","month12":"Diciembre","cvv":"CVV","active":"Activa","manageSubscription":"Administrar Suscripción","youAreUpToDate":"Estas actualizado","releaseNotes":"Notas de publicación para $ {0}","netellerInfo":"Información de Cuenta de NETELLER","netellerSignin":"Inicia Sesión en tu cuenta de NETELLER para completar tu compra","continue_":"Continuar","netellerAccount":"Cuenta de Neteller","netellerPassword":"Contraseña","orderSummary":"RESUMEN DE LA ORDEN:","changeProducts":"Cambiar Producto(s)","total":"Total","paypalComplete":"POR FAVOR COMPLETA TU COMPRA POR PAYPAL EN TU NAVEGADOR","paypalOpenedInNewBrowser":"Hemos abierto PayPal en la ventana de tu navegador de internet predeterminado. Por favor ingresa a tu cuenta de PayPal y completa la compra. Una vez que se haya completado la compra, regresa aquí y haz clic en \"Actualizar Licencia\" para cargar la licencia que has comprado.","reloadLicense":"Actualizar Licencia","thankYouForPurchase":"Gracias Por Tu Compra","purchaseConfirm1":"Recibirás una confirmación por correo electrónico en breve en $ {0}","purchaseConfirm2":"Haz clic en el botón de renovar licencia a continuación y tu licencia comprada estará activa.","restricted":"restringido","restrictionsWithYourLicense":"RESTRICCIONES CON TU LICENCIA ACTUAL","paymentPleaseChoose":"Por favor, elije un método de pago","paymentSelectExisting":"Selecciona un método de pago existente:","paymentSelectNew":"Método de Pago","paymentMethod":"Método de Pago:","changePaymentMethod":"Cambiar Método de Pago","licensedTo":"LICENCIA AUTORIZADA PARA","learnMore":"Conocer Más","startTrial":"Iniciar Prueba","purchase":"Compra","trialSuccessfullyStarted":"La Prueba se ha iniciado exitosamente","trialSuccessDetails1":"Tu prueba de 14 días está activa ahora. Por favor ","trialSuccessDetails2":"actualizar","trialSuccessDetails3":"Tan pronto como sea posible para evitar interrupciones a tu servicio.","havingTrouble":"¿Teniendo problemas?","contactUs":"Contáctanos","startUsing":"Empieza a usar HM3 ahora","missedUpdates":"$ {0} actualizaciones perdidas","updatesAreCritical":"Las actualizaciones son fundamentales para garantizar que HM3 continúe importando tu historial de manos después de que los sitios de póker realicen cambios en su software. Las nuevas características y funcionalidades también se lanzan a través de actualizaciones.","view":"Ver","oneYearOfUpdates":"Incluye un año de actualizaciones","renew":"\nRenovar ($ {0})","startingAt":"A partir de","upgrade":"Actualización","removesRestrictions1":"Elimina ","removesRestrictions2":"Restricciones","removesRestrictions3":" e incluye un año de actualizaciones","upgradePrice":"Actualizar ($ {0})","required":"Requerido","continueFreemium":"Continuar con la Versión Gratuita","defaultFatalError":"Se ha producido un error interno inesperado del servidor y se ha notificado a un administrador. Por favor, intenta comprar de nuevo más tarde.\n","restrictCashHandsType":"Manos Mesa Abierta","restrictTourneyType":"Torneo","restrictLimitCashHandsType":"Manos Mesa abierta con Límite","restrictHudType":"HUD","restrictReportDataType":"Informe de datos\n","restrictCashHands":"$ $ {0} y por debajo","restrictLimitCashHands":"$ $ {0} y por debajo\n","restrictTourney":"Máx $ {0}\n","restrictHud":"Máx ${0} Mesa(s)","restrictReportData":"Últimas $ {0} Manos","restrictionUnlimited":"Ilimitado","errorState":"Requerido","activeHoldemLicense":"ACTIVAR LICENCIA HOLDEM","activeOmahaLicense":"ACTIVAR LICENCIA OMAHA","reinstallOldVersion":"Reinstalar la Versión Antigua","removesRestrictions3b":"y vuelve a stu licencia paga pero las actualizaciones son\n","removesRestrictions4b":"NO INCLUIDO","noActiveHoldemLicense":"LICENCIA HOLDEM NO ACTIVA","noActiveOmahaLicense":"LICENCIA OMAHA NO ACTIVA","free":"GRATIS","netellerSecureId":"Identificación Segura","recurringPriceDescription":"$ {0} $ {1} Incluido *","recurringYear":"Año","recurringMonth":"Mes","recurringDay":"Día","restrictionsSmall":"Sin Límite/Límite de Bote Cash <b>restringido</b> ciegas grandes hasta $0.50 \nLímite Fijo Cash <b>restringido</b> ciegas grandes hasta $1.00 Torneos<b>restringido</b>  buy-ins hasta $22.00.","afterDiscount":"Precio luego del descuento por tiempo limitado \n","upgradeDiscount":"ATUALIZAR DESCUENTO","discountExpires":"El descuento Expira el 31 de Marzo de 2019","discountSinglePurchase":"El descuento se aplica a una sola compra.","errorNetellerAccount":"ID de Cuenta de Neteller no válida","errorNetellerSecureId":"Por favor ingresa tu ID de seguridad de 6 dígitos\n","continueTrial":"Continuar Prueba","continueTrialDaysRemaining":"($ {0} Días Restantes)\n","netellerInvalidCredentials":"No pudimos validar tus credenciales de Neteller. Por favor, intenta iniciar sesión de nuevo.\n","faq":"FAQ","forMoreDetails":" para obtener más detalles sobre la gestión de tu renovación anual de Soporte y Mantenimiento.\n ","recurringSubscription":"* Se requiere un método de pago para la renovación anual de Soporte y Mantenimiento de $$ {0} que se facturará dentro de un año ($ {1}). Ver \n","positivePrice":"La renovación anual de Soporte y Mantenimiento de $$ {0} se facturará en un año ($ {1}). Ver \n","paymentSeeWebsite1":"Ver ","paymentSeeWebsite2":"TIENDA","paymentSeeWebsite3":" para más opciones de pago","paymentOr":"- O -","couldNotStartMlaTitle":"Encontramos un problema","couldNotStartMlaText":"No se Pudieron Iniciar Mis Licencias. Hemos notificado a un administrador. Por favor verifica nuevamente más tarde. Si el problema persiste, comunícate con nuestro soporte técnico.","skipEndOfHandLabel":"Skip End Of Hand","inPosition":"In Position","outOfPosition":"Out Of Position","amountBb":"${0} bb","amountBbPlus":"${0}+ bb","amountBb100":"${0} bb/100","cbetCbetSuccessTip":"Cbet Success: ${0} % <br/>Winrate: ${1} bb/100","riverBetEfficiencyTip":"${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverCallEfficiencyTip":"${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverHandFrequencyTip":"Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100","riverPotSizeFrequencyTip":"Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100","tourneyallinRaisingCallingByPositionTip":"${0} (${1})<br/>Races Won: ${2}","threebetBetFrequencyTip":"3-Bet: ${0} % <br/>Winrate: ${1} bb/100","ipOopTip":"${0}<br/>In Position: ${1}<br/>Out of Position: ${2}","riverHereyoucanfind6":"Here you can find how often and how efficiently you play on the river based on pot size.","riverCombinethisview6":"Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.","potSizeFrequencyP":"Pot Size Frequency (%)","riverHereyoucanfind5":"Here you can find how often and how efficiently you play different hole cards on the river.","riverCombinethisview5":"Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.","riverHereyoucanfind4":"Here you can find how often and how efficiently you play on the river with different hand strengths.","riverCombinethisview4":"Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.","riverRiverCallEfficiencyNetWon":"River Call Efficiency Net Won","riverRCE":"River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.","riverCombinethisview3":"Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.","riverSawShowdown":"Saw Showdown","riverNoShowdown":"No Showdown","riverMadeRiverCbet":"Made River Cbet","riverMadeRiverDonkBet":"Made River Donk Bet","riverSmallriverbets":"Small river bets (<50% pot)","riverBigriverbets":"Big river bets (>100% pot)","riverFacedRiverCbet":"Faced River Cbet","riverFacedRiverDonkBet":"Faced River Donk Bet","riverRiverBet":"River Bet","riverRiverCall":"River Call","riverRiverRaise":"River Raise","riverRiverFold":"River Fold","riverWonHand":"Won Hand","riverLostHand":"Lost Hand","riverRiverBetEfficiencyNetWon":"River Bet Efficiency Net Won","riverRBE":"River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.","riverCombinethisview2":"Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.","riverHereyoucanfind":"Here you can find how aggressively you play on the river and your results for each action played.","tip":"Tip","riverCombinethisview":"Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more","riverAsPreflopAggressor":"As Preflop Aggressor","riverVsPreflopAggressor":"Vs Preflop Aggressor","riverCheckedToRiver":"Checked To River","handFrequencyP":"Hand Frequency (%)","totalHands":"Total Hands","wonAtShowdown":"Won At Showdown","riverAggression":"River Aggression","riverCallEff":"River Call Eff","riverBetEff":"River Bet Eff","riverWentToShowdown":"Went To Showdown","riverRiverHoleCards":"River Hole Cards","riverRiverHandStrength":"River Hand Strength","riverRiverAgression":"River Agression %","riverRiverCallEfficiency":"River Call Efficiency","riverRiverBetEfficiency":"River Bet Efficiency","riverRiverPotSize":"River Pot Size","numberOfTables":"Number Of Tables","sessions":"Sessions","leakonomicsOpponentNoteColor":"Opponent Note Color","leakonomicsSessionProgressSessionNames":"Shorter;Average Session Length;Longer","leakonomicsSessionProgressMin":"Session Progress (Min)","netWonBb":"Net Won (bb)","leakonomicsSessionsSplit":"Sessions Split","leakonomicsPotAmountWonbb":"Pot Amount Won (bb)","orLess":"${0} or less","leakonomicsAllinSplit":"All-in Split","leakonomicsAllinWinsInaRow":"All-in Wins in a Row","winnings":"Winnings","leakonomicsRollingWindow":"Rolling Window Graph","leakonomicsNetWon":"Net Won Up/Down","leakonomicsUpDownSessionNames":"When Down;Neutral;When Up","leakonomicsPreflopStatsDev":"Preflop Stats Dev","leakonomicsBestWrt":"Best wrt: ${0} bb","leakonomicsBestWrtAt":"At ${0} min","leakonomicsWinlossSessionNames":"Loss Series;Neutral;Win Series","leakonomicsAllinRate":"All-in Rate","leakonomicsWinningP":"Winning: ${0}%","leakonomicsLosingP":"Losing: ${0}%","leakonomicsBestWrt2":"Best wrt: ${0} bb/hr","leakonomicsBestWrtAt2":"At ${0} table(s)","at":"At","leakonomicsWinrateBb100P":"Winrate: 5bb/100","leakonomicsPotsLost":"Pots lost: ${0}%","leakonomicsPotsWon":"Pots won: ${0}%","leakonomicsWhenUporDownInSession":"When Up or Down In Session","leakonomicsSessionProgress":"Session Progress","leakonomicsAfterAllinSeries":"After All-in Series","leakonomicsWhenMultitabling":"When Multitabling","leakonomicsVsOpponentbyNoteColor":"Vs Opponent by Note Color","leakonomicsAfterWinningorlosingapot":"After Winning or losing a pot","cbetSuccessP":"CBet Success %","winrate":"Winrate","winrateBB100":"Winrate (bb/100)","cbetActionHU":"CBet action: Heads Up","cbetActionMultiway":"CBet action: Multiway","cbetActionHUNoHands":"Heads Up: No Hands","cbetActionMultiwayNoHands":"Multiway: No Hands","cbetWonLost":"$ Won / Lost","cbetResultsSkippedDonut1Title":"Overall Skipped Cbet","cbetResultsSkippedDonutSubtitle":"Over ${0} Hands<br/>${1} bb/100","cbetResultsSkippedDonut1TitleNoHands":"Overall Skipped Cbet: No Hands","cbetResultsSkippedDonut2Title":"Overall CBet Success","cbetResultsSkippedDonut2TitleNoHands":"Overall Cbet Success: No Hands","hands":"Hands","cbetActionIP":"CBet action: In Position","cbetActionOOP":"CBet action: Out Of Position","cbetNoHandsIP":"In Position: No Hands","cbetNoHandsOOP":"Out Of Position: No Hands","cbetOverallSuccess":"Overall Success","cbetFlopCBetSuccess":"Flop CBet Success","cbetCBetWinrate":"CBet Winrate","cbetSkippedCBetWinnings":"Skipped CBet Winnings","cbetCBetSuccessBoardTexture":"CBet Success: Board Texture","cbetCBetSuccessPosition":"CBet Success: Position","cbetHandStrengthwhenCBettting":"Hand Strength when CBettting","cbetCBetSpotsHeadsUpvsMultiway":"CBet Spots - HeadsUp vs Multiway","cbetCBetSpotsInPositionvsOutofPosition":"CBet Spots - In Position vs Out of Position","cbetResultsSkippedCBet":"Results Skipped CBet","bubbleICMDescription5":"The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.","bubblePercentageDescription5":"Percentage of the prize pool won categorized by your effective stack size","bubblePreflopDescription5":"Your preflop stats categorized on your stack size","bubbleEffectiveStackSizebb":"Effective Stack Size (bb)","bubbleBubbleStackSize":"Bubble Stack Size","bubbleCallingAllInRange":"Calling All-In Range","bubbleSitNGoEntrants":"Sit 'N Go Entrants","bubbleICMDescription4":"The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.","bubblePercentageDescription4":"Percentage of the prize pool won categorized by the number of entrants","bubblePreflopDescription4":"Your preflop stats categorized on your stack size","bubbleBubblePosition":"Bubble Position","bubbleICMDescription3":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.","bubblePercentageDescription3":"Percentage of the prize pool won categorized by your position","bubblePreflopDescription3":"Your preflop stats categorized by your position","bubblePreflopDescription2":"Percentage of the prize pool won categorized by the number players remaining at the bubble","bubblePlayersAtBubble":"# Players At Bubble","bubbleBubblePlayers":"Bubble Players at Bubble","bubblePrizePoolP":"Prize Pool%","bubbleBubbleStage":"Bubble Stage","bubbleEVbb100hands":"EV BB/100 Hands","bubbleICMDescription":"The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.","bubblePercentageDescription":"Percentage of the prize pool won before, during, and after the bubble","bubblePreflopDescription":"Your preflop stats categorized on your stack size","bubblePrizePoolWon":"Prize Pool Won","bubbleExpectedValue":"Expected Value","bubbleAverageStack":"Average Stack","bubbleCallAIWinrate":"Call AI Winrate","bubbleShoveAIWinrate":"Shove AI Winrate","tooFewHands":"Too Few Hands For This Report","bubblePrizePoolWinningsTitle":"Prize Pool Winnings","bubbleExpectationWhenReachingBubbleTitle":"Expectation When Reaching Bubble","bubblePositionTitle":"Position","bubbleBeforeAndAfterTitle":"Before And After","bubbleStackSizeTitle":"Stack Size","bubbleCallRangesTitle":"Call Ranges","bubbleShoveRangesTitle":"Shove Ranges","tourneyallinRaisingOpenAI":"Raising Open AI","tourneyallinRaising3BetAI":"Raising 3Bet AI","tourneyallinRaisevsOpen":"Raise vs Open","tourneyallinRaisevs3Bet":"Raise vs 3-Bet","tourneyallinCallvsOpen":"Call vs Open","tourneyallinCallvs3Bet":"Call vs 3-Bet","tourneyallinPreflopEffectiveStackSizeAxis":"Preflop Effective Stack Size","tourneyallinRacesWonPAxis":"Races Won %","tourneyallinEquityPAxis":"Equity %","tourneyallinCallingOpenAI":"Calling Open AI","tourneyallinCalling3BetAI":"Calling 3Bet AI","tourneyallinPositionAxis":"Position","tourneyallinExpectationAxis":"Expectation","threebetResultsTitle":"Results","threebetPositionTitle":"Position","threebetRangeTitle":"Three Bet Range","threebetSuccessTitle":"Three Bet Success","threebetFlopHandStrengthTitle":"Flop Hand Strength","threebetWinrate":"3Bet Winrate","threebetFrequency":"3Bet Frequency","threebetRange":"3Bet Range","threebetSuccessRate":"3Bet Success Rate","threebetFlopWinrate":"Flop Winrate","threebetWinrateHandStrengthAxis":"Winrate Hand Strength (bb/100)","threebetHandCount":"${0} (${1} Hands)","threebetWinrateKey":"Winrate","threebetThreeBetPercentKey":"3-Bet %","threebetWinrateAxis":"Winrate (bb/100)","threebetThreeBetPercentAxis":"3-Bet %","threebetSuccessPercentAxis":"Success %","threebetNetwonTitle":"Net Won","threebetNetwonMin":"Loss","threebetNetwonMax":"Profit","threebetDealtFrequencyTitle":"Dealt Frequency","threebetDealtFrequencyMin":"Less Frequent","threebetDealtFrequencyMax":"More Frequent","tourneyallinExpectedWon":"Expected Won","availableStringPositionString":"EP;MP;CO;BTN;SB;BB","availableStringFlopMadeHandValueString":"Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush","availableStringRiverMadeHandValueSummary":"Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush","availableStringFlopFlushTextureTypeAsString":"Flush Rainbow;Flush Two Tone;Flush Monotone","availableStringFlopStraightTextureTypeAsString":"Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper","availableStringFlopPairedTextureTypeAsString":"Paired Board;Not Paired","availableStringInPositionOnFlopShort":"IP;OOP","availableStringInPositionOnFlopLong":"In Position;Out Of Position","availableStringRiverplayCallEfficiency":"Call Efficiency;In Position;Out Of Position","availableStringRiverplayBetEfficiency":"Bet Efficiency;In Position;Out Of Position","availableStringCBetSpots":"Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand","availableStringRiverFirstActionString":"Fold;Check;Call;Bet;Raise","ECCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","ECCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","ECTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","ECTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","ERRaiseCallVsVillainOpenAllinPreflop":"AI PF vs Raise","ERRaiseEVCallVsVillainOpenAllinPreflop":"Expectation AI PF vs Raise","ERTBetCallVsVillainOpenAllinPreflop":"3Bet AI PF vs Re-Raise","ERTBetEVCallVsVillainOpenAllinPreflop":"Expectation 3Bet AI PF vs Re-Raise","BPCCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","BPCCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","BPCTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","BPCTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","BPRRaiseAllinVsRaisePreflop":"AI PF vs Raise","BPRRaiseEVAllinVsRaisePreflop":"Expectation AI PF vs Raise","BPRTBetAllinVsRaisePreflop":"3Bet AI PF vs Re-Raise","BPRTBetEVAllinVsRaisePreflop":"Expectation 3Bet AI PF vs Re-Raise","threebetHandAxis":"Hand","threebetNetBbAxis":"Net BBs","tourneyallinCallingByStackTitle":"Expectation Calling All-In By Stack Size","tourneyallinRaisingByStackTitle":"Expectation Raising All-In By Stack Size","tourneyallinRaisingAllinRangeTitle":"Raising All-In Range","tourneyallinCallingAllinRangeTitle":"Calling All-In Range","tourneyallinCallingAllinByPositionTitle":"Calling All-In Results By Position","tourneyallinRaisingAllinByPositionTitle":"Raising All-In Results By Position","tourneyallinCallAIEVWinrate":"Call AI EV Winrate","tourneyallinRaiseAIEVWinrate":"Raise AI EV Winrate","tourneyallinCallAIWinrate":"Call AI Winrate","tourneyallinRaiseAIWinrate":"Raise AI Winrate","overall":"Overall","restrictionsWithYourLicenseText":"<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"},ukrainian:{"notAllowedByLicense":"Роздача не допускається ліцензією","selectHandToExport":"Обрати руку для експорту","selectFormat":"Обрати формат...","originalFormat":"Оригiнальний формат","ctrlCToCopy":"Ctrl-C для копіювання в буфер","availableTags":"Доступнi мiтки","welcomeToHm3":"Ласкаво просимо в реплеер HoldemManager3!","theme":"Тема: ","deck":"Колода: ","showHandResults":"Показати результат роздачі: ","showHeroCards":"Завжди показувати карти Hero: ","showBB":"Показати фішки в ВБ: ","combineFolds":"Об'єднати фолди: ","maskPlayerNames":"Сховати iмена гравцiв: ","statsUpToTimeOfHand":"Стати на час початку роздачi: ","showHud":"Показати HUD: ","replaySpeed":"Швидкiсть реплееру: ","hand":"Рука","next100Hands":"Наст. 100 рук","prev100Hands":"Попер. 100 рук","addEditHandMarking":"Додати/Правити помiтки рук","wonXBB":"Виграно ${0} ВБ","lostXBB":"Програно ${0} ВБ","wonLossNA":"Виграш/Програш NA","potBB":"Банк: ${0} ВБ","userWentAllin":"Гравець пiшов олл-iн","pot":"Банк: ${0}","potOdds":"Шанси банку: ${0}:1","hhGameStart":"Гра ${0} ${1} почалася в ${2}","hhHandNotes":"Помiтка(и) рук","hhFold":"${0} фолд","hhCheck":"${0} чек","hhCall":"${0} кол ${1}","hhBet":"${0} бет ${1}","hhRaise":"${0} рейз ${1}","hhReturnedTo":"${1} повернено до ${0}","hhWin":"${0} виграв ${1}","hhRake":"Рейк: ${0}","hhActionEnded":"Дiя закiнчилася.","hhMuck":"${0} сховав ${1}","hhShow":"${0} показав ${1}","hhPostSB":"${0} розміщує великий блайнд","hhPostBB":"${0} розміщує малий блайнд","hhPostDB":"${0} розміщує мертвий блайнд","backToReleaseNotes":"Назад до приміток випуску","backToMyLicense":"Назад до моєї ліцензії","backToCardInfo":"Назад до інформації про кредитну картку","backToPayment":"Назад до способу оплати","orderBuyNow":"Придбати зараз","orderProceed":"Виконати","headerTextTrial":"Трiал (${0} днiв залишилося)","headerTextFree":"Безкоштовно","smallStakes":"Малi лiмiти","allStakes":"Всi лiмiти","smallStakesCaps":"МАЛI ЛIМIТИ","allStakesCaps":"ВСI ЛIМIТИ","smallStakesMaintenance":"ТЕХОБСЛУГОВУВАННЯ МАЛИХ СТАВОК","allStakesMaintenance":"ТЕХОБСЛУГОВУВАННЯ ВСIХ ЛIМIТIВ","buyHoldemSmallStakes":"Холдем малi лiмiти","buyHoldemAllStakes":"Холдем всi лiмiти","buyHoldemOmahaAllStakes":"Всi лiмiти","buyOmahaSmallStakes":"Омаха малi лiмiти","buyOmahaAllStakes":"Омаха всi лiмiти","holdemManager":"Holdem Manager","holdemManagerCaps":"HOLDEM MANAGER","omahaCaps":"ОМАХА","holdem":"Холдем","omaha":"Омаха","hmApps":"HM Apps","hm3":"HM3","om3":"OM3","hm3andOm3":"HM3 + OM3","expiredOn":"Термін дії закінчився ${0}","expiresOn":"Закінчується ${0}","recommended":"РЕКОМЕНДОВАНО","seeAllOptionsInStore":"Переглянути всі параметри в магазині","paypalExternalBrowser":"PayPal вiдкриється в зовнiшньюму браузерi для завершення процесу оплати.","skrillExternalBrowser":"Skrill вiдкриється в зовнiшньюму браузерi для завершення процесу оплати.","selectProduct":"ОБРАТИ ПРОДУКТ","availableUpdate":"ДОСТУПНI ОНОВЛЕННЯ: ","versionAvailable":"Версiя ${0} доступна: ${1}","fullFaq":"FAQ по повнiй версії","reviewOptions":"Перед початком оновлення перегляньте варіанти обслуговування Holdem","maintenanceOptions":"Варіанти обслуговування","addProductToLicense":"ДОДАТИ ${0} ДО ПОТОЧНОЇ ЛІЦЕНЗІЇ","purchasePrice":"Придбати (${0})","errorName":"Введiть повне iм'я","errorAddress":"Введiть вулицю та номер будинка","errorCountry":"Введiть країну","errorCity":"Введiть мiсто","errorZip":"Введiть поштовий iндекс","billingInfo":"ПЛАТIЖНА IНФОРМАЦIЯ","name":"Повне iм'я","address":"Адреса","city":"Мiсто","state":"Область/провiнцiя","zip":"Поштовий iндекс","country":"Країна","selectCountry":"Оберiть країну","buyNowTip":"Оберiть iснуючий або новий метод плати перед початком","licenses":"ЛІЦЕНЗІЇ","version":"Версiя ${0}","viewReleaseNotes":"Дивитися помiтки про змiни на сайтi","updateAndRenewMaintenance":"ОНОВЛЕННЯ ТА ПОВТОРЕННЯ ОБСЛУГОВУВАННЯ","renewGetUpdatesUntil":"Оновлюючи технічне обслуговування, ви отримаєте всі оновлення HM3 через ${0}","update":"Поновити","updateAndSwitchToFree":"ОНОВЛЕННЯ ТА ПЕРЕКЛЮЧЕННЯ ДО БЕЗКОШТОВНОЇ ВЕРСІЇ","updateAndSwitchToFreeDetails1":"Ви отримаєте оновлення, але ваш HM3 (Holdem) повернеться до безкоштовної версії та буде мати","updateAndSwitchToFreeDetails2":"обмежена функцiональнiсть","updateAndSwitch":"Поновити та перейти","errorCreditCardDigitsOnly":"Номер кредитної картки має містити лише цифри.","errorCreditCard":"Введіть дійсний номер картки.","errorRequired":"Обов'язкове","errorCardExpired":"Термін дії картки закінчився","errorCvv":"CVV має бути довжиною ${0} цифр","cardInfo":"ДАНІ КРЕДИТНОЇ КАРТКИ","cardNo":"Номер карти","expiry":"Термін дії","year":"рiк","month":"мiсяць","month01":"Сiч","month02":"Лют","month03":"Бер","month04":"Квi","month05":"Тра","month06":"Чер","month07":"Лип","month08":"Сер","month09":"Вер","month10":"Жов","month11":"Лис","month12":"Гру","cvv":"CVV","active":"Активна","manageSubscription":"Керувати підпискою","youAreUpToDate":"Ви оновленi","releaseNotes":"Примітки до випуску для ${0}","netellerInfo":"Iнформацiя рахунку NETELLER","netellerSignin":"Зайдiть в свiй рахунок NETELLER для завершення оплати","continue_":"Продовжити","netellerAccount":"Рахунок Neteller","netellerPassword":"Пароль","orderSummary":"ПІДСУМОК ЗАМОВЛЕННЯ: ","changeProducts":"Змiнити продукт(и)","total":"Загалом","paypalComplete":"ЗАВЕРШIТЬ ПРИДБАННЯ ЧЕРЕЗ РАХУНОК PAYPAL В БРАУЗЕРI","paypalOpenedInNewBrowser":"PayPal вiдкрито в iнтернет-браузерi за замовчуванням. Увійдіть до свого облікового запису PayPal і завершіть покупку. Після цього поверніться сюди та натисніть \"Перезавантажити ліцензію\", щоб завантажити ліцензію, яку ви придбали.","reloadLicense":"Перезавантажити лiцензiю","thankYouForPurchase":"Дякуємо за покупку","purchaseConfirm1":"Незабаром ви отримаєте підтвердження електронною поштою на ${0}","purchaseConfirm2":"Натисніть кнопку Перезавантаження ліцензії нижче, і ваша придбана ліцензія стане активна.","restricted":"обмежено","restrictionsWithYourLicense":"ОБМЕЖЕННЯ ВАШОЇ ЛІЦЕНЗІЇ","paymentPleaseChoose":"Оберiть метод оплати","paymentSelectExisting":"Оберiть метод оплати з iснуючих: ","paymentSelectNew":"Метод оплати","paymentMethod":"Метод оплати: ","changePaymentMethod":"Змiнити метод оплати","licensedTo":"ЛIЦЕНЗОВАНО ДЛЯ","learnMore":"Взнати бiльше","startTrial":"Почати трiал","purchase":"Придбати","trialSuccessfullyStarted":"Трiал успiшно почався","trialSuccessDetails1":"Ваш 14-денний трiал тепер активний. Будь ласка ","trialSuccessDetails2":"оновити","trialSuccessDetails3":" якомога швидше, щоб уникнути перебоїв у роботі служби.","havingTrouble":"З'явилися проблеми?","contactUs":"Зв'язок з нами","startUsing":"Почати використовувати HM3 зараз","missedUpdates":"${0} пропущених оновлень","updatesAreCritical":"Оновлення мають критичне значення для того, щоб HM3 продовжував імпортувати історії роздач після змін покерними сайтами свого програмного забезпечення. Нові функції та можливості також випускаються через оновлення.","view":"Огляд","oneYearOfUpdates":"Включає один рік оновлень","renew":"Поновити ${0}","startingAt":"Почато в ","upgrade":"Поновити","removesRestrictions1":"видаляє ","removesRestrictions2":"обмеження","removesRestrictions3":" та включає один рік оновлень","upgradePrice":"Поновити ${0}","required":"Обов'язкове","continueFreemium":"Продовжити безкоштовну версiю","defaultFatalError":"Трапилася несподiвана внутрiшня помилка серверу, адмiнiстратора повiдомлено. Спробуйте придбати знову пізніше.","restrictCashHandsType":"Кешовi роздачi","restrictTourneyType":"Турнiр","restrictLimitCashHandsType":"Обмеження кешових роздач","restrictHudType":"HUD","restrictReportDataType":"Данi звiту","restrictCashHands":"$ ${0} та нижче","restrictLimitCashHands":"$ ${0} та нижче","restrictTourney":"Макс ${0}","restrictHud":"Макс ${0} столiв","restrictReportData":"Останнi ${0} роздач","restrictionUnlimited":"Необмежено","errorState":"Обов'язкове","activeHoldemLicense":"АКТИВНА ЛIЦЕНЗIЯ ХОЛДЕМ","activeOmahaLicense":"АКТИВНА ЛIЦЕНЗIЯ ОМАХА","reinstallOldVersion":"Перевстановіть стару версію","removesRestrictions3b":"і повертається до вашої платної ліцензії, але оновлення","removesRestrictions4b":"НЕ ВХОДИТЬ","noActiveHoldemLicense":"НЕМАЄ АКТИВНОЇ ЛІЦЕНЗІЇ ХОЛДЕМ","noActiveOmahaLicense":"НЕМАЄ АКТИВНОЇ ЛІЦЕНЗІЇ ОМАХА","free":"БЕЗКОШТОВНО","netellerSecureId":"Secure ID","recurringPriceDescription":"${0} ${1} включені*","recurringYear":"Рiк","recurringMonth":"Мiсяць","recurringDay":"День","restrictionsSmall":"No Limit/Pot Limit Cash <b>обмежено</b> до великого блайнду $0.50\nFixed Limit Cash <b>обмежено</b> до великого блайнду $1.00\nTournaments <b>обмеженi</b> до бай-їну $22.00.","afterDiscount":"Цiна пiсля строку дії знижки","upgradeDiscount":"ЗНИЖКА НА ОНОВЛЕННЯ","discountExpires":"Знижка закінчується 31 березня 2019","discountSinglePurchase":"Знижка застосовується до однієї покупки.","errorNetellerAccount":"Недійсний ідентифікатор облікового запису Neteller","errorNetellerSecureId":"Введіть 6-значний Secure ID","continueTrial":"Продовжити пробу","continueTrialDaysRemaining":"(${0} днiв залишилося)","netellerInvalidCredentials":"Не вдалося перевірити облікові дані Neteller. Спробуйте ввійти знову.","faq":"FAQ","forMoreDetails":" детальніше про управління щорічним оновленням підтримки та технічного обслуговування.","recurringSubscription":"* Метод оплати необхідний для щорічного оновлення підтримки та технічного обслуговування $${0}, яке буде виставлено за один рік (${1}). Див. ","positivePrice":"Оновлення рiчноЩорічне оновлення підтримки та технічного обслуговування $${0} буде виставлено за один рік (${1}). Див. ","paymentSeeWebsite1":"Див. ","paymentSeeWebsite2":"МАГАЗИН","paymentSeeWebsite3":" iншi варiанти оплати","paymentOr":"-АБО-","couldNotStartMlaTitle":"Ми зіткнулися з проблемою","couldNotStartMlaText":"Не вдалося вiдкрити роздiл 'Мої ліцензії'. Повідомлено адміністратора. Перевірте знову пізніше. Якщо проблема не зникає, зверніться до нашої служби підтримки.","skipEndOfHandLabel":"Пропустити кінець роздачі","inPosition":"У позиції","outOfPosition":"Без позиції","amountBb":"${0} вб","amountBbPlus":"${0}+ вб","amountBb100":"${0} вб/100","cbetCbetSuccessTip":"Cbet Success: ${0} % <br/>Winrate: ${1} bb/100","riverBetEfficiencyTip":"${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverCallEfficiencyTip":"${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}","riverHandFrequencyTip":"Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100","riverPotSizeFrequencyTip":"Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100\n","tourneyallinRaisingCallingByPositionTip":"${0} (${1})<br/>Races Won: ${2}","threebetBetFrequencyTip":"3-Bet: ${0} % <br/>Winrate: ${1} bb/100","ipOopTip":"${0}<br/>In Position: ${1}<br/>Out of Position: ${2}","riverHereyoucanfind6":"Тут можна дізнатися, як часто і як ефективно ви граєте на рівері в залежності від розміру банку.","riverCombinethisview6":"У поєднанні з фільтрами цей огляд покаже, чи виграєте ви багато малих банків, програєте великі банки та інше.","potSizeFrequencyP":"Pot Size Frequency (%)","riverHereyoucanfind5":"Тут можна дізнатися, як часто і як ефективно ви граєте різні кишенькові карти на рівері.","riverCombinethisview5":"Комбінуючий цей огляд із фільтрами, можна дізнатися, як відрiзняються ваші діапазони при ставках, коллах, рейзах і т.п.","riverHereyoucanfind4":"Тут можна дізнатися, як часто і як ефективно ви граєте на рівері карти різної сили.","riverCombinethisview4":"Комбінуючий цей огляд із фільтрами, можна дізнатися, чи доходите ви до риверу із дуже слабкими картами, або дивитесь відкриття із сильною рукою та інше.","riverRiverCallEfficiencyNetWon":"River Call Efficiency Net Won","riverRCE":"River Call Efficiency (RBE) показує ваш прибуток для кожного великого блайнда, інвестованого в коли та чек-коли на рівері.","riverCombinethisview3":"Комбінуючий цей огляд із фільтрами, можна дізнатися, як ефективнi ефективні ваші коли на ривері, коли ви зустрічаєтесь з контбетами, донкбетами, різними розмірами ставок та інше.","riverSawShowdown":"Saw Showdown","riverNoShowdown":"No Showdown","riverMadeRiverCbet":"Made River Cbet","riverMadeRiverDonkBet":"Made River Donk Bet","riverSmallriverbets":"Small river bets (<50% pot)","riverBigriverbets":"Big river bets (>100% pot)","riverFacedRiverCbet":"Faced River Cbet","riverFacedRiverDonkBet":"Faced River Donk Bet","riverRiverBet":"River Bet","riverRiverCall":"River Call","riverRiverRaise":"River Raise","riverRiverFold":"River Fold","riverWonHand":"Won Hand","riverLostHand":"Lost Hand","riverRiverBetEfficiencyNetWon":"iver Bet Efficiency Net Won","riverRBE":"River Bet Efficiency (RBE) показує ваш прибуток для кожного великого блайнда, інвестованого в ставки на рівері.","riverCombinethisview2":"Комбінуючий цей огляд із фільтрами, можна дізнатися, як ефективнi ефективні ваші ставки на ривері, коли ви зустрічаєтесь з контбетами, донкбетами, різними розмірами ставок та інше.","riverHereyoucanfind":"Тут можна дізнатися, як агресивно ви граєте на рівері, та ваші результати по кожнiй ігровiй дії.","tip":"Порада","riverCombinethisview":"Комбінуючий цей огляд із фільтрами, можна дізнатися, як відрізняється ваша гра, коли ви є агресор, проти агресору та інше.","riverAsPreflopAggressor":"Як префлоп агресор","riverVsPreflopAggressor":"Проти префлоп агресора","riverCheckedToRiver":"Checked To River","handFrequencyP":"Hand Frequency (%)","totalHands":"Всього роздач","wonAtShowdown":"Виграно на розтині","riverAggression":"River Aggression","riverCallEff":"River Call Eff","riverBetEff":"River Bet Eff","riverWentToShowdown":"Went to Showdown","riverRiverHoleCards":"River Hole Cards","riverRiverHandStrength":"River Hand Strength","riverRiverAgression":"River Agression %","riverRiverCallEfficiency":"River Call Efficiency","riverRiverBetEfficiency":"River Bet Efficiency","riverRiverPotSize":"River Pot Size","numberOfTables":"Число столiв","sessions":"Сесії","leakonomicsOpponentNoteColor":"Колір примітки на опонента","leakonomicsSessionProgressSessionNames":"Shorter;Average Session Length;Longer","leakonomicsSessionProgressMin":"Session Progress (Min)","netWonBb":"Net Won (bb)","leakonomicsSessionsSplit":"Sessions Split","leakonomicsPotAmountWonbb":"Pot Amount Won (bb)","orLess":"${0} або менше","leakonomicsAllinSplit":"All-in Split","leakonomicsAllinWinsInaRow":"All-in Wins in a Row","winnings":"Виграші","leakonomicsRollingWindow":"Rolling Window Graph","leakonomicsNetWon":"Net Won Up/Down","leakonomicsUpDownSessionNames":"When Down;Neutral;When Up","leakonomicsPreflopStatsDev":"Preflop Stats Dev","leakonomicsBestWrt":"Best wrt: ${0} bb","leakonomicsBestWrtAt":"At ${0} min","leakonomicsWinlossSessionNames":"Loss Series;Neutral;Win Series","leakonomicsAllinRate":"All-in Rate","leakonomicsWinningP":"Winning: ${0}%","leakonomicsLosingP":"Losing: ${0}%","leakonomicsBestWrt2":"Best wrt: ${0} bb/hr","leakonomicsBestWrtAt2":"At ${0} table(s)","at":"на","leakonomicsWinrateBb100P":"Winrate: 5bb/100","leakonomicsPotsLost":"Pots lost: ${0}%","leakonomicsPotsWon":"Pots won: ${0}%","leakonomicsWhenUporDownInSession":"When Up or Down In Session","leakonomicsSessionProgress":"Session Progress","leakonomicsAfterAllinSeries":"After All-in Series","leakonomicsWhenMultitabling":"При грі на багатьох столах","leakonomicsVsOpponentbyNoteColor":"Vs Opponent by Note Color","leakonomicsAfterWinningorlosingapot":"Після виграшу або програшу банку","cbetSuccessP":"CBet Success %","winrate":"Winrate","winrateBB100":"Winrate (bb/100)","cbetActionHU":"CBet action: Heads Up","cbetActionMultiway":"CBet action: Multiway","cbetActionHUNoHands":"Heads Up: No Hands","cbetActionMultiwayNoHands":"Multiway: No Hands","cbetWonLost":"$ Won / Lost","cbetResultsSkippedDonut1Title":"Overall Skipped Cbet","cbetResultsSkippedDonutSubtitle":"Over ${0} Hands<br/>${1} bb/100","cbetResultsSkippedDonut1TitleNoHands":"Overall Skipped Cbet: No Hands","cbetResultsSkippedDonut2Title":"Overall CBet Success","cbetResultsSkippedDonut2TitleNoHands":"Overall Cbet Success: No Hands","hands":"Роздачі","cbetActionIP":"CBet action: In Position","cbetActionOOP":"CBet action: Out Of Position","cbetNoHandsIP":"In Position: No Hands","cbetNoHandsOOP":"Out Of Position: No Hands","cbetOverallSuccess":"Overall Success","cbetFlopCBetSuccess":"Flop CBet Success","cbetCBetWinrate":"CBet Winrate","cbetSkippedCBetWinnings":"Skipped CBet Winnings","cbetCBetSuccessBoardTexture":"CBet Success: Board Texture","cbetCBetSuccessPosition":"CBet Success: Position","cbetHandStrengthwhenCBettting":"Hand Strength when CBettting","cbetCBetSpotsHeadsUpvsMultiway":"CBet Spots - HeadsUp vs Multiway","cbetCBetSpotsInPositionvsOutofPosition":"CBet Spots - In Position vs Out of Position","cbetResultsSkippedCBet":"Results Skipped CBet","bubbleICMDescription5":"Інформація нижче показує подання до ICM (модель незалежних фішок) виграної частини призового фонду виходячи з вашого ефективного стеку на початку роздачі.","bubblePercentageDescription5":"Виграний відсоток призового фонду при різних розмірах ефективного стеку","bubblePreflopDescription5":"Ваші стати префлоп при різних розмірах стеку","bubbleEffectiveStackSizebb":"Розмір ефективного стеку (вб)","bubbleBubbleStackSize":"Bubble Stack Size","bubbleCallingAllInRange":"Calling All-In Range","bubbleSitNGoEntrants":"Гравцiв в SNG","bubbleICMDescription4":"Інформація нижче показує подання до ICM (модель незалежних фішок) виграної частини призового фонду виходячи з числа учасників турніру.","bubblePercentageDescription4":"Виграний відсоток призового фонду при різному числі учасників","bubblePreflopDescription4":"Ваші стати префлоп при різних розмірах стеку","bubbleBubblePosition":"Позицiя на бабблi","bubbleICMDescription3":"Інформація нижче показує подання до ICM (модель незалежних фішок) виграної частини призового фонду виходячи з вашої позиції за столом.","bubblePercentageDescription3":"Виграний відсоток призового фонду в різних позиціях","bubblePreflopDescription3":"Ваші стати префлоп в різних позиціях","bubblePreflopDescription2":"Виграний відсоток призового фонду при різному числі залишилися до бабблу","bubblePlayersAtBubble":"# гравцiв на бабблi","bubbleBubblePlayers":"Гравцiв на бабблi","bubblePrizePoolP":"Prize Pool%","bubbleBubbleStage":"Стадiя бабблу","bubbleEVbb100hands":"EV BB/100 Hands","bubbleICMDescription":"Інформація нижче показує подання до ICM (модель незалежних фішок) виграної частини призового фонду виходячи з стадії турніру. Поперед бабла демонструє всі роздачі, в яких ви грали перед досягненням тієї стадії турніру, коли наступний вибитий гравець \"протикає\" пузир і тепер решта учасникiв буде в призах.","bubblePercentageDescription":"Частина призового фонду, виграна до, пiд час та після бабла","bubblePreflopDescription":"Ваші статі префлоп в залежності від величини свого стеку","bubblePrizePoolWon":"Prize Pool Won","bubbleExpectedValue":"Expected Value","bubbleAverageStack":"Average Stack","bubbleCallAIWinrate":"Call AI Winrate","bubbleShoveAIWinrate":"Shove AI Winrate","tooFewHands":"Занадто мало рук для цього звіту","bubblePrizePoolWinningsTitle":"Prize Pool Winnings","bubbleExpectationWhenReachingBubbleTitle":"Expectation When Reaching Bubble","bubblePositionTitle":"Позицiя","bubbleBeforeAndAfterTitle":"До і після","bubbleStackSizeTitle":"Розмiр стеку","bubbleCallRangesTitle":"Call Ranges","bubbleShoveRangesTitle":"Shove Ranges","tourneyallinRaisingOpenAI":"Raising Open AI","tourneyallinRaising3BetAI":"Raising 3Bet AI","tourneyallinRaisevsOpen":"Raise vs Open","tourneyallinRaisevs3Bet":"Raise vs 3-Bet","tourneyallinCallvsOpen":"Call vs Open","tourneyallinCallvs3Bet":"Call vs 3-Bet","tourneyallinPreflopEffectiveStackSizeAxis":"Ефективний стек префлоп","tourneyallinRacesWonPAxis":"Races Won %","tourneyallinEquityPAxis":"Equity %","tourneyallinCallingOpenAI":"Calling Open AI","tourneyallinCalling3BetAI":"Calling 3Bet AI","tourneyallinPositionAxis":"Позицiя","tourneyallinExpectationAxis":"Очікування","threebetResultsTitle":"Результати","threebetPositionTitle":"Позицiя","threebetRangeTitle":"Three Bet Range","threebetSuccessTitle":"Three Bet Success","threebetFlopHandStrengthTitle":"Flop Hand Strength","threebetWinrate":"3Bet Winrate","threebetFrequency":"3Bet Frequency","threebetRange":"3Bet Range","threebetSuccessRate":"3Bet Success Rate","threebetFlopWinrate":"Flop Winrate","threebetWinrateHandStrengthAxis":"Winrate Hand Strength (bb/100)","threebetHandCount":"${0} (${1} Hands)","threebetWinrateKey":"Winrate","threebetThreeBetPercentKey":"3-Bet %","threebetWinrateAxis":"Winrate (bb/100)","threebetThreeBetPercentAxis":"3-Bet %","threebetSuccessPercentAxis":"Success %","threebetNetwonTitle":"Net Won","threebetNetwonMin":"Loss","threebetNetwonMax":"Profit","threebetDealtFrequencyTitle":"Частота отримання","threebetDealtFrequencyMin":"Менш часто","threebetDealtFrequencyMax":"Більш часто","tourneyallinExpectedWon":"Expected Won","availableStringPositionString":"EP;MP;CO;BTN;SB;BB","availableStringFlopMadeHandValueString":"Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush","availableStringRiverMadeHandValueSummary":"Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush","availableStringFlopFlushTextureTypeAsString":"Flush Rainbow;Flush Two Tone;Flush Monotone","availableStringFlopStraightTextureTypeAsString":"Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper","availableStringFlopPairedTextureTypeAsString":"Paired Board;Not Paired","availableStringInPositionOnFlopShort":"IP;OOP","availableStringInPositionOnFlopLong":"In Position;Out Of Position","availableStringRiverplayCallEfficiency":"Call Efficiency;In Position;Out Of Position","availableStringRiverplayBetEfficiency":"Bet Efficiency;In Position;Out Of Position","availableStringCBetSpots":"Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand","availableStringRiverFirstActionString":"Fold;Check;Call;Bet;Raise","ECCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","ECCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","ECTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","ECTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","ERRaiseCallVsVillainOpenAllinPreflop":"AI PF vs Raise","ERRaiseEVCallVsVillainOpenAllinPreflop":"Expectation AI PF vs Raise","ERTBetCallVsVillainOpenAllinPreflop":"3Bet AI PF vs Re-Raise","ERTBetEVCallVsVillainOpenAllinPreflop":"Expectation 3Bet AI PF vs Re-Raise","BPCCallCallVsVillainOpenAllinPreflop":"Call Opp AI PF","BPCCallEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp AI PF","BPCTBetCallVsVillainOpenAllinPreflop":"Call Opp 3Bet AI PF","BPCTBetEVCallVsVillainOpenAllinPreflop":"Expectation Calling Opp 3Bet AI PF","BPRRaiseAllinVsRaisePreflop":"AI PF vs Raise","BPRRaiseEVAllinVsRaisePreflop":"Expectation AI PF vs Raise","BPRTBetAllinVsRaisePreflop":"3Bet AI PF vs Re-Raise","BPRTBetEVAllinVsRaisePreflop":"Expectation 3Bet AI PF vs Re-Raise","threebetHandAxis":"Рука","threebetNetBbAxis":"Net BBs","tourneyallinCallingByStackTitle":"Expectation Calling All-In By Stack Size","tourneyallinRaisingByStackTitle":"Expectation Raising All-In By Stack Size","tourneyallinRaisingAllinRangeTitle":"Raising All-In Range","tourneyallinCallingAllinRangeTitle":"Calling All-In Range","tourneyallinCallingAllinByPositionTitle":"Calling All-In Results By Position","tourneyallinRaisingAllinByPositionTitle":"Raising All-In Results By Position","tourneyallinCallAIEVWinrate":"Call AI EV Winrate","tourneyallinRaiseAIEVWinrate":"Raise AI EV Winrate","tourneyallinCallAIWinrate":"Call AI Winrate","tourneyallinRaiseAIWinrate":"Raise AI Winrate","overall":"Загальний","restrictionsWithYourLicenseText":"<B> Немає доступу</ b> до HM3 Apps\nПовідомлення пробного періоду в звітах і в HUD\nтривалість 14 днів"},init:function init(language){if(this.initialized)return;this.initialized=true;for(var name in this.keys){this.keys[name]=name;}this.language=language;Object(__WEBPACK_IMPORTED_MODULE_0__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_0__api_logger__["a" /* LogCategory */].info,"localizer initialized "+this.language);},format:function format(key,values){// Localizer.init() hasn't been called?
console.assert(key!="");console.assert(this.initialized);var language=this.language;if(typeof language!=='string'){Object(__WEBPACK_IMPORTED_MODULE_0__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_0__api_logger__["a" /* LogCategory */].info,'fatal - invalid language '+language);language="en";}var useKeys=[];switch(language){case"en":useKeys=this.en;break;case"zh-CN":useKeys=this.chinese;break;case"fr":useKeys=this.french;break;case"de":useKeys=this.german;break;case"it":useKeys=this.italian;break;case"ja":useKeys=this.japanese;break;case"pl":useKeys=this.polish;break;case"pt":useKeys=this.portugese;break;case"pt-br":useKeys=this.portugese_br;break;case"ro":useKeys=this.romanian;break;case"ru":useKeys=this.russian;break;case"sl":useKeys=this.slovenian;break;case"es":useKeys=this.spanish;break;case"uk":useKeys=this.ukrainian;break;default:// unknown or invalid language -> use english
Object(__WEBPACK_IMPORTED_MODULE_0__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_0__api_logger__["a" /* LogCategory */].warn,"invalid language : "+language);useKeys=this.en;break;};if(useKeys.length<1)useKeys=this.keys;var msg=key;if(typeof useKeys[key]!=='undefined')msg=useKeys[key];else{// we don't have this key for a specific language - just default to 'en'
useKeys=this.en;if(typeof useKeys[key]!=='undefined')msg=useKeys[key];}if(typeof values!=='undefined'){// replace ${0} with value0 , ${1} with value1 etc.
for(var i in values){var argName="${"+i+"}";msg=msg.replace(argName,""+values[i]);}}return msg;}});

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports={None:-1,ActiveMaintenanceFull:0,ActiveMaintenanceSmall:1,BillingAddress:2,CardInfo:3,ExpiredContractFull:4,ExpiredContractSmall:5,ExpiringContractFull:6,ExpiringContractSmall:7,Freemium:8,MaintenanceOptions:9,PaymentReview:10,Paypal:11,PurchaseCompleteSuccess:12,Purchase:13,StartTrialOptions:14,TrialLicense:15,TrialStarted:16,ViewMisseddUpdates:17,ContinueTrial:18,SelectProducts:19,Netteller:20,FreemiumOverMaxVersion:21,PreSelectProducts:22,UpgradeProduct:23,CouldNotLoadMla:24,GetHm3ForFree:25,SelectHmAppsProducts:26,SelectHmAppVariantProducts:27};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports={NoLicense:1,Trial:2,Freemium:3,Maintenance:4,CouldNotStart:5};

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createStore; });
/* unused harmony export legacy_createStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(80);


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {
    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = createStore;

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}




/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _extends; });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var onLocationChanged = exports.onLocationChanged = function onLocationChanged(location, action) {
  return {
    type: _get__('LOCATION_CHANGE'),
    payload: {
      location: location,
      action: action
    }
  };
};

/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

var updateLocation = function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: _get__('CALL_HISTORY_METHOD'),
      payload: {
        method: method,
        args: args
      }
    };
  };
};

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = _get__('updateLocation')('push');
var replace = exports.replace = _get__('updateLocation')('replace');
var go = exports.go = _get__('updateLocation')('go');
var goBack = exports.goBack = _get__('updateLocation')('goBack');
var goForward = exports.goForward = _get__('updateLocation')('goForward');

var routerActions = exports.routerActions = { push: _get__('push'), replace: _get__('replace'), go: _get__('go'), goBack: _get__('goBack'), goForward: _get__('goForward') };

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'LOCATION_CHANGE':
      return LOCATION_CHANGE;

    case 'CALL_HISTORY_METHOD':
      return CALL_HISTORY_METHOD;

    case 'updateLocation':
      return updateLocation;

    case 'push':
      return push;

    case 'replace':
      return replace;

    case 'go':
      return go;

    case 'goBack':
      return goBack;

    case 'goForward':
      return goForward;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports.default = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(42);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(43);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_1__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(44);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(25);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(18);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(46);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_5__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(47);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(24);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_7__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(19);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_8__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(48);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(116);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(117);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(51);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(118);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(119);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(120);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(52);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(27);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(122);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(124);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(125);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(126);
/* unused harmony reexport withRouter */





























/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutPropertiesLoose; });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.createMatchSelector = exports.getAction = exports.getLocation = exports.routerMiddleware = exports.connectRouter = exports.ConnectedRouter = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.LOCATION_CHANGE = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createAll = __webpack_require__(90);

var _createAll2 = _interopRequireDefault(_createAll);

var _plain = __webpack_require__(101);

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _get__2 = _get__('createAll')(_get__('plainStructure'));

var LOCATION_CHANGE = _get__2.LOCATION_CHANGE,
    CALL_HISTORY_METHOD = _get__2.CALL_HISTORY_METHOD,
    push = _get__2.push,
    replace = _get__2.replace,
    go = _get__2.go,
    goBack = _get__2.goBack,
    goForward = _get__2.goForward,
    routerActions = _get__2.routerActions,
    ConnectedRouter = _get__2.ConnectedRouter,
    connectRouter = _get__2.connectRouter,
    routerMiddleware = _get__2.routerMiddleware,
    getLocation = _get__2.getLocation,
    getAction = _get__2.getAction,
    createMatchSelector = _get__2.createMatchSelector;
exports.LOCATION_CHANGE = LOCATION_CHANGE;
exports.CALL_HISTORY_METHOD = CALL_HISTORY_METHOD;
exports.push = push;
exports.replace = replace;
exports.go = go;
exports.goBack = goBack;
exports.goForward = goForward;
exports.routerActions = routerActions;
exports.ConnectedRouter = ConnectedRouter;
exports.connectRouter = connectRouter;
exports.routerMiddleware = routerMiddleware;
exports.getLocation = getLocation;
exports.getAction = getAction;
exports.createMatchSelector = createMatchSelector;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'createAll':
      return _createAll2.default;

    case 'plainStructure':
      return _plain2.default;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports.default = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(19);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({/*
     integer
     License Product ID.

     Holdem Manager 3:

     10 = Holdem All Stakes
     20 = Holdem Small Stakes
     11 = Holdem Trial
     14 = Holdem Freemium
     18 = Holdem Maint. Contract

     Omaha Manager 3:

     12 = Omaha All Stakes
     21 = Omaha Small Stakes
     13 = Omaha Trial
     15 = Omaha Freemium
     19 = Omaha Maint. Contract
         *
    * */hm3AllStakes:10,hm3SmallStakes:20,hm3Trial:11,hm3Freemium:14,hm3Maintenance:18,omahaAllStakes:12,omahaSmallStakes:21,omahaTrial:13,omahaFreemium:15,omahaMaintenance:19,isHm3:function isHm3(id){switch(id){case this.hm3AllStakes:case this.hm3SmallStakes:case this.hm3Trial:case this.hm3Freemium:case this.hm3Maintenance:return true;}return false;},isOmaha:function isOmaha(id){return!this.isHm3(id);},isTrial:function isTrial(id){return id==this.hm3Trial||id==this.omahaTrial;},isFreemium:function isFreemium(id){return id==this.hm3Freemium||id==this.omahaFreemium;},isAllStakes:function isAllStakes(id){return id==this.hm3AllStakes||id==this.omahaSmallStakes;},isSmallStakes:function isSmallStakes(id){return id==this.hm3SmallStakes||id==this.omahaSmallStakes;},isMaintenanceContract:function isMaintenanceContract(id){return id==this.hm3Maintenance||id==this.omahaMaintenance;}});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(18);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_productIds__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_productGuids__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_logger__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__format_localizer__ = __webpack_require__(11);
var HeaderType=__webpack_require__(8);var LicenseType=__webpack_require__(13);/* harmony default export */ __webpack_exports__["default"] = ({minPrice:function minPrice(guidList,state){var min=99999;for(var i in guidList){var guid=guidList[i];var product=this._guidToProduct(guid,state);if(product!==null){var price=this.buyPriceForGuid(guid,state);if(min>price)min=price;}}return min;},_productIdToGuidList:function _productIdToGuidList(productId){switch(productId){case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3AllStakes:case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3Freemium:case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3Trial:return __WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseBuyHm3All;case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3SmallStakes:return __WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseBuyHm3Small;case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaAllStakes:return __WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseBuyOm3All;case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaFreemium:case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaTrial:case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaSmallStakes:return __WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseBuyOm3Small;}return[];},_productIdToFirstGuid:function _productIdToFirstGuid(productId,state){var list=this._productIdToGuidList(productId);return this._productGuidListToFirstGuid(list,state);},idToBuyProductGuid:function idToBuyProductGuid(productId,state){return this._productIdToFirstGuid(productId,state);},_productGuidListToFirstGuid:function _productGuidListToFirstGuid(list,state){for(var guidIdx in list){for(var i in state.products.storeProducts){var p=state.products.storeProducts[i];if(p.storeProductId==list[guidIdx])return list[guidIdx];}}return null;},_productGuidListToAvailableGuidList:function _productGuidListToAvailableGuidList(list,state){var available=[];for(var guidIdx in list){for(var i in state.products.storeProducts){var p=state.products.storeProducts[i];if(p.storeProductId==list[guidIdx])available.push(list[guidIdx]);}}return available;},// if we have this GUID, returns it, otherwise returns null
_tryFindGuid:function _tryFindGuid(guid,state){for(var i in state.products.storeProducts){var p=state.products.storeProducts[i];if(p.storeProductId==guid)return guid;}return null;},// in this case, for HM3 -> return Omaha All stakes, or for Omaha -> return HM3 All Stakes
otherProductGuid:function otherProductGuid(state){var isHm3=state.header==HeaderType.Hm3;var productId=isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaAllStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3AllStakes;return this._productIdToFirstGuid(productId,state);},// if <0, we don't have this product
buyPriceFor:function buyPriceFor(productId,state){var guid=this._productIdToFirstGuid(productId,state);if(guid!=null)return this.buyPriceForGuid(guid,state);return-1;},// if <0, we don't have this product
buyPriceNoDiscountsFor:function buyPriceNoDiscountsFor(productId,state){var guid=this._productIdToFirstGuid(productId,state);if(guid!=null)return this.buyPriceNoDiscountsForGuid(guid,state);return-1;},upgradeLicensePrice:function upgradeLicensePrice(state){var isHm3=state.header==HeaderType.Hm3;return this._upgradePriceFor(isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3SmallStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaSmallStakes,state);},renewLicensePrice:function renewLicensePrice(state){var guid=this.renewLicenseGuid(state);return guid!==null?this.buyPriceForGuid(guid,state):-1;},buyLicensePrice:function buyLicensePrice(lic,state){var isHm3=lic.headerType==HeaderType.Hm3;return this.buyPriceFor(isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3AllStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaAllStakes,state);},upgradeLicenseGuid:function upgradeLicenseGuid(state){var isHm3=state.header==HeaderType.Hm3;var productId=isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3SmallStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaSmallStakes;return this._upgradePriceGuid(productId,state);},upgradeFromFreeOrTrialLicenseGuid:function upgradeFromFreeOrTrialLicenseGuid(state){var isHm3=state.header==HeaderType.Hm3;var productId=isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3AllStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaAllStakes;return this._productIdToFirstGuid(productId,state);},_upgradePriceGuid:function _upgradePriceGuid(productId,state){var upgrade=[];if(productId==__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3SmallStakes)upgrade=__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseUpgradeHm3Small;else if(productId==__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaSmallStakes)upgrade=__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseUpgradeOm3Small;if(upgrade.length>0){var guid=this._productGuidListToFirstGuid(upgrade,state);return guid;}return"";},_upgradePriceFor:function _upgradePriceFor(productId,state){var upgrade=[];if(productId==__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3SmallStakes)upgrade=__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseUpgradeHm3Small;else if(productId==__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaSmallStakes)upgrade=__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseUpgradeOm3Small;var price=0;if(upgrade.length>0){var guids=this._productGuidListToAvailableGuidList(upgrade,state);if(guids.length>0)price=this.buyPriceForGuid(guids[0],state);for(var i in guids){var guid=guids[i];var cur=this.buyPriceForGuid(guid,state);if(cur<price)price=cur;}}if(price<.01)// note: here, it's a "buy"
price=this.buyPriceFor(productId,state);return price;},// just for testing
dumpPriceInfo:function dumpPriceInfo(state){if(!__WEBPACK_IMPORTED_MODULE_2__api_logger__["a" /* LogCategory */].price.log)return;var productId=0;var preTrial=false;var isHm3=state.header==HeaderType.Hm3;switch(state.license.state){case LicenseType.NoLicense:preTrial=true;break;case LicenseType.Trial:productId=isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3Trial:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaTrial;break;case LicenseType.Freemium:productId=isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3Freemium:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaFreemium;break;case LicenseType.Maintenance:if(state.license.fullLicense)productId=isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3AllStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaAllStakes;else productId=isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3SmallStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaSmallStakes;break;default:Object(__WEBPACK_IMPORTED_MODULE_2__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__api_logger__["a" /* LogCategory */].price,"fatal: invalid state"+state.license.state);break;}if(preTrial)Object(__WEBPACK_IMPORTED_MODULE_2__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__api_logger__["a" /* LogCategory */].price,"license: "+(isHm3?"hm3 pretrial":"omaha pretrial"));else switch(productId){case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3AllStakes:Object(__WEBPACK_IMPORTED_MODULE_2__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__api_logger__["a" /* LogCategory */].price,"License: hm3 all stakes");break;case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3SmallStakes:Object(__WEBPACK_IMPORTED_MODULE_2__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__api_logger__["a" /* LogCategory */].price,"License: hm3 small stakes");break;case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3Freemium:Object(__WEBPACK_IMPORTED_MODULE_2__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__api_logger__["a" /* LogCategory */].price,"License: hm3 freemium");break;case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3Trial:Object(__WEBPACK_IMPORTED_MODULE_2__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__api_logger__["a" /* LogCategory */].price,"License: hm3 trial");break;case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaAllStakes:Object(__WEBPACK_IMPORTED_MODULE_2__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__api_logger__["a" /* LogCategory */].price,"License: omaha all stakes");break;case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaSmallStakes:Object(__WEBPACK_IMPORTED_MODULE_2__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__api_logger__["a" /* LogCategory */].price,"License: omaha small stakes");break;case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaFreemium:Object(__WEBPACK_IMPORTED_MODULE_2__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__api_logger__["a" /* LogCategory */].price,"License: omaha freemium");break;case __WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaTrial:Object(__WEBPACK_IMPORTED_MODULE_2__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__api_logger__["a" /* LogCategory */].price,"License: omaha trial");break;default:console.assert(false);break;}Object(__WEBPACK_IMPORTED_MODULE_2__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__api_logger__["a" /* LogCategory */].price,"buy: "+this.buyLicensePrice(state.license,state));Object(__WEBPACK_IMPORTED_MODULE_2__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__api_logger__["a" /* LogCategory */].price,"renew: "+this.renewLicensePrice(state)+" for "+this.renewLicenseGuid(state));},buyPriceForGuid:function buyPriceForGuid(guid,state){if(guid==null)return-1;var prices=this.guidToPrices(guid,state);var sum=0;if(prices!=null)for(var p in prices){sum+=prices[p];}sum=parseFloat(sum);if(sum>-0.001&&sum<0.0001)// yes, javascript is this stupid -> it sometimes will convert to "-0.00"
// things like this keep life interesting
sum=0;//console.log("buy price for " + guid + " - " + prices + " - " + sum);
return sum;},buyPriceNoDiscountsForGuid:function buyPriceNoDiscountsForGuid(guid,state){if(guid==null)return-1;var prices=this.guidToPricesNoDiscounts(guid,state);var sum=0;if(prices!=null)for(var p in prices){sum+=prices[p];}sum=parseFloat(sum);if(sum>-0.001&&sum<0.0001)// yes, javascript is this stupid -> it sometimes will convert to "-0.00"
// things like this keep life interesting
sum=0;//console.log("buy price for " + guid + " - " + prices + " - " + sum);
return sum;},_guidToProduct:function _guidToProduct(guid,state){for(var i in state.products.storeProducts){var p=state.products.storeProducts[i];if(p.storeProductId==guid)return p;}return null;},_guidToHmAppsProduct:function _guidToHmAppsProduct(guid,state){for(var i in state.hmApps){var p=state.hmApps[i];for(var v in p.appVariants){if(p.appVariants[v].appVariantId==guid)return p.appVariants[v];}}return null;},_discounts:function _discounts(state){if(state.products.discounts.length>0){return state.products.discounts;}return[];},guidToNames:function guidToNames(guid,state){var names=[];var product=this._guidToHmAppsProduct(guid,state);if(product!=null){names=[{name:product.name,description:null}];return names;}product=this._guidToProduct(guid,state);if(product==null)// normally, should never happen - this is just a failsafe
return[{name:"N/A",description:null}];// note: show maintenance contracts last
for(var i in product.storeProductVariants){var sub=product.storeProductVariants[i];if(__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].buyGuid.includes(sub.storeProductVariantId)){var description=sub.description!=""?sub.description:null;names.push({name:sub.name,description:description});}}for(var i in product.storeProductVariants){var sub=product.storeProductVariants[i];if(!__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].buyGuid.includes(sub.storeProductVariantId)){var description=sub.description!=""?sub.description:null;names.push({name:sub.name,description:description});}}var discounts=product.discounts;for(var d in discounts){names.push({name:discounts[d].name,description:null});}discounts=this._discounts(state);for(var d in discounts){names.push({name:discounts[d].name,description:null});}return names;},guidToPricesNoDiscounts:function guidToPricesNoDiscounts(guid,state){var prices=[];var product=this._guidToProduct(guid,state);if(product==null)// normally, should never happen - this is just a failsafe
return[-1];// note: show maintenance contracts last
for(var i in product.storeProductVariants){var sub=product.storeProductVariants[i];if(__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].buyGuid.includes(sub.storeProductVariantId))prices.push(sub.price);}for(var i in product.storeProductVariants){var sub=product.storeProductVariants[i];if(!__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].buyGuid.includes(sub.storeProductVariantId))prices.push(sub.price);}return prices;},guidToPrices:function guidToPrices(guid,state){var product=this._guidToHmAppsProduct(guid,state);if(product!=null){prices=[product.retailPrice];return prices;}product=this._guidToProduct(guid,state);if(product==null)// normally, should never happen - this is just a failsafe
return[-1];var prices=this.guidToPricesNoDiscounts(guid,state);var discounts=product.discounts;for(var d in discounts){prices.push(-discounts[d].amount);}discounts=this._discounts(state);for(var d in discounts){prices.push(-discounts[d].amount);}return prices;},_subProductPriceDescription:function _subProductPriceDescription(sub){var price=parseFloat(sub.price);var isZero=price>-0.0001&&price<0.0001;if(isZero){var str=this.prefixPeriodString(sub.recurringFrequency,sub.recurringPeriod);return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.recurringPriceDescription,[str]);}return"";},_subProductPricePaymentDetails:function _subProductPricePaymentDetails(guid,sub,isZero){var hasRecurring=sub.recurringFrequency!=null&&sub.recurringPeriod!=null;if(!hasRecurring)return"";var nextPayment=new Date();var freq=sub.recurringFrequency;switch(sub.recurringPeriod){case"days":nextPayment.setDate(nextPayment.getDate()+freq);break;case"months":var curMonth=nextPayment.getMonth();curMonth+=freq;if(curMonth>=12){curMonth-=12;nextPayment.setFullYear(nextPayment.getFullYear()+1);}nextPayment.setMonth(curMonth);break;case"years":nextPayment.setFullYear(nextPayment.getFullYear()+freq);break;}var nextPaymentDateStr=nextPayment.toLocaleDateString("en-US",{month:'short'})+" "+nextPayment.toLocaleDateString("en-US",{day:'numeric'})+", "+nextPayment.toLocaleDateString("en-US",{year:'numeric'});var recurringStr=this.prefixPeriodString(sub.recurringFrequency,sub.recurringPeriod);if(this.isHmOrOmahaRenewal(guid))return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.renewalRecurringSubscription,[sub.recurringPrice,recurringStr,nextPaymentDateStr])+" ";if(isZero)return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.recurringSubscription,[sub.recurringPrice,recurringStr,nextPaymentDateStr])+" ";else return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.positivePrice,[sub.recurringPrice,recurringStr,nextPaymentDateStr])+" ";},// if "", print the price
// if non "", print whatever is here
guidToPriceDescriptions:function guidToPriceDescriptions(guid,state){var prices=[];var product=this._guidToHmAppsProduct(guid,state);if(product!=null){prices=[""];return prices;}product=this._guidToProduct(guid,state);if(product==null)// normally, should never happen - this is just a failsafe
return[""];// note: show maintenance contracts last
for(var i in product.storeProductVariants){var sub=product.storeProductVariants[i];if(__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].buyGuid.includes(sub.storeProductVariantId))prices.push(this._subProductPriceDescription(sub));}for(var i in product.storeProductVariants){var sub=product.storeProductVariants[i];if(!__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].buyGuid.includes(sub.storeProductVariantId))prices.push(this._subProductPriceDescription(sub));}var discounts=product.discounts;for(var d in discounts){prices.push("");}discounts=this._discounts(state);for(var d in discounts){prices.push("");}return prices;},_hmAppsPricePaymentDetails:function _hmAppsPricePaymentDetails(guid,state){var price=0;var name="";var freq=1;var period="years";var free=false;for(var i in state.hmApps){var s=state.hmApps[i];for(var j in s.appVariants){var v=s.appVariants[j];if(v.appVariantId==guid){price=v.userPrice;name=v.name;freq=v.recurringFrequency;period=v.recurringPeriod;free=!v.isPaymentRequired;}}}if(free)return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.hmAppOrderSummaryFree,[name]);var str=this.periodString(freq,period);return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.hmAppOrderSummary,[name,str,price]);},pricePaymentDetails:function pricePaymentDetails(guid,state){if(this.isHmApps(guid))return this._hmAppsPricePaymentDetails(guid,state);var product=this._guidToProduct(guid,state);if(product==null)// normally, should never happen - this is just a failsafe
return"";var prices=this.guidToPrices(guid,state);var sum=0;for(var i in prices){sum+=prices[i];}var isZero=sum>-0.0001&&sum<0.0001;for(var i in product.storeProductVariants){var sub=product.storeProductVariants[i];var subPaymentDetails=this._subProductPricePaymentDetails(guid,sub,isZero);if(subPaymentDetails!="")return subPaymentDetails;}return"";},// for now, the NoteCaddy message
asteriskPaymentDetails:function asteriskPaymentDetails(guid,state){if(this.isHmApps(guid))return"";var product=this._guidToProduct(guid,state);if(product==null)// normally, should never happen - this is just a failsafe
return"";for(var i in product.storeProductVariants){var sub=product.storeProductVariants[i];if(sub.storeProductVariantId=="75e4abdd-2364-11eb-8f0b-0242ac150002")return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.asteriskNotecadyIncluded);}return"";},guidAllStakesPrice:function guidAllStakesPrice(state){var isHm3=state.header==HeaderType.Hm3;return this._productIdToFirstGuid(isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3AllStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaAllStakes,state);},guidSmallStakesPrice:function guidSmallStakesPrice(state){var isHm3=state.header==HeaderType.Hm3;return this._productIdToFirstGuid(isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3SmallStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaSmallStakes,state);},guidBothAllStakesPrice:function guidBothAllStakesPrice(state){var guid=this.purchaseBothAllGuid(state);return guid;},guidBothSmallStakesPrice:function guidBothSmallStakesPrice(state){var guid=this.purchaseBothSmallGuid(state);return guid;},guidComboAllStakesPrice:function guidComboAllStakesPrice(state){var guid=this.purchaseBothAllGuidIncludeUpgradeAllCombo(state);return guid;},buyAllStakesPrice:function buyAllStakesPrice(state){var isHm3=state.header==HeaderType.Hm3;return this.buyPriceFor(isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3AllStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaAllStakes,state);},buySmallStakesPrice:function buySmallStakesPrice(state){var isHm3=state.header==HeaderType.Hm3;return this.buyPriceFor(isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3SmallStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaSmallStakes,state);},buyBothAllStakesPrice:function buyBothAllStakesPrice(state){var guid=this.purchaseBothAllGuid(state);return this.buyPriceForGuid(guid,state);},buyBothSmallStakesPrice:function buyBothSmallStakesPrice(state){var guid=this.purchaseBothSmallGuid(state);return this.buyPriceForGuid(guid,state);},// only discounts that are not a refund count here (mla-182)
guidHasDiscountOrRefund:function guidHasDiscountOrRefund(guid,state){if(guid==null)return false;var product=this._guidToProduct(guid,state);if(product==null)// normally, should never happen - this is just a failsafe
return false;var discounts=product.discounts;for(var i in discounts){var d=discounts[i];if(d.amount>0.0001&&(d.type=="discount"||d.type=="refund"))return true;}discounts=this._discounts(state);for(var i in discounts){var d=discounts[i];if(d.amount>0.0001&&(d.type=="discount"||d.type=="refund"))return true;}return false;},guidHasRefund:function guidHasRefund(guid,state){if(guid==null)return false;var product=this._guidToProduct(guid,state);if(product==null)// normally, should never happen - this is just a failsafe
return false;var discounts=product.discounts;for(var i in discounts){var d=discounts[i];if(d.amount>0.0001&&d.type=="refund")return true;}discounts=this._discounts(state);for(var i in discounts){var d=discounts[i];if(d.amount>0.0001&&d.type=="refund")return true;}return false;},// returns a valid expiry date as Date(), or null if no expiry found
_guidDiscountExpires:function _guidDiscountExpires(guid,state){var product=this._guidToProduct(guid,state);if(product==null)return null;var discounts=product.discounts;for(var i in discounts){var d=discounts[i];if(d.amount>0.0001&&(d.type=="discount"||d.type=="refund"))return new Date(Date.parse(d.expires));}return null;},// only discounts that are not a refund count here (mla-182)
buyAllStakesHasDiscount:function buyAllStakesHasDiscount(state){var isHm3=state.header==HeaderType.Hm3;var guid=this._productIdToFirstGuid(isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3AllStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaAllStakes,state);return this.guidHasDiscountOrRefund(guid,state);},// only discounts that are not a refund count here (mla-182)
buySmallStakesHasDiscount:function buySmallStakesHasDiscount(state){var isHm3=state.header==HeaderType.Hm3;var guid=this._productIdToFirstGuid(isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3SmallStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaSmallStakes,state);return this.guidHasDiscountOrRefund(guid,state);},// only discounts that are not a refund count here (mla-182)
buyComboAllStakesHasDiscount:function buyComboAllStakesHasDiscount(state){var guid=this.purchaseBothAllGuidIncludeUpgradeAllCombo(state);return this.guidHasDiscountOrRefund(guid,state);},// only discounts that are not a refund count here (mla-182)
buyBothSmallStakesHasDiscount:function buyBothSmallStakesHasDiscount(state){var guid=this.purchaseBothSmallGuid(state);return this.guidHasDiscountOrRefund(guid,state);},buyHm3OrOmahaHasRefund:function buyHm3OrOmahaHasRefund(state){var isHm3=state.header==HeaderType.Hm3;var guid=this._productIdToFirstGuid(isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3AllStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaAllStakes,state);if(guid!=null)if(this.guidHasRefund(guid,state))return true;guid=this._productIdToFirstGuid(isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3SmallStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaSmallStakes,state);if(guid!=null)if(this.guidHasRefund(guid,state))return true;guid=this.purchaseBothAllGuidIncludeUpgradeAllCombo(state);if(guid!=null)if(this.guidHasRefund(guid,state))return true;guid=this.purchaseBothSmallGuid(state);if(guid!=null)if(this.guidHasRefund(guid,state))return true;return false;},_buyAllStakesDiscountExpires:function _buyAllStakesDiscountExpires(state){var isHm3=state.header==HeaderType.Hm3;var guid=this._productIdToFirstGuid(isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3AllStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaAllStakes,state);return this._guidDiscountExpires(guid,state);},_buySmallStakeDiscountExpires:function _buySmallStakeDiscountExpires(state){var isHm3=state.header==HeaderType.Hm3;var guid=this._productIdToFirstGuid(isHm3?__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].hm3SmallStakes:__WEBPACK_IMPORTED_MODULE_0__api_productIds__["a" /* default */].omahaSmallStakes,state);return this._guidDiscountExpires(guid,state);},_buyBothAllStakesDiscountExpires:function _buyBothAllStakesDiscountExpires(state){var guid=this.purchaseBothAllGuid(state);return this._guidDiscountExpires(guid,state);},_buyBothSmallStakesDiscountExpires:function _buyBothSmallStakesDiscountExpires(state){var guid=this.purchaseBothSmallGuid(state);return this._guidDiscountExpires(guid,state);},// if null, we can't upgrade
upgradeToAllGuid:function upgradeToAllGuid(state){var isHm3=state.header==HeaderType.Hm3;if(!state.license.fullLicense){var guid=this._productGuidListToFirstGuid(isHm3?__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseUpgradeHm3Small:__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseUpgradeOm3Small,state);return guid;}return null;},// if null, we can't upgrade
upgradeToComboSmallGuid:function upgradeToComboSmallGuid(state){var isHm3=state.header==HeaderType.Hm3;if(!state.license.fullLicense){var guid=this._productGuidListToFirstGuid(isHm3?__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].upgradeHm3ToComboSmall:__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].upgradeOm3ToComboSmall,state);return guid;}return null;},// if null, we can't upgrade
upgradeToComboAllGuid:function upgradeToComboAllGuid(state){var isHm3=state.header==HeaderType.Hm3;if(!state.license.fullLicense){var guid=this._productGuidListToFirstGuid(isHm3?__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].upgradeHm3ToComboAll:__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].upgradeOm3ToComboAll,state);return guid;}return null;},hasDiscounts:function hasDiscounts(state){return this.buyAllStakesHasDiscount(state)||this.buySmallStakesHasDiscount(state)||this.buyComboAllStakesHasDiscount(state)||this.buyBothSmallStakesHasDiscount(state);},discountExpiresDate:function discountExpiresDate(state){var allStakes=this._buyAllStakesDiscountExpires(state);var smallStakes=this._buySmallStakeDiscountExpires(state);var bothAllStakes=this._buyBothAllStakesDiscountExpires(state);var bothSmallStakes=this._buyBothSmallStakesDiscountExpires(state);if(allStakes!=null)return allStakes;if(smallStakes!=null)return smallStakes;if(bothAllStakes!=null)return bothAllStakes;if(bothSmallStakes!=null)return bothSmallStakes;Object(__WEBPACK_IMPORTED_MODULE_2__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__api_logger__["a" /* LogCategory */].fatal,"Discount Expiry date not found");return new Date();},purchaseBothAllGuidIncludeUpgradeAllCombo:function purchaseBothAllGuidIncludeUpgradeAllCombo(state){return this._productGuidListToFirstGuid(__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseBothAllIncludeUpgradeAllCombo,state);},purchaseBothAllGuid:function purchaseBothAllGuid(state){return this._productGuidListToFirstGuid(__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseBothAll,state);},purchaseBothSmallGuid:function purchaseBothSmallGuid(state){return this._productGuidListToFirstGuid(__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseBothSmall,state);},// if NO, that means the user has either HM3 All Stakes or OM3 All Stakes, thus he can only buy the other product (can't really buy a combo)
canPurchaseBothAll:function canPurchaseBothAll(state){return this._productGuidListToFirstGuid(__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseBothAll,state)!=null;},// if NO, that means the user has either HM3 All Stakes or OM3 All Stakes, thus he can only buy the other product (can't really buy a combo)
canPurchaseBothSmall:function canPurchaseBothSmall(state){return this._productGuidListToFirstGuid(__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseBothSmall,state)!=null;},canPurchaseBothAllIncludeUpgradeAllCombo:function canPurchaseBothAllIncludeUpgradeAllCombo(state){return this._productGuidListToFirstGuid(__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].purchaseBothAllIncludeUpgradeAllCombo,state)!=null;},// if the other product already has a license (small or all) -> we can't purchase the other product (we could only upgrade it)
canPurchaseOtherProduct:function canPurchaseOtherProduct(state){var otherProductIsOmaha=state.header==HeaderType.Hm3;var otherProduct=otherProductIsOmaha?state.licenseOmaha:state.licenseHm3;var hasLicense=otherProduct.state==LicenseType.Maintenance;return!hasLicense;},renewLicenseGuid:function renewLicenseGuid(state){var isHm3=state.header==HeaderType.Hm3;if(isHm3){var guid=this._productGuidListToFirstGuid(__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].renewHm3,state);return guid;}else{var _guid=this._productGuidListToFirstGuid(__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].renewOm3,state);return _guid;}},// returns true if it's an HM APPS purchase
isHmApps:function isHmApps(guid){// range wizard
if(guid=="32fa0c52-e6e8-11ea-a903-0242ac170002")return true;if(guid=="08222b30-e6e8-11ea-a903-0242ac170002")return true;// notecaddy
if(guid=="3c82b67d-22f8-11eb-9286-12aab952340b")return true;if(guid=="7e11c5d3-22f7-11eb-9286-12aab952340b")return true;if(guid=="87be1e6d-22f8-11eb-9286-12aab952340b")return true;if(guid=="c79d6c42-22f8-11eb-9286-12aab952340b")return true;if(guid=="e523341a-22fa-11eb-9286-12aab952340b")return true;return false;},isHmOrOmahaRenewal:function isHmOrOmahaRenewal(guid){return __WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].renewals.includes(guid);},// returns true, if when on HM or Omaha "buy" page, we can only renew (as opposed to do an initial purchase or upgrade)
isDoingRenewalHmOrOmaha:function isDoingRenewalHmOrOmaha(state){var isHm3=state.header==HeaderType.Hm3;var guid=this._productGuidListToFirstGuid(isHm3?__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].renewHm3:__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].renewOm3,state);return guid!=null;},renewalHmOrOmahaText:function renewalHmOrOmahaText(state){var guid=this.renewLicenseGuid(state);var isHm3=state.header==HeaderType.Hm3;if(isHm3){var isSmall=__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].renewHm3Small.includes(guid);return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(isSmall?__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.buyHoldemSmallStakes:__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.buyHoldemAllStakes);}else{var isSmall=__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].renewOm3Small.includes(guid);return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(isSmall?__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.buyOmahaSmallStakes:__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.buyOmahaAllStakes);}},isRenewalHmOrOmahaSmall:function isRenewalHmOrOmahaSmall(state){var guid=this.renewLicenseGuid(state);var isHm3=state.header==HeaderType.Hm3;if(isHm3){var isSmall=__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].renewHm3Small.includes(guid);return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(isSmall?__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.buyHoldemSmallStakes:__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.buyHoldemAllStakes);}else{var isSmall=__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].renewOm3Small.includes(guid);return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(isSmall?__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.buyOmahaSmallStakes:__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.buyOmahaAllStakes);}},renewalHmOrOmahaPrice:function renewalHmOrOmahaPrice(state){var guid=this.renewLicenseGuid(state);return this.buyPriceForGuid(guid,state);},// recurringPeriod: "months", "years"
periodString:function periodString(recurringFrequency,recurringPeriod){console.assert(recurringPeriod=="days"||recurringPeriod=="months"||recurringPeriod=="years");if(recurringPeriod=="months"&&recurringFrequency==12){recurringPeriod="years";recurringFrequency=1;}if(recurringFrequency>1)return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(recurringPeriod=="days"?__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.dayPlural:recurringPeriod=="months"?__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.monthPlural:__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.yearPlural,[recurringFrequency]);else return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(recurringPeriod=="days"?__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.daySingle:recurringPeriod=="months"?__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.monthSingle:__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.yearSingle);},// even if single period, we'll still prefix it, like, "one year"
prefixPeriodString:function prefixPeriodString(recurringFrequency,recurringPeriod){if(recurringPeriod==null)return"";console.assert(recurringPeriod=="days"||recurringPeriod=="months"||recurringPeriod=="years");if(recurringPeriod=="months"&&recurringFrequency==12){recurringPeriod="years";recurringFrequency=1;}if(recurringFrequency>1)return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(recurringPeriod=="days"?__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.dayPlural:recurringPeriod=="months"?__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.monthPlural:__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.yearPlural,[recurringFrequency]);else return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(recurringPeriod=="days"?__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.prefixDaySingle:recurringPeriod=="months"?__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.prefixMonthSingle:__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.prefixYearSingle);},renewPeriodOfUpdates:function renewPeriodOfUpdates(state){var guid=this.renewLicenseGuid(state);if(guid==null)return"";var product=this._guidToProduct(guid,state);if(product==null)return"";return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.oneYearOfUpdates,[this.prefixPeriodString(product.recurringFrequency,product.recurringPeriod)]);},upgradePeriodOfUpdates:function upgradePeriodOfUpdates(state){var upgrade=[];var isHm3=state.header==HeaderType.Hm3;if(isHm3)upgrade=__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].buyHm3Guid;else upgrade=__WEBPACK_IMPORTED_MODULE_1__api_productGuids__["a" /* default */].buyOmahaGuid;var guid=null;if(upgrade.length>0){var guids=this._productGuidListToAvailableGuidList(upgrade,state);if(guids.length>0)guid=guids[0];}if(guid!=null){var product=this._guidToProduct(guid,state);if(product!=null)return __WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_3__format_localizer__["a" /* default */].keys.removesRestrictions3,[this.prefixPeriodString(product.recurringFrequency,product.recurringPeriod)]);}return"";}});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INIT_USER_STATE */
/* unused harmony export SEND_TOKEN_TO_HOST */
/* unused harmony export SEND_HTTP_STATUS_TO_HOST */
/* unused harmony export GO_TO_PAGE_AND_HEADER */
/* unused harmony export GO_TO_PAGE */
/* unused harmony export GO_TO_HEADER */
/* unused harmony export GO_BILLING_PAGE */
/* unused harmony export SAVE_CARD */
/* unused harmony export SELECT_PROFILE */
/* unused harmony export RENEW_LICENSE */
/* unused harmony export PURCHASE_OTHER_PRODUCT */
/* unused harmony export UPGRADE_LICENSE */
/* unused harmony export UPGRADE_LICENSE_FROM_FREE_OR_TRIAL */
/* unused harmony export BUY_SMALL_STAKES */
/* unused harmony export BUY_FULL_STAKES */
/* unused harmony export BUY_HM3_AND_OMAHA_FULL_STAKES */
/* unused harmony export BUY_HM3_AND_OMAHA_SMALL_STAKES */
/* unused harmony export BUY_GUID_PRODUCT */
/* unused harmony export BUY_HM_APPS_VARIANT */
/* unused harmony export BUY_HM_APPS_VARIANT_FREE */
/* unused harmony export UPGRADE_HM3_AND_OMAHA_FULL_STAKES */
/* unused harmony export UPGRADE_HM3_AND_OMAHA_SMALL_STAKES */
/* unused harmony export START_HM3_TRIAL */
/* unused harmony export START_HM3_AND_OMAHA_TRIAL */
/* unused harmony export SWITCH_TO_FREE */
/* unused harmony export CHANGE_PRODUCTS */
/* unused harmony export BUY_NOW */
/* unused harmony export CLEAR_CREDIT_CARD */
/* unused harmony export RELOAD_LICENSE */
/* unused harmony export SWITCH_USER */
/* unused harmony export START_USING_APP */
/* unused harmony export CONTINUE_TRIAL */
/* unused harmony export GO_TO_PAYPAL */
/* unused harmony export CALL_HOST */
/* unused harmony export SAVE_NETELLER */
/* unused harmony export SAVE_ERROR */
/* unused harmony export SIMPLE_HOST_APP_ACTION */
/* unused harmony export GO_TO_HMAPP_APP */
/* unused harmony export LOG_FATAL_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return clearLastError; });
/* unused harmony export computeStartPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return computePurchasePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return computeContinueTrialHeader; });
/* unused harmony export initUserState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return goToPageAndHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return goToPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return goToHmAppPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return goToHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return goBillingPage; });
/* unused harmony export callHost */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return goToPaypal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return sendTokenToHost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return selectProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return saveCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return saveNeteller; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return saveError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return buyNow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return clearCreditCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return renewLicense; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return purchaseOtherProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return upgradeLicense; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return upgradeLicenseFromFreeOrTrial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return buySmallStakes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buyAllStakes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return buyHm3AndOmahaFullStakes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return buyHm3AndOmahaSmallStakes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return upgradeHm3AndOmahaFullStakes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return upgradeHm3AndOmahaSmallStakes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return startTrial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return startHm3AndOmahaTrial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return switchToFree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return changeProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return reloadLicense; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return switchUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return startUsingApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return continueTrial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return simpleHostAppAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return sendStatusToHost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buyGuidProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return buyHmAppsVariant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return buyHmAppsVariantFree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return serverFatalError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__licenseInfoOps__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pricing__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_productIds__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_productGuids__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_callHostApp__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_clientCall__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_logger__ = __webpack_require__(3);
var Page=__webpack_require__(12);var LicenseInfo=__webpack_require__(113);var LicenseType=__webpack_require__(13);var HeaderType=__webpack_require__(8);var INIT_USER_STATE='state/init_user_state';var SEND_TOKEN_TO_HOST='state/token_to_host';var SEND_HTTP_STATUS_TO_HOST='state/status_to_host';var GO_TO_PAGE_AND_HEADER='state/go_to_page_and_header';var GO_TO_PAGE='state/go_to_page';var GO_TO_HEADER='state/go_to_header';var GO_BILLING_PAGE='state/go_billing_page';var SAVE_CARD='state/save_card';var SELECT_PROFILE='state/select_profile';var RENEW_LICENSE='state/renew_license';var PURCHASE_OTHER_PRODUCT='state/purchase_other_product';var UPGRADE_LICENSE='state/upgrade_license';var UPGRADE_LICENSE_FROM_FREE_OR_TRIAL='state/upgrade_license_from_free_or_trial';var BUY_SMALL_STAKES='state/buy_small';var BUY_FULL_STAKES='state/buy_full';var BUY_HM3_AND_OMAHA_FULL_STAKES='state/buy_hm3_and_omaha_full';var BUY_HM3_AND_OMAHA_SMALL_STAKES='state/buy_hm3_and_omaha_small';var BUY_GUID_PRODUCT='state/buy_guid_product';var BUY_HM_APPS_VARIANT='state/buy_hm_apps_variant';var BUY_HM_APPS_VARIANT_FREE='state/buy_hm_apps_variant_free';var UPGRADE_HM3_AND_OMAHA_FULL_STAKES='state/upgrade_hm3_and_omaha_full';var UPGRADE_HM3_AND_OMAHA_SMALL_STAKES='state/upgrade_hm3_and_omaha_small';var START_HM3_TRIAL='state/start_hm3_trial';var START_HM3_AND_OMAHA_TRIAL='state/start_hm3_and_omaha_trial';var SWITCH_TO_FREE='state/switch_to_free';var CHANGE_PRODUCTS='state/change_products';var BUY_NOW='state/buy_now';var CLEAR_CREDIT_CARD='state/clear_credit_card';var RELOAD_LICENSE='state/reload_license';var SWITCH_USER='state/switch_user';var START_USING_APP='state/start_using_app';var CONTINUE_TRIAL='state/continue_trial';var GO_TO_PAYPAL='state/go_to_paypal';var CALL_HOST='state/call_hm3';var SAVE_NETELLER='state/save_neteller';var SAVE_ERROR='state/save_error';var SIMPLE_HOST_APP_ACTION='state/simple_host_app_action';var GO_TO_HMAPP_APP='state/go_to_hmapp_app';var LOG_FATAL_ERROR="state/fatal_error";var initialState={ok:false,header:HeaderType.Hm3,// true - launched from startup, false - launched when user goes to MyLicenses
fromStartup:false,language:"en",// page: billing/card/startTrial
// field: for input, what field is the error related to?
//        if the field is missing, it's a processing error
lastError:{page:0,errors:{},success:true},siteUrl:"",storeUrl:"",licenseUrl:"",downloadUrl:"",downloadRoot:"",// ... just in case we need to notify HM3 of any startup issues
storeStatus:200,// ... just in case we need to notify HM3 of any startup issues
licensingStatus:200,token:"?",session:"",// added when we decided to not use sessions on server side (since we can have several machines to handle requests,
// and a client can be handled by different machines at different times)
userId:"",licenseId:"",email:"",fingerprint:"",enableTrialAbuseCheck:0,// just in case ew want to send a fatal error to the server
//
// Workflow:
// 1. check if error was already added, if so, do nothing
// 2. add the error here,
// 3. call the server - only for the first 5 errors, no point in doing this too many times
fatalErrors:[],licenseHm3:LicenseInfo.create(),licenseOmaha:LicenseInfo.create(),licenseHmApps:LicenseInfo.create(),// copy of one of the above
license:LicenseInfo.create(),missedUpdates:[],// to be computed on login
startPage:Page.None,currentPage:Page.None,// preselected buy option
// 0 - credit card
// 1 - neteller
// 2 - saved profile
// 3 - paypal
preselectedBuyAction:{preselect:0},savedCard:{},billingAddress:{},buyNow:{},activeHmAppProductId:"",products:[],profiles:[],hmApps:[],subscribedHmApps:[],storeAppMap:[],buyProductId:-1,availableTrials:{hm3:false,omaha:false}};var clearLastError={page:0,errors:{},success:true};var computeStartPage=function computeStartPage(lic,fromStartup){if(lic.state==LicenseType.CouldNotStart)return Page.CouldNotLoadMla;if(lic.isOverMaxVersion){if(lic.hasAvailableTrial&&fromStartup){// MLA-123
return Page.PreSelectProducts;}return Page.FreemiumOverMaxVersion;}switch(lic.state){case LicenseType.NoLicense:// MLA-123
return lic.hasAvailableTrial?Page.PreSelectProducts:Page.SelectProducts;case LicenseType.Trial:if(!__WEBPACK_IMPORTED_MODULE_1__licenseInfoOps__["a" /* default */].isExpired(lic)){return fromStartup?Page.ContinueTrial:Page.TrialLicense;}break;}// check license state
switch(lic.state){case LicenseType.Trial:return Page.TrialLicense;case LicenseType.Freemium:return Page.Freemium;case LicenseType.Maintenance:if(__WEBPACK_IMPORTED_MODULE_1__licenseInfoOps__["a" /* default */].isFullStakes(lic)){if(__WEBPACK_IMPORTED_MODULE_1__licenseInfoOps__["a" /* default */].isExpired(lic))return Page.ExpiredContractFull;else if(__WEBPACK_IMPORTED_MODULE_1__licenseInfoOps__["a" /* default */].isExpiring(lic))return Page.ExpiringContractFull;else return Page.ActiveMaintenanceFull;}else{if(__WEBPACK_IMPORTED_MODULE_1__licenseInfoOps__["a" /* default */].isExpired(lic))return Page.ExpiredContractSmall;else if(__WEBPACK_IMPORTED_MODULE_1__licenseInfoOps__["a" /* default */].isExpiring(lic))return Page.ExpiringContractSmall;else return Page.ActiveMaintenanceSmall;}break;}console.assert(false);return Page.Purchase;};// MLA-19
var computePurchasePage=function computePurchasePage(lic,fromStartup){return computeStartPage(lic,fromStartup);};// MLA-19
var computeContinueTrialHeader=function computeContinueTrialHeader(state){// if trial -> use that
if(state.licenseHm3.state==LicenseType.Trial)return HeaderType.Hm3;if(state.licenseOmaha.state==LicenseType.Trial)return HeaderType.Omaha;// if freemium -> use that
if(state.licenseHm3.state==LicenseType.Freemium)return HeaderType.Hm3;if(state.licenseOmaha.state==LicenseType.Freemium)return HeaderType.Omaha;// no trials
return HeaderType.Hm3;};var actionToPage=function actionToPage(type){switch(type){case SAVE_CARD:return Page.Purchase;case UPGRADE_LICENSE_FROM_FREE_OR_TRIAL:return Page.SelectProducts;case RENEW_LICENSE:case PURCHASE_OTHER_PRODUCT:case UPGRADE_LICENSE:case BUY_SMALL_STAKES:case BUY_FULL_STAKES:case BUY_HM_APPS_VARIANT:case BUY_GUID_PRODUCT:case BUY_HM3_AND_OMAHA_FULL_STAKES:case BUY_HM3_AND_OMAHA_SMALL_STAKES:case UPGRADE_HM3_AND_OMAHA_FULL_STAKES:case UPGRADE_HM3_AND_OMAHA_SMALL_STAKES:return Page.Purchase;case START_HM3_TRIAL:return Page.TrialStarted;case START_HM3_AND_OMAHA_TRIAL:return Page.TrialStarted;case SWITCH_TO_FREE:return Page.Freemium;case BUY_NOW:return Page.PurchaseCompleteSuccess;case BUY_HM_APPS_VARIANT_FREE:return Page.SelectHmAppVariantProducts;default:console.assert(false);return Page.Purchase;}};/* harmony default export */ __webpack_exports__["o"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];if(typeof action==='undefined')return Object.assign({},state);switch(action.type){// this is just for simulation - can't otherwise set the whole state at once
case INIT_USER_STATE://log(LogCategory.info,serverclientPrefix + 'initializing user state' + JSON.stringify(action.userState));
return Object.assign({},state,{ok:action.userState.ok,language:action.userState.language,fatalErrors:[],siteUrl:action.userState.siteUrl,storeUrl:action.userState.storeUrl,licenseUrl:action.userState.licenseUrl,downloadUrl:action.userState.downloadUrl,header:action.userState.header,token:action.userState.token,session:action.userState.session,licensingStatus:action.userState.licensingStatus,storeStatus:action.userState.storeStatus,userId:action.userState.userId,licenseId:action.userState.licenseId,email:action.userState.userEmail,fingerprint:action.userState.fingerprint,enableTrialAbuseCheck:action.userState.enableTrialAbuseCheck,licenseHm3:action.userState.licenseHm3,licenseOmaha:action.userState.licenseOmaha,licenseHmApps:action.userState.licenseHmApps,license:action.userState.license,missedUpdates:action.userState.missedUpdates,restrictions:action.userState.restrictions,startPage:action.userState.startPage,currentPage:action.userState.currentPage,products:action.userState.products,profiles:action.userState.profiles,buyProductId:action.userState.buyProductId,fromStartup:action.userState.fromStartup,availableTrials:action.userState.availableTrials,hmApps:action.userState.hmApps,subscribedHmApps:action.userState.subscribedHmApps,storeAppMap:action.userState.storeAppMap,userSubscriptions:action.userState.userSubscriptions,preselectedBuyAction:{preselect:0},savedCard:{},billingAddress:{},buyNow:{}});case GO_BILLING_PAGE:return Object.assign({},state,{savedCard:action.savedCard,currentPage:Page.BillingAddress});// note: the saved card details (savedCard/billingInfo) are kept untiil the user does a purchase
case SAVE_CARD:var saveCardBuyAction=action.preselectedBuyAction;saveCardBuyAction.profile.savedCard=state.savedCard;// note: saved card info is kept until the purchase is fully successful - in case there's an error,
//       we want the user to be able to continue from where he left off
return Object.assign({},state,{preselectedBuyAction:saveCardBuyAction,billingAddress:saveCardBuyAction.preselect.billingAddress,currentPage:Page.PaymentReview});case SAVE_NETELLER:return Object.assign({},state,{preselectedBuyAction:action.preselectedBuyAction,currentPage:Page.PaymentReview});case SELECT_PROFILE:return Object.assign({},state,{preselectedBuyAction:action.preselectedBuyAction});case BUY_NOW:return Object.assign({},state,{// clear any sensitive data may be been saved
savedCard:{},billingAddress:{},preselectedBuyAction:{preselect:0},currentPage:Page.PurchaseCompleteSuccess});case CLEAR_CREDIT_CARD:return Object.assign({},state,{// clear any sensitive data may be been saved
savedCard:{},billingAddress:{},preselectedBuyAction:{preselect:0}});case SEND_TOKEN_TO_HOST:// reset the token once sent back to host
return Object.assign({},state,{token:""});case SEND_HTTP_STATUS_TO_HOST:return Object.assign({},state,{licensingStatus:200,storeStatus:200});case SAVE_ERROR:return Object.assign({},state,{lastError:action.error});case GO_TO_PAGE:return Object.assign({},state,{currentPage:action.newPage});case GO_TO_HEADER:{var copy=LicenseInfo.copy(action.license);var startPage=computeStartPage(action.license,action.fromStartup);return Object.assign({},state,{license:copy,header:action.header,currentPage:startPage,startPage:startPage});}case GO_TO_PAGE_AND_HEADER:{var _copy=LicenseInfo.copy(action.license);return Object.assign({},state,{license:_copy,header:action.header,currentPage:action.page});}case LOG_FATAL_ERROR:var newErrors=[];for(var e in state.fatalErrors){newErrors.push(state.fatalErrors[e]);}newErrors.push(action.errorNow);return Object.assign({},state,{fatalErrors:newErrors});case RENEW_LICENSE:case PURCHASE_OTHER_PRODUCT:case UPGRADE_LICENSE:case UPGRADE_LICENSE_FROM_FREE_OR_TRIAL:case BUY_SMALL_STAKES:case BUY_FULL_STAKES:case BUY_HM_APPS_VARIANT:case BUY_GUID_PRODUCT:case UPGRADE_HM3_AND_OMAHA_FULL_STAKES:case UPGRADE_HM3_AND_OMAHA_SMALL_STAKES:case BUY_HM3_AND_OMAHA_FULL_STAKES:case BUY_HM3_AND_OMAHA_SMALL_STAKES:Object(__WEBPACK_IMPORTED_MODULE_10__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_10__api_logger__["a" /* LogCategory */].info,"buying "+action.buyProductId);return Object.assign({},state,{buyProductId:action.buyProductId,currentPage:Page.Purchase});case BUY_HM_APPS_VARIANT_FREE:return Object.assign({},state,{currentPage:Page.SelectHmAppVariantProducts});case START_HM3_TRIAL:return Object.assign({},state,{currentPage:actionToPage(action.type)});case START_HM3_AND_OMAHA_TRIAL:return Object.assign({},state,{currentPage:actionToPage(action.type)});case SWITCH_TO_FREE:return Object.assign({},state,{currentPage:actionToPage(action.type)});case CHANGE_PRODUCTS:var newPage=Page.PreSelectProducts;return Object.assign({},state,{currentPage:newPage});case RELOAD_LICENSE:case START_USING_APP:case CONTINUE_TRIAL:return Object.assign({},state,{currentPage:state.startPage});case SIMPLE_HOST_APP_ACTION:case CALL_HOST:Object(__WEBPACK_IMPORTED_MODULE_10__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_10__api_logger__["a" /* LogCategory */].info,"call hm3");return Object.assign({},state);case GO_TO_HMAPP_APP:return Object.assign({},state,{activeHmAppProductId:action.activeHmAppProductId});default:return state;}});// whole user state
var initUserState=function initUserState(userState){return function(dispatch){return new Promise(function(resolve){dispatch({type:INIT_USER_STATE,userState:userState});resolve(userState);});};};var goToPageAndHeader=function goToPageAndHeader(pageAndHeader){return function(dispatch){return new Promise(function(resolve,reject){dispatch({type:GO_TO_PAGE_AND_HEADER,header:pageAndHeader.header,license:pageAndHeader.license,page:pageAndHeader.page});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(pageAndHeader.page)));resolve(pageAndHeader);});};};var goToPage=function goToPage(page,args){return function(dispatch){return new Promise(function(resolve,reject){// clear error first
dispatch({type:SAVE_ERROR,error:clearLastError});dispatch({type:GO_TO_PAGE,newPage:page});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(page,args)));resolve(page,args);});};};var goToHmAppPage=function goToHmAppPage(activeHmAppProductId){return function(dispatch){return new Promise(function(resolve,reject){dispatch({type:GO_TO_HMAPP_APP,activeHmAppProductId:activeHmAppProductId});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(Page.SelectHmAppVariantProducts)));resolve(activeHmAppProductId);});};};var goToHeader=function goToHeader(header){return function(dispatch){return new Promise(function(resolve,reject){var startPage=computeStartPage(header.license,header.fromStartup);if(header.header==HeaderType.HmApps)startPage=Page.SelectHmAppsProducts;dispatch({type:GO_TO_HEADER,license:header.license,header:header.header,fromStartup:header.fromStartup});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(startPage)));resolve(header);});};};var goBillingPage=function goBillingPage(card){return function(dispatch){return new Promise(function(resolve,reject){dispatch({type:GO_BILLING_PAGE,savedCard:card});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(Page.BillingAddress)));resolve(card);});};};var callHost=function callHost(str){return function(dispatch){return new Promise(function(resolve,reject){dispatch({type:CALL_HOST,callback:str});__WEBPACK_IMPORTED_MODULE_8__api_callHostApp__["a" /* default */].callHost(str);resolve(str);});};};var goToPaypal=function goToPaypal(state){return function(dispatch){return new Promise(function(resolve,reject){// ... just in case we get an error - visually show it relates to paypal
dispatch({type:SAVE_NETELLER,preselectedBuyAction:{preselect:3,profile:{"paymentProfileId":GO_TO_PAYPAL,"label":"      ","creditCardType":"PP"}}});__WEBPACK_IMPORTED_MODULE_9__api_clientCall__["a" /* default */].paypal(state).then(function(value){// buyNow returns an "error" answer
dispatch({type:SAVE_ERROR,error:value});if(value.success){// get the url and open it in browser
__WEBPACK_IMPORTED_MODULE_8__api_callHostApp__["a" /* default */].openPaypal(value.redirectUrl);dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(Page.Paypal)));}else// the error tells us the page to go to
dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(value.page)));resolve(state);});});};};var sendTokenToHost=function sendTokenToHost(state){return function(dispatch){return new Promise(function(resolve){__WEBPACK_IMPORTED_MODULE_8__api_callHostApp__["a" /* default */].sendTokenToHost(state.token);var t=SEND_TOKEN_TO_HOST;dispatch({type:t});resolve(state);});};};// select profile -> dispatch action, but don't change the UI
var selectProfile=function selectProfile(profile){return function(dispatch){return new Promise(function(resolve){var t=SELECT_PROFILE;dispatch({type:t,preselectedBuyAction:{preselect:2,profile:profile}});resolve(profile);});};};var saveCard=function saveCard(billingAddress){return function(dispatch){return new Promise(function(resolve){// use savedCard + billingAddress
var t=SAVE_CARD;dispatch({type:t,preselectedBuyAction:{preselect:0,profile:{"paymentProfileId":SAVE_CARD,"label":billingAddress.savedCardInfo,"creditCardType":"VS",billingAddress:billingAddress}}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(Page.PaymentReview)));resolve(billingAddress);});};};var saveNeteller=function saveNeteller(neteller,state){return function(dispatch){return new Promise(function(resolve){// first, verify this neteller account (just the account number).
// if that is ok, then we save the neteller username+password
__WEBPACK_IMPORTED_MODULE_9__api_clientCall__["a" /* default */].netellerVerify(neteller.siteUrl,neteller.session,neteller.account,state.userId,state.email).then(function(value){if(value.details!==undefined)// note: in the details -> the store sends me the "success", and the redirectUrl
value=value.details;if(value.success){dispatch({type:SAVE_ERROR,error:{page:0,success:true,errors:[]}});// user is verified, we need to see if it's given HM3 permission for purchase
dispatch({type:SAVE_NETELLER,preselectedBuyAction:{preselect:1,profile:{"paymentProfileId":SAVE_NETELLER,"label":"      ","creditCardType":"NT",neteller:{account:neteller.account,secureId:neteller.secureId,password:neteller.password}}}});if(value.redirectUrl===undefined){// success:true, no redirectUrl
// in this case -> user is verified + we (HM3) have permission for purchase
dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(Page.PaymentReview)));}else{// success:true, redirectUrl
// user is verified, but we don't yet have permission -> ask for it now
__WEBPACK_IMPORTED_MODULE_8__api_callHostApp__["a" /* default */].netellerRedirect(value.redirectUrl);}}else{// at this time, I don't get an error from store
dispatch({type:SAVE_ERROR,error:{success:false,page:Page.Netteller,errors:{general:[{message:"Invalid NETELLER account. Please double check your account email address or account ID."}]}}});// success:false from store - just show it visually via alertred (very likely, user is not allowed to do purchase)
dispatch({type:SAVE_NETELLER,preselectedBuyAction:{preselect:-2}});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(Page.Netteller)));}resolve(neteller);});});};};var saveError=function saveError(lastError){return function(dispatch){return new Promise(function(resolve,reject){dispatch({type:SAVE_ERROR,error:lastError});resolve(lastError);});};};var buyNow=function buyNow(state){return function(dispatch){return new Promise(function(resolve){__WEBPACK_IMPORTED_MODULE_9__api_clientCall__["a" /* default */].buyNow(state).then(function(value){// buyNow returns an "error" answer
dispatch({type:SAVE_ERROR,error:value});if(value.success){dispatch({type:BUY_NOW});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(Page.PurchaseCompleteSuccess)));__WEBPACK_IMPORTED_MODULE_8__api_callHostApp__["a" /* default */].needsReloadLicense();}else// the error tells us the page to go to
dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(value.page)));resolve(state);});});};};var clearCreditCard=function clearCreditCard(){return function(dispatch){return new Promise(function(resolve){Object(__WEBPACK_IMPORTED_MODULE_10__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_10__api_logger__["a" /* LogCategory */].info,"credit card cleared");dispatch({type:CLEAR_CREDIT_CARD});resolve({});});};};var renewLicense=function renewLicense(state){return function(dispatch){return new Promise(function(resolve){var t=RENEW_LICENSE;dispatch({type:t,buyProductId:__WEBPACK_IMPORTED_MODULE_5__pricing__["default"].renewLicenseGuid(state)});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(actionToPage(t))));resolve(state);});};};var purchaseOtherProduct=function purchaseOtherProduct(state){return function(dispatch){return new Promise(function(resolve){var t=PURCHASE_OTHER_PRODUCT;dispatch({type:t,buyProductId:__WEBPACK_IMPORTED_MODULE_5__pricing__["default"].otherProductGuid(state)});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(actionToPage(t))));resolve(state);});};};var upgradeLicense=function upgradeLicense(state){return function(dispatch){return new Promise(function(resolve){var t=UPGRADE_LICENSE;dispatch({type:t,buyProductId:__WEBPACK_IMPORTED_MODULE_5__pricing__["default"].upgradeLicenseGuid(state)});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(actionToPage(t))));resolve(state);});};};var upgradeLicenseFromFreeOrTrial=function upgradeLicenseFromFreeOrTrial(state){return function(dispatch){return new Promise(function(resolve){dispatch({type:GO_TO_PAGE,newPage:Page.SelectProducts});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(Page.SelectProducts)));resolve(state);});};};var buySmallStakes=function buySmallStakes(state){return function(dispatch){return new Promise(function(resolve){var t=BUY_SMALL_STAKES;var isHm3=state.license.headerType==HeaderType.Hm3;var id=isHm3?__WEBPACK_IMPORTED_MODULE_6__api_productIds__["a" /* default */].hm3SmallStakes:__WEBPACK_IMPORTED_MODULE_6__api_productIds__["a" /* default */].omahaSmallStakes;dispatch({type:t,buyProductId:__WEBPACK_IMPORTED_MODULE_5__pricing__["default"].idToBuyProductGuid(id,state)});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(actionToPage(t))));resolve(state);});};};var buyAllStakes=function buyAllStakes(state){return function(dispatch){return new Promise(function(resolve){var t=BUY_FULL_STAKES;var isHm3=state.license.headerType==HeaderType.Hm3;var id=isHm3?__WEBPACK_IMPORTED_MODULE_6__api_productIds__["a" /* default */].hm3AllStakes:__WEBPACK_IMPORTED_MODULE_6__api_productIds__["a" /* default */].omahaAllStakes;dispatch({type:t,buyProductId:__WEBPACK_IMPORTED_MODULE_5__pricing__["default"].idToBuyProductGuid(id,state)});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(actionToPage(t))));resolve(state);});};};var buyHm3AndOmahaFullStakes=function buyHm3AndOmahaFullStakes(state){return function(dispatch){return new Promise(function(resolve){var t=BUY_HM3_AND_OMAHA_FULL_STAKES;dispatch({type:t,buyProductId:__WEBPACK_IMPORTED_MODULE_5__pricing__["default"].purchaseBothAllGuidIncludeUpgradeAllCombo(state)});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(actionToPage(t))));resolve(state);});};};var buyHm3AndOmahaSmallStakes=function buyHm3AndOmahaSmallStakes(state){return function(dispatch){return new Promise(function(resolve){var t=BUY_HM3_AND_OMAHA_SMALL_STAKES;dispatch({type:t,buyProductId:__WEBPACK_IMPORTED_MODULE_5__pricing__["default"].purchaseBothSmallGuid(state)});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(actionToPage(t))));resolve(state);});};};var upgradeHm3AndOmahaFullStakes=function upgradeHm3AndOmahaFullStakes(state){return function(dispatch){return new Promise(function(resolve){var t=UPGRADE_HM3_AND_OMAHA_FULL_STAKES;var toComboAll=__WEBPACK_IMPORTED_MODULE_5__pricing__["default"].upgradeToComboAllGuid(state);dispatch({type:t,buyProductId:toComboAll});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(actionToPage(t))));resolve(state);});};};var upgradeHm3AndOmahaSmallStakes=function upgradeHm3AndOmahaSmallStakes(state){return function(dispatch){return new Promise(function(resolve){var t=UPGRADE_HM3_AND_OMAHA_SMALL_STAKES;var toComboSmall=__WEBPACK_IMPORTED_MODULE_5__pricing__["default"].upgradeToComboSmallGuid(state);dispatch({type:t,buyProductId:toComboSmall});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(actionToPage(t))));resolve(state);});};};var startTrial=function startTrial(state){return function(dispatch){return new Promise(function(resolve){var isHm3=state.header==HeaderType.Hm3;var productId=isHm3?__WEBPACK_IMPORTED_MODULE_6__api_productIds__["a" /* default */].hm3Trial:__WEBPACK_IMPORTED_MODULE_6__api_productIds__["a" /* default */].omahaTrial;__WEBPACK_IMPORTED_MODULE_9__api_clientCall__["a" /* default */].startTrial(state.siteUrl,state.session,productId,state.fingerprint,state.enableTrialAbuseCheck,state.userId,state.email).then(function(value){// startTrial returns an "error" answer
dispatch({type:SAVE_ERROR,error:value});if(value.success){dispatch({type:START_HM3_TRIAL});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(actionToPage(START_HM3_TRIAL))));__WEBPACK_IMPORTED_MODULE_8__api_callHostApp__["a" /* default */].needsReloadLicense();}else// the error tells us the page to go to
dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(value.page)));resolve(state);});});};};var startHm3AndOmahaTrial=function startHm3AndOmahaTrial(state){return function(dispatch){return new Promise(function(resolve){__WEBPACK_IMPORTED_MODULE_9__api_clientCall__["a" /* default */].startTrial(state.siteUrl,state.session,__WEBPACK_IMPORTED_MODULE_6__api_productIds__["a" /* default */].hm3Trial,state.fingerprint,state.enableTrialAbuseCheck,state.userId,state.email).then(function(value){// startTrial returns an "error" answer
dispatch({type:SAVE_ERROR,error:value});if(value.success)return __WEBPACK_IMPORTED_MODULE_9__api_clientCall__["a" /* default */].startTrial(state.siteUrl,state.session,__WEBPACK_IMPORTED_MODULE_6__api_productIds__["a" /* default */].omahaTrial,state.fingerprint,state.enableTrialAbuseCheck,state.userId,state.email);else// basically, something went wrong starting the first trial
return value;}).then(function(value){// startTrial returns an "error" answer
dispatch({type:SAVE_ERROR,error:value});if(value.success){dispatch({type:START_HM3_AND_OMAHA_TRIAL});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(actionToPage(START_HM3_AND_OMAHA_TRIAL))));__WEBPACK_IMPORTED_MODULE_8__api_callHostApp__["a" /* default */].needsReloadLicense();}else// the error tells us the page to go to
dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(value.page)));resolve(state);});});};};var switchToFree=function switchToFree(state){return function(dispatch){return new Promise(function(resolve){var t=SWITCH_TO_FREE;dispatch({type:t});var url="#";if(state.missedUpdates.length>0){var last=state.missedUpdates[state.missedUpdates.length-1];url=last.url;}__WEBPACK_IMPORTED_MODULE_8__api_callHostApp__["a" /* default */].switchToFreemium(url);dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(actionToPage(t))));resolve(state);});};};var changeProducts=function changeProducts(state){return function(dispatch){return new Promise(function(resolve){var t=CHANGE_PRODUCTS;dispatch({type:t});var newPage=Page.PreSelectProducts;var isHm3=state.header==HeaderType.Hm3;var trialAvailable=isHm3?state.availableTrials.hm3:state.availableTrials.omaha;if(!trialAvailable)newPage=Page.SelectProducts;dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(newPage)));resolve(state);});};};var reloadLicense=function reloadLicense(){return function(dispatch){return new Promise(function(resolve){var t=RELOAD_LICENSE;dispatch({type:t});__WEBPACK_IMPORTED_MODULE_8__api_callHostApp__["a" /* default */].reloadLicense();resolve({});});};};var switchUser=function switchUser(){return function(dispatch){return new Promise(function(resolve){var t=SWITCH_USER;dispatch({type:t});__WEBPACK_IMPORTED_MODULE_8__api_callHostApp__["a" /* default */].switchUser();resolve({});});};};var startUsingApp=function startUsingApp(){return function(dispatch){return new Promise(function(resolve){var t=START_USING_APP;dispatch({type:t});__WEBPACK_IMPORTED_MODULE_8__api_callHostApp__["a" /* default */].startUsingApp();resolve({});});};};var continueTrial=function continueTrial(){return function(dispatch){return new Promise(function(resolve){var t=CONTINUE_TRIAL;dispatch({type:t});__WEBPACK_IMPORTED_MODULE_8__api_callHostApp__["a" /* default */].continueTrial();resolve({});});};};var simpleHostAppAction=function simpleHostAppAction(action){return function(dispatch){return new Promise(function(resolve){var t=SIMPLE_HOST_APP_ACTION;dispatch({type:t});__WEBPACK_IMPORTED_MODULE_8__api_callHostApp__["a" /* default */].simpleAction(action);resolve(action);});};};var sendStatusToHost=function sendStatusToHost(state){return function(dispatch){return new Promise(function(resolve){__WEBPACK_IMPORTED_MODULE_8__api_callHostApp__["a" /* default */].sendHttpStatusToHost(state.licensingStatus,state.storeStatus);var t=SEND_HTTP_STATUS_TO_HOST;dispatch({type:t});resolve(state);});};};// buys a specific GUID product
var buyGuidProduct=function buyGuidProduct(guid){return function(dispatch){return new Promise(function(resolve){var t=BUY_GUID_PRODUCT;dispatch({type:t,buyProductId:guid});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(actionToPage(t))));resolve(guid);});};};var buyHmAppsVariant=function buyHmAppsVariant(id,state){return function(dispatch){return new Promise(function(resolve){var t=BUY_HM_APPS_VARIANT;dispatch({type:t,buyProductId:id});dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(actionToPage(t))));resolve(id,state);});};};var buyHmAppsVariantFree=function buyHmAppsVariantFree(id,state){return function(dispatch){return new Promise(function(resolve){var t=BUY_HM_APPS_VARIANT_FREE;__WEBPACK_IMPORTED_MODULE_9__api_clientCall__["a" /* default */].purchaseFree(state,id).then(function(value){// buyNow returns an "error" answer
dispatch({type:SAVE_ERROR,error:value});if(value.success){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(Page.PurchaseCompleteSuccess)));__WEBPACK_IMPORTED_MODULE_8__api_callHostApp__["a" /* default */].needsReloadLicense();}else// the error tells us the page to go to
dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_connected_react_router__["push"])(Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(value.page)));resolve(id,state);});});};};// DO NOT USE DIRECTLY
// in order to avoid an infinite loop, use clientUtil.logError
var serverFatalError=function serverFatalError(state,error){return function(dispatch){return new Promise(function(resolve){var t=LOG_FATAL_ERROR;if(!state.fatalErrors.includes(error)){dispatch({type:t,errorNow:error});__WEBPACK_IMPORTED_MODULE_9__api_clientCall__["a" /* default */].logError(state,error).then(function(e){resolve(state);});}else{console.log("Fatal: invalid error");resolve(state);}});};};

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ExternalProductGuids={hm3AllStakes:"df22eb12-f490-11e7-9756-0242ac130004",hm3SmallStakes:"df254920-f490-11e7-bf15-0242ac130004",hm3Trial:"bd1e49f0-0f96-11e8-946b-0242ac130005",hm3Freemium:"bd1f8b3a-0f96-11e8-99cb-0242ac130005",hm3Maintenance:"6fc72036-f48f-11e7-8fb4-0242ac130004",omahaAllStakes:"df2545a6-f490-11e7-968f-0242ac130004",omahaSmallStakes:"df254c2c-f490-11e7-891e-0242ac130004",omahaTrial:"bd1f8cde-0f96-11e8-9fed-0242ac130005",omahaFreemium:"bd1f8e00-0f96-11e8-8eb6-0242ac130005",omahaMaintenance:"dc6da1bc-f492-11e7-ae33-0242ac130004",purchaseAddHm3AllToOm3:"7197c930-b6c1-11e8-bb9f-0242ac170002",//HM3-ALL-ADD
purchaseAddHm3SmallToOm3:"7197cc45-b6c1-11e8-bb9f-0242ac170002",//HM3-SS-ADD
purchaseAddHm3AllToOm3Small:"81983108-ba86-11e8-bb9f-0242ac170002",// HM3-ALL-ADD-OM3-SS
purchaseAddHm3SmallToOm3Small:"2f99bf1d-ba87-11e8-bb9f-0242ac170002",purchaseAddOm3AllToHm3:"7197cbd8-b6c1-11e8-bb9f-0242ac170002",purchaseAddOm3SmallToHm3:"7197cc84-b6c1-11e8-bb9f-0242ac170002",purchaseAddOm3AllToHm3Small:"8198310c-ba86-11e8-bb9f-0242ac170002",purchaseAddOm3SmallToHm3Small:"2f99bf20-ba87-11e8-bb9f-0242ac170002",purchaseUpgradeHm3SmallToHm3All:"05322d69-b6c1-11e8-bb9f-0242ac170002",purchaseUpgradeHm3SmallToHm3All_Om3All:"d377a54f-ba87-11e8-bb9f-0242ac170002",//HM3-SS-UPG-OM3-ALL
purchaseUpgradeHm3SmallToHm3All_Om3Small:"d377a555-ba87-11e8-bb9f-0242ac170002",purchaseUpgradeOm3SmallToOm3All:"05322f3a-b6c1-11e8-bb9f-0242ac170002",purchaseUpgradeOm3SmallToOm3All_Hm3All:"08b446e6-ba88-11e8-bb9f-0242ac170002",purchaseUpgradeOm3SmallToOm3All_Hm3Small:"08b446ed-ba88-11e8-bb9f-0242ac170002",purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All:"ca7d6e07-18ba-11eb-baa8-0242ac150003",// HM3 All Stakes + Omaha All Stakes
purchaseBothAll:"8f9c23d2-f491-11e7-aaaf-0242ac130004",// HM3 small stakes + omaha small stakes (at this time, not used)
purchaseBothSmall:"8f9c24f4-f491-11e7-b6fa-0242ac130004",initialPurchaseHm3Small:"8f9c2206-f491-11e7-9936-0242ac130004",initialPurchaseHm3All:"8f9ae968-f491-11e7-94f3-0242ac130004",initialPurchaseOmahaSmall:"8f9c272e-f491-11e7-b44b-0242ac130004",initialPurchaseOmahaAll:"8f9c262a-f491-11e7-97d1-0242ac130004",renewalHm3AAll_Om3All:"05c40b8e-f7c4-11e8-82dc-0242ac150002",renewalHm3Small_Om3Small:"05c41a34-f7c4-11e8-8adb-0242ac150002",renewalHm3All_Om3Small:"05c4257e-f7c4-11e8-9dc9-0242ac150002",renewalHm3Small_Om3All:"05c42b78-f7c4-11e8-b290-0242ac150002",renewalHm3All:"05c4324e-f7c4-11e8-8657-0242ac150002",renewalHm3Small:"05c439ec-f7c4-11e8-8b77-0242ac150002",renewalOm3All:"05c44112-f7c4-11e8-bbc8-0242ac150002",renewalOm3Small:"05c44982-f7c4-11e8-b14d-0242ac150002"};/* harmony default export */ __webpack_exports__["a"] = ({hm3AllStakes:ExternalProductGuids.hm3AllStakes,hm3SmallStakes:ExternalProductGuids.hm3SmallStakes,hm3Trial:ExternalProductGuids.hm3Trial,hm3Freemium:ExternalProductGuids.hm3Freemium,hm3Maintenance:ExternalProductGuids.hm3Maintenance,omahaAllStakes:ExternalProductGuids.omahaAllStakes,omahaSmallStakes:ExternalProductGuids.omahaSmallStakes,omahaTrial:ExternalProductGuids.omahaTrial,omahaFreemium:ExternalProductGuids.omahaFreemium,omahaMaintenance:ExternalProductGuids.omahaMaintenance,// HM3 All Stakes + Omaha All Stakes
purchaseBothAll:[ExternalProductGuids.purchaseBothAll,ExternalProductGuids.purchaseAddHm3AllToOm3,ExternalProductGuids.purchaseAddOm3AllToHm3],purchaseBothAllIncludeUpgradeAllCombo:[ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,ExternalProductGuids.purchaseBothAll,ExternalProductGuids.purchaseAddHm3AllToOm3,ExternalProductGuids.purchaseAddOm3AllToHm3],// HM3 small stakes + omaha small stakes
purchaseBothSmall:[ExternalProductGuids.purchaseBothSmall,ExternalProductGuids.purchaseAddHm3SmallToOm3Small,ExternalProductGuids.purchaseAddOm3SmallToHm3Small],purchaseBuyHm3Small:[ExternalProductGuids.initialPurchaseHm3Small,ExternalProductGuids.purchaseAddHm3SmallToOm3,ExternalProductGuids.purchaseAddHm3SmallToOm3Small,ExternalProductGuids.renewalHm3Small],purchaseBuyHm3All:[ExternalProductGuids.initialPurchaseHm3All,ExternalProductGuids.purchaseAddHm3AllToOm3,ExternalProductGuids.purchaseAddHm3AllToOm3Small,ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All,ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3All,ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3Small,ExternalProductGuids.renewalHm3All],purchaseBuyOm3Small:[ExternalProductGuids.initialPurchaseOmahaSmall,ExternalProductGuids.purchaseAddOm3SmallToHm3,ExternalProductGuids.purchaseAddOm3SmallToHm3Small,ExternalProductGuids.renewalOm3Small],purchaseBuyOm3All:[ExternalProductGuids.initialPurchaseOmahaAll,ExternalProductGuids.purchaseAddOm3AllToHm3,ExternalProductGuids.purchaseAddOm3AllToHm3Small,ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All,ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3All,ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3Small,ExternalProductGuids.renewalOm3All],purchaseUpgradeHm3Small:[ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All,ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3All],purchaseUpgradeOm3Small:[ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All,ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3All],renewHm3Both:[ExternalProductGuids.renewalHm3AAll_Om3All,ExternalProductGuids.renewalHm3All_Om3Small,ExternalProductGuids.renewalHm3Small_Om3All,ExternalProductGuids.renewalHm3Small_Om3Small],renewHm3Single:[ExternalProductGuids.renewalHm3All,ExternalProductGuids.renewalHm3Small],renewOm3Both:[ExternalProductGuids.renewalHm3AAll_Om3All,ExternalProductGuids.renewalHm3All_Om3Small,ExternalProductGuids.renewalHm3Small_Om3All,ExternalProductGuids.renewalHm3Small_Om3Small],renewOm3Single:[ExternalProductGuids.renewalOm3All,ExternalProductGuids.renewalOm3Small],renewHm3:[ExternalProductGuids.renewalHm3AAll_Om3All,ExternalProductGuids.renewalHm3All_Om3Small,ExternalProductGuids.renewalHm3Small_Om3All,ExternalProductGuids.renewalHm3Small_Om3Small,ExternalProductGuids.renewalHm3All,ExternalProductGuids.renewalHm3Small],renewOm3:[ExternalProductGuids.renewalHm3AAll_Om3All,ExternalProductGuids.renewalHm3All_Om3Small,ExternalProductGuids.renewalHm3Small_Om3All,ExternalProductGuids.renewalHm3Small_Om3Small,ExternalProductGuids.renewalOm3All,ExternalProductGuids.renewalOm3Small],renewHm3Small:[ExternalProductGuids.renewalHm3Small_Om3All,ExternalProductGuids.renewalHm3Small_Om3Small,ExternalProductGuids.renewalHm3Small],renewOm3Small:[ExternalProductGuids.renewalHm3All_Om3Small,ExternalProductGuids.renewalHm3Small_Om3Small,ExternalProductGuids.renewalOm3Small],upgradeHm3ToComboSmall:[ExternalProductGuids.purchaseAddOm3SmallToHm3Small],upgradeOm3ToComboSmall:[ExternalProductGuids.purchaseAddHm3SmallToOm3Small],upgradeHm3ToComboAll:[//ExternalProductGuids.initialPurchaseOmahaAll,
//ExternalProductGuids.purchaseAddOm3AllToHm3,
//ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3All,
//ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3Small,
ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,ExternalProductGuids.purchaseBothAll],upgradeOm3ToComboAll:[//ExternalProductGuids.initialPurchaseHm3All,
//ExternalProductGuids.purchaseAddHm3AllToOm3,
//ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3All,
//ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3Small,
ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,ExternalProductGuids.purchaseBothAll],buyGuid:[ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All,ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3All,ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3Small,ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All,ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3All,ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3Small,ExternalProductGuids.purchaseAddHm3AllToOm3,ExternalProductGuids.purchaseAddHm3AllToOm3Small,ExternalProductGuids.purchaseAddHm3SmallToOm3,ExternalProductGuids.purchaseAddHm3SmallToOm3Small,ExternalProductGuids.purchaseAddOm3AllToHm3,ExternalProductGuids.purchaseAddOm3AllToHm3Small,ExternalProductGuids.purchaseAddOm3SmallToHm3,ExternalProductGuids.purchaseAddOm3SmallToHm3Small,ExternalProductGuids.initialPurchaseHm3All,ExternalProductGuids.initialPurchaseHm3Small,ExternalProductGuids.initialPurchaseOmahaAll,ExternalProductGuids.initialPurchaseOmahaSmall,ExternalProductGuids.renewalHm3AAll_Om3All,ExternalProductGuids.renewalHm3All,ExternalProductGuids.renewalHm3All_Om3Small,ExternalProductGuids.renewalHm3Small,ExternalProductGuids.renewalHm3Small_Om3All,ExternalProductGuids.renewalHm3Small_Om3Small,ExternalProductGuids.renewalOm3All,ExternalProductGuids.renewalOm3Small,ExternalProductGuids.hm3AllStakes,ExternalProductGuids.hm3SmallStakes,ExternalProductGuids.omahaAllStakes,ExternalProductGuids.omahaSmallStakes],buyHm3Guid:[ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All,ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3All,ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3Small,ExternalProductGuids.purchaseAddHm3AllToOm3,ExternalProductGuids.purchaseAddHm3AllToOm3Small,ExternalProductGuids.purchaseAddHm3SmallToOm3,ExternalProductGuids.purchaseAddHm3SmallToOm3Small,ExternalProductGuids.initialPurchaseHm3All,ExternalProductGuids.initialPurchaseHm3Small,ExternalProductGuids.hm3AllStakes,ExternalProductGuids.hm3SmallStakes,ExternalProductGuids.renewalHm3All,ExternalProductGuids.renewalHm3Small,// note: user can have biggest discount when buying a combo
ExternalProductGuids.purchaseBothAll,ExternalProductGuids.purchaseBothSmall],buyOmahaGuid:[ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All,ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3All,ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3Small,ExternalProductGuids.purchaseAddOm3AllToHm3,ExternalProductGuids.purchaseAddOm3AllToHm3Small,ExternalProductGuids.purchaseAddOm3SmallToHm3,ExternalProductGuids.purchaseAddOm3SmallToHm3Small,ExternalProductGuids.initialPurchaseOmahaAll,ExternalProductGuids.initialPurchaseOmahaSmall,ExternalProductGuids.renewalOm3All,ExternalProductGuids.renewalOm3Small,ExternalProductGuids.omahaAllStakes,ExternalProductGuids.omahaSmallStakes,// note: user can have biggest discount when buying a combo
ExternalProductGuids.purchaseBothAll,ExternalProductGuids.purchaseBothSmall],smallGuids:[ExternalProductGuids.purchaseAddHm3SmallToOm3,ExternalProductGuids.purchaseAddHm3SmallToOm3Small,ExternalProductGuids.purchaseAddOm3SmallToHm3,ExternalProductGuids.purchaseAddOm3SmallToHm3Small,ExternalProductGuids.initialPurchaseHm3Small,ExternalProductGuids.initialPurchaseOmahaSmall,ExternalProductGuids.hm3SmallStakes,ExternalProductGuids.omahaSmallStakes,ExternalProductGuids.purchaseBothSmall],comboGuids:[ExternalProductGuids.purchaseBothAll,ExternalProductGuids.purchaseBothSmall],renewals:[ExternalProductGuids.renewalHm3AAll_Om3All,ExternalProductGuids.renewalHm3Small_Om3Small,ExternalProductGuids.renewalHm3All_Om3Small,ExternalProductGuids.renewalHm3Small_Om3All,ExternalProductGuids.renewalHm3All,ExternalProductGuids.renewalHm3Small,ExternalProductGuids.renewalOm3All,ExternalProductGuids.renewalOm3Small],renewalHm3AAll_Om3All:ExternalProductGuids.renewalHm3AAll_Om3All,renewalHm3Small_Om3Small:ExternalProductGuids.renewalHm3Small_Om3Small,renewalHm3All_Om3Small:ExternalProductGuids.renewalHm3All_Om3Small,renewalHm3Small_Om3All:ExternalProductGuids.renewalHm3Small_Om3All,renewalHm3All:ExternalProductGuids.renewalHm3All,renewalHm3Small:ExternalProductGuids.renewalHm3Small,renewalOm3All:ExternalProductGuids.renewalOm3All,renewalOm3Small:ExternalProductGuids.renewalOm3Small});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AUTHENTICATE */
/* unused harmony export SET_CURRENT_USER */
/* unused harmony export COOKIE_USER */
/* unused harmony export setCurrentUser */
/* unused harmony export establishCurrentUser */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loginUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return logoutUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
var AUTHENTICATE='auth/AUTHENTICATE';var SET_CURRENT_USER='auth/SET_CURRENT_USER';var COOKIE_USER='hm3lic_user';var initialState={isAuthenticated:false,currentUser:{}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case AUTHENTICATE:return Object.assign({},state,{isAuthenticated:action.authenticated});case SET_CURRENT_USER:return Object.assign({},state,{currentUser:action.user});default:return state;}});var setCurrentUser=function setCurrentUser(user){return function(dispatch){return new Promise(function(resolve){dispatch({type:SET_CURRENT_USER,user:user});__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(COOKIE_USER,user);dispatch({type:AUTHENTICATE,authenticated:true});resolve(user);});};};var establishCurrentUser=function establishCurrentUser(){return function(dispatch){return new Promise(function(resolve){var userFromCookie=__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.getJSON(COOKIE_USER);if(userFromCookie){dispatch(setCurrentUser(userFromCookie));resolve(userFromCookie);}else{resolve({});}});};};// note : not used anymore
var loginUser=function loginUser(email,password){return function(dispatch){return new Promise(function(resolve,reject){var user={email:email,password:password,name:'Awesome User'};dispatch(setCurrentUser(user));resolve(user);});};};// note : not used anymore
var logoutUser=function logoutUser(){return function(dispatch){return new Promise(function(resolve){dispatch({type:AUTHENTICATE,authenticated:false});dispatch({type:SET_CURRENT_USER,user:{}});__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(COOKIE_USER);resolve({});});};};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Settings; });
/* unused harmony export updateSettingsFromUrl */
/* unused harmony export urlIsProduction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(3);
// increase this to easily see if our latest version is online
var CurVersion="1.0.146";var Suffixes={licensingRoot:"/licensing/V1/",storeRoot:"/api/licenseApp/v1/"};var TestLocalSettings={port:3000,siteUrl:"http://mylicenseapp.maxvaluesoftware.com:3000/",licensingRoot:"http://apis_app_1"+Suffixes.licensingRoot,storeRoot:"http://store_app_1"+Suffixes.storeRoot,downloadRoot:"https://staging.holdemmanager.com/",isProduction:false,type:"local",logCategory:{startup:{name:"startup",log:true},info:{name:"info",log:false},warn:{name:"warn",log:false},error:{name:"ERROR",log:true},fatal:{name:"FATAL",log:true},initializeData:{name:"initialize",log:false},initialState:{name:"initialState",log:false},newUser:{name:"newUser",log:true},expires:{name:"expires",log:false},product:{name:"product",log:false},price:{name:"price",log:false},callback:{name:"callback",log:false},postInitialCall:{name:"postInitialCall",log:true},clientCall:{name:"clientCall",log:true},rawApiCallHeaders:{name:"rawApiCAllHeaders",log:true},rawApiCall:{name:"rawApiCall",log:false},rawApiPostBody:{name:"rawApiPostBody",log:true},rawApiCallAnswer:{name:"rawApiCallAnswer",log:false},restriction:{name:"restriction",log:false},purchase:{name:"purchase",log:true}},licensingToken:'HM3-MLA-SERVER',// allow mocking the credit card info- for testing (have a dummy John Doe with some predefined info)
mockCardInfo:true,mockCalls:true,simulateOverMaxVersion:false,// mock sending these exact license ids to store
//mockStoreLicenseIds: [10],
mockStoreLicenseIds:[],simulateStoreCalls:false,//simulateStoreCalls: true,
simulateStorePaypalCall:{general:[{message:"simulate: paypal error"}]}};var TestLocalDockerSettings={port:86,siteUrl:"http://mylicenseapp.maxvaluesoftware.com:86/",licensingRoot:"http://apis_app_1"+Suffixes.licensingRoot,storeRoot:"http://store_app_1"+Suffixes.storeRoot,downloadRoot:"https://staging.holdemmanager.com/",isProduction:false,type:"local_docker",logCategory:{startup:{name:"startup",log:true},info:{name:"info",log:true},warn:{name:"warn",log:true},error:{name:"ERROR",log:true},fatal:{name:"FATAL",log:true},initializeData:{name:"initialize",log:false},initialState:{name:"initialState",log:false},newUser:{name:"newUser",log:true},expires:{name:"expires",log:false},product:{name:"product",log:false},price:{name:"price",log:false},callback:{name:"callback",log:false},postInitialCall:{name:"postInitialCall",log:true},clientCall:{name:"clientCall",log:true},rawApiCallHeaders:{name:"rawApiCAllHeaders",log:true},rawApiCall:{name:"rawApiCall",log:true},rawApiPostBody:{name:"rawApiPostBody",log:true},rawApiCallAnswer:{name:"rawApiCallAnswer",log:true},restriction:{name:"restriction",log:false},purchase:{name:"purchase",log:true}},licensingToken:'HM3-MLA-SERVER',mockCardInfo:true,mockCalls:false,simulateOverMaxVersion:false,mockStoreLicenseIds:[],mockName:"",simulateStoreCalls:false};var StagingSettings={port:80,siteUrl:"https://stagmla.maxvaluesoftware.com/",licensingRoot:"https://stagapi.maxvaluesoftware.com"+Suffixes.licensingRoot,storeRoot:"https://stagstore.holdemmanager.com"+Suffixes.storeRoot,downloadRoot:"https://staging.holdemmanager.com/",isProduction:false,type:"staging",logCategory:{startup:{name:"startup",log:true},info:{name:"info",log:false},warn:{name:"warn",log:false},error:{name:"ERROR",log:true},fatal:{name:"FATAL",log:true},initializeData:{name:"initialize",log:true},initialState:{name:"initialState",log:false},newUser:{name:"newUser",log:true},expires:{name:"expires",log:false},product:{name:"product",log:false},price:{name:"price",log:false},callback:{name:"callback",log:false},postInitialCall:{name:"postInitialCall",log:false},clientCall:{name:"clientCall",log:false},rawApiCallHeaders:{name:"rawApiCAllHeaders",log:false},rawApiCall:{name:"rawApiCall",log:false},rawApiPostBody:{name:"rawApiPostBody",log:false},rawApiCallAnswer:{name:"rawApiCallAnswer",log:false},restriction:{name:"restriction",log:false},purchase:{name:"purchase",log:false}},licensingToken:'HM3-MLA-SERVER',mockCardInfo:false,mockCalls:false,simulateOverMaxVersion:false,mockStoreLicenseIds:[],mockName:"",simulateStoreCalls:false};//live (production)
var ProductionSettings={port:80,siteUrl:"https://mylicenseapp.maxvaluesoftware.com/",licensingRoot:"https://api.maxvaluesoftware.com"+Suffixes.licensingRoot,storeRoot:"https://store.holdemmanager.com"+Suffixes.storeRoot,downloadRoot:"https://www.holdemmanager.com/",isProduction:true,type:"production",logCategory:{startup:{name:"startup",log:true},info:{name:"info",log:false},warn:{name:"warn",log:false},error:{name:"ERROR",log:true},fatal:{name:"FATAL",log:true},initializeData:{name:"initialize",log:true},initialState:{name:"initialState",log:false},newUser:{name:"newUser",log:false},expires:{name:"expires",log:false},product:{name:"product",log:false},price:{name:"price",log:false},callback:{name:"callback",log:false},postInitialCall:{name:"postInitialCall",log:false},clientCall:{name:"clientCall",log:false},rawApiCallHeaders:{name:"rawApiCAllHeaders",log:false},rawApiCall:{name:"rawApiCall",log:false},rawApiPostBody:{name:"rawApiPostBody",log:false},rawApiCallAnswer:{name:"rawApiCallAnswer",log:false},restriction:{name:"restriction",log:false},purchase:{name:"purchase",log:true}},licensingToken:'HM3-MLA-SERVER',mockCardInfo:false,mockCalls:false,simulateOverMaxVersion:false,mockStoreLicenseIds:[],mockName:"",simulateStoreCalls:false};var _settingsAlreadySet=false;var Settings=ProductionSettings;var updateSettingsFromUrl=function updateSettingsFromUrl(url){if(_settingsAlreadySet)return;_settingsAlreadySet=true;var isLocal=false;var from=ProductionSettings;if(url.indexOf("localhost")>=0){from=TestLocalSettings;isLocal=true;}if(url.indexOf("mylicenseapp.maxvaluesoftware.com:86")>=0){from=TestLocalDockerSettings;isLocal=true;}if(url.indexOf("stagmla.")>=0)from=StagingSettings;Settings=from;Object(__WEBPACK_IMPORTED_MODULE_0__logger__["e" /* setLogCategory */])(Settings.logCategory);Object(__WEBPACK_IMPORTED_MODULE_0__logger__["d" /* logJsonAsFormatted */])(isLocal);Object(__WEBPACK_IMPORTED_MODULE_0__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_0__logger__["a" /* LogCategory */].info,"initializing settings from url "+url+" at version "+CurVersion+" => "+JSON.stringify(Settings));Object(__WEBPACK_IMPORTED_MODULE_0__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_0__logger__["a" /* LogCategory */].startup,"starting up "+CurVersion);};var urlIsProduction=function urlIsProduction(url){var isProduction=true;if(url.indexOf("localhost")>=0){isProduction=false;}if(url.indexOf("mylicenseapp.maxvaluesoftware.com:86")>=0){isProduction=false;}if(url.indexOf("stagmla.")>=0)isProduction=false;return isProduction;};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(61);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inheritsLoose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(70);

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(t, o);
}


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(35);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(75);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _typeof; });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(40);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(21);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(1);

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];

function isWebpackReady(getModuleIds) {
  if (( false ? "undefined" : _typeof(__webpack_require__.m)) !== "object") {
    return false;
  }

  return getModuleIds().every(function (moduleId) {
    return typeof moduleId !== "undefined" && typeof __webpack_require__.m[moduleId] !== "undefined";
  });
}

function load(loader) {
  var promise = loader();

  var state = {
    loading: true,
    loaded: null,
    error: null
  };

  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });

  return state;
}

function loadMap(obj) {
  var state = {
    loading: false,
    loaded: {},
    error: null
  };

  var promises = [];

  try {
    Object.keys(obj).forEach(function (key) {
      var result = load(obj[key]);

      if (!result.loading) {
        state.loaded[key] = result.loaded;
        state.error = result.error;
      } else {
        state.loading = true;
      }

      promises.push(result.promise);

      result.promise.then(function (res) {
        state.loaded[key] = res;
      }).catch(function (err) {
        state.error = err;
      });
    });
  } catch (err) {
    state.error = err;
  }

  state.promise = Promise.all(promises).then(function (res) {
    state.loading = false;
    return res;
  }).catch(function (err) {
    state.loading = false;
    throw err;
  });

  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function render(loaded, props) {
  return React.createElement(resolve(loaded), props);
}

function createLoadableComponent(loadFn, options) {
  var _class, _temp;

  if (!options.loading) {
    throw new Error("react-loadable requires a `loading` component");
  }

  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    render: render,
    webpack: null,
    modules: null
  }, options);

  var res = null;

  function init() {
    if (!res) {
      res = loadFn(opts.loader);
    }
    return res.promise;
  }

  ALL_INITIALIZERS.push(init);

  if (typeof opts.webpack === "function") {
    READY_INITIALIZERS.push(function () {
      if (isWebpackReady(opts.webpack)) {
        return init();
      }
    });
  }

  return _temp = _class = function (_React$Component) {
    _inherits(LoadableComponent, _React$Component);

    function LoadableComponent(props) {
      _classCallCheck(this, LoadableComponent);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

      _this.retry = function () {
        _this.setState({ error: null, loading: true, timedOut: false });
        res = loadFn(opts.loader);
        _this._loadModule();
      };

      init();

      _this.state = {
        error: res.error,
        pastDelay: false,
        timedOut: false,
        loading: res.loading,
        loaded: res.loaded
      };
      return _this;
    }

    LoadableComponent.preload = function preload() {
      return init();
    };

    LoadableComponent.prototype.componentWillMount = function componentWillMount() {
      this._mounted = true;
      this._loadModule();
    };

    LoadableComponent.prototype._loadModule = function _loadModule() {
      var _this2 = this;

      if (this.context.loadable && Array.isArray(opts.modules)) {
        opts.modules.forEach(function (moduleName) {
          _this2.context.loadable.report(moduleName);
        });
      }

      if (!res.loading) {
        return;
      }

      if (typeof opts.delay === "number") {
        if (opts.delay === 0) {
          this.setState({ pastDelay: true });
        } else {
          this._delay = setTimeout(function () {
            _this2.setState({ pastDelay: true });
          }, opts.delay);
        }
      }

      if (typeof opts.timeout === "number") {
        this._timeout = setTimeout(function () {
          _this2.setState({ timedOut: true });
        }, opts.timeout);
      }

      var update = function update() {
        if (!_this2._mounted) {
          return;
        }

        _this2.setState({
          error: res.error,
          loaded: res.loaded,
          loading: res.loading
        });

        _this2._clearTimeouts();
      };

      res.promise.then(function () {
        update();
      }).catch(function (err) {
        update();
      });
    };

    LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this._mounted = false;
      this._clearTimeouts();
    };

    LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    };

    LoadableComponent.prototype.render = function render() {
      if (this.state.loading || this.state.error) {
        return React.createElement(opts.loading, {
          isLoading: this.state.loading,
          pastDelay: this.state.pastDelay,
          timedOut: this.state.timedOut,
          error: this.state.error,
          retry: this.retry
        });
      } else if (this.state.loaded) {
        return opts.render(this.state.loaded, this.props);
      } else {
        return null;
      }
    };

    return LoadableComponent;
  }(React.Component), _class.contextTypes = {
    loadable: PropTypes.shape({
      report: PropTypes.func.isRequired
    })
  }, _temp;
}

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function LoadableMap(opts) {
  if (typeof opts.render !== "function") {
    throw new Error("LoadableMap requires a `render(loaded, props)` function");
  }

  return createLoadableComponent(loadMap, opts);
}

Loadable.Map = LoadableMap;

var Capture = function (_React$Component2) {
  _inherits(Capture, _React$Component2);

  function Capture() {
    _classCallCheck(this, Capture);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Capture.prototype.getChildContext = function getChildContext() {
    return {
      loadable: {
        report: this.props.report
      }
    };
  };

  Capture.prototype.render = function render() {
    return React.Children.only(this.props.children);
  };

  return Capture;
}(React.Component);

Capture.propTypes = {
  report: PropTypes.func.isRequired
};
Capture.childContextTypes = {
  loadable: PropTypes.shape({
    report: PropTypes.func.isRequired
  }).isRequired
};


Loadable.Capture = Capture;

function flushInitializers(initializers) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init());
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolve, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolve, reject);
  });
};

Loadable.preloadReady = function () {
  return new Promise(function (resolve, reject) {
    // We always will resolve, errors should be handled within loading UIs.
    flushInitializers(READY_INITIALIZERS).then(resolve, resolve);
  });
};

module.exports = Loadable;

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(18);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(24);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(96)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = prefix || defaultDelimiter
    var pattern = capture || group
    var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '')

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : restrictBacktrack(delimiter, prevText))
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

function restrictBacktrack(delimiter, prevText) {
  if (!prevText || prevText.indexOf(delimiter) > -1) {
    return '[^' + escapeString(delimiter) + ']+?'
  }

  return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?'
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(19);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_logger__ = __webpack_require__(3);
var Page=__webpack_require__(12);/* harmony default export */ __webpack_exports__["a"] = (function(page,args){var http="";switch(page){case Page.ActiveMaintenanceFull:http="/activeMaintenanceFullPage";break;case Page.ActiveMaintenanceSmall:http="/activeMaintenanceSmallPage";break;case Page.BillingAddress:http="/billingAddressPage";break;case Page.CardInfo:http="/cardInfoPage";break;case Page.ExpiredContractFull:http="/expiredContractFullPage";break;case Page.ExpiredContractSmall:http="/expiredContractSmallPage";break;case Page.ExpiringContractFull:http="/expiringContractFullPage";break;case Page.ExpiringContractSmall:http="/expiringContractSmallPage";break;case Page.Freemium:http="/freemiumPage";break;case Page.FreemiumOverMaxVersion:http="/freemiumOverMaxVersionPage";break;case Page.MaintenanceOptions:http="/maintenanceOptionsPage";break;case Page.PaymentReview:http="/paymentReviewPage";break;case Page.Paypal:http="/paypalPage";break;case Page.Netteller:http="/netellerPage";break;case Page.PurchaseCompleteSuccess:http="/purchaseCompleteSuccessPage";break;case Page.Purchase:http="/purchasePage";break;case Page.StartTrialOptions:http="/startTrialOptionsPage";break;case Page.TrialLicense:http="/trialLicensePage";break;case Page.TrialStarted:http="/trialStartedPage";break;case Page.ViewMisseddUpdates:http="/viewMissedUpdatesPage";break;case Page.SelectProducts:http="/selectProductsPage";break;case Page.PreSelectProducts:http="/preSelectProductsPage";break;case Page.ContinueTrial:http="/continueTrialPage";break;case Page.UpgradeProduct:http="/upgradeProductsPage";break;case Page.CouldNotLoadMla:http="/couldNotStartMlaPage";break;case Page.GetHm3ForFree:http="/getHm3ForFreePage";break;case Page.SelectHmAppsProducts:http="/selectHmAppsProductsPage";break;case Page.SelectHmAppVariantProducts:http="/selectHmAppVariantProductsPage"+(args!==undefined?"/"+args[0]:"/years");break;default:Object(__WEBPACK_IMPORTED_MODULE_0__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_0__api_logger__["a" /* LogCategory */].info,'invalid page '+JSON.stringify(page));http="/error";break;}return http;});

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(108);


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(25);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 53 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_localizer__ = __webpack_require__(11);
var LicenseType=__webpack_require__(13);var HeaderType=__webpack_require__(8);var Pricing=__webpack_require__(28);/* harmony default export */ __webpack_exports__["a"] = ({isFullStakes:function isFullStakes(lic){return lic.fullLicense;},isSmallStakes:function isSmallStakes(lic){return!lic.fullLicense;},isExpired:function isExpired(lic){return lic.expires<Date.now();},isExpiring:function isExpiring(lic){if(lic.cancelled)// a license is cancelled when still active but user cancelled it
// when it expires, the license will become "expired"
return true;return lic.expires>Date.now()&&lic.expires<30*24*60*60*1000+Date.now();},// mla-279 - i want to know if the user has ever paid for this product before (even if it's expired now)
hasHadMaintenanceContract:function hasHadMaintenanceContract(lic){if(lic.state==LicenseType.NoLicense)return false;if(lic.state==LicenseType.Trial)if(lic.expires!=lic.trialExpires)return true;if(lic.state==LicenseType.Freemium)if(lic.expires!=null)return true;if(lic.state==LicenseType.Maintenance)return true;return false;},headerFriendlyName:function headerFriendlyName(lic){var friendly="HM";switch(lic.headerType){case HeaderType.Hm3:friendly=__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.holdemManager);break;case HeaderType.Omaha:friendly=__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.omaha);break;case HeaderType.HmApps:friendly=__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.hmApps);break;default:console.assert(false);break;}return friendly;},friendlyName:function friendlyName(lic){var friendly=this.headerFriendlyName(lic);var suffix=this.isSmallStakes(lic)?__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.smallStakes):__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.allStakes);return friendly+" "+suffix;},headerText:function headerText(lic){if(lic.headerType==HeaderType.HmApps)return"";// HM APPS - where you select the HM app to manage/view
var expiredDays=parseInt((Date.now()-lic.trialExpires)/(24*60*60*1000));var expiresDays=-expiredDays;switch(lic.state){case LicenseType.Trial:if(expiresDays>=0)return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.headerTextTrial,[expiresDays]);else return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.expiredHeaderTextTrial);case LicenseType.NoLicense:return"";case LicenseType.Freemium:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.headerTextFree);case LicenseType.Maintenance:return this.isSmallStakes(lic)?__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.smallStakes):__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.allStakes);}console.assert(false);return"-";},myProductText:function myProductText(lic){switch(lic.headerType){case HeaderType.Hm3:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.holdemManagerCaps);case HeaderType.Omaha:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.omahaCaps);case HeaderType.HmApps:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.hmApps);default:console.assert(false);break;}return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.holdemManagerCaps);},buyTextHeader:function buyTextHeader(lic){switch(lic.headerType){case HeaderType.Hm3:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.hm3);case HeaderType.Omaha:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.om3);case HeaderType.HmApps:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.hmApps);default:console.assert(false);break;}},buyBothTextHeader:function buyBothTextHeader(lic){switch(lic.headerType){case HeaderType.Hm3:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.hm3andOm3);case HeaderType.Omaha:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.hm3andOm3);case HeaderType.HmApps:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.hmApps);default:console.assert(false);break;}},buySmallStakesText:function buySmallStakesText(lic){switch(lic.headerType){case HeaderType.Hm3:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.buyHoldemSmallStakes);case HeaderType.Omaha:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.buyOmahaSmallStakes);case HeaderType.HmApps:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.hmApps);default:console.assert(false);break;}},buyAllStakesText:function buyAllStakesText(lic){switch(lic.headerType){case HeaderType.Hm3:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.buyHoldemAllStakes);case HeaderType.Omaha:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.buyOmahaAllStakes);case HeaderType.HmApps:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.hmApps);default:console.assert(false);break;}},buyBothAllStakesText:function buyBothAllStakesText(lic){switch(lic.headerType){case HeaderType.Hm3:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.buyHoldemOmahaAllStakes);case HeaderType.Omaha:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.buyHoldemOmahaAllStakes);case HeaderType.HmApps:return __WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_0__format_localizer__["a" /* default */].keys.hmApps);default:console.assert(false);break;}}});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(3);
/* harmony default export */ __webpack_exports__["a"] = ({callHost:function callHost(str){if(!__WEBPACK_IMPORTED_MODULE_0__store__["b" /* isServer */]){var args=str;if(str.startsWith("action OpenUrl"))console.log(str);// for debugging
var str='hm3Callback.args = "'+args+'"; hm3Callback.execute();';Object(__WEBPACK_IMPORTED_MODULE_1__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_1__logger__["a" /* LogCategory */].callback,"send to host "+args);try{eval(str);}catch(e){Object(__WEBPACK_IMPORTED_MODULE_1__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_1__logger__["a" /* LogCategory */].error,"error call host "+e.message);}}},sendTokenToHost:function sendTokenToHost(token){// don't log the token itself
console.log("sending token back to host");this.callHost("action Token "+token);},openUrl:function openUrl(url){this.callHost("action OpenUrl "+url);},openPaypal:function openPaypal(url){this.callHost("action OpenPaypal "+url);},reloadLicense:function reloadLicense(){this.callHost("action ReloadLicense");},switchToFreemium:function switchToFreemium(url){this.callHost("action SwitchToFreemium "+url);},startUsingApp:function startUsingApp(){this.callHost("action StartUsingApp");},continueTrial:function continueTrial(){this.callHost("action ContinueTrial");},close:function close(){this.callHost("action Close");},switchUser:function switchUser(){this.callHost("action SwitchUser");},simpleAction:function simpleAction(action){this.callHost("action "+action);},needsReloadLicense:function needsReloadLicense(){this.callHost("action NeedsReloadLicense");},netellerRedirect:function netellerRedirect(url){// at this point (7 feb 2019), store doesn't send https
if(url.indexOf("redirect_uri=http%")>=0)url=url.replace("redirect_uri=http%","redirect_uri=https%");this.callHost("action NetellerRedirect "+url);},// sends the http status from the licensing/store
sendHttpStatusToHost:function sendHttpStatusToHost(licensing,store){this.callHost("action HttpStatus "+licensing+" "+store);}});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(66);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_settings__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SITE_URL=__WEBPACK_IMPORTED_MODULE_3__api_settings__["a" /* Settings */].siteUrl;var FACEBOOK_APP_ID='XXXXXXXXX';var defaultTitle='HM3 Licensing';var defaultDescription='HM3 Licensing';//const defaultImage = `${SITE_URL}${logo}`;
var defaultTwitter='@holdemmanager';var defaultSep=' | ';var Page=function(_Component){_inherits(Page,_Component);function Page(){_classCallCheck(this,Page);return _possibleConstructorReturn(this,(Page.__proto__||Object.getPrototypeOf(Page)).apply(this,arguments));}_createClass(Page,[{key:'getMetaTags',value:function getMetaTags(_ref,pathname){var title=_ref.title,description=_ref.description,image=_ref.image,contentType=_ref.contentType,twitter=_ref.twitter,noCrawl=_ref.noCrawl,published=_ref.published,updated=_ref.updated,category=_ref.category,tags=_ref.tags;var theTitle=title?(title+defaultSep+defaultTitle).substring(0,60):defaultTitle;var theDescription=description?description.substring(0,155):defaultDescription;//const theImage = image ? `${SITE_URL}${image}` : defaultImage;
var metaTags=[{itemprop:'name',content:theTitle},{itemprop:'description',content:theDescription},//{ itemprop: 'image', content: theImage },
{name:'description',content:theDescription},{name:'twitter:card',content:'summary_large_image'},{name:'twitter:site',content:defaultTwitter},{name:'twitter:title',content:theTitle},{name:'twitter:description',content:theDescription},{name:'twitter:creator',content:twitter||defaultTwitter},//{ name: 'twitter:image:src', content: theImage },
{property:'og:title',content:theTitle},{property:'og:type',content:contentType||'website'},{property:'og:url',content:SITE_URL+pathname},//{ property: 'og:image', content: theImage },
{property:'og:description',content:theDescription},{property:'og:site_name',content:defaultTitle},{property:'fb:app_id',content:FACEBOOK_APP_ID}];if(noCrawl){metaTags.push({name:'robots',content:'noindex, nofollow'});}if(published){metaTags.push({name:'article:published_time',content:published});}if(updated){metaTags.push({name:'article:modified_time',content:updated});}if(category){metaTags.push({name:'article:section',content:category});}if(tags){metaTags.push({name:'article:tag',content:tags});}return metaTags;}},{key:'render',value:function render(){var _props=this.props,children=_props.children,id=_props.id,className=_props.className,rest=_objectWithoutProperties(_props,['children','id','className']);// helmet is optional, but lets leave it for now
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:id,className:className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a,{htmlAttributes:{lang:'en',itemscope:undefined,itemtype:'http://schema.org/'+(rest.schema||'WebPage')},title:rest.title?rest.title+defaultSep+defaultTitle:defaultTitle,link:[{rel:'canonical',href:SITE_URL+this.props.location.pathname}],meta:this.getMetaTags(rest,this.props.location.pathname)}),children);}}]);return Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["withRouter"])(Page));

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(59);
module.exports = __webpack_require__(64);


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(60).enable();
  window.Promise = __webpack_require__(62);
}

// fetch() polyfill for making API calls.
__webpack_require__(63);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(10);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(33);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(33);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_loadable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_frontload__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_frontload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_frontload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_connected_react_router__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_connected_react_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_connected_react_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_app__ = __webpack_require__(114);
// Create a store and get back itself and its history object
var _createStore=Object(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */])(),store=_createStore.store,history=_createStore.history;// Running locally, we should run on a <ConnectedRouter /> rather than on a <StaticRouter /> like on the server
// Let's also let React Frontload explicitly know we're not rendering on the server here
var Application=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_connected_react_router__["ConnectedRouter"],{history:history},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_frontload__["Frontload"],{noServerRender:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__app_app__["a" /* default */],null))));var root=document.querySelector('#root');if(true){// If we're running in production, we use hydrate to get fast page loads by just
// attaching event listeners after the initial render
__WEBPACK_IMPORTED_MODULE_3_react_loadable___default.a.preloadReady().then(function(){Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["hydrate"])(Application,root);});}else{// If we're not running on the server, just render like normal
render(Application,root);}

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(10),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(10),r=__webpack_require__(67);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(68);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(21);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(72);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(37);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(87);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(39);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectSpread2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(81);

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(82);

function _defineProperty(e, r, t) {
  return (r = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toPropertyKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(83);


function toPropertyKey(t) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(t, "string");
  return "symbol" == Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(i) ? i : i + "";
}


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toPrimitive; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(38);

function toPrimitive(t, r) {
  if ("object" != Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(39);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(40);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(88);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(21);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.frontloadServerRender = exports.frontloadConnect = exports.Frontload = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FRONTLOAD_QUEUES = [];

var LIFECYCLE_PHASES = {
  MOUNT: 0,
  UPDATE: 1
};

var log = "production" !== 'production' && function (name, message) {
  console.log('[react-frontload]' + (name ? ' [' + name + ']' : '') + ' ' + message);
};

var autoDetectIsServer = function autoDetectIsServer() {
  return typeof window === 'undefined' || !window.document || !window.document.createElement;
};

var cleanQueues = function cleanQueues(index) {
  if (index === undefined) {
    FRONTLOAD_QUEUES = [];
  } else {
    FRONTLOAD_QUEUES[index] = [];
  }
};

var map = function map(arr, fn) {
  var mapped = [];
  for (var i = 0; i < arr.length; i++) {
    mapped.push(fn(arr[i], i));
  }return mapped;
};

var waitForAllToComplete = function waitForAllToComplete(promises) {
  return Promise.all(map(promises, function (promise) {
    return promise['catch'](function (error) {
      return error;
    });
  }));
};

function flushQueues(index) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (index === undefined) return Promise.all(map(FRONTLOAD_QUEUES, function (_, i) {
    return flushQueues(i);
  }));

  var frontloadPromises = [];
  var queue = FRONTLOAD_QUEUES[index];

  for (var i = 0; i < queue.length; i++) {
    var frontload = queue[i];
    if (!options.firstClientRender) {
      frontloadPromises.push(frontload.fn());
    } else if (options.noServerRender || frontload.options.noServerRender) {
      if (false) {
        options.log('[1st client render] NOTE running frontload fn for component [' + frontload.componentDisplayName + '], since noServerRender === true ' + (options.noServerRender ? 'globally' : 'for this component'));
      }

      frontloadPromises.push(frontload.fn());
    }
  }

  cleanQueues(index);

  return waitForAllToComplete(frontloadPromises);
}

var Frontload = exports.Frontload = function (_React$Component) {
  _inherits(Frontload, _React$Component);

  _createClass(Frontload, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _this2 = this;

      return {
        frontload: {
          isServer: this.isServer,
          firstClientRenderDone: this.isServer ? true : this.firstClientRenderDone,

          pushFrontload: function pushFrontload(frontload, options, lifecylePhase, childProps, logMessage) {
            var isMount = lifecylePhase === LIFECYCLE_PHASES.MOUNT;
            var isUpdate = lifecylePhase === LIFECYCLE_PHASES.UPDATE;
            var queue = FRONTLOAD_QUEUES[_this2.queueIndex];
            var noServerRender = _this2.props.noServerRender || options.noServerRender;

            if (_this2.isServer && noServerRender || isMount && options.onMount === false || isUpdate && !options.onUpdate) {
              return;
            }

            if (_this2.isServer) {
              queue.unshift({
                fn: function fn() {
                  return frontload(childProps, { isMount: isMount, isUpdate: isUpdate });
                },
                options: options,
                componentDisplayName: childProps.displayName
              });

              if (false) {
                log(_this2.props.name, 'added frontload fn to queue ' + logMessage);
              }
            } else if (noServerRender || _this2.firstClientRenderDone) {
              frontload(childProps, { isMount: isMount, isUpdate: isUpdate });

              if (false) {
                log(_this2.props.name, 'executed frontload fn ' + logMessage);
              }
            } else if (false) {
              log(_this2.props.name, 'did not execute frontload fn on first client render ' + logMessage + ', since server rendering is enabled');
            }
          }
        }
      };
    }
  }]);

  function Frontload(props, context) {
    _classCallCheck(this, Frontload);

    var _this = _possibleConstructorReturn(this, (Frontload.__proto__ || Object.getPrototypeOf(Frontload)).call(this, props, context));

    _this.isServer = props.isServer === undefined ? autoDetectIsServer() : props.isServer;

    _this.queueIndex = FRONTLOAD_QUEUES.push([]) - 1;

    _this.componentDidMount = function () {
      _this.firstClientRenderDone = true;

      if (false) {
        log(props.name, '1st client render done, from now on all frontloads will run');
      }
    };
    return _this;
  }

  _createClass(Frontload, [{
    key: 'render',
    value: function render() {
      return _react2.default.Children.only(this.props.children);
    }
  }]);

  return Frontload;
}(_react2.default.Component);

Frontload.childContextTypes = {
  frontload: _propTypes2.default.object
};

var FrontloadConnectedComponent = function (_React$Component2) {
  _inherits(FrontloadConnectedComponent, _React$Component2);

  function FrontloadConnectedComponent(props, context) {
    _classCallCheck(this, FrontloadConnectedComponent);

    var _this3 = _possibleConstructorReturn(this, (FrontloadConnectedComponent.__proto__ || Object.getPrototypeOf(FrontloadConnectedComponent)).call(this, props, context));

    _this3.pushFrontload = function (lifecyclePhase, isServer) {
      return function () {
        var logMessage =  false ? null : 'for component: [' + (_this3.props.component.displayName || 'anonymous') + '] on [' + (lifecyclePhase === LIFECYCLE_PHASES.MOUNT ? 'mount' : 'update') + ']';

        _this3.context.frontload.pushFrontload(_this3.props.frontload, _this3.props.options, lifecyclePhase, _this3.props.componentProps, logMessage);
      };
    };

    if (context.frontload.isServer) {
      _this3.componentWillMount = _this3.pushFrontload(LIFECYCLE_PHASES.MOUNT, true);
    } else {
      _this3.componentDidMount = _this3.pushFrontload(LIFECYCLE_PHASES.MOUNT);
      _this3.componentDidUpdate = _this3.pushFrontload(LIFECYCLE_PHASES.UPDATE);
    }
    return _this3;
  }

  _createClass(FrontloadConnectedComponent, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(this.props.component, this.props.componentProps);
    }
  }]);

  return FrontloadConnectedComponent;
}(_react2.default.Component);

FrontloadConnectedComponent.contextTypes = {
  frontload: _propTypes2.default.object
};
var frontloadConnect = exports.frontloadConnect = function frontloadConnect(frontload) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (component) {
    return function (props) {
      return _react2.default.createElement(FrontloadConnectedComponent, {
        frontload: frontload,
        component: component,
        componentProps: props,
        options: options });
    };
  };
};

var frontloadServerRender = exports.frontloadServerRender = function frontloadServerRender(render, withLogging) {
  if (false) {
    log('frontloadServerRender info', 'running first render to fill frontload fn queue(s)');
  }

  render();

  if (false) {
    log('frontloadServerRender info', 'first render succeeded, frontend fn queue(s) filled');
    log('frontloadServerRender info', 'flushing frontend fn queue(s) before running second render...');
  }

  var startFlushAt = withLogging && Date.now();

  var rendered = flushQueues().then(function () {
    if (false) {
      log('frontloadServerRender info', 'flushed frontload fn queue(s) in ' + (Date.now() - startFlushAt) + 'ms');
      log('frontloadServerRender info', 'Running second render.');
    }

    var output = render();

    cleanQueues();

    if (false) {
      log('frontloadServerRender info', 'NOTE: as the logs show, the queue(s) are filled by Frontload before the second render, however they are NOT flushed, so the frontload fns DO NOT run twice.');
      log('frontloadServerRender info', 'second render succeeded. Server rendering is done.');
    }

    return output;
  });

  return rendered;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actions = __webpack_require__(16);

var actions = _interopRequireWildcard(_actions);

var _ConnectedRouter = __webpack_require__(91);

var _ConnectedRouter2 = _interopRequireDefault(_ConnectedRouter);

var _reducer = __webpack_require__(98);

var _reducer2 = _interopRequireDefault(_reducer);

var _middleware = __webpack_require__(99);

var _middleware2 = _interopRequireDefault(_middleware);

var _selectors = __webpack_require__(100);

var _selectors2 = _interopRequireDefault(_selectors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var createAll = function createAll(structure) {
  return _extends({}, _get__('actions'), _get__('createSelectors')(structure), {
    ConnectedRouter: _get__('createConnectedRouter')(structure),
    connectRouter: _get__('createConnectRouter')(structure),
    routerMiddleware: _get__('routerMiddleware')
  });
};

exports.default = _get__('createAll');

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'actions':
      return _filterWildcardImport__(actions);

    case 'createSelectors':
      return _selectors2.default;

    case 'createConnectedRouter':
      return _ConnectedRouter2.default;

    case 'createConnectRouter':
      return _reducer2.default;

    case 'routerMiddleware':
      return _middleware2.default;

    case 'createAll':
      return createAll;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof createAll === 'undefined' ? 'undefined' : _typeof(createAll);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(createAll, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createAll)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

function _filterWildcardImport__() {
  var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
    return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
  });
  return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
    filteredWildcardImport[propertyName] = wildcardImport[propertyName];
    return filteredWildcardImport;
  }, {});
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(6);

var _reactRouter = __webpack_require__(17);

var _actions = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createConnectedRouter = function createConnectedRouter(structure) {
  var getIn = structure.getIn,
      toJS = structure.toJS;
  /*
   * ConnectedRouter listens to a history object passed from props.
   * When history is changed, it dispatches action to redux store.
   * Then, store will pass props to component to render.
   * This creates uni-directional flow from history->store->router->components.
   */

  var ConnectedRouter = function (_get__2) {
    _inherits(ConnectedRouter, _get__2);

    function ConnectedRouter(props, context) {
      _classCallCheck(this, ConnectedRouter);

      var _this = _possibleConstructorReturn(this, (ConnectedRouter.__proto__ || Object.getPrototypeOf(ConnectedRouter)).call(this, props));

      _this.inTimeTravelling = false;

      // Subscribe to store changes
      _this.unsubscribe = context.store.subscribe(function () {
        // Extract store's location
        var _toJS = toJS(getIn(context.store.getState(), ['router', 'location'])),
            pathnameInStore = _toJS.pathname,
            searchInStore = _toJS.search,
            hashInStore = _toJS.hash;
        // Extract history's location


        var _props$history$locati = props.history.location,
            pathnameInHistory = _props$history$locati.pathname,
            searchInHistory = _props$history$locati.search,
            hashInHistory = _props$history$locati.hash;

        // If we do time travelling, the location in store is changed but location in history is not changed

        if (pathnameInHistory !== pathnameInStore || searchInHistory !== searchInStore || hashInHistory !== hashInStore) {
          _this.inTimeTravelling = true;
          // Update history's location to match store's location
          props.history.push({
            pathname: pathnameInStore,
            search: searchInStore,
            hash: hashInStore
          });
        }
      });

      var handleLocationChange = function handleLocationChange(location, action) {
        // Dispatch onLocationChanged except when we're in time travelling
        if (!_this.inTimeTravelling) {
          props.onLocationChanged(location, action);
        } else {
          _this.inTimeTravelling = false;
        }
      };

      // Listen to history changes
      _this.unlisten = props.history.listen(handleLocationChange);
      // Dispatch a location change action for the initial location
      handleLocationChange(props.history.location, props.history.action);
      return _this;
    }

    _createClass(ConnectedRouter, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.unlisten();
        this.unsubscribe();
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            history = _props.history,
            children = _props.children;


        return _get__('React').createElement(
          _get__('Router'),
          { history: history },
          children
        );
      }
    }]);

    return ConnectedRouter;
  }(_get__('Component'));

  ConnectedRouter.contextTypes = {
    store: _get__('PropTypes').shape({
      getState: _get__('PropTypes').func.isRequired,
      subscribe: _get__('PropTypes').func.isRequired
    }).isRequired
  };

  ConnectedRouter.propTypes = {
    history: _get__('PropTypes').shape({
      action: _get__('PropTypes').string.isRequired,
      listen: _get__('PropTypes').func.isRequired,
      location: _get__('PropTypes').object.isRequired,
      push: _get__('PropTypes').func.isRequired
    }).isRequired,
    location: _get__('PropTypes').oneOfType([_get__('PropTypes').object, _get__('PropTypes').string]).isRequired,
    action: _get__('PropTypes').string.isRequired,
    basename: _get__('PropTypes').string,
    children: _get__('PropTypes').oneOfType([_get__('PropTypes').func, _get__('PropTypes').node]),
    onLocationChanged: _get__('PropTypes').func.isRequired
  };

  var mapStateToProps = function mapStateToProps(state) {
    return {
      action: getIn(state, ['router', 'action']),
      location: getIn(state, ['router', 'location'])
    };
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      onLocationChanged: function onLocationChanged(location, action) {
        return dispatch(_get__('onLocationChanged')(location, action));
      }
    };
  };

  return _get__('connect')(mapStateToProps, mapDispatchToProps)(ConnectedRouter);
};

exports.default = _get__('createConnectedRouter');

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'Component':
      return _react.Component;

    case 'PropTypes':
      return _propTypes2.default;

    case 'onLocationChanged':
      return _actions.onLocationChanged;

    case 'connect':
      return _reactRedux.connect;

    case 'createConnectedRouter':
      return createConnectedRouter;

    case 'React':
      return _react2.default;

    case 'Router':
      return _reactRouter.Router;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof createConnectedRouter === 'undefined' ? 'undefined' : _typeof(createConnectedRouter);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(createConnectedRouter, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createConnectedRouter)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}




/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _actions = __webpack_require__(16);

var createConnectRouter = function createConnectRouter(structure) {
  var filterNotRouter = structure.filterNotRouter,
      fromJS = structure.fromJS,
      getIn = structure.getIn,
      merge = structure.merge,
      setIn = structure.setIn;
  /**
   * This reducer will update the state with the most recent location history
   * has transitioned to.
   */

  var routerReducer = function routerReducer(state) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        type = _ref.type,
        payload = _ref.payload;

    if (type === _get__('LOCATION_CHANGE')) {
      return merge(state, payload);
    }

    return state;
  };

  var connectRouter = function connectRouter(history) {
    var initialRouterState = fromJS({
      location: history.location,
      action: history.action
    });
    // Wrap a root reducer and return a new root reducer with router state
    return function (rootReducer) {
      return function (state, action) {
        var routerState = initialRouterState;

        // Extract router state
        if (state) {
          routerState = getIn(state, ['router']) || routerState;
          state = filterNotRouter(state);
        }
        var reducerResults = rootReducer(state, action);

        return setIn(reducerResults, ['router'], routerReducer(routerState, action));
      };
    };
  };

  return connectRouter;
};

exports.default = _get__('createConnectRouter');

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'LOCATION_CHANGE':
      return _actions.LOCATION_CHANGE;

    case 'createConnectRouter':
      return createConnectRouter;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof createConnectRouter === 'undefined' ? 'undefined' : _typeof(createConnectRouter);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(createConnectRouter, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createConnectRouter)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _actions = __webpack_require__(16);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
var routerMiddleware = function routerMiddleware(history) {
  return function (store) {
    return function (next) {
      return function (action) {
        // eslint-disable-line no-unused-vars
        if (action.type !== _get__('CALL_HISTORY_METHOD')) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
};

exports.default = _get__('routerMiddleware');

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'CALL_HISTORY_METHOD':
      return _actions.CALL_HISTORY_METHOD;

    case 'routerMiddleware':
      return routerMiddleware;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof routerMiddleware === 'undefined' ? 'undefined' : _typeof(routerMiddleware);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(routerMiddleware, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(routerMiddleware)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _reactRouter = __webpack_require__(17);

var createSelectors = function createSelectors(structure) {
  var getIn = structure.getIn,
      toJS = structure.toJS;

  var getLocation = function getLocation(state) {
    return toJS(getIn(state, ['router', 'location']));
  };
  var getAction = function getAction(state) {
    return toJS(getIn(state, ['router', 'action']));
  };

  // It only makes sense to recalculate the `matchPath` whenever the pathname
  // of the location changes. That's why `createMatchSelector` memoizes
  // the latest result based on the location's pathname.
  var createMatchSelector = function createMatchSelector(path) {
    var lastPathname = null;
    var lastMatch = null;

    return function (state) {
      var _ref = getLocation(state) || {},
          pathname = _ref.pathname;

      if (pathname === lastPathname) {
        return lastMatch;
      }
      lastPathname = pathname;
      var match = _get__('matchPath')(pathname, path);
      if (!match || !lastMatch || match.url !== lastMatch.url) {
        lastMatch = match;
      }

      return lastMatch;
    };
  };

  return { getLocation: getLocation, getAction: getAction, createMatchSelector: createMatchSelector };
};

exports.default = _get__('createSelectors');

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'matchPath':
      return _reactRouter.matchPath;

    case 'createSelectors':
      return createSelectors;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof createSelectors === 'undefined' ? 'undefined' : _typeof(createSelectors);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(createSelectors, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createSelectors)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _getIn = __webpack_require__(102);

var _getIn2 = _interopRequireDefault(_getIn);

var _setIn = __webpack_require__(103);

var _setIn2 = _interopRequireDefault(_setIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var structure = {
  filterNotRouter: function filterNotRouter(state) {
    var router = state.router,
        rest = _objectWithoutProperties(state, ['router']); // eslint-disable-line no-unused-vars


    return rest;
  },
  fromJS: function fromJS(value) {
    return value;
  },
  getIn: _get__('getIn'),
  merge: function merge(state, payload) {
    return _extends({}, state, payload);
  },
  setIn: _get__('setIn'),
  toJS: function toJS(value) {
    return value;
  }
};

exports.default = _get__('structure');

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'getIn':
      return _getIn2.default;

    case 'setIn':
      return _setIn2.default;

    case 'structure':
      return structure;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof structure === 'undefined' ? 'undefined' : _typeof(structure);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(structure, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(structure)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* Code from github.com/erikras/redux-form by Erik Rasmussen */

var getIn = function getIn(state, path) {
  if (!state) {
    return state;
  }

  var length = path.length;
  if (!length) {
    return undefined;
  }

  var result = state;
  for (var i = 0; i < length && !!result; ++i) {
    result = result[path[i]];
  }

  return result;
};

exports.default = _get__("getIn");

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case "getIn":
      return getIn;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof getIn === "undefined" ? "undefined" : _typeof(getIn);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(getIn, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(getIn)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* Code from github.com/erikras/redux-form by Erik Rasmussen */

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var next = _get__("setInWithPath")(state && state[first], value, path, pathIndex + 1);

  if (!state) {
    var initialized = isNaN(first) ? {} : [];
    initialized[first] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[first] = next;
    return copy;
  }

  return _extends({}, state, _defineProperty({}, first, next));
};

var setIn = function setIn(state, field, value) {
  return _get__("setInWithPath")(state, value, field, 0);
};

exports.default = _get__("setIn");

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return __$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case "setInWithPath":
      return setInWithPath;

    case "setIn":
      return setIn;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset).catch(reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof setIn === "undefined" ? "undefined" : _typeof(setIn);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(setIn, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(setIn)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_lic_state__ = __webpack_require__(29);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({auth:__WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */],lic_state:__WEBPACK_IMPORTED_MODULE_2__state_lic_state__["o" /* default */]}));

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rawApiCall__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buildUrl__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Page=__webpack_require__(12);// note: node-fetch does not work correctly when doing a POST from the client side.
//       for now, doing everything using GET
var ClientCall=function(){function ClientCall(){_classCallCheck(this,ClientCall);}_createClass(ClientCall,null,[{key:'_logErrorImpl',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(siteUrl,session,error,userId,email){var url,req,result,ok;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].clientCall,"client logError "+session+"/"+error);url=new __WEBPACK_IMPORTED_MODULE_2__buildUrl__["a" /* default */](siteUrl+"call").add("action","error").add("session",session).add("userId",userId).add("email",email).add("error",error);req={url:url.get(),method:'GET'};_context.next=5;return __WEBPACK_IMPORTED_MODULE_1__rawApiCall__["a" /* default */].apiCall(req);case 5:result=_context.sent;ok=result.status==200;if(!ok)Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].error,"client logE error="+result.body);// on error - the result.json is the error details
return _context.abrupt('return',ok?{page:0,errors:[],success:true}:result.json);case 9:case'end':return _context.stop();}}},_callee,this);}));function _logErrorImpl(_x,_x2,_x3,_x4,_x5){return _ref.apply(this,arguments);}return _logErrorImpl;}()},{key:'startTrial',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(siteUrl,session,productId,fingerprint,enableTrialAbuseCheck,userId,email){var url,req,result,ok;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].clientCall,"client startTrial "+session+"/"+productId);url=new __WEBPACK_IMPORTED_MODULE_2__buildUrl__["a" /* default */](siteUrl+"call").add("action","startTrial").add("session",session).add("userId",userId).add("email",email).add("id",productId).add("fingerprint",fingerprint).add("enableTrialAbuseCheck",enableTrialAbuseCheck);req={url:url.get(),method:'GET'};_context2.next=5;return __WEBPACK_IMPORTED_MODULE_1__rawApiCall__["a" /* default */].apiCall(req);case 5:result=_context2.sent;ok=result.status==200;if(!ok)Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].error,"client startTrial error="+result.body);// on error - the result.json is the error details
return _context2.abrupt('return',ok?{page:0,errors:[],success:true}:result.json);case 9:case'end':return _context2.stop();}}},_callee2,this);}));function startTrial(_x6,_x7,_x8,_x9,_x10,_x11,_x12){return _ref2.apply(this,arguments);}return startTrial;}()},{key:'netellerVerify',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(siteUrl,session,accountId,userId,email){var url,req,result,ok,nv;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].clientCall,"client netellerVerify "+session);url=new __WEBPACK_IMPORTED_MODULE_2__buildUrl__["a" /* default */](siteUrl+"call").add("action","netellerVerify").add("session",session).add("userId",userId).add("email",email).add("accountId",accountId);req={url:url.get(),method:'GET'};_context3.next=5;return __WEBPACK_IMPORTED_MODULE_1__rawApiCall__["a" /* default */].apiCall(req);case 5:result=_context3.sent;ok=result.status==200&&result.jsonOk&&result.json.success==true;if(!ok)Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].error,"client netellerVerify error="+result.body);// on error - the result.json is the error details
// on success - the result.json.details contains what store sent us
nv=ok?{page:0,errors:[],success:true,details:result.json.details}:result.json;//console.log("verify result=" + JSON.stringify(nv));
return _context3.abrupt('return',nv);case 10:case'end':return _context3.stop();}}},_callee3,this);}));function netellerVerify(_x13,_x14,_x15,_x16,_x17){return _ref3.apply(this,arguments);}return netellerVerify;}()},{key:'purchaseFree',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(state,storeProductId){var siteUrl,session,userId,licenseId,email,url,req,result,ok;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:siteUrl=state.siteUrl;session=state.session;userId=state.userId;licenseId=state.licenseId;email=state.email;Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].clientCall,"client purchaseFree "+session+"/"+storeProductId);url=new __WEBPACK_IMPORTED_MODULE_2__buildUrl__["a" /* default */](siteUrl+"call").add("action","purchaseFree").add("session",session).add("userId",userId).add("email",email).add("licenseId",licenseId).add("guid",storeProductId);req={url:url.get(),method:'GET'};_context4.next=10;return __WEBPACK_IMPORTED_MODULE_1__rawApiCall__["a" /* default */].apiCall(req);case 10:result=_context4.sent;ok=result.status==200;if(!ok)Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].error,"client purchaseFree error="+result.body);// on error - the result.json is the error details
return _context4.abrupt('return',ok?{page:0,errors:[],success:true}:result.json);case 14:case'end':return _context4.stop();}}},_callee4,this);}));function purchaseFree(_x18,_x19){return _ref4.apply(this,arguments);}return purchaseFree;}()},{key:'creditCardPurchase',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(siteUrl,session,storeProductId,card,billing,userId,email,licenseId){var url,req,result,ok;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].clientCall,"client creditCardPurchase "+session+"/"+storeProductId);url=new __WEBPACK_IMPORTED_MODULE_2__buildUrl__["a" /* default */](siteUrl+"call").add("action","creditCardPurchase").add("session",session).add("userId",userId).add("email",email).add("licenseId",licenseId).add("guid",storeProductId).add("card",card.card).add("cvv",card.cvv).add("expiresYear",card.expiresYear).add("expiresMonth",card.expiresMonth).add("name",billing.name).add("address",billing.address).add("country",billing.country).add("city",billing.city).add("zip",billing.zip).add("state",billing.state);req={url:url.get(),method:'GET'};_context5.next=5;return __WEBPACK_IMPORTED_MODULE_1__rawApiCall__["a" /* default */].apiCall(req);case 5:result=_context5.sent;ok=result.status==200;if(!ok)Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].error,"client creditCardPurchase error="+result.body);// on error - the result.json is the error details
return _context5.abrupt('return',ok?{page:0,errors:[],success:true}:result.json);case 9:case'end':return _context5.stop();}}},_callee5,this);}));function creditCardPurchase(_x20,_x21,_x22,_x23,_x24,_x25,_x26,_x27){return _ref5.apply(this,arguments);}return creditCardPurchase;}()},{key:'netellerPurchase',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(siteUrl,session,storeProductId,account,secureId,password,userId,email,licenseId){var url,req,result,ok;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].clientCall,"client netellerPurchase "+session+"/"+storeProductId);url=new __WEBPACK_IMPORTED_MODULE_2__buildUrl__["a" /* default */](siteUrl+"call").add("action","netellerPurchase").add("session",session).add("userId",userId).add("email",email).add("licenseId",licenseId).add("guid",storeProductId).add("account",account).add("secureId",secureId).add("password",password);req={url:url.get(),method:'GET'};_context6.next=5;return __WEBPACK_IMPORTED_MODULE_1__rawApiCall__["a" /* default */].apiCall(req);case 5:result=_context6.sent;ok=result.status==200;if(!ok)Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].error,"client netellerPurchase error="+result.body);// on error - the result.json is the error details
return _context6.abrupt('return',ok?{page:0,errors:[],success:true}:result.json);case 9:case'end':return _context6.stop();}}},_callee6,this);}));function netellerPurchase(_x28,_x29,_x30,_x31,_x32,_x33,_x34,_x35,_x36){return _ref6.apply(this,arguments);}return netellerPurchase;}()},{key:'paypalPurchase',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(siteUrl,session,storeProductId,userId,email,licenseId){var url,req,result,ok;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].clientCall,"client paypalPurchase "+session+"/"+storeProductId);url=new __WEBPACK_IMPORTED_MODULE_2__buildUrl__["a" /* default */](siteUrl+"call").add("action","paypalPurchase").add("session",session).add("userId",userId).add("email",email).add("licenseId",licenseId).add("guid",storeProductId);req={url:url.get(),method:'GET'};_context7.next=5;return __WEBPACK_IMPORTED_MODULE_1__rawApiCall__["a" /* default */].apiCall(req);case 5:result=_context7.sent;ok=result.status==200&&result.json.redirectUrl!==undefined;if(!ok)Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].error,"client paypalPurchase error="+result.body);// on error - the result.json is the error details
return _context7.abrupt('return',ok?{page:0,errors:[],success:true,redirectUrl:result.json.redirectUrl}:result.json);case 9:case'end':return _context7.stop();}}},_callee7,this);}));function paypalPurchase(_x37,_x38,_x39,_x40,_x41,_x42){return _ref7.apply(this,arguments);}return paypalPurchase;}()},{key:'paymentProfilePurchase',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(siteUrl,session,storeProductId,profileId,userId,email,licenseId){var url,req,result,ok;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].clientCall,"client paymentProfilePurchase "+session+"/"+storeProductId);url=new __WEBPACK_IMPORTED_MODULE_2__buildUrl__["a" /* default */](siteUrl+"call").add("action","paymentProfilePurchase").add("session",session).add("userId",userId).add("email",email).add("licenseId",licenseId).add("guid",storeProductId).add("profileId",profileId);req={url:url.get(),method:'GET'};_context8.next=5;return __WEBPACK_IMPORTED_MODULE_1__rawApiCall__["a" /* default */].apiCall(req);case 5:result=_context8.sent;ok=result.status==200;if(!ok)Object(__WEBPACK_IMPORTED_MODULE_3__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_3__logger__["a" /* LogCategory */].error,"client paymentProfilePurchase error="+result.body);// on error - the result.json is the error details
return _context8.abrupt('return',ok?{page:0,errors:[],success:true}:result.json);case 9:case'end':return _context8.stop();}}},_callee8,this);}));function paymentProfilePurchase(_x43,_x44,_x45,_x46,_x47,_x48,_x49){return _ref8.apply(this,arguments);}return paymentProfilePurchase;}()},{key:'buyNow',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(state){var session,profile,userId,licenseId,email;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:session=state.session;profile=state.preselectedBuyAction.profile;userId=state.userId;licenseId=state.licenseId;email=state.email;//log(LogCategory.info,"buynow=" + JSON.stringify(state.preselectedBuyAction));
_context9.t0=state.preselectedBuyAction.preselect;_context9.next=_context9.t0===0?8:_context9.t0===1?11:_context9.t0===2?14:17;break;case 8:_context9.next=10;return ClientCall.creditCardPurchase(state.siteUrl,session,state.buyProductId,profile.savedCard,profile.billingAddress,userId,email,licenseId);case 10:return _context9.abrupt('return',_context9.sent);case 11:_context9.next=13;return ClientCall.netellerPurchase(state.siteUrl,session,state.buyProductId,profile.neteller.account,profile.neteller.secureId,profile.neteller.password,userId,email,licenseId);case 13:return _context9.abrupt('return',_context9.sent);case 14:_context9.next=16;return ClientCall.paymentProfilePurchase(state.siteUrl,session,state.buyProductId,profile.paymentProfileId,userId,email,licenseId);case 16:return _context9.abrupt('return',_context9.sent);case 17:console.assert(false);return _context9.abrupt('return',false);case 19:case'end':return _context9.stop();}}},_callee9,this);}));function buyNow(_x50){return _ref9.apply(this,arguments);}return buyNow;}()},{key:'logError',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(state,err){var session,userId,email;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:session=state.session;userId=state.userId;email=state.email;_context10.next=5;return ClientCall._logErrorImpl(state.siteUrl,session,err,userId,email);case 5:return _context10.abrupt('return',_context10.sent);case 6:case'end':return _context10.stop();}}},_callee10,this);}));function logError(_x51,_x52){return _ref10.apply(this,arguments);}return logError;}()},{key:'paypal',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(state){var userId,licenseId,email,session;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:userId=state.userId;licenseId=state.licenseId;email=state.email;session=state.session;_context11.next=6;return ClientCall.paypalPurchase(state.siteUrl,session,state.buyProductId,userId,email,licenseId);case 6:return _context11.abrupt('return',_context11.sent);case 7:case'end':return _context11.stop();}}},_callee11,this);}));function paypal(_x53){return _ref11.apply(this,arguments);}return paypal;}()}]);return ClientCall;}();/* harmony default export */ __webpack_exports__["a"] = (ClientCall);;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(109);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_node_fetch__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_node_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_node_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var RawApiCall=function(){function RawApiCall(){_classCallCheck(this,RawApiCall);}_createClass(RawApiCall,null,[{key:'apiCall',/* IN:
        {
        url: url
        body: body / undefined
        method: GET / POST / undefined
        headers: collection of headers  or undefined
        wantAnswerHeaders: array of answer header names to return or undefined
        }

        OUT:
        {
        status: status
        headers: collection of header values, based on wantAnswerHeaders
        body: body of answer (as text). If error during request, check status. body will be null
        json: the body, converted to json (if possible). Otherwise, {}
        jsonOk: true if body could be converted to json, false otherwise
        }
    * */value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(json){var url,req,status,body,headers,response,i,h,resultJson,jsonOk,trimmedBody,stringifiedJson,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:url=encodeURI(json.url);req={mode:"no-cors",cache:"no-cache",method:'GET'};if(json.method!==undefined)req.method=json.method;if(json.headers!==undefined)req.headers=json.headers;else req.headers={};if(json.clientIp!==undefined)req.headers["X-Forwarded-For"]=json.clientIp;if(json.body!==undefined)req.body=JSON.stringify(json.body);status=500;body=null;headers=[];Object(__WEBPACK_IMPORTED_MODULE_2__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__logger__["a" /* LogCategory */].rawApiCallHeaders,"headers for "+url+" => "+JSON.stringify(req.headers));_context.prev=10;_context.next=13;return __WEBPACK_IMPORTED_MODULE_1_node_fetch___default()(url,req);case 13:response=_context.sent;status=response.status;// read headers
if(json.wantAnswerHeaders!==undefined){for(i in json.wantAnswerHeaders){h=json.wantAnswerHeaders[i];headers[h]=response.headers.get(h);}}_context.next=18;return response.text();case 18:body=_context.sent;_context.next=25;break;case 21:_context.prev=21;_context.t0=_context['catch'](10);Object(__WEBPACK_IMPORTED_MODULE_2__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__logger__["a" /* LogCategory */].error,"could not get url "+url+" "+_context.t0.message+"\r\n"+_context.t0.stack);body="";case 25:resultJson={};jsonOk=true;try{if(body!="")resultJson=JSON.parse(body);}catch(e){resultJson={};Object(__WEBPACK_IMPORTED_MODULE_2__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__logger__["a" /* LogCategory */].warn,"could not parse json for "+url);jsonOk=false;}Object(__WEBPACK_IMPORTED_MODULE_2__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__logger__["a" /* LogCategory */].rawApiCall,"raw api "+url+" "+(__WEBPACK_IMPORTED_MODULE_2__logger__["a" /* LogCategory */].rawApiPostBody.log?"body["+req.body+"] ":"")+status);if(__WEBPACK_IMPORTED_MODULE_2__logger__["a" /* LogCategory */].rawApiPostBody.log){// if we have json -> dump that. Otherwise, dump at most 1000 chars of the body
trimmedBody=body;if(trimmedBody.length>1000)trimmedBody=trimmedBody.substr(0,1000);stringifiedJson=Object(__WEBPACK_IMPORTED_MODULE_2__logger__["b" /* getJson */])(resultJson);if(stringifiedJson.length>10)trimmedBody=stringifiedJson;Object(__WEBPACK_IMPORTED_MODULE_2__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_2__logger__["a" /* LogCategory */].rawApiCallAnswer,"raw api "+url+" [answer]: "+trimmedBody);}result={url:url,status:status,body:body,headers:headers,json:resultJson,jsonOk:jsonOk};//log(LogCategory.info,"api result=" + getJson(result, null, 4));
return _context.abrupt('return',result);case 32:case'end':return _context.stop();}}},_callee,this,[[10,21]]);}));function apiCall(_x){return _ref.apply(this,arguments);}return apiCall;}()}]);return RawApiCall;}();/* harmony default export */ __webpack_exports__["a"] = (RawApiCall);;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// ref: https://github.com/tc39/proposal-global
var getGlobal = function () {
	// the only reliable means to get the global object is
	// `Function('return this')()`
	// However, this causes CSP violations in Chrome apps.
	if (typeof self !== 'undefined') { return self; }
	if (typeof window !== 'undefined') { return window; }
	if (typeof global !== 'undefined') { return global; }
	throw new Error('unable to locate global object');
}

var globalObject = getGlobal();

module.exports = exports = globalObject.fetch;

// Needed for TypeScript and Webpack.
if (globalObject.fetch) {
	exports.default = globalObject.fetch.bind(globalObject);
}

exports.Headers = globalObject.Headers;
exports.Request = globalObject.Request;
exports.Response = globalObject.Response;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var BuildUrl=function(){function BuildUrl(sitePrefix){_classCallCheck(this,BuildUrl);this._hexEncode=function(str){var hex,i;var result="";for(i=0;i<str.length;i++){hex=str.charCodeAt(i).toString(16);result+=("000"+hex).slice(-4);}return result;};this._url=sitePrefix;this._firstTime=true;}// https://stackoverflow.com/questions/21647928/javascript-unicode-string-to-hex
_createClass(BuildUrl,[{key:"add",value:function add(name,value){// convert it to string
value=""+value;var prefix=this._firstTime?"?":"&";this._firstTime=false;// IMPORTANT: we could devise a lot of schemes to encode the value, but it unless there's a unique way to unescape it, we'd run into trouble
this._url+=prefix+name+"="+this._hexEncode(value);return this;}},{key:"get",value:function get(){return this._url;}}]);return BuildUrl;}();/* harmony default export */ __webpack_exports__["a"] = (BuildUrl);;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var LicenseType=__webpack_require__(13);var HeaderType=__webpack_require__(8);// this is serialized to/from string  - thus, no functions (they would be lost at deserializing)
var LicenseInfo={create:function create(){var val={headerType:HeaderType.Hm3,state:LicenseType.NoLicense,// kept as millis , to allow easy serializing
expires:Date.now(),// mla-274 - differentiate from maintenance expired
trialExpires:Date.now(),cancelled:false,// if true, Full license, if false, small stakes
fullLicense:true,userEmail:"",// "dummy@dummy.com",
isOverMaxVersion:false,hasAvailableTrial:false,maxVersion:"",restrictions:[],restrictionsFreemium:[]};return val;},copy:function copy(other){var c=this.create();c.headerType=other.headerType;c.state=other.state;c.expires=other.expires;c.trialExpires=other.trialExpires;c.fullLicense=other.fullLicense;c.userEmail=other.userEmail;c.cancelled=other.cancelled;c.isOverMaxVersion=other.isOverMaxVersion;c.maxVersion=other.maxVersion;c.hasAvailableTrial=other.hasAvailableTrial;c.restrictions=other.restrictions;c.restrictionsFreemium=other.restrictionsFreemium;return c;}};module.exports=LicenseInfo;

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_auth__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_lic_state__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__format_localizer__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_logger__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// The basics
// Action creators and helpers
var HeaderType=__webpack_require__(8);var Page=__webpack_require__(12);var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'componentWillMount',value:function componentWillMount(){if(!__WEBPACK_IMPORTED_MODULE_7__store__["b" /* isServer */]){// for now, just have everything in english
__WEBPACK_IMPORTED_MODULE_8__format_localizer__["a" /* default */].init(this.props.lic_state.language);var state=this.props.lic_state;if(state.token!="")this.props.sendTokenToHost(state);var goToPageAndHeader=this.props.goToPageAndHeader;// this part is duplicated in loader; we can't avoid it, because of how React handles dispatch()
window.goToPage=function(page){Object(__WEBPACK_IMPORTED_MODULE_9__api_logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_9__api_logger__["a" /* LogCategory */].info,"window go to page"+page);switch(page){case"continueTrial":var header=Object(__WEBPACK_IMPORTED_MODULE_5__state_lic_state__["l" /* computeContinueTrialHeader */])(state);goToPageAndHeader({header:header,license:header==HeaderType.Hm3?state.licenseHm3:state.licenseOmaha,page:Page.ContinueTrial});break;case"hm3Purchase":goToPageAndHeader({header:HeaderType.Hm3,license:state.licenseHm3,page:Object(__WEBPACK_IMPORTED_MODULE_5__state_lic_state__["m" /* computePurchasePage */])(state.licenseHm3,state.fromStartup)});break;case"om3Purchase":goToPageAndHeader({header:HeaderType.Omaha,license:state.licenseOmaha,page:Object(__WEBPACK_IMPORTED_MODULE_5__state_lic_state__["m" /* computePurchasePage */])(state.licenseOmaha,state.fromStartup)});break;case"maintenanceOptionsHm3Page":return goToPageAndHeader({header:HeaderType.Hm3,license:state.licenseHm3,page:Page.MaintenanceOptions});case"maintenanceOptionsOmahaPage":return goToPageAndHeader({header:HeaderType.Omaha,license:state.licenseOmaha,page:Page.MaintenanceOptions});}};var goToPage=this.props.goToPage;var saveError=this.props.saveError;window.onNetellerFinish=function(success){if(success)goToPage(Page.PaymentReview);else{saveError({page:Page.Netteller,success:false,errors:{general:[{message:"NETELLER transaction canceled. Please login again or choose another payment method."}]}});goToPage(Page.Netteller);}};}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState,snapshot){}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__routes__["a" /* default */],null));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{lic_state:state.lic_state};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({sendTokenToHost:__WEBPACK_IMPORTED_MODULE_5__state_lic_state__["D" /* sendTokenToHost */],goToPageAndHeader:__WEBPACK_IMPORTED_MODULE_5__state_lic_state__["t" /* goToPageAndHeader */],computePurchasePage:__WEBPACK_IMPORTED_MODULE_5__state_lic_state__["m" /* computePurchasePage */],computeContinueTrialHeader:__WEBPACK_IMPORTED_MODULE_5__state_lic_state__["l" /* computeContinueTrialHeader */],saveError:__WEBPACK_IMPORTED_MODULE_5__state_lic_state__["z" /* saveError */],goToPage:__WEBPACK_IMPORTED_MODULE_5__state_lic_state__["s" /* goToPage */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["withRouter"])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(App)));

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_authenticated_route__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_index_route__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_unauthenticated_route__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_loadable__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__error__ = __webpack_require__(133);
var Homepage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 139));},loading:function loading(){return null;}});var Login=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 140));},loading:function loading(){return null;}});var Logout=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 141));},loading:function loading(){return null;}});var ActiveMaintenanceFullPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 142));},loading:function loading(){return null;}});var ActiveMaintenanceSmallPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 143));},loading:function loading(){return null;}});var BillingAddressPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 144));},loading:function loading(){return null;}});var CardInfoPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 145));},loading:function loading(){return null;}});var ContinueTrialPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 146));},loading:function loading(){return null;}});var ExpiredContractFullPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 147));},loading:function loading(){return null;}});var ExpiredContractSmallPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 148));},loading:function loading(){return null;}});var ExpiringContractFullPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 149));},loading:function loading(){return null;}});var ExpiringContractSmallPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 150));},loading:function loading(){return null;}});var FreemiumPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 151));},loading:function loading(){return null;}});var FreemiumOverMaxVersionPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 152));},loading:function loading(){return null;}});var MaintenanceOptionsPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 153));},loading:function loading(){return null;}});var CouldNotStartMlaPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 154));},loading:function loading(){return null;}});var PaymentReviewPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 155));},loading:function loading(){return null;}});var PaypalPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 156));},loading:function loading(){return null;}});var NetellerPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 157));},loading:function loading(){return null;}});var PurchaseCompleteSuccessPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 158));},loading:function loading(){return null;}});var PurchasePage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 159));},loading:function loading(){return null;}});var SelectProductsPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 160));},loading:function loading(){return null;}});var SelectHmAppsProductsPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 161));},loading:function loading(){return null;}});var SelectHmAppVariantProductsPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 162));},loading:function loading(){return null;}});var UpgradeProductsPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 163));},loading:function loading(){return null;}});var PreSelectProductsPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 164));},loading:function loading(){return null;}});var StartTrialOptionsPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 165));},loading:function loading(){return null;}});var TrialLicensePage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 166));},loading:function loading(){return null;}});var TrialStartedPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 167));},loading:function loading(){return null;}});var ViewMissedUpdatesPage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 168));},loading:function loading(){return null;}});var GetHm3ForFreePage=__WEBPACK_IMPORTED_MODULE_5_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 169));},loading:function loading(){return null;}});/* harmony default export */ __webpack_exports__["a"] = (function(){//log(LogCategory.info,"routing " + (isServer ? "server" : "client") );
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_index_route__["a" /* default */],{exact:true,path:'/',component:Homepage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/activeMaintenanceFullPage',component:ActiveMaintenanceFullPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/activeMaintenanceSmallPage',component:ActiveMaintenanceSmallPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/billingAddressPage',component:BillingAddressPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/cardInfoPage',component:CardInfoPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/continueTrialPage',component:ContinueTrialPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/expiredContractFullPage',component:ExpiredContractFullPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/expiredContractSmallPage',component:ExpiredContractSmallPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/expiringContractSmallPage',component:ExpiringContractSmallPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/expiringContractFullPage',component:ExpiringContractFullPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/freemiumPage',component:FreemiumPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/freemiumOverMaxVersionPage',component:FreemiumOverMaxVersionPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/maintenanceOptionsPage',component:MaintenanceOptionsPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/paymentReviewPage',component:PaymentReviewPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/paypalPage',component:PaypalPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/purchaseCompleteSuccessPage',component:PurchaseCompleteSuccessPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/purchasePage',component:PurchasePage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/netellerPage',component:NetellerPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/selectProductsPage',component:SelectProductsPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/selectHmAppsProductsPage',component:SelectHmAppsProductsPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/selectHmAppVariantProductsPage/:filter',component:SelectHmAppVariantProductsPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/upgradeProductsPage',component:UpgradeProductsPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/preSelectProductsPage',component:PreSelectProductsPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/startTrialOptionsPage',component:StartTrialOptionsPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/trialLicensePage',component:TrialLicensePage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/getHm3ForFreePage',component:GetHm3ForFreePage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/trialStartedPage',component:TrialStartedPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/viewMissedUpdatesPage',component:ViewMissedUpdatesPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/couldNotStartMlaPage',component:CouldNotStartMlaPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_8__error__["a" /* default */]}));});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(27);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(27);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(42);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(51);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(43);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(44);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(46);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(47);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(24);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(19);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(48);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(20);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var AuthenticatedRoute=function AuthenticatedRoute(_ref){var Component=_ref.component,rest=_objectWithoutProperties(_ref,['component']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Route */],Object.assign({},rest,{render:function render(props){return rest.isAuthenticated?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Redirect */],{to:'/login?redirect='+props.location.pathname});}}));};var mapStateToProps=function mapStateToProps(state){return{isAuthenticated:state.auth.isAuthenticated};};/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,null)(AuthenticatedRoute));

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_host_hostApp__ = __webpack_require__(129);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var RedirectTo=function RedirectTo(page){return Object(__WEBPACK_IMPORTED_MODULE_3__dispatcher_pageUrl__["a" /* default */])(page);};var IndexRoute=function IndexRoute(_ref){var Component=_ref.component,rest=_objectWithoutProperties(_ref,['component']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Route */],Object.assign({},rest,{render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Redirect */],{to:RedirectTo(rest.lic_state.currentPage)});}}));};var mapStateToProps=function mapStateToProps(state){return{isAuthenticated:state.auth.isAuthenticated,lic_state:state.lic_state};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,null)(IndexRoute));

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__productIds__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__format_localizer__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var HostApp=function(){function HostApp(){_classCallCheck(this,HostApp);this.errorString="";// this is the important info we get from HM3
this.fingerprint="";this.token="";this.userEmail="";this.userName="";this.userId=0;this.licenseId="";this.version="";this.license=[];this.enableTrialAbuseCheck=0;this.fromStartup=true;this.language="en";}_createClass(HostApp,[{key:'isVersionLowerThanMaxVersion',value:function isVersionLowerThanMaxVersion(maxVersion){if(this.version=="")return true;if(__WEBPACK_IMPORTED_MODULE_3__settings__["a" /* Settings */].simulateOverMaxVersion)return false;var ours=this.version.split('.');var max=maxVersion.split('.');var isLower=true;for(var i=0;i<4;++i){var curOurs=parseInt(ours[i]);var curMax=parseInt(max[i]);if(curOurs!=curMax){isLower=curOurs<curMax;break;}// here, they are the same, go to the next sub-version
}//log(LogCategory.info,"comparing " + this.version + " to " + maxVersion + " -> " + ( isLower ? "lower" : "higher" ));
return isLower;}},{key:'startup',value:function startup(jsonHostAnswer){try{if(typeof jsonHostAnswer==='string')jsonHostAnswer=JSON.parse(jsonHostAnswer);if(typeof jsonHostAnswer.fingerprint!=='undefined')this.fingerprint=jsonHostAnswer.fingerprint;if(jsonHostAnswer.language!==undefined)this.language=jsonHostAnswer.language;if(typeof jsonHostAnswer.userToken!=='undefined')if(typeof jsonHostAnswer.userToken.token!=='undefined')this.token=jsonHostAnswer.userToken.token;if(typeof jsonHostAnswer.version!=='undefined')this.version=jsonHostAnswer.version;if(typeof jsonHostAnswer.enableTrialAbuseCheck!=='undefined')this.enableTrialAbuseCheck=jsonHostAnswer.enableTrialAbuseCheck;if(typeof jsonHostAnswer.fromStartup!=='undefined')this.fromStartup=jsonHostAnswer.fromStartup;if(jsonHostAnswer.cached!==undefined){// when the answer is build from HM3 internal data, not coming from the startup response
var cached=jsonHostAnswer.cached;this.token=cached.token;this.userName=cached.name;this.userEmail=cached.email;this.userId=cached.userId;this.licenseId=cached.licenseId;this.license=cached.license.items;}if(typeof jsonHostAnswer.application!=='undefined')if(typeof jsonHostAnswer.application.license!=='undefined'&&jsonHostAnswer.application.license!==null){if(typeof jsonHostAnswer.application.license.name!=='undefined')this.userName=jsonHostAnswer.application.license.name;if(typeof jsonHostAnswer.application.license.name!=='undefined')this.userEmail=jsonHostAnswer.application.license.name;if(typeof jsonHostAnswer.application.license.email!=='undefined')this.userEmail=jsonHostAnswer.application.license.email;if(typeof jsonHostAnswer.application.license.id_user!=='undefined')this.userId=jsonHostAnswer.application.license.id_user;// note: at this time, this is not really sent from HM3
if(typeof jsonHostAnswer.application.license.id_license!=='undefined')this.licenseId=jsonHostAnswer.application.license.id_license;if(typeof jsonHostAnswer.application.license.items!=='undefined')this.license=jsonHostAnswer.application.license.items;}if(this.token==""||this.version=="")this.errorString="Invalid HM3 Startup.";}catch(e){this.errorString="Invalid HM3 Startup - "+JSON.stringify(e);}var hm3=this._getActiveHm3LicenseProductId(this.license);var omaha=this._getActiveOmahaLicenseProductId(this.license);var result={version:this.version,token:this.token,userEmail:this.userEmail,userName:this.userName,userId:this.userId,licenseId:this.licenseId,fromStartup:this.fromStartup,language:this.language,hmApps:jsonHostAnswer&&jsonHostAnswer.application&&jsonHostAnswer.application.license!==undefined&&jsonHostAnswer.application.license!=null?jsonHostAnswer.application.license.apps:[],errorString:this.errorString,enableTrialAbuseCheck:this.enableTrialAbuseCheck,hm3LicenseProductId:hm3.id,omahaLicenseProductId:omaha.id,hm3LicenseIsOverMaxVersion:hm3.isOverMaxVersion,omahaLicenseIsOverMaxVersion:omaha.isOverMaxVersion,hm3LicenseMaxVersion:hm3.maxVersion,omahaLicenseMaxVersion:omaha.maxVersion,// note: the freemium restrictions <- are needed only to show "Limited functionality" tooltip on Maintenance Page
restrictionsHm3:this._getRestrictions(this._getHm3Restrictions(this.license)),restrictionsHm3Freemium:this._getRestrictions(this._getHm3FreemiumRestrictions(this.license)),restrictionsOmaha:this._getRestrictions(this._getOmahaRestrictions(this.license)),restrictionsOmahaFreemium:this._getRestrictions(this._getOmahaFreemiumRestrictions(this.license)),fingerprint:this.fingerprint,license:this.license};return result;}},{key:'_getActiveHm3LicenseProductId',value:function _getActiveHm3LicenseProductId(license){var all=this._getLicenseByProductId(license,__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3AllStakes);var small=this._getLicenseByProductId(license,__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3SmallStakes);var trial=this._getLicenseByProductId(license,__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3Trial);var freemium=this._getLicenseByProductId(license,__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3Freemium);var maintenace=this._getLicenseByProductId(license,__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3Maintenance);var isOverMaxVersion=false;var maxVersion="";// if any of small stakes / all stakes is active -> use that
// (the idea is - we could have a recently expired license + an active one)
if(all!==null&&maintenace!==null&&HostApp.isActive(maintenace.date_expires,maintenace.flg_active))return{id:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3AllStakes,restrictionsId:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3AllStakes,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion};if(small!==null&&maintenace!==null&&HostApp.isActive(maintenace.date_expires,maintenace.flg_active))return{id:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3SmallStakes,restrictionsId:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3SmallStakes,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion};// if any of small stakes / all stakes is recently expired -> use that
if(all!==null&&maintenace!==null&&HostApp.isExpired(maintenace.date_expires,maintenace.flg_active)){maxVersion=HostApp.getMaxVersion(all.restrictions);if(this.isVersionLowerThanMaxVersion(HostApp.getMaxVersion(all.restrictions)))return{id:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3AllStakes,restrictionsId:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3AllStakes,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion};isOverMaxVersion=true;if(freemium===null&&trial===null)// license expired, but hasn't started a trial yet
return{id:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3AllStakes,restrictionsId:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3AllStakes,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion};}if(small!==null&&maintenace!==null&&HostApp.isExpired(maintenace.date_expires,maintenace.flg_active)){maxVersion=HostApp.getMaxVersion(small.restrictions);if(this.isVersionLowerThanMaxVersion(HostApp.getMaxVersion(small.restrictions)))return{id:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3SmallStakes,restrictionsId:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3SmallStakes,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion};isOverMaxVersion=true;if(freemium===null&&trial===null)// license expired, but hasn't started a trial yet
return{id:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3SmallStakes,restrictionsId:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3SmallStakes,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion};if(trial!==null)return{id:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3Trial,restrictionsId:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3SmallStakes,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion};}// if trial -> use that
// note: if trial is expired is as if it hasn't been there
if(trial!==null&&HostApp.isActive(trial.date_expires,trial.flg_active))return{id:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3Trial,restrictionsId:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3Trial,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion};// if freemium -> use that
if(freemium!==null){return{id:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3Freemium,restrictionsId:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3Freemium,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion,// find out if we initially had an ALL STAKES license that expired
isFullLicense:all!==null};}// otherwise , 0
return{id:0,restrictionsId:0,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion};}},{key:'_getActiveOmahaLicenseProductId',value:function _getActiveOmahaLicenseProductId(license){var all=this._getLicenseByProductId(license,__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaAllStakes);var small=this._getLicenseByProductId(license,__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaSmallStakes);var trial=this._getLicenseByProductId(license,__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaTrial);var freemium=this._getLicenseByProductId(license,__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaFreemium);var maintenace=this._getLicenseByProductId(license,__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaMaintenance);var isOverMaxVersion=false;var maxVersion="";// if any of small stakes / all stakes is active -> use that
// (the idea is - we could have a recently expired license + an active one)
if(all!==null&&maintenace!==null&&HostApp.isActive(maintenace.date_expires,maintenace.flg_active))return{id:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaAllStakes,restrictionsId:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaAllStakes,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion};if(small!==null&&maintenace!==null&&HostApp.isActive(maintenace.date_expires,maintenace.flg_active))return{id:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaSmallStakes,restrictionsId:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaSmallStakes,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion};// if any of small stakes / all stakes is recently expired -> use that
if(all!==null&&maintenace!==null&&HostApp.isExpired(maintenace.date_expires,maintenace.flg_active)){maxVersion=HostApp.getMaxVersion(all.restrictions);if(this.isVersionLowerThanMaxVersion(HostApp.getMaxVersion(all.restrictions)))return{id:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaAllStakes,restrictionsId:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaAllStakes,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion};isOverMaxVersion=true;}if(small!==null&&maintenace!==null&&HostApp.isExpired(maintenace.date_expires,maintenace.flg_active)){maxVersion=HostApp.getMaxVersion(small.restrictions);if(this.isVersionLowerThanMaxVersion(HostApp.getMaxVersion(small.restrictions)))return{id:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaSmallStakes,restrictionsId:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaSmallStakes,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion};isOverMaxVersion=true;}// if trial -> use that
// note: if trial is expired is as if it hasn't been there
if(trial!==null&&HostApp.isActive(trial.date_expires,trial.flg_active))return{id:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaTrial,restrictionsId:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaTrial,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion};// if freemium -> use that
if(freemium!==null)return{id:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaFreemium,restrictionsId:__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaFreemium,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion,// find out if we initially had an ALL STAKES license that expired
isFullLicense:all!==null};// otherwise , 0
return{id:0,restrictionsId:0,isOverMaxVersion:isOverMaxVersion,maxVersion:maxVersion};}},{key:'_getLicenseByProductId',value:function _getLicenseByProductId(license,productId){for(var i in license){var item=license[i];if(item.id_product_variant==productId){return item;}}return null;}},{key:'_getHm3Restrictions',value:function _getHm3Restrictions(license){var id=this._getActiveHm3LicenseProductId(license).restrictionsId;if(id!=0)return this._getRawRestrictions(license,id);return[];}},{key:'_getHm3FreemiumRestrictions',value:function _getHm3FreemiumRestrictions(license){return this._getRawRestrictions(license,__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].hm3Freemium);}},{key:'_getOmahaRestrictions',value:function _getOmahaRestrictions(license){var id=this._getActiveOmahaLicenseProductId(license).restrictionsId;if(id!=0)return this._getRawRestrictions(license,id);return[];}},{key:'_getOmahaFreemiumRestrictions',value:function _getOmahaFreemiumRestrictions(license){this._getRawRestrictions(license,__WEBPACK_IMPORTED_MODULE_0__productIds__["a" /* default */].omahaFreemium);}// note: returns the restrictions ONLY if license hasn't already expired
},{key:'_getRawRestrictions',value:function _getRawRestrictions(license,productId){// if we have a subscription that expired recently, show it (and its restrictions)
for(var i in license){var item=license[i];if(item.id_product_variant==productId){if(HostApp.isActive(item.date_expires,item.flg_active)||HostApp.isExpired(item.date_expires,item.flg_active))return item.restrictions;}}return[];}},{key:'_getRestrictions',value:function _getRestrictions(srcRestrictions){var restrictionsByName={};restrictionsByName["RestrictNL"]={restrictedTo:"",restrictedToExtra:[],isSummary:true,type:__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].keys.restrictCashHandsType)};restrictionsByName["RestrictTny"]={restrictedTo:"",restrictedToExtra:[],isSummary:true,type:__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].keys.restrictTourneyType)};restrictionsByName["RestrictLimit"]={restrictedTo:"",restrictedToExtra:[],isSummary:true,type:__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].keys.restrictLimitCashHandsType)};restrictionsByName["HudMaxTables"]={restrictedTo:"",restrictedToExtra:[],isSummary:false,type:__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].keys.restrictHudType)};restrictionsByName["ReportHandLimit"]={restrictedTo:"",restrictedToExtra:[],isSummary:false,type:__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].keys.restrictReportDataType)};for(var i in srcRestrictions){var r=srcRestrictions[i];if(r.unit=="PLY")r.value=__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].keys.restrictionUnlimited);switch(r.name){case"RestrictNL":case"RestrictTny":if(r.unit==null){restrictionsByName[r.name].restrictedTo=__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].keys.restrictCashHands,[r.value]);}else restrictionsByName[r.name].restrictedToExtra.push(r.unit+" "+r.value);break;case"RestrictLimit":if(r.unit==null){restrictionsByName[r.name].restrictedTo=__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].keys.restrictLimitCashHands,[r.value]);}else restrictionsByName[r.name].restrictedToExtra.push(r.unit+" "+r.value);break;case"HudMaxTables":restrictionsByName[r.name].restrictedTo=__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].keys.restrictHud,[r.value]);break;case"ReportHandLimit":restrictionsByName[r.name].restrictedTo=__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].format(__WEBPACK_IMPORTED_MODULE_2__format_localizer__["a" /* default */].keys.restrictReportData,[r.value]);break;}}var allRestrictions=[restrictionsByName["RestrictNL"],restrictionsByName["RestrictTny"],restrictionsByName["RestrictLimit"],restrictionsByName["HudMaxTables"],restrictionsByName["ReportHandLimit"]];var restrictions=[];if(allRestrictions[0].restrictedTo!=="")restrictions.push(allRestrictions[0]);if(allRestrictions[1].restrictedTo!=="")restrictions.push(allRestrictions[1]);if(allRestrictions[2].restrictedTo!=="")restrictions.push(allRestrictions[2]);if(allRestrictions[3].restrictedTo!=="")restrictions.push(allRestrictions[3]);if(allRestrictions[4].restrictedTo!=="")restrictions.push(allRestrictions[4]);Object(__WEBPACK_IMPORTED_MODULE_1__logger__["c" /* log */])(__WEBPACK_IMPORTED_MODULE_1__logger__["a" /* LogCategory */].restriction,"restrictions="+Object(__WEBPACK_IMPORTED_MODULE_1__logger__["b" /* getJson */])(restrictions));return restrictions;}}],[{key:'isActive',value:function isActive(date,activeFlag){if(activeFlag!=1)return false;if(date===null)return true;// perpetual license
var now=Date.now();var expires=Date.parse(date);// make sure 'date' is valid Date string
console.assert(expires>1);return expires>now;}},{key:'isExpired',value:function isExpired(date,activeFlag){if(activeFlag!=1)return false;if(date===null)return false;// perpetual license
var now=Date.now();var expires=Date.parse(date);// make sure 'date' is valid Date string
console.assert(expires>1);var expired=expires<now;return expired;}},{key:'getMaxVersion',value:function getMaxVersion(restrictions){for(var i in restrictions){var restriction=restrictions[i];if(restriction.name=='MaxVersion')return restriction.value;}// highest version possible
return"100.0.0.0";}}]);return HostApp;}();/* unused harmony default export */ var _unused_webpack_default_export = (HostApp);;

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(20);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var UnauthenticatedRoute=function UnauthenticatedRoute(_ref){var Component=_ref.component,rest=_objectWithoutProperties(_ref,['component']);var query=__WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(rest.location.search);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],Object.assign({},rest,{render:function render(props){return!rest.isAuthenticated?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Redirect */],{to:query.redirect||'/dashboard'});}}));};var mapStateToProps=function mapStateToProps(state){return{isAuthenticated:state.auth.isAuthenticated};};/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,null)(UnauthenticatedRoute));

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(132);
var objectAssign = __webpack_require__(10);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_page__ = __webpack_require__(57);
/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_page__["a" /* default */],{id:'not-found',title:'Not Found',description:'This is embarrassing.',noCrawl:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Super embarrassing.'));});

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(135);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _reactFastCompare = __webpack_require__(137);

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _HelmetUtils = __webpack_require__(138);

var _HelmetConstants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _reactFastCompare2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__(136));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      _proto.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(10);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.7a28cae3.js